export const KeyPageList = [
    {
        ID: "1",
        Name: "Patron Librarian of History’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "Malkuth",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "2",
        Name: "Patron Librarian of Tech. Sciences’ Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "Yesod",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "3",
        Name: "Patron Librarian of Literature’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "Hod",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "4",
        Name: "Patron Librarian of Art’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "Netzach",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "5",
        Name: "Patron Librarian of Nat. Sciences’ Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "Tiphereth",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "6",
        Name: "Patron Librarian of Language’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "Gebura",
        Passive: [
            "10005",
        ],
        Desc: [
        ],
    },
    {
        ID: "7",
        Name: "Patron Librarian of Soc. Sciences’ Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "Chesed",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "8",
        Name: "Patron Librarian of Philosophy’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 100,
        StaggerHP: 55,
        SResist: [1, 2],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Binah",
        Passive: [
            "10008",
            "10010",
            "10011",
        ],
        Desc: [
        ],
    },
    {
        ID: "9",
        Name: "Patron Librarian of Religion’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "Hokma",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "10",
        Name: "Patron Librarian of Gen. Works’ Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "Roland",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "11",
        Name: "Assistant History Librarian’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "MalkuthLibrarian",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "12",
        Name: "Assistant Tech. Sciences Librarian’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "YesodLibrarian",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "13",
        Name: "Assistant Literature Librarian’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "HodLibrarian",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "14",
        Name: "Assistant Art Librarian’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "NetzachLibrarian",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "15",
        Name: "Assistant Nat. Sciences Librarian’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "TipherethLibrarian",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "16",
        Name: "Assistant Language Librarian’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "GeburaLibrarian",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "17",
        Name: "Assistant Soc. Sciences Librarian’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "ChesedLibrarian",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "18",
        Name: "Assistant Philosophy Librarian’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "BinahLibrarian",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "19",
        Name: "Assistant Religion Librarian’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "HokmaLibrarian",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "20",
        Name: "Assistant Gen. Works Librarian’s Page",
        Level: "Library",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 30,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "KetherLibrarian",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "102",
        Name: "The Black Silence’s Page",
        Level: "Impuritas Civitatis",
        Source: "Library",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 106,
        StaggerHP: 56,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "BlackSilence",
        Passive: [
            "10008",
            "10012",
            "10013",
        ],
        Desc: [
        ],
    },
    {
        ID: "200001",
        Name: "Lenny’s Page",
        Level: "Canard",
        Source: "Rats",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 42,
        StaggerHP: 22,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "Lenny",
        Passive: [
        ],
        Desc: [
            "Wanna hear a secret? This is kinda embarrassing, but… I used to have a dream once, like Pete does now. Yeah, I know, I’m still younger than him with a long future ahead of me. But what could I do? Life’s too rough for that. Others say that Rats are a pathetic bunch who were too incompetent to join even the smallest Syndicate let alone a Wing. Filthy losers who feed on junk and leftovers, not making any effort to change…",
            "Back when I was a young kid, I didn’t like that. I thought I was better than those Rats. So I decided to get into an examinee town. Little did I know that it’d be the one choice I’d regret the most… I begged and nagged at my parents, wanting to achieve that stupid dream. How’d it go, you ask? Seems you’re just as stupid, aren’t you. I wouldn’t be hanging out with these folks if I made it, now would I?",
            "What I’m saying is, dreaming won’t do jack shit for you. They didn’t end up here because they gave up trying. Hell, they wouldn’t have set foot on this gutter in the first place if they had what it takes to achieve their dreams. You get it now? Pete’s a huge idiot.",
        ],
    },
    {
        ID: "200002",
        Name: "Mang-chi’s Page",
        Level: "Canard",
        Source: "Rats",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 42,
        StaggerHP: 22,
        SResist: [-2, -2],
        PResist: [-1, -1],
        BResist: [0, 0],
        Skin: "MangChi",
        Passive: [
        ],
        Desc: [
            "Didja know? There’s grades for each alley in the Backstreets. Funny, ain’t it. Trash in a trash can are grading each other… The parts that’re under the protection of a Syndicate, Office, or Association are pretty safe. Sweepers can’t raid those streets easily. Putting the people who live there in a different grade from those who don’t, though… is pointless, honestly speaking. Sure, it’s a bit safer over there, but we’re talking about the Backstreets, get it?",
            "You know what’s funnier? Even kids would group themselves according to what part of the streets they live in. They’d even shun the others whose clothes or manner didn’t fit their turf’s style. I had no choice but to accept this sad truth.",
            "You wonderin’ how things were in the alleys I lived? Couldn’t afford to pay protection fees to a Syndicate, so the Sweepers came down at night and collected most of my neighbors. I had to witness ‘em take chunks of flesh outta my parents and brothers while they were still breathing. Don’t pity me, though. My story ain’t nothing special around here.",
        ],
    },
    {
        ID: "200003",
        Name: "Pete’s Page",
        Level: "Canard",
        Source: "Rats",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 42,
        StaggerHP: 22,
        SResist: [-1, -1],
        PResist: [0, 0],
        BResist: [-2, -2],
        Skin: "Pete",
        Passive: [
        ],
        Desc: [
            "There’s not a lot of peeps who hang around in the Backstreets alone. It’s cuz that’s just madness. Weak and dowdy folks gotta band together to survive. Get into a small Syndicate or anything and make a living somehow. Some ignorant fool makes a scene in the Backstreets on their own, they’re just making themselves a target as soon as others notice they’re alone. That’s why we move in groups. We’re called Rats for a reason. We crawl about the dark in packs, and jump at prey for the chance to bite ‘em apart when we spot one.",
            "So, you wondering if we Rats have any dreams? Hmm… I guess belonging to a proper Syndicate, if any. We’re just too tacky and amateurish to be called one. We hate being bound to rules, so hell’ll freeze over before one of us joins an Office, and no Rat I know would move to an examinee town and study for Wing entrance exams. Those nerds at examinee towns ain’t too different from Rats like us. We’re all dreaming silly dreams that’ll never come true with our petty skills. An Office, a Wing, a Syndicate, or whatever… Think it’s an easy task to belong to a decent group? People just accept what they got and live on. But still, I wanted to have a dream.",
        ],
    },
    {
        ID: "200004",
        Name: "Finn’s Page",
        Level: "Canard",
        Source: "Yun's Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [1, 4],
        HP: 42,
        StaggerHP: 22,
        SResist: [0, 0],
        PResist: [-1, -1],
        BResist: [-2, -2],
        Skin: "Finn",
        Passive: [
            "200004",
        ],
        Desc: [
            "It’s been a while, sis. Actually… I talked to you some time ago. By myself, of course. It sounds a bit lonely… But I’m fine! Today’s not gonna be the same as the days before; I have good news. I finally joined an Office run by this guy named ‘Yun’ and officially became a Fixer. You’re proud to see your precious little younger brother grow up and make it, aren’t you? Isn’t it cool? I told you there’s no need to worry about me.",
            "Oh, about Yun’s Office… I think it’s a really nice place. No, I’m not lying. Our operator Yun is a bit cold, but he teaches me a lot of things, and there’s also Eri, who’s my senior. I’ve yet to be friends with her… but she seems like a good person, too. For now, they’re giving me small jobs like searching for lost cats. Maybe they’re worried I’m too inexperienced to handle tougher stuff. It’s not really fancy, but… If I start out with small tasks like this and work up slowly, I’m gonna be a great Fixer one day, yeah? My heart is already pumping with excitement…",
            "When I become a proud and dashing Fixer, I’ll buy a Nest migration ticket and get a nice new home for you. I could buy my gear at a workshop thanks to your help, and all that… Though that’s not all. You always looked after me, sis. …It’s kind of embarrassing to talk about this. Anyway, don’t worry about me, and do the things you want to do. I know you were always too busy caring for me to pursue your own interests. You offered to give me a prosthetic body or even a minor procedure the last time we met, but… I’m doing fine without any of that stuff. And you got money to earn for yourself. Hngh, chaa… I’m tired, so I’ll be going now. I ran around the whole town chasing a cat all day… Night, sis. I hope we see each other again.",
        ],
    },
    {
        ID: "200005",
        Name: "Eri’s Page",
        Level: "Canard",
        Source: "Yun's Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [1, 4],
        HP: 42,
        StaggerHP: 22,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "Eri",
        Passive: [
            "200005",
        ],
        Desc: [
            "You have lots of things to prepare before you can jump into the Fixer business. Starting with choosing equipment, you’ll need clothes to protect your bodily accessories, et cetera… But, before any of that, body augmentation comes first. There’s no point having masterful skills or fancy equipment if your body can’t keep up, y’know? And training hard isn’t gonna do it. There’s a limit to training your body, and the fittest body is still no match for mechanical prosthetics or bionic organs. You gotta be able to keep your body intact to do anything, so you’re pretty much forced to spend a fortune on it.",
            "There’s a ton of methods to enhance your body. Exoskeletons, bionic surgeries, nano-tattoos, prosthetic body parts… You name it. Deciding what workshop tech to employ is up to preference and purpose. Some would want insane muscular strength that could let them carry a power pole one-handed, and others would want ludicrous speed, quick enough to skip over multiple blocks in a split second. It’s so diverse, I could go on forever. You need any ability, they’ve got you covered. The only hurdle is money. In the City, money is what gets you power. That’s why the first thing we notice when we assess our foes is how much they’ve spent on their bodies… Oh, of course, some technologies patented by closed groups like certain Syndicates or Wings are hard to get your hands on even if you have all the cash in the world.",
            "Just look at me, though! It took a teensy little procedure for me to lift this humongous weapon with one hand. This is the kind of power you can get, you see? Body augmentation is more of a necessity than an option these days, so you’ll want to study up on that. You don’t wanna stay a weakling when everyone else’s getting their augmentations, now do you?",
        ],
    },
    {
        ID: "200006",
        Name: "Yun’s Page",
        Level: "Canard",
        Source: "Yun's Office",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 4],
        HP: 46,
        StaggerHP: 22,
        SResist: [-1, -1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Yun",
        Passive: [
            "200006",
        ],
        Desc: [
            "Finn was bungling in many ways. He had no talent, he refused to take modification procedures, all he armed himself with was a tiny weapon. I didn’t exactly dislike him, though. They say a delicate person like him is nothing short of pathetic here, but he had passion regardless, and he was going to be our colleague from now on. Besides, it’s not too common to see such a passionate fellow in this grueling mess of a City. He was an interesting one.",
            "Then why did I exploit him? …“Exploit” is a rather harsh word to describe it, if you ask me. A sloppy kid like him would’ve gotten killed anyway, abducted in the Backstreets and fading away while witnessing his innards getting ripped from his body. And that’s one of the tamer examples I could give. In this City, worse things are happening here and there on a daily basis. If he didn’t die there, he could’ve faced a much more terrible fate somewhere else, isn’t that right? …Nevermind, this is all but rationalization. Think what you want.",
        ],
    },
    {
        ID: "200007",
        Name: "Mo’s Page",
        Level: "Canard",
        Source: "Brotherhood of Iron",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [1, 4],
        HP: 46,
        StaggerHP: 22,
        SResist: [0, 0],
        PResist: [-1, -1],
        BResist: [0, 0],
        Skin: "Mo",
        Passive: [
            "200007",
        ],
        Desc: [
            "I frankly don’t recommend replacing your entire body with a machine. Especially with a cheap one. Aside from basic issues such as vulnerability to damage and creaky noises, cheap prosthetic bodies compromise too much. You’re basically giving up all the joys of life. Can you imagine? You can’t taste anything when you eat delicious food, and you can’t feel the softness and coziness of a good bed. You can’t feel anything get stuck in your body, be it a piece of paper or a knife. The head remembers those feelings, but you can’t experience them again.",
            "There are ways to overcome it, though. You can buy a desire stimulation chip and plug it in your brain, inject medications, or use other methods. They’re just absurdly expensive. You’re better off saving up for a more expensive prosthetic body if you really want your senses back. High quality, pricey bodies come with sensory organs. As I always say, it’s all about money in this world.",
        ],
    },
    {
        ID: "200008",
        Name: "Consta’s Page",
        Level: "Canard",
        Source: "Brotherhood of Iron",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [1, 4],
        HP: 43,
        StaggerHP: 22,
        SResist: [0, -2],
        PResist: [-2, -1],
        BResist: [0, 0],
        Skin: "Consta",
        Passive: [
            "200007",
        ],
        Desc: [
            "What’s your favorite food? That’s the question I used to ask the most when I still had a human body. I love… looooove eating. Talking about food was a huge delight for me. We would share each other’s tastes and preferences, and sometimes head to a restaurant for a meal just like that.",
            "But now… My body’s a machine as you can see. I can’t taste anything anymore. Thanks for pointing that out. Mo told me to stop dreaming about it. I still wanna try more delicious foods, though. Hot and flavorful… Spicy and sweet… Stuff like that. I guess this body is too cheap to restrain delusional thoughts like this. If we get more money and change our bodies to new ones… then maybe I’ll be able to stop these thoughts from getting in the way of my work?",
        ],
    },
    {
        ID: "200009",
        Name: "Arnold’s Page",
        Level: "Canard",
        Source: "Brotherhood of Iron",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [1, 4],
        HP: 43,
        StaggerHP: 22,
        SResist: [0, -2],
        PResist: [0, 0],
        BResist: [-2, -1],
        Skin: "Arnold",
        Passive: [
            "200007",
        ],
        Desc: [
            "The City consists of 25 Nests, and 25 Districts of the Backstreets that surround those Nests. And countless Offices and Syndicates reside in the Backstreets. You know what’s a surefire way for a Syndicate to make a name for itself among all the competitors? The simplest method is Office raiding. You literally storm into an Office and wreak havoc on it.",
            "You never know who will be the winner until you fight. It could stop at a good beating and one side surrendering, but some Syndicates raid Offices out of pure boredom and kill everyone. Each Syndicate has its own way of operation. It goes without saying that the Syndicate has more fame to gain out of raiding a high-grade Office filled with seasoned Fixers. So the Offices have to stay sharp at all times. But you’ll also have to watch it. If you misjudge your opponents, you’ll end up dead before you could try anything…",
        ],
    },
    {
        ID: "200010",
        Name: "McCullin’s Page",
        Level: "Canard",
        Source: "Hook Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [1, 4],
        HP: 43,
        StaggerHP: 22,
        SResist: [0, -2],
        PResist: [-1, -1],
        BResist: [0, 0],
        Skin: "McCullin",
        Passive: [
            "200010",
        ],
        Desc: [
            "It’s not entirely impossible for a Syndicate member to engage in Fixer work or vice versa. It’s a pretty common occurrence, actually. If you have the skills to back yourself up, multiple organizations will make sweet offers to recruit you. What matters the most here is the relationships you’ve built. Your fate depends on the things you’ve done, or karma in other words.",
            "We didn’t start out as Fixers at the beginning. No, we were in fact part of a homicidal Syndicate. Just see how intimidating we look. We used to be murder for hire in District 23. It was a small Syndicate ran by Naoki, I, and a few others, but our influence started to expand bit by bit since the young and talented Taein joined us. Our current boss… was originally the representative of an Office we raided. They visited us once they heard that we shredded their Fixers brutally and hung their ragged corpses on the streets like scarecrows. Said they’ll need people like us.",
            "I thought they were just freaky with weird tastes, but looking back, now I get why they chose us. It’s a strategy. Each Office does all kinds of sensational stunts to attract the attention of potential clients in this oversaturated market. They hold radical events such as “Pay for one request, get one for free”, or group weapons into different grades and offer a free exchange for one of their most expensive ones. And the gullible clients fall for it. They don’t know how much more that “one plus one” deal actually costs, or how it has limitations on the grades of requests you can make… They don’t bother looking up to check if the top-grade weapons are in fact used ones. Seems our boss didn’t want to add lies to this industry that’s already full of filthy schemes, but they still had to catch people’s eyes somehow. And this is the result: hire guys like us and proudly advertise it. ‘Fixers from a former killer Syndicate will tear things up for you! You can count on us!’ Hang up a slogan like this, people get hooked up. If that suits their taste, that is.",
        ],
    },
    {
        ID: "200011",
        Name: "Taein’s Page",
        Level: "Canard",
        Source: "Hook Office",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [1, 4],
        HP: 43,
        StaggerHP: 22,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [-1, -1],
        Skin: "Taein",
        Passive: [
            "200010",
        ],
        Desc: [
            "How’s my new weapon, isn’t it sick? Union Co. is the go-to workshop brand for ready-made bionic weapons and equipment. Their prices are pretty reasonable compared to most procedures and workshop weapons, too. On top of superb performance, you can replace or attach them easily without having to worry about allergies, so it’s pretty damn handy, you see?",
            "Oh, bionic equipment is pretty simple; it’s like a weapon you attach to your body. It’s not at all scary or dangerous, though it could feel a bit awkward when you use it for the first time. In my case, I accidentally ripped Naoki’s clothes while walking by, and cut my own cheek when I flailed it outta frustration… But, now that I’ve gotten used to it, I feel as if I have three hands. If you have trouble finding the perfect procedure or weapon for you, try bionic equipment. I guarantee it’s good.",
        ],
    },
    {
        ID: "200012",
        Name: "Naoki’s Page",
        Level: "Canard",
        Source: "Hook Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [1, 4],
        HP: 43,
        StaggerHP: 22,
        SResist: [0, 0],
        PResist: [0, -1],
        BResist: [-1, -2],
        Skin: "Naoki",
        Passive: [
            "200010",
        ],
        Desc: [
            "There’s a huge variety of workshops. As diverse as Syndicates and Fixers are, weapons need individuality to stand out in this day and age. Old-fashioned swords or guns won’t stand a chance against modern weapons loaded with new technology, I bet. From cheap and common gear to bionic equipment like the one Taein’s using, to equipment with ridiculous abilities that’s almost indistinguishable from magic. Don’t get too hyped, though. More options means you need to be more cautious about choosing the right one for you. If you had the time and money, you could buy ‘em all and test them out at your leisure, but… We have neither, do we?",
            "Don’t just buy the things others recommend without doing your own research, though. That’s one of the stupidest things you could do. Might fit them, but that doesn’t necessarily mean you’ll have a good time with it. Still confident that you can wield ‘em well? Get real, buddy. Workshop equipment is not your average weaponry. So, before you choose your weapon, observe others carefully. See if any workshop products might suit you. Having keen eyes is all part of our skills. Guess why people choose us and our Office out of all the tough Fixers out there.",
        ],
    },
    {
        ID: "201001",
        Name: "A Yun’s Office Fixer, Page 1",
        Level: "Canard",
        Source: "Yun's Office",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 43,
        StaggerHP: 22,
        SResist: [-1, -1],
        PResist: [0, 0],
        BResist: [-2, -2],
        Skin: "YunUnit1",
        Passive: [
            "201001",
        ],
        Desc: [
            "The society of Fixers is built entirely up on meritocracy. The greater you are, the higher you can climb. On the other hand, if you don’t have the capability, you should be thankful for any org that accepts you and stay low. Thing is, ‘capability’ can mean many things. For some, it could be physical strength, and others might have superior intellect. It seems kinda unfair to me that they make arbitrary evaluations of a concept that can be taken in so many different ways. Not that I think I have some hidden talent that deserves a better grade or anything, though. I do feel a bit upset, but I think I’m at the right place. The jobs I usually do are looking for lost cats at night… You can tell how low my spot is, yeah?",
            "I’m not a huge fan of the jobs I’m doing right now, of course. I mean, sure, I wouldn’t say no to some flashier requests. I just accepted to carry on with my life.",
        ],
    },
    {
        ID: "201002",
        Name: "A Yun’s Office Fixer, Page 2",
        Level: "Canard",
        Source: "Yun's Office",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 43,
        StaggerHP: 22,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "YunUnit2",
        Passive: [
            "201002",
        ],
        Desc: [
            "The Backstreets are alleyways densely spread across the city. They’re entangled like spiderwebs, and spread far and wide, so it is virtually impossible for one to know every single thing that occurs in the Backstreets. And they’re populated with all sorts of people.",
            "Examinee towns where people preparing for entrance exams in hopes of getting into a Nest have gathered; Syndicates and Fixers thirstily looking for business; workshops that benefit from their conflicts, crafting various tools and gadgets…  It’s a disorderly lump of all kinds of desires for wealth and dreams.",
            "People think Fixers are “good guys” who fight off bad guys here, but they’re just humans in reality. They’re simply doing their jobs to make a living. Some clients look at us with sparkly eyes like we’re heroes or something. This might seem funny to you, but things get troublesome if we don’t fulfill their requests. They give us a disappointed look, yell profanities at us… Turn into rude customers before leaving.",
        ],
    },
    {
        ID: "201003",
        Name: "A Yun’s Office Fixer, Page 3",
        Level: "Canard",
        Source: "Yun's Office",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 43,
        StaggerHP: 22,
        SResist: [-2, -2],
        PResist: [-1, -1],
        BResist: [0, 0],
        Skin: "YunUnit3",
        Passive: [
            "201003",
        ],
        Desc: [
            "A hotshot Fixer gets all the push they can get from their Office. And an Office housing competent Fixers can get sponsorships from Associations, Wings, or workshops. The same can be said for individual Fixers; the spicy ones are sought after by many firms. But that won’t be you guys. Most of us have to purchase equipment with our own budget. Insane things happen in the City, and even Rats could tear you a new one if you haven’t got any useful gadgets or procedures.",
            "And how do you get the money for that? Duh, you’re supposed to earn it, isn’t that obvious? …Funny, isn’t it. You jump into the Fixer business trying to earn money, but you need to get into debt and spend money to be able to do proper work. How ironic is that? This world’s one giant hamster wheel.",
        ],
    },
    {
        ID: "210001",
        Name: "Jack’s Page",
        Level: "Urban Myth",
        Source: "Pierre's Bistro",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 4],
        HP: 50,
        StaggerHP: 25,
        SResist: [0, 0],
        PResist: [-1, -2],
        BResist: [0, -1],
        Skin: "Jack",
        Passive: [
            "8",
            "210001",
        ],
        Desc: [
            "Our usual source of cooking ingredients are Syndicates specializing in butchery. The kinds of meat they treat and how they process it differs for each Syndicate, so you should pick your caterer carefully. Our meat pie bistro used to frequently trade with ‘The Musicians of Bremen’ and ‘Little Piggy's’.",
            "‘The Musicians of Bremen’ provided large quantities of meat, though it wasn’t exactly the freshest. Shattered chips of bones were often in the meat, and the mixture of different types would create an odd flavor. Still was a reliable supplier of ingredients, all in all. Outside of special occasions, we’d use them for making experimental dishes or sausages. Oh, speaking of, sausages are made from a mix of several different kinds of meat. You could even find a rat inside at times. Anyway, we rarely sold the dishes made out of their meat other than the sausages. They’d never treat their meat nicely before handing it to us.",
            "The meat from ‘Little Piggy's’ is pricey and comes in small quantities, but its quality is good. We even got the highest grade meat sometimes if we were lucky. Just looking at the meat from ‘Little Piggy's’ fills me with ideas about how to cook it and makes my mouth water. That’s how appealing the meat looks. But the price is rather heavy, so we only used it for important dishes or foods we serve to customers.",
            "But both Syndicates suddenly said they’re no longer selling ingredients for some reason. So now Pierre and I have to pioneer a new supply chain on our own. I don’t think this is all too bad, though. I enjoy working with Pierre a lot.",
        ],
    },
    {
        ID: "210002",
        Name: "Pierre’s Page",
        Level: "Urban Myth",
        Source: "Pierre's Bistro",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 4],
        HP: 44,
        StaggerHP: 25,
        SResist: [0, 0],
        PResist: [0, -1],
        BResist: [-1, 0],
        Skin: "Pierre",
        Passive: [
            "8",
            "210002",
        ],
        Desc: [
            "Most cooks who live here have the same dream: becoming one of ‘The Eight Chefs’! They’re the people who pursue the ultimate delicacy. Their way of cooking will… give you a thrill just hearing about it! You don’t feel it? No no, I’m sure you can feel it inside. I sound crazy? Nyeh, listen up, you stubborn square! This is why I can’t talk with people whose brains are too old. They taste bad, too!",
            "There’s a limit to the flavors people can draw forth. The height of taste the human tongue can feel isn’t as impressive as you might think, really. The most delicious food doesn’t come close to sending chills down your spine. At most… it’s just good enough to make your eyes spin! And the food you guys casually eat, going “Mm~ Tasty~”, are way! Way, way way way waaaaaay~ below that! So, many chefs gathered round one time… pondering what to do to pursue a taste beyond this limit… And then inspiration struck all of them at the same time like lightning! What if they sublimated the experience into taste, something beyond what the tongue can feel? You know, they say the presentation of food adds to its taste, right? What if the whole process of cooking could be tasted! They performed several experiments in an attempt to make that dream come true.",
            "“So?” What do you mean, “So?” I wouldn’t be trying so hard if there was an end to delicacy! All the chefs are continuing their research to this day, seeking more stimulating flavors. And I just want to be as good as the stain on their apron at least!",
        ],
    },
    {
        ID: "210003",
        Name: "Mars’ Page",
        Level: "Urban Myth",
        Source: "Streetlight Office",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 5],
        HP: 65,
        StaggerHP: 27,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Mars",
        Passive: [
            "11",
            "10001",
            "210003",
        ],
        Desc: [
            "My mother was a Fixer with a high grade that every one of my peers would dream of reaching. She was the envy of all, a radiant individual who received endless supplies of various expensive equipment and garnered constant recruit offers from other Offices. Does that mean I had a safe, comfortable childhood under the care and wealth of such a wonderful person? Had that been the case, I would’ve earned a position in one of the Wings already. Being the son of a high-rank Fixer, I was often targeted by Syndicates opposing her, and my mother’s acquaintances held high expectations for me.",
            "At first, I was okay with their expectations. I was already dreaming to follow the path of my mother. In fact, I was hoping to live up to it and hear compliments such as “I knew you could make it!” from others. “Yes. I’m going to become a great Fixer just like my mother. Then she’ll be proud of me one day, right? She’ll proudly say ‘That's my boy’, in front of others.” I studied hard day after day, taking no breaks in-between… Countless times, I held my sword with a strong resolve, and many days I spent weeping alone. Even if I faced setbacks and failures, I believed I could overcome them and stand strong like the protagonist of a movie. As if I could actually be someone great.",
            "But in the end, I grew into an ordinary aspiring Fixer, and I learned that I was only an average person with no talent to show off. When I entered an ordinary Office with my ordinary capabilities, my mother seemed very glad to hear the news. She said an associate Office of the Zwei is a good start, and that I’ll certainly be able to become successful if I work my way up slowly. However, I was greatly disappointed in myself, and I couldn’t look my mother in the eyes until I said my final goodbyes and left the house.",
        ],
    },
    {
        ID: "210006",
        Name: "Lulu’s Page",
        Level: "Urban Myth",
        Source: "Streetlight Office",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [1, 5],
        HP: 53,
        StaggerHP: 26,
        SResist: [-1, -2],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Ruru",
        Passive: [
            "8",
            "210006",
        ],
        Desc: [
            "Ugh, crap… Another day without work! Fantastic. There’s got to be some case for us to take care of, like fly tipping or something? I’m gonna forget how to move at this rate… If I told my friends about this, they’re so gonna whine like “Well, isn’t it a good thing that you have a lot of free time~” or “You’re well off, we’re about to starve from the lack of requests~”. Those dummies… Think about it for a moment. You need results to promote to better Fixer grades and see some growth in your Office, right? And that’s gonna lead to higher income for us. For now, I’m working with my boss San and some dork shaped like a ball of rice cake… But things could be better than this in the future, yeah? …It’s not like I have problems with my coworkers!!! I’m talking about stuff like weapons, and Office interior… You know, those kinda things. You get what I mean!",
            "I do bicker with Mars and snap at him often, yes! But that doesn’t mean I hate him. San and Mars are both precious colleagues to me. Though, yeah, I know what you’re about to say. If Fixers develop private feelings for each other, it could be much harder to bear whatever happens down the line. I know what I’m doing is stupid. I have wits, unlike mister rice cake face.",
            "But we’re humans, it’s just… something that can’t be helped. How could we just strictly detach ourselves from one another and focus on work? I tried acting nonchalant, I did, but… I guess I can’t do it. San said he feels the same. I gotta envy Mars for being cool-headed all the time.",
        ],
    },
    {
        ID: "211001",
        Name: "A Hook Office Fixer, Page 1",
        Level: "Canard",
        Source: "Hook Office",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 43,
        StaggerHP: 22,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "HookUnit1",
        Passive: [
            "8",
            "200010",
        ],
        Desc: [
            "Back when we were still part of the killer Syndicate, we got a client asking us to hunt some crazed Syndicate. They were shaking like a drenched rat as they came in. I suppose they were scared of places like this. They asked us to catch the wicked criminals kidnapping people in the parts of the streets they live in. We had one question, though; it’s nice that they’re giving us a job, but why ask a Syndicate like ours instead of going to the Zwei or other Offices that are better suited for handling public safety issues?",
            "And they said, they did try to request an Office at first with the money raised by their neighbors. But then the Office asked for a ridiculous sum of money, claiming that there’s much preparation they need to take before they can uproot a whole Syndicate. Poor fellow begged for help, but the Office personnel didn’t even flinch. Well, money is the only thing that gets Fixers moving, so that’s understandable. And I think their friend recommended us to them while they were looking for another way, if I remember it right? Introduced us as a trustworthy Syndicate. So they came all the way to our hideout.",
            "Trustworthy Syndicate… It’s a shame, really. I can still remember the client’s head staring daggers at me, hanging from the top of a power pole. The Syndicate paid us more cash. What could I do about it? We don’t write official contracts or anything, so the highest bidder gets our favor. No use glaring at me like that, pal. We were told by our new client to hang their head and guts out in the streets, to make an example of ‘em. Those sickfucks even used some kinda Singularity to keep ‘em alive. Poor bastard. Shoulda requested an Office in the first place somehow.",
        ],
    },
    {
        ID: "211002",
        Name: "A Hook Office Fixer, Page 2",
        Level: "Urban Myth",
        Source: "Hook Office",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 43,
        StaggerHP: 22,
        SResist: [-1, -1],
        PResist: [-2, -2],
        BResist: [0, 0],
        Skin: "HookUnit2",
        Passive: [
            "8",
            "200010",
        ],
        Desc: [
            "Backstreets are spread all over the City, and the Nests are no exception. But all this means is that “there are Backstreets in the Nests”, since the Nests are completely segregated from the Backstreets in terms of access. Each Wing employs their own methods like electric fences or plasma walls, and some just fence the boundary with a couple of loose chains. Needless to say, the Backstreet residents don’t even think about crossing the border, regardless of how insecure it looks.",
            "If I had to point out one thing the Backstreets and the Nest have in common… It’d be that residents of the Nests can get a good view of the Backstreets, and vice versa. Hey, did you hear that? Watching the Backstreet’s apparently a trend among Nest dwellers these days. After a day’s work, they sit by the windows and look out on the streets, cracking open a can of beer… Chat with their friends about what they witnessed last evening. Hell, there’s even a club dedicated to that, apparently. Isn’t that absurd? People in the Backstreets live from day to day with their lives on the line, and their struggle is nothing more than entertainment to those who live inside the Nest.",
        ],
    },
    {
        ID: "211003",
        Name: "A Backstreets Butcher, Page 1",
        Level: "Urban Myth",
        Source: "Backstreets Butcher",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 47,
        StaggerHP: 25,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "BackStreetChef1",
        Passive: [
            "8",
            "211003",
        ],
        Desc: [
            "District 23 is the street of flavor. Everything is permitted in the pursuit of making delicious dishes. Even dismembering humans. Isn’t that exciting?",
            "‘A guest walked into a restaurant for a meal, but then the chef fell in love with them! They had the perfect amount of tenderness and girth. The chef pulled out a knife, and the guest ended up on a plate. You'll become the food you appreciated one day, and others will appreciate what you've become.’",
            "It’s a common story often told in these streets. Well… If you really become the main character of one of those tales, be honored. That means the chef saw you as excellent meat. Hmm? This is one of the best compliments you can hear in District 23. The more you know~",
        ],
    },
    {
        ID: "211004",
        Name: "A Backstreets Butcher, Page 2",
        Level: "Urban Myth",
        Source: "Backstreets Butcher",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 47,
        StaggerHP: 25,
        SResist: [0, 0],
        PResist: [-1, -1],
        BResist: [-2, -2],
        Skin: "BackStreetChef2",
        Passive: [
            "8",
            "211003",
        ],
        Desc: [
            "Butchering a human is a lot simpler than butchering other animals. Most of them are smaller than us. Which means we can subdue them right away even if they try to resist. Oh, I’m not saying you necessarily have to be tall to be a butcher, so don’t be discouraged. Anyway, humans can be a bit noisy, but they’re very handy to deal with overall since there’s little to worry about compared to other meats.",
            "Besides, the uhh… ‘The Eight Chefs’? For them, human meat is the one and only ingredient that matches their pursuit. Some buzz about how the process of cooking should be part of the flavor… You can’t do that with any other meat. So you’d better watch it. If you dare wander this part of the town, your destination might end up being a dining table.",
        ],
    },
    {
        ID: "211005",
        Name: "Lulu’s Friend, Page 1",
        Level: "Urban Myth",
        Source: "Streetlight Office",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 47,
        StaggerHP: 25,
        SResist: [0, 0],
        PResist: [-1, -1],
        BResist: [-2, -2],
        Skin: "LuluFriend1",
        Passive: [
            "8",
            "211005",
        ],
        Desc: [
            "A peacekeeping Office provides protection for requested territories for a certain period of time. Lulu’s is one of those Offices. What are they protecting against, you ask? The City, obviously. What I’m saying is, their job is to keep the area safe from all sorts of happenings and incidents that occur in the City. Of course, there won’t be much to do if the area is too small or peaceful.",
            "But, man. Compared to us who have to wait indefinitely for someone to make a request… Lulu’s living a good life. At least she does something. And they don’t have to worry about starving to death even if they don’t get requests.",
        ],
    },
    {
        ID: "211006",
        Name: "Lulu’s Friend, Page 2",
        Level: "Urban Myth",
        Source: "Streetlight Office",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 47,
        StaggerHP: 25,
        SResist: [-1, -1],
        PResist: [0, 0],
        BResist: [-2, -2],
        Skin: "LuluFriend2",
        Passive: [
            "8",
            "211005",
        ],
        Desc: [
            "A peacekeeping Office provides protection for requested territories for a certain period of time. Lulu’s is one of those Offices. What are they protecting against, you ask? The City, obviously. What I’m saying is, their job is to keep the area safe from all sorts of happenings and incidents that occur in the City. Of course, there won’t be much to do if the area is too small or peaceful.",
            "But, man. Compared to us who have to wait indefinitely for someone to make a request… Lulu’s living a good life. At least she does something. And they don’t have to worry about starving to death even if they don’t get requests.",
        ],
    },
    {
        ID: "211007",
        Name: "Lulu’s Friend, Page 3",
        Level: "Urban Myth",
        Source: "Streetlight Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [1, 4],
        HP: 45,
        StaggerHP: 22,
        SResist: [0, 0],
        PResist: [-1, -1],
        BResist: [0, -2],
        Skin: "LuluFriend_Ver2_W1",
        Passive: [
            "8",
            "211007",
        ],
        Desc: [
            "As her friend, it’s unfortunate that Lulu is struck with grief. I don’t have any tears to shed for her, though. I’ve got my share of rough experiences, I’m just not sharing it with others. Well, I did say I’ll help her out, but the truth is… My Office figured that we could find plenty of valuable loot in the Library. And that’s pretty tempting. The other one is probably thinking the same thing as me. I mean, what dummy would actually head to such a dangerous place motivated purely by a friend’s sob story? That kind of intimate and deep relationship is long gone from this world. Especially in this business.",
            "That’s why I can’t understand Lulu. Sure, let’s say that her colleague died there. Even then, she should be valuing her own life, shouldn’t she? She can be so stupid at times… Welp, I have to go in with her anyway.",
        ],
    },
    {
        ID: "211008",
        Name: "Lulu’s Friend, Page 4",
        Level: "Urban Myth",
        Source: "Streetlight Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [1, 4],
        HP: 45,
        StaggerHP: 22,
        SResist: [-1, -1],
        PResist: [0, 0],
        BResist: [0, -2],
        Skin: "LuluFriend_Ver2_W2",
        Passive: [
            "8",
            "211007",
        ],
        Desc: [
            "As her friend, it’s unfortunate that Lulu is struck with grief. I don’t have any tears to shed for her, though. I’ve got my share of rough experiences, I’m just not sharing it with others. Well, I did say I’ll help her out, but the truth is… My Office figured that we could find plenty of valuable loot in the Library. And that’s pretty tempting. The other one is probably thinking the same thing as me. I mean, what dummy would actually head to such a dangerous place motivated purely by a friend’s sob story? That kind of intimate and deep relationship is long gone from this world. Especially in this business.",
            "That’s why I can’t understand Lulu. Sure, let’s say that her colleague died there. Even then, she should be valuing her own life, shouldn’t she? She can be so stupid at times… Welp, I have to go in with her anyway.",
        ],
    },
    {
        ID: "220001",
        Name: "San’s Page",
        Level: "Urban Legend",
        Source: "Zwei Association South Section 6",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 57,
        StaggerHP: 29,
        SResist: [0, 0],
        PResist: [0, 1],
        BResist: [-2, -1],
        Skin: "San",
        Passive: [
            "9",
            "220001",
        ],
        Desc: [
            "An associate Office is one that is in a cooperative relationship with one of the Associations. The advantage of this designation is that its Fixers will not have to worry about starving, since they’re paid a stable salary… And that the Office simply has to handle tasks given by the Association with proficiency, rather than having to deal with clients and accept their requests as ordinary Offices do. Spending days without any incident happening in the area designated for peacekeeping can be admittedly boring… Though it’s a blessing to have such a peaceful day in the City. I was grateful to have such serenity each day, reasoning with Lulu’s occasional complaints.",
            "Is boredom the only downside of being an associate Office? That’s not quite true. Because we’re under the direct command of the Association, we’re forced to take on any undesirable tasks they give. Even if it carries the risk of wiping out the Office…",
            "…I can’t blame the Association, so I only have myself to fault for failing to save my guys.",
        ],
    },
    {
        ID: "220002",
        Name: "Julia’s Page",
        Level: "Urban Legend",
        Source: "Zwei Association South Section 6",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 57,
        StaggerHP: 29,
        SResist: [-1, -2],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Julia",
        Passive: [
            "9",
            "220002",
        ],
        Desc: [
            "I still remember the day when the three of us met for the first time. It was when I joined my previous Office.",
            "I was actually scared back then. It was the first workplace I was assigned to just after I became a Fixer. I was hesitating in front of the glass door, wondering whether I should go in or wait for someone to open it, but then I heard a sound coming from inside. Two people arguing with each other… I decided to get close to the door and eavesdrop on them.",
            "“How tight did the bonds between our fates have to be to lead us here… Sigh…”",
            "“I mean, both you and I are first timers, isn’t it reassuring to be with a familiar face?”",
            "“Not at all! When is this Julia person coming, anyway? Don’t tell me she got disappointed by your pathetic impression and went back already.”",
            "“She’s not coming in because she’s intimidated by your facial expression.”",
            "She gave me a glance, turned back to the tall person with an even fiercer gaze than moments ago, then kicked him in the shin and came striding along towards me. The tall person followed, rubbing his shin. As the person with pigtails got closer and closer, I found myself stepping backward, even though I knew I should be saying hello to her… Soon, the chime on the door rang as it opened up, and we stood still for a few seconds like that, not one of us saying a single word. I don’t know why, but it was so funny to me that she was puckering her lips, just as hesitant to speak as I was, so I burst out laughing.",
        ],
    },
    {
        ID: "220003",
        Name: "Isadora’s Page",
        Level: "Urban Legend",
        Source: "Zwei Association South Section 6",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 57,
        StaggerHP: 29,
        SResist: [0, 0],
        PResist: [-1, -2],
        BResist: [0, 1],
        Skin: "Isadora",
        Passive: [
            "9",
            "220003",
        ],
        Desc: [
            "San and Julia are old Fixer friends of mine. And San’s from the streets of District 21, the same place I grew up in. This is a secret I’ve only told Julia, but San actually used to be a huge coward. It’s probably not that surprising to you since he still acts like a coward from time to time. Thinking about the old days makes me laugh, though? He’d always “train” himself so he “doesn’t lag behind” and end up getting scars on his face. And one time, he walked into a dark alleyway, saying exploration shouldn’t be a problem for a brave person even though his face was already full of fear, and then ran back to me in less than a minute.",
            "We almost got into serious danger one time. The two of us were hanging out until after dark, and ran into something nasty in a remote street. It happened when I was a little kid, so my memory of that is blurry… All I can remember is looking at San’s back, standing in front me holding a tree branch he hurriedly picked up. My heart was racing with fright, but looking at his shivering legs made me chuckle a little on the inside. I don’t really remember what happened after that, as I said.",
            "Why am I bringing this up all of a sudden? I don’t know. I was just reminded of the old times seeing San kneel down for the sake of his Office juniors. He never changes, huh?",
        ],
    },
    {
        ID: "220004",
        Name: "Walter’s Page",
        Level: "Urban Legend",
        Source: "Zwei Association South Section 6",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [3, 5],
        HP: 63,
        StaggerHP: 29,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [-2, -2],
        Skin: "Walter",
        Passive: [
            "10",
            "10001",
            "220004",
        ],
        Desc: [
            "The Associations handle requests often made for Fixers such as security, combat, assassination, intel, patenting, and trades. When there is money, there are Associations. The Associations follow the demand, not the other way around. Demand equals requests, and requests equals profit.",
            "It may seem too materialistic to you, but seeing how the Associations work, you’ll have to agree that money is their prime objective. For instance, the Associations sort and classify every single notable event in the City. Urban Myths, Urban Legends, Urban Plagues, Urban Nightmares, and Stars of the City… Risk is not what determines their grade. The only question that matters is how much people are willing to pay to have the threat eliminated.",
        ],
    },
    {
        ID: "220005",
        Name: "Mika’s Page",
        Level: "Urban Legend",
        Source: "Molar Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 57,
        StaggerHP: 29,
        SResist: [-2, -1],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Mika",
        Passive: [
            "9",
            "220005",
        ],
        Desc: [
            "Every useful workshop technology is patented. The City strictly forbade making or selling products using technology patented by another workshop without purchasing the rights to it. If anyone infringes this regulation and still uses technology they shouldn’t have access to… They will receive a cease and desist letter up to three times. When you receive the warning, you must pay all profit you’ve earned through the infringement to A Corp. as a fine. Why A Corp. out of all places? Because that’s the corporate in charge of managing and granting all patents. It’s the Head we’re talking about. In any case, if you can’t pay the penalty by the third warning… The Claw will tear you down.",
            "To tell you the truth… Yes. I’m the daughter of a small workshop owner. My father dreamed to make his little brand famous one day. Its name was… Sorry, I don’t feel like saying it out loud. It’s long gone, so you’ll get nothing even if you look for it. That’s right. As I explained moments ago… If you can’t spit out the money you illegitimately earned from manufacturing or selling products using stolen technology, punishment awaits. W-wait, please listen to my story to the end. My father was a victim of fraud. His friend gave him a technology and asked him to make weapons for his Office out of it, so he made them per his request. He didn’t even realize that the technology was stolen from someone else. He’d already sent the weapons to the Office, and when he was waiting for his friend to test them out and transfer the payment, a cease and desist was sent. …You can guess the rest of this story.",
        ],
    },
    {
        ID: "220006",
        Name: "Olga’s Page",
        Level: "Urban Legend",
        Source: "Molar Office",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 5],
        HP: 67,
        StaggerHP: 32,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Olga",
        Passive: [
            "11",
            "10001",
            "220006",
        ],
        Desc: [
            "Myo and I are old friends. I honestly don’t ‘member how our first meeting went, other than being Backstreets buddies, but eh… That just goes to show how long our friendship’s been, don’t it? We’ve done requests together, been in life or death situations together. We’d been too busy to contact each other often ever since I moved to this Office, but then Myo called me out for a date one day.",
            "Maybe it was because I got to drink with my old friend after a long while, or maybe it was the honor of having a seat with the famous captain of the Rabbit Team, but I was in a mighty good mood. I was taking swig after swig of booze… Rain would’ve scolded me for sure if I went back drunk as a broom, I felt that… But that happens all the time anyway, so I didn’t care much. “How’s it going?” “So-so, how about you?” “Same as you, lass.” After some meaningless chatters, Myo gasped like she remembered something and started skimming through her fanny pack. Then she shot me a stealthy look.",
            "“Psst, Olga. Come closer. We don’t want anyone peeping at us, so stick right next to me. And stay quiet!”",
            "“You’re the noisiest one here and you already stick out like a sore thumb, so just say it already.”",
            "“You’re not a woman of style, are you. It’s more fun to talk like we’re secret agents exchanging confidential info when we’re discussing topics like this! It’s stylish that way. Forget it, R Corp. has been investigating something of late. It’s…”",
            "“Are you giving work to our Office? Or are you just bragging. By the way, I guess it’s pretty serious if R Corp. is paying attention to whatever that is, just how big is it? Oh, I heard people’s been going missing lately… Does it have anything to do with that? Or…”",
            "“Shut up and listen for a sec! You always have too much to say… Here’s the deal, Olga; I’ve got a lush grassland to show you, so graze it to your heart’s content and bring some of its veggies for me. How’s it sound?”",
            "Some words she chose. I clicked me tongue and took a close look at the black card and WARP train tickets Myo pushed to my side, before drinking off my glass and agreeing to give it a go. I wouldn’t have taken it if I’d known it’d bring us to this complete lunacy.",
        ],
    },
    {
        ID: "220007",
        Name: "Rain’s Page",
        Level: "Urban Legend",
        Source: "Molar Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 57,
        StaggerHP: 29,
        SResist: [0, 1],
        PResist: [-1, -2],
        BResist: [0, 0],
        Skin: "Rain",
        Passive: [
            "9",
            "220007",
        ],
        Desc: [
            "When an Office accepts a request, an official deed of contract must be drawn up before the case can be dealt with. It sounds big, but it’s basically just a mutual promise; I think it’s “consideration” in legal terms. The client will pay a certain amount of money as reward, and the Fixers will do their best to resolve the case… They’re plain and natural clauses for the most part. It seems people in this City are prone to breaking promises as simple as those without a contract to bind them, though. In any case, contracts serve as physical evidence to prove our performance and secure our payment when we submit reports to the Association. Without a contract, there’s no assurance that we’ll score a record for our career or get our due payment. To give you an example, Big Sis resolved a huge case the other day, but we got absolutely nothing out of it because she forgot to sign a contract for it.",
            "Requests made by Wings are quite different from those assigned by the Associations in several aspects. You’ll be made the envy of everyone once you get a request from a Wing. First of all, a Wing commissioning a regular Office indicates that the Office has been recognized to be worthy of its trust, and that alone can be a significant achievement. You’ll have something to brag about to other Fixers… And the payment is big as well. A single request from a Wing resolved can keep us afloat for three months minimum. If I must be honest, however, I am rather… unnerved. As rewarding as work given by Wings can be, there’s significant risk associated with it. Imagine how dangerous and difficult this mission may be if R Corp, a Wing specializing in combat, requested us to resolve it for them. Big Sis happily accepted the job, though I still can’t help but be worried a little. Still… I hope it goes well.",
        ],
    },
    {
        ID: "220008",
        Name: "Gyeong-mi’s Page",
        Level: "Urban Legend",
        Source: "Stray Dogs",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 5],
        HP: 64,
        StaggerHP: 32,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [0, 1],
        Skin: "Gyeong-mi",
        Passive: [
            "10",
            "10001",
            "220008",
        ],
        Desc: [
            "Some fools laugh at these accessories I’m wearing. They think I’m a glossy punk trying to look cool, figged out with random ornaments without a second thought. What they don’t know is that these ain’t just for fashion. They’re good for making arrogant idiots let their guard down, but before that, they’re workshop products with real, practical uses.",
            "You heard about how people use belts to choke others, didn’t ya? These accessories are similar to that. They’re useful for beating someone to death, though I gotta take the risk that comes from using ‘em. Expensive gadgets crafted by premium workshops have almost zero side effects. On the other hand, this ring for example lets me deliver a harder blow with my punches, but it chafes the skin of my hand at the same time. This one’s on me for using it for too long, and I hear quality products usually get regular repairs and maintenance to prevent that… The side effects on my gear’s pretty minor and negligible, but in worse cases, you get some poor sod whose neck got snapped by the necklace they were wearing.",
        ],
    },
    {
        ID: "220009",
        Name: "Dino’s Page",
        Level: "Urban Legend",
        Source: "Stray Dogs",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 57,
        StaggerHP: 29,
        SResist: [-2, -1],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Dino",
        Passive: [
            "9",
            "220009",
        ],
        Desc: [
            "Tattoos are the cleanest type of augment procedure you could get. I only got it ‘cause Gyeong-mi pushed me to give it a shot… I’m pretty satisfied with the result. It doesn’t cost an awful lot, and it looks pretty damn nice, too. Weakass wimps run away at the sight of my tattoo. But you see, coolness isn’t the only notable feature of these tattoos.",
            "There’s tons of tattoo types depending on the quality of the ink and the material used, but generally speaking, you can have results like bursts of strength or skin as hard as steel. It used to be a Singularity, but ever since the Wing owning the tech got snapped and its patent expired, everyone and their mother’s been using it. Don’t get tattoos that are too cheap, though. You might wake up to find melted flesh. You get exactly what you pay for in this City. Bastards are only honest when money’s involved.",
        ],
    },
    {
        ID: "220010",
        Name: "Zulu’s Page",
        Level: "Urban Legend",
        Source: "Stray Dogs",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 57,
        StaggerHP: 29,
        SResist: [0, 0],
        PResist: [-2, -1],
        BResist: [1, 0],
        Skin: "Zulu",
        Passive: [
            "9",
            "220010",
        ],
        Desc: [
            "Even if you make your way up to the big leagues and become a decently influential Syndicate, there’s still loads of stronger gangs above ya, and they peck at you all the same. No matter how far a Syndicate climbs and tries, you just can’t surpass the Five Fingers at the top. Syndicates ain’t too different from Fixers in that you have to repeat the same, stupid shit following orders from above. So in my opinion, holding onto your place seems wiser than trying to climb up out of ambition or greed. Unless you’re at rock bottom, of course. Someone’s gotta be below us to serve as a punching bag, ain’t that right?",
        ],
    },
    {
        ID: "221001",
        Name: "A Zwei Fixer’s Page",
        Level: "Urban Legend",
        Source: "Zwei Association South Section 6",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 53,
        StaggerHP: 29,
        SResist: [0, 0],
        PResist: [-2, -1],
        BResist: [1, 0],
        Skin: "ZweiUnit1",
        Passive: [
            "9",
            "221001",
        ],
        Desc: [
            "Is there a person or a group dedicated to stopping violence or murder in the Backstreets? Not quite. You’re on your own, unless you have the money to hire Fixers. Protection isn’t some volunteer service you can get for free. Fixers risk their lives for it, it’ll take our lives’ worth of money to get motivated to work. We aren’t robots. If you’re so afraid, why don’t you hire Fixers or move to a Nest. You’re free from all outside threats when you live in a Nest. Unless the Nest falls, of course.",
            "Zwei Association is your shield. We protect you, your family, and your home from Syndicates of the Backstreets or crazed murderers. If you have the wealth to make a direct request to the Association, that is. Without due payment, the Association will not move.",
            "Do you believe our request fee is too expensive, and you would rather request a Syndicate? Hmm… While making a request to a Syndicate is an option… We don’t recommend it. The reason is obvious. No organization in the City that operates without abiding formal procedures can be trusted.",
            "Associate Fixers are classified into multiple levels, too. From Section 1, which is the apex, to Section 6, the bottom… There’s a world of difference in the salaries and treatment they get. I guess that’s because they’re much more experienced than us… If I keep trying hard, then maybe I’ll be able to join Section 5 someday!",
            "It’s not an easy feat to get out of Section 6, of course…. It takes a huge effort, or perhaps something that can’t be accomplished with effort alone. I’m a fresh member here, so there’s still a lot for me to learn… Still, I’m gonna pick up experience as I resolve the missions assigned to me, and I’ll probably figure out what to do in time.",
            "The Zwei tends to be more defensive than other Associations or Offices. Our main purpose is not to fight and win, but rather to ensure the safety of our clients. We don’t perpetrate unnecessary killings in our duty of protecting people.",
            "Thus, if you’re looking to make a request for someone’s death, we recommend seeking other Associations for it.",
        ],
    },
    {
        ID: "221005",
        Name: "A Stray Dog’s Page",
        Level: "Urban Legend",
        Source: "Stray Dogs",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 53,
        StaggerHP: 29,
        SResist: [-1, 0],
        PResist: [0, -1],
        BResist: [0, 0],
        Skin: "StrayDogs_1",
        Passive: [
            "9",
            "221005",
        ],
        Desc: [
            "It’s true that our Syndicate’s sorta intimidating and got a tight hierarchy goin’ on, but the bond between members is strong. We’re actually leagues nicer than those Office fucks who exploit and abandon each other with every breath. Those crooked bastards’ll do anything for profit. I’m sometimes in awe of the shit they pull.",
            "I actually used to be a Rat. Yeah, those filthy and wretched Rats everyone looks down upon. It’s amazing that I’m now standing shoulder to shoulder with the Dogs, ain’t it? I busted my ass crawling up the ladder. I did everything in my power. Got a small tattoo with the little cash I had, and rummaged through trash to find worn but still usable accessories.",
            "It was a damn tough climb, but now that I’m up here, I’m starting to feel like it might’ve been better off to just live as a Rat. Here, a strict barking order’s set up between members. It’s nothing like the Rats who move in close packs.",
            "Sometimes… I do miss my old family.",
        ],
    },
    {
        ID: "221006",
        Name: "A Stray Dog’s Page",
        Level: "Urban Legend",
        Source: "Stray Dogs",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 53,
        StaggerHP: 29,
        SResist: [-1, 0],
        PResist: [0, -1],
        BResist: [0, 0],
        Skin: "StrayDogs_1",
        Passive: [
            "9",
            "221006",
        ],
        Desc: [
            "It’s true that our Syndicate’s sorta intimidating and got a tight hierarchy goin’ on, but the bond between members is strong. We’re actually leagues nicer than those Office fucks who exploit and abandon each other with every breath. Those crooked bastards’ll do anything for profit. I’m sometimes in awe of the shit they pull.",
            "I actually used to be a Rat. Yeah, those filthy and wretched Rats everyone looks down upon. It’s amazing that I’m now standing shoulder to shoulder with the Dogs, ain’t it? I busted my ass crawling up the ladder. I did everything in my power. Got a small tattoo with the little cash I had, and rummaged through trash to find worn but still usable accessories.",
            "It was a damn tough climb, but now that I’m up here, I’m starting to feel like it might’ve been better off to just live as a Rat. Here, a strict barking order’s set up between members. It’s nothing like the Rats who move in close packs.",
            "Sometimes… I do miss my old family.",
        ],
    },
    {
        ID: "221007",
        Name: "A Grade 8 Fixer, Page 1",
        Level: "Urban Legend",
        Source: "Grade 8 Fixers",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 53,
        StaggerHP: 29,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [-2, -1],
        Skin: "NewStaff_1",
        Passive: [
            "9",
            "221007",
        ],
        Desc: [
            "All people and firms generating income in this City must pay their taxes. In addition to the fund for work-related expenses such as maintenance of equipment and monthly rent for Office space, which is already a lot, Fixers must accommodate for rather heavy taxes as well. I became a Fixer trying not to starve, but the taxes have put me in an even tougher hardship… Ordinary people have a hard time bearing this pressure, but what can I do… In the City, orders are to be followed.  We all know what happens if we don’t abide by them…",
        ],
    },
    {
        ID: "221008",
        Name: "A Grade 8 Fixer, Page 2",
        Level: "Urban Legend",
        Source: "Grade 8 Fixers",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 53,
        StaggerHP: 29,
        SResist: [-2, -1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "NewStaff_2",
        Passive: [
            "9",
            "221007",
        ],
        Desc: [
            "All people and firms generating income in this City must pay their taxes. In addition to the fund for work-related expenses such as maintenance of equipment and monthly rent for Office space, which is already a lot, Fixers must accommodate for rather heavy taxes as well. I became a Fixer trying not to starve, but the taxes have put me in an even tougher hardship… Ordinary people have a hard time bearing this pressure, but what can I do… In the City, orders are to be followed.  We all know what happens if we don’t abide by them…",
        ],
    },
    {
        ID: "221009",
        Name: "A Grade 8 Fixer, Page 3",
        Level: "Urban Legend",
        Source: "Grade 8 Fixers",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 63,
        StaggerHP: 29,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [-2, -2],
        Skin: "NewStaff_3",
        Passive: [
            "9",
            "221009",
        ],
        Desc: [
            "For one to start working as a Fixer, they must acquire a license issued by the ‘Hana Association’, the first Association in the order. The set of skills required to get a Fixer’s license is quite different from those needed to pass Wing entrance exams. One is about physical fitness while the other is more about mental prowess, so to speak. There are exceptions, of course, but this is generally the case.",
            "After acquiring the license, the Fixer must join an ‘Office’. After all, it’s nigh impossible for a no-name Fixer to take jobs on their own. Choosing the right Office is also important, but you can worry about that later. Only the skilled ones can afford to make choices, like decline offers from Offices or ask to be transferred to another. Newcomers who’ve only just become Fixers or incompetent planks who can’t handle their work properly should be content with any Office that accepts them.",
        ],
    },
    {
        ID: "221010",
        Name: "A Grade 7 Fixer, Page 1",
        Level: "Urban Legend",
        Source: "Grade 7 Fixers",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 53,
        StaggerHP: 29,
        SResist: [-1, -2],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "3rdFixer_1",
        Passive: [
            "9",
            "221010",
        ],
        Desc: [
            "Really, does being a Fixer sound cool to you? I suppose it seems nicer than the likes of Rats swarming about in the Backstreets. It does have a professional charm to it, too. But this is a tough job, I tell you. It might be better for you to try and enter a small company to do desk work instead. If you really believe that Fixers are cool… then let me tell you something.",
            "Fixers have to risk their lives at every moment. I know, it sounds silly. Everyone already struggles and fights for their life, so what’s so special about us. But, at least, you won’t have to hear of your friend’s death while you’re having lunch. You pack your favorite food, savor its taste, and when you’re about to swallow it… Know how it feels to choke on it? Your friend’s head suddenly rolls over to your feet. Things… just happen like that. Syndicate grunts rush into your Office all of a sudden, heads are blown off, and a gruesome fight breaks out. It’s the so-called ‘Office raid’.",
            "Are you still not convinced? Syndicate or Fixer, once you set foot in this business, all the things will bind you like shackles, slowly dragging you to the bottom. The sheer weight is going to tire you, and you’d no longer be willing to go back up… Go back and think again carefully. It’s not too late for you to make the right choice.",
        ],
    },
    {
        ID: "221011",
        Name: "A Grade 7 Fixer, Page 2",
        Level: "Urban Legend",
        Source: "Grade 7 Fixers",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 53,
        StaggerHP: 29,
        SResist: [0, 0],
        PResist: [-1, -2],
        BResist: [0, 0],
        Skin: "3rdFixer_2",
        Passive: [
            "9",
            "221010",
        ],
        Desc: [
            "Really, does being a Fixer sound cool to you? I suppose it seems nicer than the likes of Rats swarming about in the Backstreets. It does have a professional charm to it, too. But this is a tough job, I tell you. It might be better for you to try and enter a small company to do desk work instead. If you really believe that Fixers are cool… then let me tell you something.",
            "Fixers have to risk their lives at every moment. I know, it sounds silly. Everyone already struggles and fights for their life, so what’s so special about us. But, at least, you won’t have to hear of your friend’s death while you’re having lunch. You pack your favorite food, savor its taste, and when you’re about to swallow it… Know how it feels to choke on it? Your friend’s head suddenly rolls over to your feet. Things… just happen like that. Syndicate grunts rush into your Office all of a sudden, heads are blown off, and a gruesome fight breaks out. It’s the so-called ‘Office raid’.",
            "Are you still not convinced? Syndicate or Fixer, once you set foot in this business, all the things will bind you like shackles, slowly dragging you to the bottom. The sheer weight is going to tire you, and you’d no longer be willing to go back up… Go back and think again carefully. It’s not too late for you to make the right choice.",
        ],
    },
    {
        ID: "221012",
        Name: "A Grade 7 Fixer, Page 3",
        Level: "Urban Legend",
        Source: "Grade 7 Fixers",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [3, 5],
        HP: 63,
        StaggerHP: 29,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "3rdFixer_3",
        Passive: [
            "9",
            "221012",
        ],
        Desc: [
            "Who said a Fixer is a free man? Must’ve been some no-good showoff who told you that… Kid, that’s just our dream and nothing more. Fixers are managed by Offices. Most of our jobs come from the requests the Offices get, so we’re virtually out of work without them. And Offices are managed by the twelve Associations. And on top of those twelve is the Hana Association. Our lives are subordinate to layer upon layer of hierarchy. I’d love to hear where that supposed freedom is according to them, because I don’t see it.",
            "Ah, there’s one way to achieve that pipe dream. A Fixer’s freedom is only truly complete when they are given a color from the Hana Association. Don’t go around proclaiming that you’ll become one of the ‘Colors’, though. You think it’s that easy to break free from these massive fetters?",
        ],
    },
    {
        ID: "221013",
        Name: "An Axe Gang Member, Page 1",
        Level: "Urban Legend",
        Source: "Axe Gang",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 53,
        StaggerHP: 29,
        SResist: [0, 0],
        PResist: [-1, -2],
        BResist: [0, 0],
        Skin: "AxeGroup1",
        Passive: [
            "9",
            "221013",
        ],
        Desc: [
            "Our Syndicate’s well acquainted with the guys at Hook Office~ We used to chop n’ rip n’ tear together before they moved on to Fixer business… We were the best buddies, the two Syndicates had a wonderful time with each other. We still do help ‘em out sometimes nowadays. Hm? You thought Fixers and Syndicates were enemies for life? Well… You could say it’s a longstanding love-hate relationship. Usually, a Syndicate causes a scene and Fixers come over to take care of it. But think about it for a sec. If Syndicates didn’t exist, more than half of all Offices would be out of jobs, essentially unemployed, ya get it? It’s a symbiotic relationship right there~! So don’t be so cold to us.",
            "And some Fixers often cooperate with Syndicates to handle cases. Y’know, it’s not like dogs and cats constantly fight each other when they’re together, yeah? That sorta logic. We Syndicates do the things Fixers can’t dare take care of. I heard some Offices straight up ban killing people, even. Something about life being precious and whatevs. It’s bullcrap. Anyway, that’s how Syndicates and Fixers complement each other. There’s some crooks you’d want dead for sure before they could complicate things, you see?",
            "Man~ Talking about ‘em makes me miss my ol’ friends. Don’t get to meet those pals often these days… I might as well storm Hook Office this time around, see some familiar faces~",
        ],
    },
    {
        ID: "221014",
        Name: "An Axe Gang Member, Page 2",
        Level: "Urban Legend",
        Source: "Axe Gang",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [4, 5],
        HP: 63,
        StaggerHP: 29,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [0, 0],
        Skin: "AxeGroup2",
        Passive: [
            "9",
            "221014",
        ],
        Desc: [
            "If you think Syndicates are nothing more than gangs of ugly and bad guys, then let me tell ya that’s an outdated bias. Course, we’re freer than Fixers who have to follow orders and requests from Associations. A lot of us kill people and do some wicked shit for the sake of cash, I’ll give you that… But others aren’t too different from your average Fixers, I’m tellin’ ya! We get requests and solve problems. Though, our group’s moral compass is tilted a bit to the dark side, so I can’t give you a good example myself…",
            "Right! Some Syndicates actually do heroic stuff. Syndicates hunting Syndicates. I asked ‘em, “Hell man, why aren’t you guys just becoming Fixers instead?”, and they said… They don’t really feel like it, since they don’t really wanna get entangled in formal stuff and there’s just too much to prepare to get a license and everything. Welp, who’s to say Syndicates can’t be the good guys, right? We’re living as we like in the Backstreets.",
        ],
    },
    {
        ID: "230001",
        Name: "The Carnival’s Page",
        Level: "Urban Plague",
        Source: "The Carnival",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 64,
        StaggerHP: 34,
        SResist: [-2, -2],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Carnival_Librarian",
        Passive: [
            "10",
            "230001",
        ],
        Desc: [
            "There are many important things to consider as a Fixer, and attire is one of them. A Fixer’s attire is the most effective way to signify the image of an Office. It’s important for an Office to show that it has formality and class; most Offices have set a dress code for that reason.",
            "As much as it’s necessary to choose the right attire according to the code, the most important factor is the fabric that clothing is made of. Quality fabric can offer better protection, lighten the wearer’s weight for quicker movement, or allow the wearer to carry heavy weapons as large as their body. Those who create and provide such fabric are called ‘Tailors’.",
            "We are Tailors who consume people and make silk out of them. Whether it’s melting people inside our belly and congealing them in a mold, or it’s unraveling humans into the thread they’re really made of, the fundamentals do not matter. This technology doesn’t originally belong to us. We merely took hold of a technology that came off patent when a Wing was broken. The only thing that matters is that silk made from humans has strength that differentiates it from ordinary thread. Only those who crave it visit us.",
            "Cloth weaved from human silk possesses various powers depending on the human’s strengths. Some humans may have a strong body, another may be fragile but wise, and yet another may flaunt incredible speed. Since the silk reflects the characteristics of the human it was made from, there are as many forms and powers of cloth as there are humans in this world. Therefore, there is more to being a Tailor than simply weaving silk carefully. Picking the right people to meet the demands of the client is the most important. Hastily making silk out of a human that looks courageous on the outside might end up yielding useless cloth that does nothing but bolster courage, so one must be careful with picking the right material.",
            "Not every piece of fabric is accessible, however. It takes more than cash to purchase high-class fabric; one must earn the favor of Tailors first and foremost. Many Tailors will only give their best fabric once the trust between them and their client has been established after complex turns of events.",
            "Because of that, Tailors who make high-quality fabric usually belong to an organization and create cloth exclusively for them. But we were different. Until the Index gave us a Prescript, we did our work without taking orders from anyone, unchained to any Syndicate or other organization. We were free, as some may call it.",
            "L8372-#928: ‘Eat 15 Sweepers and extract silk from them to make fabric.’",
        ],
    },
    {
        ID: "230004",
        Name: "Liwei’s Page",
        Level: "Urban Plague",
        Source: "Full-Stop Office",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [1, 5],
        HP: 64,
        StaggerHP: 34,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [0, 0],
        Skin: "Liwei",
        Passive: [
            "10",
            "230004",
        ],
        Desc: [
            "A color is the dream and lifetime goal of all Fixers who wish for freedom. Those who have been assigned a color are called the ‘Colors’; a Color is the pride of the Fixer and the Associations. They put forward the Colors as great and successful people that other Fixers will look up to. They dream of earning wealth and fame, and to be free like them one day.",
            "Colors are assigned by the ‘Hana Association’. They’re bundled into such a category because the Hana deemed them to be the most ideal Fixers. Because they’re the most adequate individuals to deal with the ‘Stars of the City’. The title of a Color is forcibly given to Fixers who qualify, essentially. Can a Fixer be truly happy with freedom that was forcefully handed to them?",
            "Why ‘Colors’ of all terms when there are many other stylish words to choose from? I have no comment to make, since I don’t know the reason myself. My assumption is that colors are used because giving people hues representative of them makes it easier to refer to and remember them by. It may not be the answer you were expecting, but it can’t be helped; the Colors have their own ways of working, and they have basically nothing in common. It’s akin to how visible colors have their own vibrant characteristics. In that sense, the term ‘Colors’ isn’t entirely off-putting.",
        ],
    },
    {
        ID: "230005",
        Name: "Stephan’s Page",
        Level: "Urban Plague",
        Source: "Full-Stop Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [1, 5],
        HP: 64,
        StaggerHP: 34,
        SResist: [0, -2],
        PResist: [0, 0],
        BResist: [0, -2],
        Skin: "Stephan",
        Passive: [
            "10",
            "230005",
        ],
        Desc: [
            "Few Fixers use guns for self-defense. Bullets cost an arm and a leg, and foes who are relatively powerful tend to dodge shots like it’s nothing, and I can barely graze ‘em… There’s not a lot of ways to react to enemies closing in, either. You’d have to be quick on the draw and shoot them in the weak spots; if you aren’t, the other options are running away or grabbing some prop to guard yourself… Like hell that’ll save you. It takes several augmentation procedures to be able to carry something as heavy as a firearm and run fast enough. If you’re a sniper, you’ll be busy packing up your weapon mount n’ everything; have to make unnecessarily big movements. And what if the precious gun gets damaged if you try blocking your foe’s attack with it? Oh, I was talking about the kinds of guns me and Tamaki use, not firearms in general. You see what Liwei’s carrying? I heard there are lighter rifles, and some that come with bayonets for close-quarters combat… But mind you, those guns have their fair share of downsides, so don’t be too quick to buy them. You might as well save the money and get a quality workshop weapon or an augmentation surgery instead. Hell, you could probably buy a fine weapon with the money it takes to buy bullets for target practice. You weren’t planning on using guns in actual fights without even practicing, were you? I mean, go ahead, if you really want dislocated shoulders and severed fingers.",
            "Despite all this, there still are workshops that manufacture guns and people like us who use them. Guns are just that comfortable to use. Those heavy taxes won’t be a problem as long as use your gun for its intended purpose. How many defenseless thugs standing in the middle of the street can notice a bullet flying toward them? Of course, it’d be even better to get specially made workshop devices that use a special technology to muffle the sound of gunfire, but… Don’t expect too much. There’s currently no technology in our world that can completely cancel out noise, and it won’t exist in the foreseeable future. You don’t need that to make guns work, though. All it takes is an advantageous situation.",
        ],
    },
    {
        ID: "230006",
        Name: "Tamaki’s Page",
        Level: "Urban Plague",
        Source: "Full-Stop Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [1, 5],
        HP: 64,
        StaggerHP: 34,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [-2, -2],
        Skin: "Tamaki",
        Passive: [
            "10",
            "230006",
        ],
        Desc: [
            "There aren’t many workshops that can craft guns. Setting aside the low demand, the difficulty of acquiring a firearms manufacturing license and the Head’s strict guidelines are the biggest limitations. The guidelines include clauses such as: “The maximum length of the gun barrel must be shorter the higher the gun’s caliber is”, “No gun should possess the firepower to penetrate steel or building walls”, “A gunfire sound must be audible”, and I haven’t even started with the “bad” ones yet. The first page of the guideline boldly states: “Do not research or imagine technology that infringes the firearm manufacturing guidelines, as provided by the Head along with the license.” I’m not a gunsmith myself, so I don’t know the details, and I frankly don’t want to know any more than that. There certainly are workshops permitted to make S-class firearms, but I’m guessing only three to five of them exist in the entire City. Who do they take requests from, where they are, and what kind of people run them… They’re all a mystery. The most I could hear was a rumor that an S-class workshop exists somewhere.",
            "People say that the Head put heavy restrictions on firearms because they don’t want its denizens to be harmed too easily. It’s true that a gun can effortlessly kill a person with one well-placed shot. That’s not all; the assailant doesn’t have to show themselves to attack and a flying bullet is simply too fast for the average person to track with their eyes, making it a fine weapon for stealthily killing others. But making it harder to kill people doesn’t seem good enough a reason to impose such restrictions. What about the countless other trifling and useless methods that exist to kill people? I just cannot understand that they would see this as a solely philosophical issue. Are you asking if it’s because the Wings don’t have sufficient technical expertise? I’m not here for senseless chatter. The Wings could easily make superior weapons with their technology, there’s no real reason they couldn’t improve upon the current designs.",
            "There are probably some people who feel the same as me. They don’t question it further or try to dig deeper into the truth, because… Well, they have their hands full with making their ends meet, and they don’t want to risk losing it all meddling in business secrets, I suppose.",
        ],
    },
    {
        ID: "230007",
        Name: "Salvador’s Page",
        Level: "Urban Plague",
        Source: "Dawn Office",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 76,
        StaggerHP: 37,
        SResist: [1, 0],
        PResist: [0, 1],
        BResist: [0, 0],
        Skin: "Salvador",
        Passive: [
            "12",
            "10001",
            "230007",
            "230107",
            "230207",
        ],
        Desc: [
            "Case Name: ‘Thousand Needles’",
            "Serial Code: DN-00113",
            "Grade: Urban Legend",
            "Date of Occurrence: XXXX/XX/21",
            "Description: This document is a compilation of relevant information on the case of the Thousand Needles, which occurred in the Backstreets of District 22. While a clear conclusion on this case has yet to be made, it is speculated to be a case of the Distortion based on the apparent inability to confirm the cause or analyze the composition.",
            "Case Report: Entity A-01, the first apparent source of the incident, was wandering the Backstreets of District 22 before swelling up and exploding. Numerous needles were dispersed upon the explosion, flying in all directions. The needles which stuck onto building walls caused the site of impact to melt and crack; when a human was struck with one of the needles, they were transformed into A-02, going through the same bizarre process of detonation A-01 did. The orange symbol on the nape of A-01’s neck was also found on the needles discharged from its body. When I arrived at the scene after taking the request, the bits of flesh scattered around the streets began to merge into one giant body using a brainstem focus resonator, becoming a 3-meter-tall (~10ft) mass that I will refer to as A-03. A-03 began throwing large needles, the length of which varied from 1 to 3 meters. Unlike the small needles fired from the explosion of A-01 or A-02 that could only leave small dents on building structures, the giant needles flung by A-03 caused buildings to helplessly melt. In addition, local residents who stared into the entity’s eyes or holes in its body soon produced a boiling sound before turning into A-02, so I had to forbid people from observing it closely.",
            "A-01 visited OO Office to give a request four days prior to the incident. (Refer to &lt;Audio Transcript of Testimony from a Fixer of OO Office&gt;) Judging by what they said, such as “Made a deal with the devil”, and “Terrible things will happen if I break the contract”, it is speculated that ‘Yesterday's Promise’ is behind the incident.",
            "",
            "Audio Transcript of Testimony from a Fixer of OO Office",
            "File Name: #S-0012-XXXX/XX/23",
            "I’m fine. Can I just talk like this? ……Oh, okay. Got it. When was it… A person visited our Office last Wednesday, if my memory serves me right. They introduced themself as an ordinary resident of the Backstreets of District 22, and said they urgently needed help. There were huge bags under their eyes, and their hair was a tangled mess. Their eyes were lifeless and blurry, and there was some sort of symbol on their neck, as if they’d been attacked by a Stigma Workshop product… The desperation was palpable. They couldn’t even walk straight, and they were straining to approach me with their awkward steps. I managed to calm them down, and they said… I’m sorry. I’m not sure how I should explain it… In short, they made a contract with a devilish person of some kind, and they’re scared that they might break the contract, so they were now asking us to take care of the devil so it can’t kill them as punishment. I still don’t get what that was about, even though I’m talking about it. To be frank… I just couldn’t understand what they were saying. Not just because their level of knowledge and manner of speech was lamentably inferior, no. All they uttered was a series of simple words, but the splendid images delivered in those hysteric words they let out like they were possessed by something, I can’t dare try to describe them… They kept saying confusing things like ‘Will skewer people's heads and make a necklace out of them to offer to it.’ ‘They keep getting closer. They're multiplying in numbers. They're approaching from inside me.’ All with a mysteriously bright glint in their eyes. Oh, our Office records counseling with our clients by principle. You’ll see how confusing the whole situation was if you give this file a listen. Don’t worry, we record them with the client’s consent and everything, so there’s nothing illegal about this. (Refer to &lt;Evidence 5-1: OO Office Counseling Audio Recording&gt;.) But what can I do, really. The whole deal with the devil thing just sounds too unrealistic. I honestly thought they were lying, so I made up an excuse to turn them away.",
        ],
    },
    {
        ID: "230008",
        Name: "Yuna’s Page",
        Level: "Urban Plague",
        Source: "Dawn Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 64,
        StaggerHP: 34,
        SResist: [-2, 0],
        PResist: [0, 1],
        BResist: [-2, 0],
        Skin: "Yuna",
        Passive: [
            "10",
            "230008",
            "230207",
        ],
        Desc: [
            "Audio Transcript of Testimony from District 22 Resident 1",
            "File Name: #S-0019-XXXX/XX/25",
            "(Omitted) I think it was last Monday. Dery said something strange to me. They told me they made a contract with someone and they’re scared that they might break it. They said they don’t know what horrifying penalty they’ll have to face upon breaking the contract. I tried to calm them down, saying they should be fine as long as they don’t actually breach the contract, but Dery got ticked off and complained that it’s unfair how they’re supposed to comply with unfavorable terms hidden in the fine print. Then they broke into tears, saying they’re doomed anyway. They apparently agreed to do three tasks in exchange for gaining power. (Omitted)",
            "",
            "Audio Transcript of Testimony from District 22 Resident 2",
            "File Name: #S-0021-XXXX/XX/25",
            "Do I have to recall that messed up memory…? …Alright. If it’s necessary to prevent another incident from happening… I guess there’s no choice. You can record it, sure. I don’t remember everything that happened, actually. That day was just like any other, except Dery showed up in the streets after going missing for a few days, looking awfully gaunt… Other than that, the weather was normal, and the streets were the same as always. I know, that’s when the incident started… Dery was walking the street as they mumbled something, but they didn’t seem to be heading to a specific destination. It’s like they were staring off into space and forcibly dragging their feet along. They said strange things like something… keeps coming, or boiling; they were always a bit of a weirdo, so that didn’t bother me too much. But then… Dery’s body began swelling up. All I could think at that moment was how funny they looked, expanded like a balloon. The scene was that unrealistic. Maybe it was the shock of confronting an unbelievable situation paralyzing the human brain, or the brain beginning to believe that it’s only a dream and marveling at the scene, but I was just standing still and staring at what was going on. “Am I really in reality?” But before I could gather myself up, the incident happened. Dery’s body blew up and weird needles went. Mrs. Madrid, who was standing in front of me, was struck with one of the needles. And her body swelled up and exploded into a shower of needles, just like Dery did. I luckily managed to get away without getting hit by any needles. I ran right to this Office without turning back once… And now… Now… I don’t think I can get back there. I wonder if anyone else lived… If my friend Mijin’s alright… If my house is fine… I’m curious, but I just can’t go back—I can’t do it… What do I do… I don’t wanna go back to… (The interviewee’s breath became coarse and unstable afterwards; the recording was suspended as it was deemed that the interview could no longer proceed.)",
        ],
    },
    {
        ID: "230010",
        Name: "Alloc’s Page",
        Level: "Urban Plague",
        Source: "Gaze Office",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 5],
        HP: 70,
        StaggerHP: 34,
        SResist: [-2, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Alloc",
        Passive: [
            "10",
            "230010",
        ],
        Desc: [
            "Cane Office is a notary public Office that officially administers various matters when a contract is made between two Offices. A notary public Office preserves evidence involved in contractual processes and certifies legal issues. Sometimes, the Office may play the role of a broker.",
            "When you work with Cane Office, the process you have to follow will usually be simple outside of a few special cases. All you need to do is make a summary of all the details for the deal you’re making and visit the Office. And don’t forget to take all the relevant documents with you: Notarial deed of promissory note, Migration permit for the Nest (or the Backstreets) of District OO, Deed of forward contract, and everything else related to the deal. If you safely finished your business with Cane Office, those documents will become powerful pieces of evidence that’ll protect you in case a dispute breaks out for whatever reason.",
        ],
    },
    {
        ID: "230011",
        Name: "Dalloc’s Page",
        Level: "Urban Plague",
        Source: "Gaze Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 64,
        StaggerHP: 34,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [-2, -2],
        Skin: "Dalloc",
        Passive: [
            "10",
            "230011",
        ],
        Desc: [
            "The Nest is a home where birds brood their eggs. They use their wings to devotedly protect their eggs from outside threat. Such is the role of the Nests and Wings that constitute the City. Do the eggs represent people inhabiting the Nest, then? Not a chance. These “eggs” are the treasures that Wings possess. Singularities, technologies that make money, featured in countless patents. Its residents are nothing more than feathers of the Wings that serve to protect the eggs. A Wing will end up falling when it loses too many of its feathers, but it won’t bother to desperately protect all of its feathers since a feather or two will naturally grow back. They’re basically expendables.",
            "The twenty-six Wings have their own subsets of culture. It might be the personal preference of the Wing’s founder or the influence of the Singularity, but the cultural styles and social atmosphere vary vastly between the Nests. The Wing’s policies also determine the culture of the Backstreets that belong to it. Each Wing has distinct sets of conducts; some Wings take a relatively cooperative approach to their Backstreets, while others thoroughly exploit them. But Wings will be Wings. “Cooperation” is just a fancy expression for “taking advantage of the Backstreets when the Wing needs them”. If you can’t afford to enter a Wing and have to live in the Backstreets, you’re best off settling in the District that suits you well. You’ll still need a home and source of income, of course.",
        ],
    },
    {
        ID: "230012",
        Name: "Bono’s Page",
        Level: "Urban Plague",
        Source: "Gaze Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 64,
        StaggerHP: 34,
        SResist: [1, 0],
        PResist: [-2, -2],
        BResist: [0, 0],
        Skin: "Bono",
        Passive: [
            "10",
            "230012",
        ],
        Desc: [
            "People are hung up on money, but it’s not just because they want to be well off; the formidable tax burden is a big part of why. No matter how humble your job is, you’re still obliged to pay your duties if you earn money. It goes for every type of business transaction. Even Syndicates are no exception; anyone living in the City has to pay taxes. If you don’t meet the deadline, you’ll get a warning. For the first three offenses, you’ll get a notice of warning and no other penalty. But if you don’t pay your taxes for the fourth time? Then you’re dead meat. They’ll come for you. The Eye will seek out tax evaders by any means, and the person it sends will rip those poor cheats to shreds.",
        ],
    },
    {
        ID: "230018",
        Name: "Sayo’s Page",
        Level: "Urban Plague",
        Source: "Kurokumo Clan",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 5],
        HP: 70,
        StaggerHP: 34,
        SResist: [1, 0],
        PResist: [0, 1],
        BResist: [-2, 0],
        Skin: "Sayo",
        Passive: [
            "11",
            "10001",
            "230018",
            "230118",
            "231001",
        ],
        Desc: [
            "The Hand of the Backstreets is possibly the biggest reason no one dares to take care of the lawless land that is the Backstreets; no Associations or Wings can touch it, and not even the Head itself can easily interfere. The five Syndicates at the apex of the Backstreets are called the Thumb, the Index, the Middle, the Ring, and the Pinky, namely. They parcel out districts of the Backstreets and comprehensively manage their territories, and periodically hold meetings to efficiently control the Backstreets. They call this conference the “Finger Bow-Bell”; I’m uncertain as to whether this name is meant to suggest that they actually make pinky swears not to invade each other’s territories, or if they call it as such simply because the Fingers gather in one place… The mind of higher-ups is a mystery, truly. Going back to the topic, when the Finger Bow-Bell nears, all members of the five Fingers will try to avoid conflict and refrain from causing big problems. It’s thanks to the leaders of each Syndicate who caution their subordinates that fights between smaller Syndicates could grow into a massive conflict between the big ones, perhaps… If subsidiary Syndicates ran into trouble, the seniors at the Finger Bow-Bell would be faced with quite the embarrassment, now wouldn’t they?",
        ],
    },
    {
        ID: "230019",
        Name: "Yang’s Page",
        Level: "Urban Plague",
        Source: "Kurokumo Clan",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 64,
        StaggerHP: 34,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [-2, 0],
        Skin: "Yang",
        Passive: [
            "10",
            "230019",
            "231001",
        ],
        Desc: [
            "There are two kinds of folks who hang around in the Backstreets at night: the predator and the prey. Pretty much everything going on in the City can be described as ‘savage’, but the other parts of the City at least put up the effort to package them in gentlemanly guises. Even a cheap hamburger made from whatever unspeakable ingredients is still wrapped in a modern and rich packing, yeah? On the other hand, the Backstreets at night are filled with raw and blatant barbarity; not even a layer of crude cover is there to censor this brutality. No deed is forbidden… No one is held responsible. Imagining the most appalling, vulgar, and filthy deed you can think of. I won’t dare say “beyond your imagination” since I have no idea how insane you might be. But I can guarantee that whatever you’re thinking casually happens somewhere in the dark alleys of the Backstreets at night.",
            "Despite all that, people still inhabit the Backstreets. They doggedly struggle and survive in their own ways here.",
        ],
    },
    {
        ID: "230020",
        Name: "Gin’s Page",
        Level: "Urban Plague",
        Source: "Kurokumo Clan",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 64,
        StaggerHP: 34,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [-2, 0],
        Skin: "Gin",
        Passive: [
            "10",
            "230020",
            "231001",
        ],
        Desc: [
            "A fallen Nest no longer has an owner to protect its inhabitants. What happens to them, then? In the wreckage of the Nest that’s gradually turned into an environment similar to the Backstreets, all they can do is accept horrible deaths as Backstreets residents do or hire a Fixer… Or pay protection fees to one of the powerful Syndicates that enter the Nest and be under their care. Some move to a different Wing, but this is an exceptionally rare case. The Syndicate may charge ridiculously expensive fees, but they will keep you safe for sure once you pay them. (If an even stronger Syndicate comes in, drives off the others, and asks you to pay a protection fee… Then there’s no choice but to give your new protectors what they ask for.) They’ll protect you with their lives as long as you still have money to pay. The assets will become useless when you die anyhow, so you might as well spend it to extend your life for just a little longer. The former feathers don’t have a choice in this matter. If they don’t pay the fee, they’ll die or get kicked out. It would be a miracle to walk out unharmed.",
        ],
    },
    {
        ID: "231001",
        Name: "A Kurokumo Henchman’s Page",
        Level: "Urban Plague",
        Source: "Kurokumo Clan",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 62,
        StaggerHP: 32,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [-2, 0],
        Skin: "Kurokumo1",
        Passive: [
            "10",
            "231001",
        ],
        Desc: [
            "“You hear that news? We’re about to collide with Kingfishers again.”",
            "“Kingfishers? Don’t remember that name at all. Were they a real thing?”",
            "“You know, the Syndicate that’s been struggling with finance and feuds between members recently. They seemed to be getting back on their feet after raiding the Constellars, but it looks like that didn’t last long.”",
            "“They were irrelevant chumps, so I completely forgot about ‘em.”",
            "“The Knots seemed to be after them… Maybe they finally hit ‘em.”",
            "“Weaklings will get hounded.”",
            "“And now they’ve been trying to invade our territory, desperate to loot anything.”",
            "“Doesn’t matter. Their names wouldn’t be so unmemorable if they were any strong. Taking ‘em down shouldn’t be a problem.”",
            "“And the Fixers at Clam Office that were cooperating with them from the back are gone, too…”",
            "“Clam? What are they about?”",
        ],
    },
    {
        ID: "230021",
        Name: "Meow’s Page",
        Level: "Urban Plague",
        Source: "The Musicians of Bremen",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 5],
        HP: 70,
        StaggerHP: 34,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Meow",
        Passive: [
            "11",
            "10001",
            "230021",
            "230121",
        ],
        Desc: [
            "Heehaw, Doodle-doo, Woof… and me. The four of us were moved to the core by the Pianist’s performance. To recreate the performance half as splendid as what we heard that day, we formed the Musicians of Bremen to study the music. We tried flicking strings here and there… Playing music while sitting, on our backs, and even while handstanding! We still couldn’t come close to the Pianist’s level, but we managed to make our own brand of music, something that only the Musicians of Bremen can play. Our performance was actually pretty fantastic, you know?",
            "Sadly, our time didn’t last long. One day, a mysterious person approached us and asked us to join his ensemble and perform with him… Woof, Doodle-doo, and Heehaw took the offer and left with that guy. I had to stay because of new members that had just joined our band, though. Yep, MuMu and Oink. It’s kinda… uncomfortable to just leave them behind, you know? We can’t let them mess around and taint our name, either. I’ve been practicing with them to create a performance that could get a standing ovation once my old bandmates come back. But at their current level of skills, the three would just cluck at these newbies’ performance and go back to whatever they were doing.",
        ],
    },
    {
        ID: "230022",
        Name: "MuMu’s Page",
        Level: "Urban Plague",
        Source: "The Musicians of Bremen",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 64,
        StaggerHP: 34,
        SResist: [-2, -2],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Mumu",
        Passive: [
            "10",
            "230022",
            "230121",
        ],
        Desc: [
            "They say the Backstreets are a nigh-inhabitable hellscape, but the people here live on somehow. There’s lots of people who live in fear every moment, but… The others live a pretty normal life. Some think the Backstreets are totally shady and poorly aged slums… But we do have all the amenities we need here. For one, the supermarkets Oink likes aren’t as good as those in the Nest, but it’s got everything people need. Clothing stores, groceries, dry cleaners, etc… I heard the details are different for each District, so there’s that… I’m just telling you how things are where I live. People here aren’t too unkind to each other. Those Nest dwellers like to gossip about how we’re cruel and dreary and all that, but the truth is, we’re doing just fine.",
            "Oh, and there’s tons of good restaurants here. It’s the street of flavor, after all. Freshly baked meat pies, spaghetti made of special pasta… Your tongue and stomach have a wonderful time if you ever go on a trip to our District. We used to hand over the leftovers from our performance here to local restaurants. That meat would go to waste if we left it on the spot, so we might as well give it to the people who can make good use of it, ain’t that right? When Woof, Doodle-doo, and Heehaw were around, we got enough chow to share with several eateries, but our find was halved since they were gone… And Oink kept making silly mistakes with it and ruined those ingredients too often, so we quit that biz altogether. Which is a tad bit unfortunate~ We sometimes got tasty meals for free when we gave them our meat.",
        ],
    },
    {
        ID: "230023",
        Name: "Oink’s Page",
        Level: "Urban Plague",
        Source: "The Musicians of Bremen",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 64,
        StaggerHP: 34,
        SResist: [-2, -2],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Oink",
        Passive: [
            "10",
            "230023",
            "230121",
        ],
        Desc: [
            "The Seven Association is a Fixer Association specializing in investigation and intelligence, and it’s knowledgeable in pretty much every affair that takes place in the City. Details about a Syndicate gaining infamy in the Backstreets of some place (the Association probably knows what District it is exactly, but I left before I checked the details of it.), all the information revealed about the Distortion Phenomenon which has been going around lately, when and where Fixer Offices start up and close business, and the beat goes on… The Association treats all kinds of information about the City. Oh, they don’t have access to top-secret intels like the secrets of the Singularities each Nest holds, obviously speaking. When they solve cases, they usually cooperate with other Associations like the Shi and the Liu.",
            "If you ask how the Seven Association can secure its confidentiality despite holding lots of juicy info that could attract the many, it’s likely because its staff aren’t bad combatants by any means. They don’t use fancy but crude workshop weapons that are basically large amalgamations of various technologies. Regular informants are armed with nothing more than a simple bladed tool. It sounds very underwhelming judging from the weapon alone, but they use the minimum technique with pinpoint precision to take down their foes.",
        ],
    },
    {
        ID: "230024",
        Name: "Oscar’s Page",
        Level: "Urban Plague",
        Source: "Wedge Office",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 77,
        StaggerHP: 38,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Oscar",
        Passive: [
            "12",
            "10001",
            "230024",
            "230025",
            "230026",
            "230124",
        ],
        Desc: [
            "The 8 o’Clock Circus was a real sod of a case. Its leader wasn’t a particularly powerful enemy, but it took a long time to assess the strengths and behavior of each of his 'crew'. There was no specific pattern to it, and it was difficult to predict what would come next; it was akin to watching an erratic circus of lunacy. Their lair was mysterious and terrifyingly bleak, and the crew took hideous forms as well, looking too grotesque to possibly be considered normal living beings. They were as strong as they looked; when the blob shaped like a lion bit Pameli with its blunt teeth, her body quite literally blew up on the spot.",
            "However, our enemies were slowly brought down from the vantage point, and when they were completely cornered, the leader escaped along with a few of his crew. Even though we couldn’t put an end to the case, we decided to prioritize recovering Pameli’s body as we deemed the Circus would be weakened enough to stay low for a while. As we stored Pameli’s head in a stasis preservation case and headed to the exit of the collapsing circus tent, we ran into a group of Fixers. They seemed rather exhausted after fighting a swarm of the crew outside. I suppose that’s why they couldn’t enter the tent until that moment. It’s not uncommon for two or more Offices of Fixers to be present at the scene of a finished case, so I gently nodded to greet them, identifying ourselves as Fixers of Wedge Office who have come here to solve the case. The shortest person among them… The aged-looking woman who appeared to be the representative of that group looked around the circus tent, let out a deep sigh, and introduced herself as Moses—of Moses’ Office—while smoking from her pipe. Moses then started thinking, presumably ruminating over what words to choose. She must’ve taken a request that’s rather tricky to disclose. The two people behind her nervously exchanging glances with each other appeared to be her bodyguards of some sort. Having such trivial thoughts, I waited for this Moses person to resume speaking. After a brief period of silence, Moses breathed out smoke in the other direction and asked me where the leader of the Circus went. Since I didn’t know much better than them, I told them what I could in brief. They seemed troubled by my unhelpful answer, but they soon accepted it and left the scene.",
            "…That group reportedly appears every time a case of the Distortion is solved. They’re allegedly working as “The Distortion Detective”, but recent witnesses of their appearance were always followed with a Distortion case in the same location. While it’s unclear whether they’re involved in this case… I believe there’s enough reason to be wary of them.",
        ],
    },
    {
        ID: "230025",
        Name: "Pameli’s Page",
        Level: "Urban Plague",
        Source: "Wedge Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 64,
        StaggerHP: 34,
        SResist: [-2, -2],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Pameli",
        Passive: [
            "10",
            "230124",
            "230025",
        ],
        Desc: [
            "Life insurance for Fixers is often a sham. A lot of them take your money never to give it back; even if you terminate your insurance, they won’t. It’s not easy for your damage to be insured, either. You have to be at death’s door to qualify, pretty much? The chances are as low as winning the lottery. And what if you just up and died? What can the dead do with money? You’ll be much better off making a savings account for an augment procedure or quality workshop gear. I was a very lucky case; keep in mind that this isn’t the norm at all. Insurance can sometimes be useful depending on its form and conditions, sure… But if you take the pay into account, it still doesn’t feel too great.        ",
        ],
    },
    {
        ID: "230026",
        Name: "Pamela’s Page",
        Level: "Urban Plague",
        Source: "Wedge Office",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 64,
        StaggerHP: 34,
        SResist: [-2, -2],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Pamela",
        Passive: [
            "10",
            "230124",
            "230026",
        ],
        Desc: [
            "Basically speaking, people who visit our Office are looking for shrewd and precise situational assessment rather than combat prowess. The ability to make quick calculations for various possible scenarios and neutralize or kill the enemy with the least effort. We are hunters of the City. We Wedge pierce the requests we get with swiftness and precision.",
            "Of course, our Office isn’t perfect in every regard, so we’re in partnership with a number of other Offices. Fixer Offices often request others for help when reinforcements or professional aid in specific areas is needed. In the case of our Office, we were sister Offices with Dawn Office, sharing more information than we did with most other partners. Oscar is good friends with Salvador—the man running that Office—and they’ve known each other for quite some time, but there’s more to this sisterhood than that. Wedge Office excels at analyzing the capabilities of foes, and Dawn Office specializes in combat, so it’s only natural that we go well together.",
        ],
    },
    {
        ID: "232001",
        Name: "Jikan’s Page",
        Level: "Urban Plague",
        Source: "Rusted Chains",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 5],
        HP: 70,
        StaggerHP: 34,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Jikan",
        Passive: [
            "6",
            "10001",
            "232001",
            "211003",
            "232002",
        ],
        Desc: [
            "The Rusted Chains ain’t the biggest Syndicate, but each member’s got strength to boot n’ boast. The only weapon we use is these spiky chains. Tie ‘em, smack ‘em, anythin’ goes. We gotta be careful not to get swung or swayed around, or bind ourselves with our own metal. My body’s full of scars thanks to that, but hey… It’s not too bad, is it?",
        ],
    },
    {
        ID: "232002",
        Name: "A Rusted Chainlink’s page",
        Level: "Urban Plague",
        Source: "Rusted Chains",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 65,
        StaggerHP: 34,
        SResist: [0, 0],
        PResist: [-2, 0],
        BResist: [1, 1],
        Skin: "RustyChainGroup",
        Passive: [
            "6",
            "211003",
            "232002",
        ],
        Desc: [
            "“Bah… Every part of my body’s aching.”",
            "“Cloudy bastards… Why’re they picking at us so much? We’ve taken some serious damage on our side.”",
            "“Heard the Blade Lineage’s also got messed up… Got any news?”",
            "“Heard our boss is gonna go out and talk to ‘em.”",
            "“If boss is going alone… Won’t that be dangerous?” ",
            "“The other side’s also only sending their top dog or whatevs… No need to worry about the boss.”",
            "“Right… They’re weaklings individually, that’s why they like to move in packs.”",
        ],
    },
    {
        ID: "233001",
        Name: "A Workshop-affiliated Fixer’s Page",
        Level: "Urban Plague",
        Source: "Workshop-affiliated Fixers",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 64,
        StaggerHP: 34,
        SResist: [-2, 0],
        PResist: [0, 0],
        BResist: [0, -2],
        Skin: "WorkshopFixer",
        Passive: [
            "233001",
        ],
        Desc: [
            "In the City, there are as many workshops as there are unique gadgets. And the Tres Association is the one responsible for managing those workshops in general. It reviews newly designed weapons, files applications to the Head, and charges taxes for them. You can’t use the weapons that haven’t passed their evaluation. Getting a rejection from them basically means they see the weapon as something that shouldn’t be used in this City. They aren’t too cold about it, though. They sometimes send the applicants feedback about how they can improve their designs to a passable level. Not that we need it, since our latest weapon passed on the first try!",
        ],
    },
    {
        ID: "234001",
        Name: "Hanafuda’s Page",
        Level: "Urban Plague",
        Source: "Jeong's Office",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 5],
        HP: 68,
        StaggerHP: 35,
        SResist: [0, 1],
        PResist: [0, 1],
        BResist: [-2, -2],
        Skin: "J_Named",
        Passive: [
            "10001",
            "234001",
            "234002",
        ],
        Desc: [
            "In the Nest of gambling, hundreds of games take place every day, the humans leaving as winners or losers. Some admit their defeat, while others try to make a scene and escalate it into a violent mess. It’s the job of Offices like ours to monitor the gaming between individuals or organizations, verify the results, and prevent situations from turning violent.",
            "There are naturally a lot of Offices that handle this kind of work, most of them being affiliated with the Öufi Association, ours included. Whenever a game happens with something at stake, a go-between needs to be there to prove that the results were legitimate. Given the sheer number of games, we’re short-handed sometimes.",
        ],
    },
    {
        ID: "234002",
        Name: "A Jeong’s Office Fixer’s Page",
        Level: "Urban Plague",
        Source: "Jeong's Office",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 5],
        HP: 62,
        StaggerHP: 32,
        SResist: [0, 1],
        PResist: [0, -2],
        BResist: [0, 0],
        Skin: "J",
        Passive: [
            "234001",
        ],
        Desc: [
            "Most residents in Nest J are relying on a special entity. I can’t talk much about it, but it’s like the fortune readings others sometimes see. It predicts the events that’ll happen to you during a year like an annual fortune, and gives opinions on immediate matters. It never gives a direct solution to your problems, though. It’s up to you to make your choices… but I can’t deny that it has a strong influence on your decision.",
            "This is the Nest of gambling. You hear all sorts of noise daily—it almost drives you mad. Gunshots and screams aren’t exactly swell to wake up to… Those sounds used to wake me up everyday, but not anymore. The person living in Room 1829 vanished after losing a bet a week ago, and I saw ‘em carrying a large coffin out of Room 1831 yesterday…",
        ],
    },
    {
        ID: "240001",
        Name: "Yujin’s Page",
        Level: "Urban Nightmare",
        Source: "Shi Association South Section 2",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 268,
        StaggerHP: 44,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 1],
        Skin: "Yujin",
        Passive: [
            "17",
            "10004",
            "240001",
            "240101",
            "240301",
            "241001",
        ],
        Desc: [
            "Argalia. Alias: The Blue Reverberation. The person who is known to furtively cause incidents. Recently, he is suspected of recruiting individuals wielding powers that are possibly related to the Distortion Phenomenon in an attempt to form an organization. As well as prying into his plots, I intend to hamper his efforts myself before collecting data and presenting evidence of his irregular activity to the Head. As the Blue Reverberation’s plot was already in motion, I needed to act quick and do the least I could to stop him. However, Shi Association was too fatigued from the barrage of requests, so I asked Full-Stop Office to deal with the Church of Gears, whose leader seemed to harness a power that resembles the Distortion. But I haven’t heard from them since. Perhaps they were eliminated in their mission at the hands of the Church… Or, if the Blue Reverberation expected the Fixers’ arrival and toyed with them, then I will definitely have to get to the Library and read their books. There was evident rationale to read the books of the Musicians of Bremen as well, for they could contain even the slightest hint on the Blue Reverberation’s plots he might have told them. Even I do not know the man in detail, admittedly. However, because I am certain that the Blue Reverberation is conspiring something that violates or will violate the rules stipulated by the Head, I must gather crucial evidence and report it.",
            "…I know how corrupt this Association is. I am woefully aware of Thelma’s cunning and unhinged purpose behind saddling Section 2 with one request after another and wearing us down… I am but waiting for the right time. Waiting and enduring until I seize the chance to bring the Shi back to glory… I firmly believe that everything will take a turn for the better once I take care of this work. I pledge to change the system with my hands… No matter what.",
        ],
    },
    {
        ID: "240002",
        Name: "Valentin’s Page",
        Level: "Urban Nightmare",
        Source: "Shi Association South Section 2",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 100,
        StaggerHP: 40,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, -2],
        Skin: "Valentin",
        Passive: [
            "12",
            "10001",
            "240002",
            "241301",
        ],
        Desc: [
            "Thelma, head of the Southern Branch, has been overworking Section 2 to a nonsensical degree lately. The requests he’s giving us are burdensome to take once per week, and he’s constantly cramming them down our throats, sapping the strength and will out of our section… It’s unclear if we can successfully handle this mission to the Library, but it’s painstakingly obvious that he’ll give us another request to take care of immediately afterwards even if we could; most of our surviving crew are losing what little motivation they had left. As for why he insists on using Section 2 when the other sections are available… He’s probably trying to get rid of Director Yujin because he suspects that our director knows something about the Blue Reverberation. It’s unacceptable that someone could use a branch leader of an Association to make a toy of the entire Association, Color or not. Especially if the goal is to remove our director Yujin… I’m not sure what plan Director Yujin has to overcome this, but I suppose that can wait until we’ve finished our mission.",
        ],
    },
    {
        ID: "240003",
        Name: "Tenma’s Page",
        Level: "Urban Nightmare",
        Source: "Shi Association South Section 2",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [1, 7],
        HP: 96,
        StaggerHP: 41,
        SResist: [0, -2],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Tenma",
        Passive: [
            "12",
            "10001",
            "240003",
            "241301",
        ],
        Desc: [
            "From the receipt of the request to preparation for execution, every step of an assassination is carried out covertly. Discreet killing is the Shi Association’s specialty. An all-out war in open fields where numerous people clash at once is not our preferred form of battle (though, it’s one of the areas where the Liu Association excels); we truly shine when we operate in small numbers. We pursue extreme efficiency in order to kill our target within the limited window of opportunity. Also required is the ability to make quick assessments of the situation in order to swiftly strike the target’s vital point with minimal movement.",
            "The demand for assassination requests is pretty high these days as the most surefire way to eliminate people armed with high-quality workshop equipment on top of body augments is sneaking up on them for a fatal blow when they least suspect it. Still, the streets aren’t being filled with corpses of assassinated targets because there are Fixers whose job is to kill those who were hired for assassination. Fixers are continuing their fierce strife no matter the place.",
        ],
    },
    {
        ID: "240004",
        Name: "A Puppet, Page 1",
        Level: "Urban Nightmare",
        Source: "Puppets",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 77,
        StaggerHP: 40,
        SResist: [0, -2],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Puppet2Librarian",
        Passive: [
            "11",
            "240004",
            "240006",
        ],
        Desc: [
            "Life in the Nest isn’t anything special, honestly. It’s the same the whole world over. You get pecked by your boss and go through mountains of workload, you find yourself working overtime pretty much everyday… Payday isn’t all that exciting either, when you realize that you barely get any money for yourself after paying for maintenance, credit cards, insurance, living expenses and all that. Most of your income’s gone in a flash. And then, back to work… I have my ways of enjoying the little things in life, though. When I come back home from work, I crack open a cold one and watch the Backstreets through the window as night falls. When I’m lucky, I can see people chasing each other or getting into a tussle. And I think, ‘Oh, I sure hope that person manages to get away…’ I’m just being a hypocrite, of course. We’re all simply watching it for fun, don’t you agree? It’s like a TV show. Viewers aren’t genuinely concerned for the people on the rectangular screen. All they care about is guessing who will win. So many unrealistic and varied situations take place in the streets, it actually feels as if I’m watching television. Don’t call me out for being inhumane. Who knows, maybe someone is watching me work myself to the bones from a high rise, holding a glass of wine in their hand?",
        ],
    },
    {
        ID: "240005",
        Name: "A Puppet, Page 2",
        Level: "Urban Nightmare",
        Source: "Puppets",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [3, 5],
        HP: 79,
        StaggerHP: 41,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Puppet1Librarian",
        Passive: [
            "12",
            "10001",
            "240005",
            "240006",
        ],
        Desc: [
            "Money rules this City. Every denizen of the City is obsessed with money to the point of popularizing the belief that money can be thrown almost any problem. While the earnings of an average Nest resident are significantly higher than those of a person inhabiting the Backstreets, there’s also a notable wage gap among the Nest habitants. One thing to keep in mind is that your position in your job doesn’t always guarantee a high income. No matter how high your rank is in a small enterprise, you might not earn much more than a Fixer in the Section 6 of an Association.",
            "Even if your financial gain is on the higher side, you likely won’t earn enough to waste extravagantly. Meaning, you won’t get to take first class seats on WARP trains all the time or load the table with a sumptuous feast. However, it will be enough money to secure a stable life in the Nest. People who earn 4 million Ahn or more per month can be considered the upper middle class. That’s where the quality of life sees a visible increase. You no longer have to worry about being evicted from the Nest for being unable to pay taxes, and you can even hire Fixers to keep you safe. You can save up in case of emergencies, or send your children to better schools. A life lived in safe haven, free of illness and starvation. Well, that’s the life of an upper middle class they all talk about. What is there to be considered special? We just earn a bit more than others, and live in a bit more comfort than others.",
        ],
    },
    {
        ID: "240009",
        Name: "Emma’s Page",
        Level: "Urban Nightmare",
        Source: "The 8 o'Clock Circus",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [3, 5],
        HP: 80,
        StaggerHP: 42,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Ema_Librarian",
        Passive: [
            "12",
            "10001",
            "240308",
            "240408",
        ],
        Desc: [
            "Each Nest has its Singularity. For example: W Corp. has WARP, a fast and reliable means of transportation that’s guaranteed to deliver you to your destination on time; F Corp. has Fairies, which can unlock anything that’s considered ‘locked’, physically or conceptually; G Corp. has spheres that can control gravity, and so on… J Corp’s Singularity is pretty much the opposite of F Corp’s: it’s a technology that can lock and seal something that’s open or exposed on a conceptual level. Of course, the range or size of things that can be locked will depend on how much you pay. Cheap ones are mostly used for locking small boxes and other personal objects, while expensive ones can seal an area of space so nothing can come inside, or even lock a person’s body to prevent it from being dissected. The technology has a pretty wide range of applications. You can lock basically anything that’s open in one sense or another. Could it be that this Singularity was created because our Nest, where J Corp. is located, is a Nest of gambling that holds a smart few secrets that shouldn’t be leaked… Beats me. Not like anything good will come out of knowing the real reason, anyway…",
        ],
    },
    {
        ID: "240010",
        Name: "Noah’s Page",
        Level: "Urban Nightmare",
        Source: "The 8 o'Clock Circus",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [1, 5],
        HP: 1,
        StaggerHP: 1,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Puppet1Librarian",
        Passive: [
        ],
        Desc: [
            "J Corp. owns the Nest of gambling. Every person here devotes their life to those insane games of chance. Emma and I check the security cameras placed in affiliated facilities and spot anyone who cheats. We get hundreds of calls each day. Please check if the person in a dark red coat at N-9281-R231 used a sleight of hand to switch cards, I think my table was rigged at Q-198-OF1929, I think they’re using marbles that weigh 0.1g more in the roulettes at K-1928-R029, etc… A variety of creative and absurd calls flood the lines all the time.",
            "What’s so difficult about watching the security feed all day, you ask? Sure, you could think that if you’re unfamiliar with how things work here. But imagine having to check the feeds for tens and even hundreds of rooms that have ten cams each. The workload is spread over multiple people, of course, but each of us still has dozens of screens to stare at, it makes my eyes spin like a top. Besides, some people are sneaky enough to pull trickery off camera, and some incidents might occur during maintenance hours. This job is such a busy one, two eyes just aren’t enough. When you’re checking one case, another call comes in, when you’re done checking that, more calls wait for you… The shortage of manpower is driving me crazy, I swear.",
        ],
    },
    {
        ID: "240015",
        Name: "Anton’s Page",
        Level: "Urban Nightmare",
        Source: "Sweepers",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 77,
        StaggerHP: 40,
        SResist: [1, 0],
        PResist: [0, -2],
        BResist: [0, 0],
        Skin: "Anton",
        Passive: [
            "11",
            "240015",
            "241002",
            "241102",
        ],
        Desc: [
            "Our body is composed of liquid. Liquid is the substance that fuels our body. While humans maintain their form with the shell they call flesh and skin, we maintain our form with the suit we wear. If this liquid runs out, we will stop dead in place. Therefore, the liquid must always be filled, which is the reason we dine. This liquid is what constitutes and moves our body, but we also use the liquid to sweep the streets and dine. The method is simple. When we embed a hook connected to the fuel tank on our back into a human, they melt like a liquid. Then we consume that liquid to refuel. Without this shell, we would deform and spill on the ground like them. The liquid is patented with the approval of the Head; you must change your body to become like us if you wish to join our family. Do not worry about side effects. Mother will give you all the assistance you need. We all could safely become a family thanks to her.",
        ],
    },
    {
        ID: "240016",
        Name: "Lyla’s Page",
        Level: "Urban Nightmare",
        Source: "Sweepers",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [3, 5],
        HP: 77,
        StaggerHP: 40,
        SResist: [0, 0],
        PResist: [1, -2],
        BResist: [0, 0],
        Skin: "Lyla",
        Passive: [
            "11",
            "240016",
            "241002",
            "241102",
        ],
        Desc: [
            "That is correct. We are conscious of the attention of people during the daytime. We practice caution. It would be a public nuisance to show up in broad daylight and cause a ruckus, and we have a set of rules that we abide to. Of course, if the Head demands our service, we must assemble, day or night. Oh, and I believe there is a small misunderstanding between us. It is not by the will of us Sweepers that the night in the Backstreets has become a time when no deed is forbidden. Does it appear to you that every denizen of the Backstreets disapproves of the rules? ‘Anyone is allowed to commit terrible acts at night, and there is nowhere to complain to if you are victimized.’ While this means terrible things can happen to you at night, it also means that you are free to be the perpetrator of such a deed yourself. In fact, we do not see much benefit from the freedom of the nighttime, other than being allowed to dine all we want.",
        ],
    },
    {
        ID: "240017",
        Name: "Valerie’s Page",
        Level: "Urban Nightmare",
        Source: "Sweepers",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 77,
        StaggerHP: 40,
        SResist: [0, 0],
        PResist: [0, -2],
        BResist: [1, 0],
        Skin: "Valerie",
        Passive: [
            "11",
            "240015",
            "241002",
            "241102",
        ],
        Desc: [
            "The Backstreets are our main stage of activity at night. When night falls, our world unfolds. At regular intervals, we start marching from the perimeter of a Nest and sweep everything as we move forward. Even if someone stands in our way, and attacks us… Even if a powerful Fixer kills a Sweeper next to us who was our family, we pay no heed and continue onward. Like a wave of water, we sweep everything in our way, except for those who are strong enough to resist it. From an edge of a Nest to the opposite end, we march without break for 80 minutes until the ‘Night in the Backstreets’ ends.",
        ],
    },
    {
        ID: "240018",
        Name: "An Index Proselyte’s Page",
        Level: "Urban Nightmare",
        Source: "Index Proselytes",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 79,
        StaggerHP: 41,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "IndexUnit",
        Passive: [
            "11",
            "240018",
            "240118",
        ],
        Desc: [
            "No two Prescripts are the same in any way; as well as their contents being completely different from each other, you can’t expect when and where you’ll receive one. It could be placed between the patties of the hamburger you’re holding, it could be in your mailbox, it could be handed to you by a passerby. However, if you question who delivers those Prescripts or where they come from and put your curiosity into action, the Proxies will come for you, so beware. Here’s a few examples of the Prescripts:",
            "‘To Rimi, Deliver a bacon pizza to Danny’s doorstep on 8th St. before 10 AM sharp on September 14th.’",
            "‘To Jimin, Do not utter a single word for five days.’",
            "‘To Sehee, If the first person you meet outside today answers your greetings by lifting their right hand, take their heart out; if the person ignores your greetings, remove your own heart from your body.’",
            "…And this is only scratching the surface of the shambolic orders written on the Prescripts. The contents of a Prescript range from ordinary tasks to things that cannot be carried out in relatively normal (in terms of morality) means… The arrant variety and creativity of the Prescripts will make you wonder just what goes on in the head of the person responsible for writing them. Take a moment to think about how you would feel if you received a Prescript that says ‘Chop off your right ankle and eat it medium rare. (P.S. You don't have to eat the bones.)’ You’d think this is an absurd instruction no sane person could follow, but those who belong to the Index will feel glad that it doesn’t require chopping off both feet or eating the bones.",
        ],
    },
    {
        ID: "240019",
        Name: "Rose’s Page",
        Level: "Urban Nightmare",
        Source: "WARP Cleanup Crew",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 87,
        StaggerHP: 43,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Rose",
        Passive: [
            "13",
            "10001",
            "240019",
            "240020",
            "240022",
        ],
        Desc: [
            "Many people are under the impression that W Corp’s Singularity is quick transportation via teleportation. That’s how our technology is advertised to the public, anyway. They aren’t strictly wrong; we’re just hiding the bigger picture from them.",
            "W Corp’s Singularity is the restoration of a previous status. To put it in layman’s terms, even if your body is crushed to a pulp, it can be restored to a recorded state as long as all the pieces remain.",
            "First off, we scan the molecular structures, genomic data, and other information of the passengers required for their restoration when they sit on their seats. The scanned data is stored in the transmission device inside the train, ready to be sent to the restoration machine. With that, any and all kinds of pandemonium into which the carriages may have turned can be reverted with a single button. The machine has difficulty scanning lifeforms that move too much, so we need to take measures to subdue it. As with all Singularities, it has small side effects. Some might leave the train with slightly more weight than before, or gain a bit of height… No one has filed a complaint about it, likely because the change is so minor that they just shrug it off as a matter of feelings, like the body feeling lighter because of their excitement for going on a trip, or it feeling heavier because they ate too much prior to boarding the train.",
            "The passengers don’t remember what happened inside the train, but that’s not because we use amnestics. It’s the restoration procedure reverting the people’s memories to a previous state rather than selectively erasing them. In plain language, everything goes back to how it was when it was scanned. The passengers will continue the conversations they were having when they first boarded the train as if nothing happened. They won’t notice any oddity or displacement in their dialogue; any thoughts they had or words they were about to speak will be restored and resumed seamlessly.",
        ],
    },
    {
        ID: "240020",
        Name: "Sen’s Page",
        Level: "Urban Nightmare",
        Source: "WARP Cleanup Crew",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [3, 5],
        HP: 79,
        StaggerHP: 41,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Sen",
        Passive: [
            "11",
            "240020",
            "240022",
        ],
        Desc: [
            "You thought opening gates to different dimensions was our Singularity? That’s actually a former Singularity a fallen Wing used to own. It wasn’t a very well-known Wing, so you probably won’t recognize it even if I told you its name. Point is, that Wing discovered a way to open gates between dimensions. The ability to create rifts in space. The Wing sadly never knew how to utilize that stunning technology they’d found; the Nest ended up falling before it could find a proper use for the Singularity, and the company now known as W Corp. spent a huge sum of money to purchase it.",
            "At first, people at this corp also struggled to think of a good way to use this tech. Even if it could make a big rip in space, entering it was a whole different matter; you don’t know what’s in there or if you can even come back… They had no idea. But soon enough, W Corp. found a way to put this dimensional gate to use, which involves T Corp’s technology. With the device made by T Corp. that collects time installed in the train, not a single second really 'passes' in the carriages even if the train travels for thousands of years. It’s the, uhh… temporal preservation or whatever. That’s what they apparently use, but it’s too complicated for me. Anyway, whatever happens in the train, we revert it using our Singularity of restoration, and T Corp. takes the time we collect for their own Singularity. We’re good business partners.",
            "This tech isn’t just used for long-distance travel. It’s applied to the weapons we use, too. Equipment used by agents of W Corp. is specialized in tearing and cutting things apart. We can precisely cleave lumps into individual pieces with the help of the space-ripping technology.",
        ],
    },
    {
        ID: "240021",
        Name: "Lesti’s Page",
        Level: "Urban Nightmare",
        Source: "WARP Cleanup Crew",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 79,
        StaggerHP: 41,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Lesti",
        Passive: [
            "11",
            "240021",
            "240022",
        ],
        Desc: [
            "To restore the train, the passengers have to be in their seats. You have to be seated so the scanning program can detect your genomic data and put you back on the right seat~ Oh, and the scanner has trouble reading things that are moving too much, so you should be nice and stay still in your seat! So the WARP cleanup crew (like us!) tidy up the carriages and put the passengers in their seats according to their genomic data. And with the press of a button… Tada! Everything goes back to normal as if nothing happened! I only learned this after I joined the corp… But, isn’t that so cool? That’s what we agents do.",
            "But sometimes, the cleanup crew isn’t enough for the job. What’s so scary about dealing with humans, you ask? I heard this story from my seniors… One time, a Color hid their identity and snuck onto the train. What a shocker that must’ve been… It’s our rule to stop powerful people like Colors or key members of Associations from boarding our WARP trains, or to guide them to take First Class seats if they must board the train, for a safe and smooth restoration process. We want them to sleep without a care instead of joining in the chaos of the other carriages~ That Color Fixer was super tricky to deal with, they told me? Most passengers started training under the Color’s guidance in order to attain some kind of enlightenment. All but a few of our agents were pulverized by those people before they could even see a glimpse of the Color…",
            "But, we aren’t totally powerless against those situations. We would’ve gotten into so many problems otherwise, yeah? In case things get too difficult for our agents to handle, we call R Corp, a Wing we’re partnered with. I saw footage about R Corp. in our training course… They were so cool. That was my first time seeing the mercenaries in action! They’d keep pressing on and wipe their targets, no matter how harsh their resistance was… I was like, whoa, they really are something else. The Fourth Pack… Was it called the Rabbit Team? Yeah, I think it was. I gotta wonder, though; why rabbits of all animals? Isn’t that an herbivore?",
        ],
    },
    {
        ID: "240022",
        Name: "A WARP Cleanup Agent’s Page",
        Level: "Urban Nightmare",
        Source: "WARP Cleanup Crew",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [2, 6],
        HP: 77,
        StaggerHP: 38,
        SResist: [0, 1],
        PResist: [-2, 0],
        BResist: [0, 0],
        Skin: "WarpCrewUnit",
        Passive: [
            "11",
            "240022",
        ],
        Desc: [
            "Sigh… They ain’t going to raise the ticket prices or run fewer trains like the last time, are they?",
            "Whaddaya mean, cap?",
            "Lobotomy Corp—the company that was supplying our energy needs—went down recently.",
            "That’s a good point, it’s harder to operate the trains with less energy… What do you mean by “last time”, though?",
            "Oh, you’re too new to know? Back in the day, L Corp’s Nest was occupied by another energy company.",
            "So, that company puttered out and put our corporation into the same sort of energy shortage we’re dealing with now?",
            "Not quite. It did go bust eventually, but it’s more that the company was stingy about sharing its energy. Awfully strict, too… I heard it had a bad reputation among its partnered companies. Because they were so tight-arsed about energy supply, we had to reduce the number of trains running at the time for a while.",
            "I had no idea…",
            "Don’t count on me, though. I also picked this story up from my superior. That’s enough chittering, let’s get back to work.",
        ],
    },
    {
        ID: "240023",
        Name: "Wang’s Page",
        Level: "Urban Nightmare",
        Source: "Smiling Faces",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [3, 5],
        HP: 81,
        StaggerHP: 43,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Wang_Librarian",
        Passive: [
            "12",
            "10001",
            "240023",
            "240026",
        ],
        Desc: [
            "They call the Backstreets unsafe because there’s this one time o’ the day when darkness comes out and your friendly neighborhood watch can’t do jacks about it. The Night in the Backstreets, when the City shuts its eyes. Breakin’ any rules are forgiven during that time. Means to protect yerself from harm like recording videos or hirin’ peacekeepers? All rendered useless. And those rusty ol’ fellas sweep every corner of the streets, so no evidence is left behind. No corpses, no weapons, no nuthin’. Not only do all the security measures stop, peeking at folk as a whole is banned during these hours! Well, stumbling on the scene o’ the crime ain’t banned. What it really means is… you ain’t suppos’d record videos o’ the scene or spy it with security cams… No one should be strolling the streets that late in the first place though, hoh hoh hon!",
            "Cause of that, they don’t ask a darn thing about crimes happening during that time unless an eyewitness shows up. They just can’t, if I’m bein’ blunt. The public institutions… Ye know the deal, those shuckin’ shucks at the Head, Fixer Associations, vigilance peeps n’ the like. If one o’ those officials try to take a dig at somethin’ that happened during the Night in the Backstreets, some scary fellas called the Claws go after ‘em… I hear the Night in the Backstreets is considered a whatsit time for doin’ whatchamacallit permitted by the Head? I’ve got no dang clue why they set a time like this when every soul ‘ere’s already frightened to the bone. No matter what folks say, the Night in the Backstreets starts at 3:13 and ends at 4:34, ne’er too early or late by a single second, every time~",
        ],
    },
    {
        ID: "240024",
        Name: "Jin’s Page",
        Level: "Urban Nightmare",
        Source: "Smiling Faces",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 81,
        StaggerHP: 43,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Jin_Librarian",
        Passive: [
            "12",
            "10001",
            "240024",
            "240026",
        ],
        Desc: [
            "The Backstreets aren’t some unlivable mess like some folk’re saying, ye see? Rough things do happen often ‘round here, sure, but there’s some effort at peacekeeping goin’ on to stop a whole lotta people dying all the harking time. Every area of the streets has some kinda neighborhood watch made outta local residents voluntarily doing jobs like Fixers do, trynna make the Backstreets a safer place. Unlike the so-called public safety Association that starts with a Z… whatever that stuffy org is called, the neighborhood watch ain’t chained to any official authority nor do they ask for huge fees. Each area’s got different styles of neighbors, so not everyone in every corner of the town likes ‘em. Most folks do appreciate that they’re kee’ing ‘em safe, though.",
        ],
    },
    {
        ID: "240025",
        Name: "Mi’s Page",
        Level: "Urban Nightmare",
        Source: "Smiling Faces",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 81,
        StaggerHP: 43,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Mi_Librarian",
        Passive: [
            "12",
            "10001",
            "240025",
            "240026",
        ],
        Desc: [
            "There’s this one rule that stands squarely in this nigh-lawless land. Doing any kinda harm to the residential area is forbidden… No invading people’s homes, no demolishing ‘em, n’ all that. Not even the big n’ tough crooks of the Fingers can touch this! I’m guessing they decided it’s gotta stay the most whatsit place. If ye didn’t know, the City’s taboos are a ‘uge deal, ‘s much more serious than taboos of the Nest. You break it, and yer life’s over right then n’ there!",
        ],
    },
    {
        ID: "240026",
        Name: "A Smiling Face’s Page",
        Level: "Urban Nightmare",
        Source: "Smiling Faces",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [2, 6],
        HP: 77,
        StaggerHP: 40,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "SmilingFacesUnit_Librarian",
        Passive: [
            "11",
            "240026",
        ],
        Desc: [
            "The rules o’ the Backstreets don’t work in the Nest, and the opposite’s also true. You could drag a higher-up working for whatchamacallit from the Nest to the Backstreets and do whatsit to ‘em and get away with it, as long as it was during the Night in the Backstreets and no sneaky rat saw you doin’ it. But if you did the same whatsit in the Nest, you’d be breaking rules. The Night in the Backstreets is only a thing in the Backstreets, like da name suggests.",
        ],
    },
    {
        ID: "240027",
        Name: "Unstable Page of the Crying Children",
        Level: "Urban Nightmare",
        Source: "The Crying Children",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 87,
        StaggerHP: 43,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "PhilipEgo",
        Passive: [
            "13",
            "10001",
            "240027",
            "240127",
            "240227",
        ],
        Desc: [
            "“Sorry. I get how you feel, but I’ll need more time to think about this.”",
            "“…”",
            "“…Um, are you feeling down?”",
            "“N-no, I’m fine… I get it. This was rather sudden, and you’ll need some time to collect your thoughts.”",
            "“Thanks for understanding. You know, you’re a very caring person. I guess gramps picked the right rookie to hire.”",
            "“Is that so… Thank you.”",
            "I couldn’t say anything beyond that. I tried to think positively about it, convincing myself that I wouldn’t want to see seonbae feel troubled because of me in the future. Clinging on to it further would only make me seem pathetic… Although seonbae didn’t decline my confession outright, it felt safer to think of it as a refusal so I wouldn’t get my head in the clouds and make another attempt at it. I shouldn’t have held any expectations in the first place. I thought I’d feel like a load had been taken off my chest after I’d confessed my pent-up feelings to her, but I couldn’t even bring myself to look seonbae in the eyes. I didn’t see it. I found myself looking for excuses. It’s not because I’m a coward… It’s not because I was afraid that I might be faced with darkness I can’t possibly handle if I lift my head, no. I just looked at the shade so I could see a brighter light, that’s all. That thought made me feel a bit easier. I don’t know what expression seonbae wore at that time. Was she grinning at my nonsense, or was she upset? All I can think is that she was probably giving me a look of disgust.",
            " ",
            "“You gave a fine speech, but I must wonder if you’re truly upset for the sake of Salvador and your other late colleagues.”",
            "“…I’ll go prepare myself.”",
            "I closed the door on my way out. Was it because I didn’t want to hear any more of it? Did I lack the energy to refute him? I had no time to reflect on the reason I left my seat. The one thing I couldn’t stand was him putting the blame on me for leaving my master and seonbae behind in that place they call the Library when I escaped so that I could bring others to save them. A wise person once said that you must close your ears when someone utters useless words or speaks with harmful intention. Is the ‘uselessness’ of a talk determined solely by one’s own standards? Maybe Oscar was right. But are his words useless and wrong because they distressed me? Maybe I just didn’t want to accept it. Consoling myself that I need some time to focus only on the grief of losing my master and seonbae… I covered my ears.",
            " ",
            "“You’re pausing it at just the right moment like it’s a rerun you’ve watched over and over… There’s got to be a reason.”",
            "“Shut up, shut the hell up…!”",
            "Sometimes, the human brain has difficulty telling reality from illusion. Watching a horror film incites fear even though you know it’s fiction; however, it’s not always easy to discern the truth. They’re standing right before my eyes reproaching me, but I can’t dismiss them as mere illusions. Even though they’re… dead. Gone. There was no way they could be real. It doesn’t make sense that I know what they’re about to say otherwise. It couldn’t be something they told me beforehand. When seonbae was about to speak, I shut her up, as though I knew what was going to unfold. What could I gain from uttering what will harm me. Self-justification? Those words would’ve wounded me for sure, but they were also words that would protect me. Yet again, I’m running away from truth. Vilifying others. It made me feel a bit better. Pameli was right; all I had to do was make up reasons that are convenient to me. It’s not my fault at all. They’re the bad ones… It’s derisive how shallow my admiration for my master and seonbae was, changing my attitude toward them so easily out of selfish self-preservation.",
            "Nothing is more beautiful than knowing the truth, and therefore, nothing must be more shameful than admitting that what one believed in was a lie. I could’ve sworn I acknowledged my vice and embraced it. Although the process was a little unstable, I still felt ashamed for the truthless deeds I had done, and decided to cherish that negative part of myself as I am. Or so I thought… I stopped talking. I couldn’t even tell what was appropriate to speak anymore.",
            " ",
            "Turn a blind eye to all that tries to hurt me. Turn a deaf ear to words that will lead me down the wrong path. Turn a mute mouth to unnecessary evil. And last of all, act not. Make myself happy that way.",
            "I could no longer perceive anything.",
        ],
    },
    {
        ID: "241001",
        Name: "A Shi Fixer’s Page",
        Level: "Urban Nightmare",
        Source: "Shi Association South Section 2",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [2, 6],
        HP: 80,
        StaggerHP: 40,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [-2, 0],
        Skin: "ShiFixer",
        Passive: [
            "11",
            "241301",
        ],
        Desc: [
            "Being an organization that is familiar with dealing death, the Shi’s code of honor is to treat every person equally, as the weight of death is equal for everyone. As long as the request fee is paid, we remove the target with no questions asked, regardless of who the client is, what kind of crime they may have committed, or any other details. The boss of a Syndicate known for murdering people in cold blood, a criminal wanted by a street somewhere, laundering an identity for a person of higher status who often bribes, even requests to kill one’s own friends and family… We handle all requests without leaning to a side. Of course, we have a duty of confidentiality to uphold for our clients. We mustn’t give in and maintain silence even in the face of immediate threats of death. Such are the rules and mindsets that the Shi Association’s members must abide by.",
            "However, the recent behavior of the Southern Branch goes against the core values of the Shi. On top of exerting power for his private interest, his selfish actions are causing severe damage to Section 2… All of us are eagerly waiting for Director Yujin to overthrow this rotten system one day.",
        ],
    },
    {
        ID: "241002",
        Name: "A Sweeper’s Page",
        Level: "Urban Nightmare",
        Source: "Sweepers",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [2, 6],
        HP: 74,
        StaggerHP: 37,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [0, 0],
        Skin: "SweeperUnit",
        Passive: [
            "11",
            "241002",
            "241102",
        ],
        Desc: [
            "If the ‘Night in the Backstreets’ were to be gone, the Backstreets will fall into even worse chaos than before. In other words, the Night in the Backstreets is the rein that keeps this place in check. Because the Night exists, people here show the least amount of human decency.",
            "Here’s an example. You come home at the end of a hellish day. Dragging your weary body to the sofa, you hope to get a small break lying on the couch and watching cheap entertainment shows. But guess what happens. Some crazy jerk upstairs turns up their speakerphone’s volume to the max and makes obnoxious noises that make your ceiling shake. Too bad, there goes your peaceful respite. You can’t stand the noise that’s getting to your head, so you decide to ask your neighbor to please be considerate and lower the volume. You want to talk this over without a fight, so you battle the furious urge a million times before you go upstairs. But then our unfriendly neighbor gives you a baffling reply when you confront them. I need some free time for myself too, I have gripes with my neighbors that I just live with, so you should do the same. Why make a huge fuss about the noise when it isn’t even too loud, blah blah… Talking out of their ass. What can you do, though? Barely keeping your boiling anger inside, you go back down to your house, covering your ears with a pillow and yelling curse words as you try to sleep. Even if you told your landlord about it, they’d shrug off your complaint and smile like a saint, so there’s no use speaking up about it.",
            "That’s when the Night of the Backstreets comes into play. First off, you block the entrance to that shithead’s house before they return. Anything works; you could weld the door, use wooden planks, padlock the door, or whatever. Ensure that they can’t enter their own house by any means, and go back to your home. Some time later, they’ll come back to find that the door to their house has been sealed shut; they’ll struggle with the door before giving up. And they’ll make a serious face as though they’re trying to think of who could’ve done this ridiculous prank to them. Once they realize that it couldn’t possibly have been anyone else’s doing but yours, it’ll be too late. Because you’ll be behind them, bashing their head in with a brick or some heavy object. Killing them right now would obviously break the rules, so you drag them to your house and enjoy a quiet rest.",
            "When the clock hits 3 AM, you drag the little shit outside and throw it in the middle of a relatively large street. You return to your home before it’s too late and watch the scene from the window. The time is 3:13 AM; Sweepers crawl out of the dark and sweep the streets clean, collecting all the trash including that noise pollutant.",
        ],
    },
    {
        ID: "243001",
        Name: "Dante’s Page",
        Level: "Urban Nightmare",
        Source: "Seven Association",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [1, 6],
        HP: 80,
        StaggerHP: 40,
        SResist: [1, 0],
        PResist: [0, -2],
        BResist: [0, 0],
        Skin: "Dante",
        Passive: [
            "10001",
            "243001",
            "243101",
            "243201",
        ],
        Desc: [
            "Seven Association deals with info and investigations; we collect all kinds of information on this City. Though, why aren’t we disclosing the full details about certain cases to the general public through news outlets or anything, you ask? Some things are better left unknown—for the sake of the safety of this world.",
        ],
    },
    {
        ID: "243002",
        Name: "A Seven Association Fixer’s Page",
        Level: "Urban Nightmare",
        Source: "Seven Association",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 72,
        StaggerHP: 40,
        SResist: [0, 0],
        PResist: [-2, 0],
        BResist: [0, -2],
        Skin: "SevenUnit",
        Passive: [
            "243001",
        ],
        Desc: [
            "“Section 3 feels empty these days.”",
            "“Oh, didn’t you hear the news? Many of them died in that incident with the Distortion last time. Even the guy we counted on resigned and ran off…”",
            "“Right, that happened. I guess that’s why the empty seats felt even more noticeable… He seemed pretty refreshed and relaxed on his last day.”",
            "“I wonder why he quit, though. Sure, the work here can be tough, but… isn’t it still easy compared to some others?”",
            "“Gotta agree with that. Beats having to worry about getting axed all the time…”",
            "“Rumor says he went on to join the Musicians of Bremen…”",
            "“Why would he join that weird funky band?”",
            "“You tell me. Maybe there was something more important than making a fortune and spending the rest of his life in comfort for him…”",
        ],
    },
    {
        ID: "243003",
        Name: "Bamboo-hatted Kim’s Page",
        Level: "Urban Nightmare",
        Source: "Blade Lineage",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 78,
        StaggerHP: 40,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Kimsatgat",
        Passive: [
            "10001",
            "240002",
            "230024",
            "243003",
            "231001",
            "220003",
        ],
        Desc: [
            "We value the art of violence more than anything here; those with an unscathed body are not permitted to join us. A swordsman who does not have a single blade scar on his skin is doubtlessly too careful when he wields his weapon, and his inane hesitation will be an obstacle. Too irresolute to endure the wounds his own blade would leave, let alone the assault of others… A body free of scars is proof of cowardice. Alas, it would be wise not to expose your wounds outside of those on your face.",
        ],
    },
    {
        ID: "243004",
        Name: "A Blade Lineage Cutthroat’s Page",
        Level: "Urban Nightmare",
        Source: "Blade Lineage",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 73,
        StaggerHP: 40,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [0, 0],
        Skin: "Sword",
        Passive: [
            "231001",
            "220003",
        ],
        Desc: [
            "Blade Lineage isn’t known for coordination. It’s little more than a cohort of people who have nowhere else to go, or those who carry the intent to murder someone. Most who seek to join us sit at lowly social positions. It’s not rare for such people to hold a deadly grudge against someone. You’d best behave before those who are more skilled than you. We may be a band of murderous ruffians, but we understand our place.",
        ],
    },
    {
        ID: "243005",
        Name: "Dong-hwan the Grade 1 Fixer’s Page",
        Level: "Star of the City",
        Source: "Dong-hwan the Grade 1 Fixer",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 87,
        StaggerHP: 45,
        SResist: [0, 1],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "ClassOneFixer",
        Passive: [
            "10008",
            "250001",
            "243005",
            "243105",
            "243205",
        ],
        Desc: [
            "Hana Association seems to have taken an interest in the Library and the Blue Reverberation—the two entities at the center of all the problems that have been happening in L Corp’s Nest lately—now that they’ve marked their presence in the City’s sky as Stars. I asked a Color who happens to be a friend of mine about it… and he said the Association’s going to recruit him to hunt down the Blue Reverberation and his cohorts soon. They’ve been making quite a scene in L Corp’s Nest… In particular, the lives of many Syndicates, Fixers, and residents close to the Library were lost to their hands, so the Association couldn’t just sit and watch anymore. They’ve apparently set up a camp at the door of the Library, though no one knows what they’re waiting for. A couple other things I heard are that all sorts of sounds and noises are coming from that camp… and that a large number of firearms belonging to the Thumb were abandoned on the ground. Maybe they launched an assault on the Syndicate while it was still struggling to recover from the loss of the Underboss and his Capos. The ensemble’s not like most Syndicates just trying to make money off the turf of the wingless Nest, that’s for sure… But we still don’t know what their goals really are, and I can’t shake this bad feeling.",
            "Anyways, since I was asked to pay a visit to the Library… It’ll be worth investigating the case some more after I get this job done.",
        ],
    },
    {
        ID: "252001",
        Name: "Allen’s Page",
        Level: "Star of the City",
        Source: "Night Awls",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [3, 6],
        HP: 95,
        StaggerHP: 49,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "AwlOfNight_Named",
        Passive: [
            "10008",
            "252001",
            "252002",
            "252003",
        ],
        Desc: [
            "The message we got wasn’t unexpected. The boss of our organization had always been a rash one, and he’d no patience with injustice or for his own curiosity. It was a miracle that he managed to stay under the Thumb for so long. I told him to be more careful since his words and actions as the boss will affect his underlings as well, yet here we are… I thought I’d flip my lid at hearing the news, but I didn’t feel as much anger as I expected to. The only thought that came to my mind was that he’d finally done it. With my head cool, I calmly considered my next move. At least some of us’ll make it outta here thanks to the early warning.",
        ],
    },
    {
        ID: "252002",
        Name: "A Night Awl’s Page",
        Level: "Star of the City",
        Source: "Night Awls",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 86,
        StaggerHP: 45,
        SResist: [0, 0],
        PResist: [0, 1],
        BResist: [0, 0],
        Skin: "AwlOfNight",
        Passive: [
            "10001",
            "252001",
            "252002",
        ],
        Desc: [
            "S’usually a good idea to zip your mouth shut at a gathering of Thumb subsidiaries. If you don’t have any good suggestions to make, shutting up is the next best contribution you can make. Can never be sure if what you’re about to say is a good opinion either, so just sock it in general. In other places, mistakes would just cost ya own life, but losing your credit in meetings like that means the members of your Syndicate are also biting the dust. What did we do wrong to deserve the punishment for our boss being a moron?",
        ],
    },
    {
        ID: "253001",
        Name: "An Udjat’s Page",
        Level: "Star of the City",
        Source: "The Udjat",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 89,
        StaggerHP: 46,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Usett",
        Passive: [
            "10001",
            "253001",
            "253002",
            "253003",
        ],
        Desc: [
            "We are Udjat. While it’s a Grade 1 Office on the surface, we only receive requests from one person. It exists for Lady Dias and Lady Dias alone. We are ready to perform any feat that she demands. Her pure ambition will bring her to a position of great power one day. We simply serve as stepping stones for her ascent to the top.",
        ],
    },
    {
        ID: "254001",
        Name: "Irina’s Page",
        Level: "Star of the City",
        Source: "Mirae Life Insurance",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 96,
        StaggerHP: 59,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "MiraeNamed",
        Passive: [
            "10008",
            "254001",
            "254002",
            "254003",
        ],
        Desc: [
            "Did you know? Many people whom insurance companies employ are those who have experience with detective work involving investigations and deduction. Since we deal with huge sums of money, there are more than a few cases where our clients deliberately harm themselves or lie to us in an attempt to commit insurance fraud. A considerable number of calls we get actually aren’t mere incidents. How do we tell apart a real accident from the fake ones, then? Haha, that’s a business secret. Well, maybe a little hint… Oftentimes, something will be off about the way they act or talk. I told you that folks who used to do detective work frequently jump over to our industry, right? Those armchair fellows certainly have their wits… Their keen eyes will catch the signs hidden in even the most elaborate of disguises.",
            "They say the terms can be a little too particular, but I disagree. When handling that much money, it doesn’t hurt to be thorough with inspecting and determining the validity of cases, right? If people started reaping insurance payouts for the smallest things, our business wouldn’t survive. You’d be surprised to learn how many people in the City still cling to the idea of get-rich-quick schemes.",
        ],
    },
    {
        ID: "254002",
        Name: "A Mirae Insurer’s Page",
        Level: "Star of the City",
        Source: "Mirae Life Insurance",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 86,
        StaggerHP: 46,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Mirae",
        Passive: [
            "10001",
            "254001",
        ],
        Desc: [
            "In this City, money has more value than anything. You need money to be able to start anything. Money is also required in case of unexpected events. An accident that will cost you a great deal of money could happen at any time; insurance is useful for such cases. As long as the conditions are met, the payout will fill in for financial damage. Of course… not all accidents will fit the insurance’s bill perfectly.",
            "There are insurance plans for Fixers, Associations, and even Wings… on top of secondary insurance an insurer can take… It would take a long while to list all the insurance that exists in the City. There’s a wide range of carriers and plans to choose from, each fulfilling the needs of a different type of individual or group. You never know what danger awaits you…",
        ],
    },
    {
        ID: "255001",
        Name: "Yae’s Page",
        Level: "Star of the City",
        Source: "Leaflet Workshop",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 94,
        StaggerHP: 50,
        SResist: [0, 1],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "CorNamedLibrarian",
        Passive: [
            "10008",
            "240026",
            "255001",
            "255002",
            "255003",
            "255004",
        ],
        Desc: [
            "A friend of mine who was trained in the same workshop as me told me about this place. Said some new tech was discovered recently. Something about tinkering with the mind to use it for your advantage… It’s apparently more powerful than I can ever imagine? I’m honestly not very good at forming an impression of something when I just hear or read about it… So I told them I don’t get it, and then they said maybe going to the Library would help. They’ve been researching this new and exciting technology lately, but they say they’re too scared to head into that place even if there’s vital information to be found. They weren’t the kind of person to get physical… so I understand. Thus, I told my buddy that I’d visit that place for them once I’m finished developing this one thing. There’s a new gadget to test anyway, and to witness a technology that’s still obscure and hot off the presses… That just makes your heart throb, doesn’t it?",
        ],
    },
    {
        ID: "255002",
        Name: "A Leaflet Workshop Fixer’s Page",
        Level: "Star of the City",
        Source: "Leaflet Workshop",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 87,
        StaggerHP: 46,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Cor",
        Passive: [
            "10001",
            "240026",
            "255001",
            "255002",
        ],
        Desc: [
            "Leaflet Workshop… It’s a good place! Offers serviceable weapons to Fixers at a reasonable price, and sells quality weapons to underground Syndicates at higher prices… There’s been cases of the opposite happening sometimes, but that’s not what matters. Just wanted to emphasize that people from all walks of life visit our workshop. Oh, and I heard some workshops have membership clubs! The select few chosen by the workshop’s owner are sent an invitation, or so I heard. Business would be much handier if we adopted the same system… as with everything else… Greeting guests is the one thing that’s more dangerous than developing new weapons when you run a workshop.",
        ],
    },
    {
        ID: "256001",
        Name: "Bayard’s Page",
        Level: "Star of the City",
        Source: "Bayard",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 96,
        StaggerHP: 49,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "BayyardNamed",
        Passive: [
            "10008",
            "256001",
            "256002",
            "256003",
        ],
        Desc: [
            "This wasn’t always the prim and proper Office of amenable Fixers that it is now. It was the complete opposite, actually, full of uncontrollable punks. I tried to gather the rascals in one place and lead them, but it never worked out smoothly. It was a ragtag band of people without a place to call home, like Rats. So I got my frustration off my chest when I met my old friend Maugie… Oh, maybe you’re more familiar with the name Maugris? Anyway, after hearing my ramblings, they said that there’s someone in their Office who would be perfect for the job, and I took the offer since I didn’t have any better ideas. That someone was Renaud.",
            "At first, I didn’t expect that spring chicken to be able to do much, but I was surprised to see that he only needed a week to convince everyone. For a guy who looked much younger than me, he had both power and smarts to boast. He had a way with words that persuaded some, and for those that wouldn’t listen, he’d settle it with a contest of strength like in some parts of the Backstreets. Back then, I was kinda jealous seeing Renaud handle something that I struggled with like it was nothing, but now I’ve accepted that he’s the better man. I know that I wouldn’t have managed to do it myself. I could’ve booted him out like a stubborn old man, but I have better things to keep than my pride.",
        ],
    },
    {
        ID: "256002",
        Name: "A Bayard’s Office Fixer’s Page",
        Level: "Star of the City",
        Source: "Bayard",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 86,
        StaggerHP: 46,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Bayyard",
        Passive: [
            "10001",
            "256001",
            "256002",
        ],
        Desc: [
            "Charles’ Office, the place Renaud worked, was popular among Fixers. It was the subject of a lot of gossip. For good reason, as it was a Grade 1 Office consisting of just a few elites, handling any request with ease… People would often wonder exactly what kind of Fixers were in that Office. All we know about the Office is that its Fixers wore luxurious clothes, and the Office interior was fancy as well—in a style unique to the northern side… And that there were twelve Fixers led by someone called the “captain”… and they’ve all parted ways now, living their own lives. That’s about it.",
            "Outside of Renaud, the person who helped us, we’ve only ever seen Maugris and Astolfo, who he would sometimes accompany… And someone called Bradamante. Their attire and weapons were all so distinct from what I could see of just those four, I couldn’t find anything in common. And the pressure I felt just from being around those powerful Fixers… The stark difference between me and them was something, I couldn’t think much else.",
        ],
    },

    {
        ID: "250001",
        Name: "A Liu Section 2 Fixer’s Page",
        Level: "Star of the City",
        Source: "Liu Association South Section 2",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 86,
        StaggerHP: 45,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "LiuSection2Unit",
        Passive: [
            "12",
            "10001",
            "250001",
        ],
        Desc: [
            "Liu Association is a battle-oriented Fixer Association specializing in all-out combat; we receive requests from Wings and fight great battles for them. Some may see the Liu’s fighting style as old-fashioned, but we get frequent requests from those who want strong-willed and determined warriors. Most requests that come our way aren’t complicated. Nine out of ten are resolved by simply marching towards enemies and defeating them in battle. It doesn’t require specific strategies or certain personnel. We’re the Liu, the Association that solely exists for war.",
            "That doesn’t mean war is the only type of request we accept. After all, a Fixer is free to take any request. The catch is that all requests must be reported to the Hana Association after you deal with them. The report must include the details of the request, the client’s info, how the case was resolved, and any other relevant information… Once the report has been submitted, Hana Association will assess the performance of the Office and its Fixers, and evaluate them for promotion or demotion. That’s how the grades of Offices and Fixers are updated. Therefore, a Fixer’s grade doesn’t necessarily correlate with strength.",
            "One last thing I’d like to add is that there is a line Fixers shouldn’t cross; a Fixer may advertise themself or their Office to get more requests, but they should not threaten people to give requests to them. This is an area handled by the Hana Association and Öufi Association, a specialist in dealings and transactions. Of course, Associations shouldn’t have to worry about running out of requests in the first place.",
        ],
    },
    {
        ID: "250002",
        Name: "Lowell’s Page",
        Level: "Star of the City",
        Source: "Liu Association South Section 2",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 95,
        StaggerHP: 51,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Lowell",
        Passive: [
            "16",
            "10008",
            "250002",
            "250001",
        ],
        Desc: [
            "Xiao was a cold person who wouldn’t easily show her feelings. Even though the Liu consists of those who only face forward and never express any emotion in battle, Xiao was especially hard-edged above the rest. I came to wonder if she was capable of possessing emotions at all. Her tone was dry in the most upsetting situations, and she seemed apathetic to the loss of several colleagues. Never showing her emotions in response anything, but thoroughly looking after herself. That was my impression of Xiao. I thought the path Xiao was walking was completely different from mine. We disagreed on every aspect, from strategies to personalities; I thought my relationship with her would stay a formal relation between two coworking directors of an association.",
            "I don’t remember when and how we got so close to each other. I couldn’t be bothered to push away the person who naturally came to my side. We started spending more time together outside of work; people intersect one another somehow. Though, I have no clue how our paths managed to converge, or what about the paths led them to cross… One thing I can say for certain is that… our relationship isn’t a superficial bond between two directors. We need each other because we cherish each other, not the other way around; can you really call it love if you only cherish your significant other because you need something out of them? At the very least, I don’t think of Xiao as an object of exploitation nor gratification.",
            "However, I know that preaching love is utterly meaningless in this City. A Fixer should never be carried away by emotion. I know well that a person at a position as high as mine should be extra careful. I’ve seen countless Fixers who brought private matters to the official grounds, only to meet undesirable results. The moment you get swayed by something you cherish, you lose yourself; you neglect your own safety. When a human, a creature that always puts itself above all else, loses their edge because of what they hold dear and places higher priority on it over their own life… The consequences will be grim in any case. Knowing this, I decided to remind ourselves of one thing when we plighted our troth: Whatever happens to each other, we won’t put ourselves at risk. As I thought, Xiao agreed plainly and rightly. I could trust in Xiao, and I was glad to have this person as my lifelong partner. It was reassuring to know that Xiao wouldn’t throw away her own life if I ever died. Focus on my own survival, even in a mortal peril. Perhaps my heart has grown stronger since I met her. Having her next to me was already a great help to me at that point.",
        ],
    },
    {
        ID: "250003",
        Name: "Cecil’s Page",
        Level: "Star of the City",
        Source: "Liu Association South Section 2",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 89,
        StaggerHP: 47,
        SResist: [0, 1],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Cecil",
        Passive: [
            "14",
            "10001",
            "250003",
            "250001",
        ],
        Desc: [
            "The Liu is an Association that specializes in warfare. We work for the single goal of victory. However, victory isn’t necessarily won in battle. The ideal course of action begins by identifying the reason the enemy intends to fight in the first place. Next, we break the enemy’s will. Only then will we launch an attack on enemy forces. Even when war is inevitable, we mustn’t hope for victory after starting the war. ‘Secure a path to victory before engaging in warfare.’ The Liu engages in battles that are already won. With a strategy that is fated to lead us to triumph, we face enemies that are fated to lose.",
            "In other words, we don’t participate in a war that cannot be won. Blindly charging into the fray isn’t always the path to victory. And while strategizing allows you to look ahead and see where victory lies, it doesn’t ensure that you will reach it. Therefore, it’s crucial to assess the strength of the ally and the condition of the enemy before you determine if you should advance or retreat. It’s up to the director of each section—our leaders, basically—to decide what to prioritize and what to discard. For instance, Director Lowell is extremely cautious; he’s not hesitant to retreat and reorganize his forces if there’s a slight disadvantage. On the other hand, Director Xiao tends to push forward as long as there is an opportunity to count on, but she isn’t reckless about it; she designs elaborate strategies that will overcome the odds. Director Lowell’s choices aren’t always wise, and Director Xiao’s choices don’t always result in a smooth victory, but the two work their hardest within their abilities.",
        ],
    },
    {
        ID: "250004",
        Name: "Mei’s Page",
        Level: "Star of the City",
        Source: "Liu Association South Section 2",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [1, 7],
        HP: 89,
        StaggerHP: 47,
        SResist: [0, 1],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Mei",
        Passive: [
            "14",
            "10001",
            "250004",
            "250001",
        ],
        Desc: [
            "Outside of weapons and martial arts, the most important thing that provides us with protection is our clothing. It might look like a fancy suit with golden decorations at first glance, but you know how a Fixer’s attire is no ordinary clothing! It’s mandatory for people working in relatively higher Sections to wear clothing adorned with the moonlight stone, M Corp’s Singularity. Of course, the Liu doesn’t have the exclusive right to use it, so you can see it on the clothes of other Fixers and Syndicate members, too. The moonlight stone emits a golden glint, and you can either gild your clothes with it or make ornaments out of it.",
            "The moonlight stone mitigates or shuts off psychological affliction induced from all kinds of mental attacks, pressure, interference, and all that… Whether it’s caused by seeing, hearing, or feeling something, or a direct assault to the mind. Although, I don’t really know how the stone works… They said it amplifies a single purpose or thought, making people forget the mental pain coming from outside, or fortifying the mind as if it’s surrounded with a giant barrier. It’s all thanks to this clothing that we didn’t panic when we saw the Crying Children, a Distortion!",
        ],
    },
    {
        ID: "250005",
        Name: "A Thumb Soldato’s Page",
        Level: "Star of the City",
        Source: "The Thumb",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 86,
        StaggerHP: 45,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "ThumbUnit",
        Passive: [
            "10001",
            "250005",
        ],
        Desc: [
            "The Thumb is the most cultivated and humane of the Five Fingers. Just be polite, and know to respect others. But then, why did the Thumb top the list of Syndicates one would never want to get involved with in the survey for Fixers conducted by the Hana Association, in spite of such good manners? The reason is simple: Hierarchy is absolute for the Thumb. To us, it’s as natural as the fact of nature that spilt blood only flows downwards, not up. One is expected to give unconditional obedience to a higher authority. That’s where the relative courteousness of the Thumb comes from.",
        ],
    },
    {
        ID: "250006",
        Name: "Kalo’s Page",
        Level: "Star of the City",
        Source: "The Thumb",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [3, 6],
        HP: 94,
        StaggerHP: 53,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "KaloLibrarian",
        Passive: [
            "10008",
            "250005",
            "250006",
            "250106",
        ],
        Desc: [
            "Capo dei capi (Godfather), Sottocapo (Underboss), Capo (Captain), and Soldato (Soldier/Goodfella)… The Thumb is divided into these four echelons. This hierarchical structure is still effective outside of the Syndicate. For example, a common Fixer is comparable to a Soldato, an Associate Fixer to a Capo, a board member of a Wing to a Sottocapo… This is how the hierarchy is to be interpreted. No outsider is exempt from this rule. No matter how you usually behave, you must remember your place and respect our rules when you’re dealing with the Thumb. If a young, oblivious Fixer walks up to a Capo and speaks to them, that poor picciotto will be rolling in the street the next day with his jaw and teeth missing. On the other hand, someone with the right level of authority or person of a higher class would be a different story. If a person on the same echelon as ours were to approach us, we’d gladly greet them and hear what they have to say with an open mind. Conversations with them are to be conducted with courtesy and decorum. Furthermore, if the person you’re dealing with stands on a higher echelon than yours… They must be treated with utmost devotion and delicacy. Such is the rule of ours, and the respect to their position. Don’t be too bitter over it. Indeed, class is earned, not given for free; it’s only right to give it the respect it deserves.",
        ],
    },
    {
        ID: "250007",
        Name: "Boris’ Page",
        Level: "Star of the City",
        Source: "The Thumb",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 90,
        StaggerHP: 50,
        SResist: [0, 0],
        PResist: [0, 1],
        BResist: [1, 0],
        Skin: "Boris",
        Passive: [
            "10001",
            "250007",
        ],
        Desc: [
            "The Thumb uses various types of bullets. We pick the right ammo for the right situation. But, as you can guess, the price of those bullets is a serious drawback. Not even the Thumb, one of the Five Fingers sitting at the apex of the Backstreets, can just waste bullets willy-nilly… That’s how costly it gets. You can’t get trigger happy. Because of that, the Thumb fight with the bayonet and buttstock of their guns most of the time, and only fire bullets when it’s absolutely necessary. The buttstock is built to be solid enough to crush most things to a pulp, and the bayonet is pretty handy as a sword. Some just stick to raw strength, though.",
        ],
    },
    {
        ID: "250008",
        Name: "Katriel’s Page",
        Level: "Star of the City",
        Source: "The Thumb",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 89,
        StaggerHP: 47,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Katriel",
        Passive: [
            "10001",
            "250005",
            "250008",
        ],
        Desc: [
            "The Thumb’s chain of command is simple: Obey the orders issued by your superior unconditionally, and do not question the intentions of your superior. Kill if you’re told to kill, and die if you’re told to die. You cannot defy the orders no matter how baffling it may seem. Those who violate them are punished on the spot. Even if the order is made by someone whose rank is only one step higher than yours, you’re still obligated to follow it. There’s nothing you can do about it, unless another person whose position in the pecking order is even higher than your commander’s decides to step in and take your side.",
            "There is one exception, however; it’s when a high-ranking individual temporarily devolves their power to a subordinate of theirs. Usually, this occurs if they have urgent business that prevents them from joining a meeting, or when they need their peer to know something that the subordinate can explain more professionally… It’s still a rare occurrence even then. No one transfers their authority for the fun of simulated uprising or other trivial reasons. That’s how significant the hierarchy is to us.",
        ],
    },
    {
        ID: "250009",
        Name: "Denis’ Page",
        Level: "Star of the City",
        Source: "The Thumb",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 89,
        StaggerHP: 47,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Dennis",
        Passive: [
            "10001",
            "250005",
            "250009",
        ],
        Desc: [
            "Even in a powerful Syndicate, weaklings exist… Cowardice can surface among the strong, and chaos can ensue from the most faultless rules. Not everyone in the Thumb can abide the rules without a slip-up.",
            "What happens when one violates the rules… If someone is trying to disrupt the hierarchy, they will be purged in a few days. It doesn’t matter if it’s a member of the Syndicate or an outsider… Every person must abide by the rules… The degree of violation is irrelevant; that doesn’t decide the weight of the purge. The one thing that matters the most is the fact that they showed insolence. The lesson is marked with blood so that no one… no one dares to break this rule again. That’s the most important one. It might seem like nitpicking, but there’s one basic principle to remember: Don’t get on the nerves of your superior. It’s such an elementary part of the basic decencies for human relationships, yet so many people seem to be oblivious of this…",
        ],
    },
    {
        ID: "250010",
        Name: "Nemo’s Page",
        Level: "Star of the City",
        Source: "Cane Office",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [4, 6],
        HP: 94,
        StaggerHP: 53,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Nemo",
        Passive: [
            "10001",
            "250010",
            "250110",
            "250210",
        ],
        Desc: [
            "We live in turbulent times when Wings are destined to fall behind in the market if they don’t respond to patent disputes effectively, big or small! It’s one of the reasons patent wars are that much important. Those megacorporations sue one another for patent infringement, or accuse one another for stealing their patent… Us small fries can watch the giants clash without worrying about getting caught in the crossfire; in fact, we benefit from such conflict! There are unspoken rules that you need to remember to keep your stake in a patent war: One must patent their technology separately for areas outside of the Nest or other domain under their jurisdiction, one must avoid admitting to infringement before carefully reviewing the lawsuit, the rights to a technology cannot be protected if its details were publicized through advertisements or such before the patent was registered, et cetera… Patent wars break out for so many reasons, it’ll take a day and a half to list them out!",
        ],
    },
    {
        ID: "250011",
        Name: "Martina’s Page",
        Level: "Star of the City",
        Source: "Cane Office",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 87,
        StaggerHP: 49,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Martina",
        Passive: [
            "10001",
            "250012",
            "250110",
            "250210",
        ],
        Desc: [
            "Notarization is the process of drafting a document to officially certify a deal between two Offices in case things happen… A notarial act is fairly powerful. Through these documents, you can verify various facts and secure executory force. Meaning, if one side doesn’t carry out their part of the contract… The contract can be enforced on them. There’s no need to argue about who is to blame. Notary acts exist to stop unnecessary disputes from occurring, and it’s the job of notary public Offices like Cane Office to help with that…",
            "Oh, and the City is divided into domains… It’s similar to how the Zwei Association sets territories for policing; it’s fair to expect at least one notary public Office in every domain. This isn’t to say that you can only use the notary public in your domain; if you can’t find a notary public, or if the Office isn’t functional for whatever reason, you can always go to other domains… Though it costs a bit more… A lot of people still choose the latter since they need to get business done in a hurry. Not every notary public Office has the same level of professionalism, after all…",
        ],
    },
    {
        ID: "250012",
        Name: "Bada’s Page",
        Level: "Star of the City",
        Source: "Cane Office",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 89,
        StaggerHP: 47,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Bada",
        Passive: [
            "10001",
            "250011",
            "250110",
            "250210",
        ],
        Desc: [
            "Contracts should be signed on equal terms with the consent of all parties involved. And the Offices must fulfill the terms of the contract following the mutual agreement. It’s a societal boundary that keeps us humans from betraying each other’s trust as we must coexist. Although these principles are rather abstract, they exist to prevent anyone from devising lowly schemes and ensure that each party gets just benefits. The Head’s rules don’t cover every small detail, so you can say this is a necessary addition to fill those gaps.",
        ],
    },
    {
        ID: "250014",
        Name: "A Church of Gears Worshipper’s Page",
        Level: "Star of the City",
        Source: "Argalia & The Churches of Gear",
        Obtainable: "True",
        Rarity: "Paperback",
        Speed: [2, 6],
        HP: 86,
        StaggerHP: 45,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "GearsUnit",
        Passive: [
            "240026",
            "250014",
            "250114",
            "250214",
        ],
        Desc: [
            "As the gears turn, our bodies are put in motion… Thought Gears are indispensable for Meat Gears… The introduction seems terrifying, but Thought Gears are said to feel much more satisfaction than Meat Gears do as time passes… Actually, I’m not sure if… a Thought Gear can still think like a human… They say Thought Gears are honored to be serving their role… But perhaps it’s only a made up story told by the worshippers who hadn’t completely gone awry… wishing to free themselves of what little guilt they had… The words I sometimes hear aren’t heard through my ears… The gear guides my body as it rotates, as if it’s entering commands into my brain… Though that matters not… We are able to live thanks to the help of the Thought Gears… We’re no longer lost, unable to find a way ahead… Even if there is no path to take… It tells me where to place my next step…",
        ],
    },
    {
        ID: "250015",
        Name: "Esther’s Page",
        Level: "Star of the City",
        Source: "The Index",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 101,
        StaggerHP: 53,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Esther",
        Passive: [
            "10008",
            "250115",
            "250015",
        ],
        Desc: [
            "Is forging Prescripts a violation of rules? The answer is “Not exactly.” It can be written on any kind of paper, and as long as it is stamped with the seal of the Index, it’ll pass as a real Prescript. You will then wonder: Wouldn’t there be many people who exploit the system with malicious intent? Copying the seal is a complicated process, and not many know how; even if they overcame those hurdles, they still cannot outsmart the Prescripts. The Prescripts know all. They can tell whether or not a Prescript has been carried out, how it was done, and if someone is delivering fabricated Prescripts. An individual sending counterfeit Prescripts out of their own volition can ultimately be traced back to the will of the Prescripts, and the City itself. I suppose the Prescripts have some generosity for those forgers, as they may remain unpunished unless a Prescript ordering it has been issued. The Prescripts were already aware that Messenger Yan was giving out false ones, hence the Prescript to follow those faked orders. …No, that the Prescripts “know” might not be the most appropriate expression.",
        ],
    },
    {
        ID: "250016",
        Name: "Hubert’s Page",
        Level: "Star of the City",
        Source: "The Index",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [4, 6],
        HP: 101,
        StaggerHP: 53,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Hubert",
        Passive: [
            "10001",
            "250115",
            "250016",
        ],
        Desc: [
            "There are a number of ranks within the Index. Proselytes, Messengers, and Proxies are as much as I know.",
            "Those who have been chosen by the Prescripts will decide whether to become a Proselyte. If they accept it, they will cover their eyes with a blindfold as they serve the role. The blindfold has little symbolic significance; it’s to teach the Proselyte to follow the Prescripts regardless of what is happening before their eyes. Usually, a group of five to six Proselytes accompany a Proxy, learning the rules of the Index and the role of each rank. If a Proselyte shows a certain level of competence, the Prescripts will assign the role of a Messenger or a Proxy to them. After being promoted, they are given a blade of their own, and they may take off the blindfold.",
            "The Prescripts are a predetermined path; there is no point for Proselytes to refuse any. It’s still within their choice to decline the Prescript’s offer. Even though they’re free to quit anytime, no one knows if the Prescripts will allow it. The Prescripts might order Proxies to kill the runaway who abandoned their position, or let it slide, or even give the order to resign first. The Prescripts are truly unpredictable.",
        ],
    },
    {
        ID: "250017",
        Name: "Gloria’s Page",
        Level: "Star of the City",
        Source: "The Index",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 101,
        StaggerHP: 53,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Gloria",
        Passive: [
            "10001",
            "250115",
            "250017",
        ],
        Desc: [
            "The Index has an arsenal of swords and blades. Most of the Prescripts we receive can be solved with a sword, too. Mmm~ Never really thought about why we use swords, nope! Maybe it’s because they have this oppressive aura and make us look serious or something?!",
            "Each of us uses different types of blades. Starting with the ranks of Messengers and Proxies, the Prescripts give personalized swords. From a light one-edged sword fit for slicing things quickly; to heavy, double-edged greatswords~ They come in all kinds of shapes and sizes. Helps us stand out from each other. As for me, I’ve got five whole blades~ Maybe being speedy helped? It looks like we get swords that fit our traits~ Have you seen the sword Hubert’s carrying? It looks so heavy, and he swings it like it’s nothing.",
        ],
    },
    {
        ID: "250018",
        Name: "Chun’s Page",
        Level: "Star of the City",
        Source: "Liu Association South Section 1",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [3, 6],
        HP: 94,
        StaggerHP: 50,
        SResist: [0, 0],
        PResist: [0, 1],
        BResist: [1, 0],
        Skin: "Chun",
        Passive: [
            "10001",
            "250018",
            "250001",
        ],
        Desc: [
            "Right now, Nest L is practically a warzone with all the Associations, Syndicates, and Fixers at each other’s throats. On top of that, the Distortions are making things worse for Associations and the residents of the Nest… According to the report from the powers up above, there are three major factions of note currently remaining in the Nest: The Index, R Corp, and the Blue Reverberation and his group. R Corp. seemed to be eliminating threats as per request from another Wing, similar to what the Liu is doing. The Index appears to have been guided here by the Prescripts. After all, they gladly obeyed the piece of paper telling them to kill every member of the Thumb in the Nest. As a result, pretty much every Thumb crook and the Syndicate’s subsidiaries that were in this place are goners… Even the Underboss who was supposed to lead them kicked the bucket, so you can guess how it went.",
        ],
    },
    {
        ID: "250019",
        Name: "A Liu Section 1 Fixer’s Page",
        Level: "Star of the City",
        Source: "Liu Association South Section 1",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 87,
        StaggerHP: 46,
        SResist: [0, 0],
        PResist: [0, 1],
        BResist: [0, 0],
        Skin: "Liu1Unit",
        Passive: [
            "12",
            "10001",
            "250001",
        ],
        Desc: [
            "To a leader of the Liu, the most crucial element that can make or break a battle is vigor; not the competence or strength of individuals. With vigor, even the weakest creek can carry heavy rocks like a gale blowing up leaves. Therefore, an excellent leader chooses good Fixers and then puts vigor into them. Strength or skill alone won’t make a good Fixer. While those traits do play a role in higher Sections, the most important quality is how well the Fixer meshes with their leader’s combat style. Section 2, the team with Mei and Cecil, consists of careful and level-headed Fixers. They go quite well with Director Lowell because of that. Section 1 would clearly be superior in terms of sheer power, but we follow different strategies with pros and cons for each, so a direct comparison won’t really tell much about our actual performance in the field.",
        ],
    },
    {
        ID: "250022",
        Name: "The Red Mist’s Page",
        Level: "Star of the City",
        Source: "The Red Mist",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [1, 8],
        HP: 105,
        StaggerHP: 57,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Kali",
        Passive: [
            "250122",
            "250222",
            "250322",
            "10008",
        ],
        Desc: [
            "E.G.O. The weapon that corresponds to the mind of its wielder. The sword Carmen gave me was extracted from someone by chance. Giant eyeballs were attached to the sword adorned with crimson chunks of flesh; they watched my every move, almost to the point of making me feel a bit uncomfortable. Wondering if this was a product of some new Singularity, I asked Carmen what the thing was; she only said that I’ll have to get used to it, since there’s little she can do about how it looks. Although it looked a bit creepy, it wasn’t anything unbearable, and Carmen didn’t seem to mind it as long as there were experiments to be performed with it. She added that I have to be careful with it as it was thanks to sheer luck that the “E.G.O” could be extracted at all in its unstable state. I had a plethora of experience handling various workshop products, so I decided to take the sword without much hesitation.",
            "When I first had the sword in my grip, I didn’t feel anything in particular. All I could tell is that it’s just a big, heavy greatsword; nothing out of the ordinary other than its appearance. But when I held the sword a few days later to protect a coworker of mine, I heard a voice. It was the voice of someone desperately yearning for something. Unfortunately, the meaning of that voice was lost on me. Rather… it wasn’t even human speech. An awkward sound mimicking somebody. Noises of teeth grinding, bones crackling, mingling with flesh. Some things collide, fall apart, and mix in irregular patterns as if to mimic the way humans speak. However, that sound was too violent and sharp. The strong obsession of an empty one. Attachment. Void. I’m not sure what word I should use to define this.",
            "One thing I understood was that only I could hear that voice, and that it rang in my head rather than my ears. The stronger and clearer my aim to protect someone became, the louder the noise in my head got. Anxious that my mind might be consumed by the voice if I let it weaken my will, I tried my best to pretend that I didn’t hear it. The eyes on the blade carefully observed me as I fought the voice in my head. The piercing gaze persisted as if to replace me if I faltered even for a second; it made me feel hazy sometimes. The “voice” was only a bunch of grinding noises at the beginning, but it slowly learned to speak over time. Soon enough, it started speaking in a language that I could understand, though it stammered a bit. It takes human hide to protect human flesh. A shell… It kept asking for a shell. I couldn’t stop the voice, so the most I could do was ignore it.",
            "Even though there was danger in using it, its power was formidable; with it, I protected many a person, and cut down many a threat. The voice became stronger and deeper with the more blood the blade drank. One day, it asked a sharp question: “Don’t you desire a human shell as well?” When I think back on it, the question might not have been aimed at me specifically. It would only say whatever it wanted to say. It wouldn’t try to convince or allure me. All it uttered was monologue. Yet, I was frozen stiff when I heard that. It kept saying something. Are our lives really worth the blood I spilt for them? It wasn’t actually capable of forming such detailed sentences, but my head took it that way for some reason… Maybe I was thinking to myself.",
            "I denied its claim at the start. I’d never provoked anyone first. I’d only acted to protect others from an approaching danger. But, I felt a small part of myself waver from what the voice said. What will remain when I keep washing away blood with blood? A bloodstained shell would be all that is left.",
            "I collapsed for a moment; but I didn’t stop thinking. If I broke down, I might be in danger as Carmen warned. Carmen… Right, Carmen would’ve been different. Nothing could possibly beat the glitter in her eyes that shines as she pioneers a new path. Those honest, virtuous eyes… Even when someone jeered at her speech, even when everyone despaired in the face of an obstacle that brought progress to a halt, Carmen never stopped looking after others. She would always take the initiative to lead all of them. If I can protect a person like that, maybe this place will change? Yes. As long as I can protect that one person.",
            "As my thoughts became clearer, I couldn’t just sit down. My body acted before my head could decide what to do. I don’t exactly remember what happened then. When I finally took a grip on my rationality in a vast mindscape and came back to my senses, my body was burning hot. Is this rage? Have I been taken over to the point where I can’t even see ahead? But I felt so calm, refreshed even. My head was kept cool, while my heart leading the body was aflame. It wasn’t long until I felt that something was different. On solid armor, there was a layer of something tough and dense, but it wasn’t fabric… A veil of mist was covering me. Astonished, I moved around and shook my limbs several times, and the veil dissipated soon after.",
            "When Carmen learned of this, she didn’t say much. She didn’t make a big fuss about it or suggest trying something with it right away. She only said that wielding this power is more important than simply manifesting it, so I shouldn’t be lazy… She went back to work after leaving that peculiar piece of advice. Maybe she didn’t want me to feel too much pressure.",
            "As more time passed, I could use the armor for longer, and eventually got to draw out its full power. I had a weapon and armor that resonate with my emotions. Using them, I could protect more people, and I was able to draw forth more durability and strength. The researchers seemed to be struggling to make progress with their work, but it was alright. I believed in them to make it through, and I just had to be quicker to do my job in the meantime. However, not long after, the incident happened all too suddenly. No, maybe it wasn’t so sudden. The sign was there.",
            "Just around this corner, I can hear a child crying; she’s sitting in front of a door. One of the two children Carmen took in died in a failed experiment. Unlike Lisa who was wary and reluctant to open up to us, Enoch showed interest in our research, and volunteered to be a test subject the other day. Enoch’s speech was so concise and on point, everyone was shocked. He wasn’t afraid, and he wasn’t shaking… His voice was unswerving and gentle. Enoch’s eyes weren’t those of a naive little kid. His words and thoughts were surprisingly deep and mature; even I was astonished. I sometimes wondered what made this kid have such thoughts. His eyes seemed to have already seen so much of this world’s despair and misfortune. However, it was still no reason to allow a kid to participate in the experiments. Carmen spent several nights agonizing over the matter.",
            "The experiment was authorized at last, though I didn’t want to know what they thought of it anymore. What were they going to do, holding the hand of that little kid? I had to wonder if we were that desperate. But I shrugged it off. I wasn’t one to stop him from doing what he chose to do.",
            "“You should’ve been the one to die…” The other kid, who was now all alone, mumbled crying. Her words had no weight to it. She probably spouted what she didn’t sincerely mean, because the situation was too much for her.",
            "“Yeah… I— I should have died.” Carmen’s answer, on the other hand, was likely sincere. Everyone stood still. A crack appeared in our minds which we never thought would crumble. Maybe we all expected it to happen deep down.",
            "Carmen’s state worsened with each passing day, like a rusting nail. The sunny eyes of the woman who had brought us together were now cloudy, and she spoke less and less. Her voice was lifeless, and she had gotten so cold; it wouldn’t have come to anyone’s surprise if she died at any moment. She didn’t bother trying to look okay. I think it was better that way. Everyone in the laboratory felt constraint in her presence. They viewed Carmen in different ways. Reproachful looks of those resenting her for bringing them so far, only to let go of her responsibility. Concerned looks of those worried that something might happen to her. And I guess there were some who had no thoughts. The research went on quietly, but not for long.",
            "A few days later, Carmen spilled out all of the guilt within her and plunged into it, never to come back up.",
        ],
    },
    {
        ID: "250023",
        Name: "Nikolai’s Page",
        Level: "Star of the City",
        Source: "R Corp",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 101,
        StaggerHP: 53,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Nicolai",
        Passive: [
            "10008",
            "250123",
            "250023",
            "250223",
        ],
        Desc: [
            "After a moment of silence, she slowly opened her mouth. A large-scale war was about to occur. If we made big enough contributions in that war, we might be able to avoid being destroyed. That wasn’t a suggestion or a plea for help. It was a semi-mandatory request. The reward: We get to avoid termination. Her attitude was something else; the way she confidently delivered her speech in front of me gave off a certain sense of conviction. It was as if she were saying she’s going to make the war happen. Baffled, I let out a bout of laughter. I knew we weren’t in the position to refuse it.",
            "And she was right; a huge war broke out soon after. Thick smoke covered that Nest.",
        ],
    },
    {
        ID: "250024",
        Name: "Myo’s Page",
        Level: "Star of the City",
        Source: "R Corp",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 101,
        StaggerHP: 53,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Myo1",
        Passive: [
            "10001",
            "250123",
            "251001",
            "251101",
            "251201",
            "250024",
        ],
        Desc: [
            "Ever since that day, I trained myself, aspiring to become like the hero that saved me that day; and landed a job at R Corp. I wanted to become a hero myself and save the lives of others… What I wanted more than anything, though, was to meet that person once more. R Corp. participated in most large battles in the City, so I expected to see her someday. I thought she’d have been alive all along since she was tough. I was going to thank her and show her how much stronger I had gotten since then if I did get to see her again.",
            "But, I… well, yeah, I couldn’t tell her. Not just because I never saw the Red Mist again… or Gebura, as she is called now. We did meet each other after a long time, but that’s another story. I wouldn’t have been able to say it even if I met the Red Mist when she was alive and well. I got embarrassed of myself again. I thought I’d saved everyone, but after all, what I’ve been doing was far from being a hero.",
            "Hey, what do you think a hero is?",
        ],
    },
    {
        ID: "250025",
        Name: "Maxim’s Page",
        Level: "Star of the City",
        Source: "R Corp",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [3, 6],
        HP: 105,
        StaggerHP: 52,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Maxim",
        Passive: [
            "10001",
            "250123",
            "251002",
            "251102",
            "250025",
        ],
        Desc: [
            "One day, some rich person visited us and said that a war will break out soon. Said we’ll get some benefits if we helped her.",
            "That gave us a bigger thing to worry about than an upcoming destruction. A war is about to happen? Nikolai collected her thoughts and calmly asked why a war was going to occur.",
            "That person paused for a bit, then spoke in a languid tone. I was creeped out by how she said it like it was no big deal.",
            "“When one person’s pure ambition and another’s tragic obsession join together, a dream is destined to be born.”",
        ],
    },
    {
        ID: "250026",
        Name: "Rudolph’s Page",
        Level: "Star of the City",
        Source: "R Corp",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 101,
        StaggerHP: 53,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Rudolph",
        Passive: [
            "10001",
            "250123",
            "251003",
            "251103",
            "250026",
        ],
        Desc: [
            "R Corp. is particularly famous as a private military company. No matter how many combatants die in battle, we fill the vacancy with new soldiers in no time. It was natural for the Wings giving us requests to wonder what kind of Singularity we have to pump out so many mercenaries in such a short time frame. Besides, our soldiers weren’t lacking in combat prowess by any means, so there had to be more to us than just hiring many people. The mercenaries of R Corp. don’t fear death in the first place; they don’t hesitate to carry out any tasks. We’re big in numbers, casualties are replaced quickly, and we fearlessly proceed and get the job done. R Corp’s mercs were ideal for Outskirts explorations and other dangerous operations.",
            "How could such a feat be possible, then? People started making guesses.",
            "At the end of the day people just laughed it off, talking about how nonsensical their hypotheses were and how secretive Singularities are. Maybe they had the right answer, though they missed the mark a bit.",
        ],
    },
    {
        ID: "250035",
        Name: "The Purple Tear’s Page",
        Level: "Star of the City",
        Source: "The Purple Tear",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 103,
        StaggerHP: 53,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "ThePurpleTear",
        Passive: [
            "10008",
            "250027",
            "250127",
        ],
        Desc: [
            "If you’re reading this book, it must mean there’s something you want to know about me. I’m sure you have lots of questions, but I sadly can’t give out detailed answers. It’s hard to come up with a definition and explanation for a power that naturally emerged, you see? How should I put it, in that case…",
            "I can travel through time and space and see a myriad of possibilities, too many for you to possibly fathom. It’s probably a little bit different from time travel as you commonly imagine it. The future self who experienced a certain past returns to it in order to change the future… Whatever is going on in the past, some kind of paradox is bound to happen to causality. Big or small. Little things can set off massive twists, like the flap of a butterfly’s wings causing a tornado… And even I’m afraid of bearing that risk. It could turn into a cycle of meaningless struggles.",
            "Yeah. I guess it’s fairer to say that I travel to a completely different space. Ever thought about the possibility that an infinity of different versions of the world you live in might exist? Let’s say that you sidetracked on your way home and were killed by some Syndicate members that ambushed you. But in another world, you might have decided you wanna go straight home, and the assault would’ve never happened. Or, you might have noticed the Syndicate members as soon as you stepped into the wrong alley and quickly got back on track. Those small choices can add up, and result in countless worlds where countless outcomes unfold. …I know what you’re thinking; this isn’t logic that can realistically be proven. I know all of this sounds unbelievable. People can’t understand me because of that, and even I have difficulty explaining myself.",
            "I made it sound grandiose, but this power isn’t almighty by any means, so I try not to use it carelessly. Not that I expect you to care for such details. It’s already complicated enough as it is, isn’t it? Just know that this power isn’t omnipotent. No power is conveniently given to you in this world, after all; there’s always a price you need to pay, and there is a world I yearn to reach, no matter that price. I’m doing this so I can find the world where I can see that possibility.",
            "And in the many worlds I’ve been to while doing this job… I saw many people who were lost after losing their precious stuff, just like me. I couldn’t just pass them by. They looked so miserable and pitiful. Well… It wasn’t entirely out of goodwill. The fact that they were worth helping played a big part. Once again, nothing in this world is free. I didn’t quite pity them as much as I weighed up the favors they could give me in return. Thanks to that, I’ve become acquainted with quite a few Fixers… And as corny as it is to say this myself, some even started calling me their mentor, and became my devoted admirers.",
            "Lots of people ask me what I’m going to such great lengths to see. A leading figure that commands powerful Fixers who are on the level of a Color? I dunno. All I want is to meet my son, whom I had to part with in the most unfortunate way. Meaning I don’t care about the ancillary stuff. I can see it so faintly… It almost seems to be within my reach, but it always ends up being a mirage.",
        ],
    },
    {
        ID: "250036",
        Name: "Xiao’s Page",
        Level: "Star of the City",
        Source: "Xiao & Miris",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 101,
        StaggerHP: 58,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Shyao",
        Passive: [
            "10008",
            "250001",
            "250020",
            "250036",
        ],
        Desc: [
            "I was in no way a soft person, though I don’t view myself as particularly tough or rugged, either. A straight and honest person. Accusations would be brought against me for being unmoved by the death of any person however close they may have been in life, a point not everyone would see as criticism. How could a person be so cold and heartless, even if the basic bearing of a Fixer is to look after oneself first and foremost? At first, I spent much time thinking over it, and asked myself many questions. Xiao as a person valued the lives of her colleagues, although her position forced her to keep her farewell to deceased teammates short, since carrying out her duty and emerging victorious came first. Shedding fewer drops of tears than the number of fallen was all the tribute I could pay. Bawling my eyes out would have stirred uneasiness in my colleagues. In the early days, the responsibility sometimes felt too heavy and burdensome.",
            "I had never once thought that my method was incorrect; I believed it to be the best method for myself, and I deemed that problems couldn’t be solved any other way. Most Fixers will probably think in the same way. Therefore, I could not understand the manners of Lowell, the newly appointed Section 2 Director at the time. A person who tries to look after everyone, and doesn’t hide his grief-stricken face when a coworker passes away. It seemed clear as crystal that his tenderness would one day lead his team to death, yet he was faring better than I thought. A polar opposite to me. The ways I wanted to pursue but gave up because I was faced with my limitations. It might have upset me for a moment. A principle I could not follow, for I was not allowed to openly express sadness over the death of the few in order to protect the many; and my obligation to seize any chance of victory compelled me to march forward if there was something to count on. My capability wasn’t vast enough to embrace every member of the team. Was my choice wrong? What did he have that I did not? Looking back, I don’t think what I felt was envy or jealousy. The indignation certainly was not a toxic emotion. I’m sure each of us had different specialties.",
            "It is said that people intersect with one another in some manner. I don’t think the process to be natural at all; I was not a believer of fateful meetings. After all, two parallel roads could never cross. A relationship begins with a desire to know. Simple curiosity. To know more about a person, or to go further and see what they are seeing together. People open up new roads to merge into the roads of others for various reasons.",
            "I thought I would never care about him since he was so different from me, but my expectations weren’t quite right. I wanted to learn more about him, and I wanted to know what this emotion I felt was. And I thought I could perhaps become a better person if I saw what he was seeing together. If there’s one thing I realized, it’s that relationships between people always start from such small curiosity.",
            "Taking in what I have said so far, you would think that this is such a peculiar and untruthful love. You might think it’s fussy. I cannot give out a clear answer, for I can’t dare define what love is. What could I say or add about an emotion I felt for the first time, one that I am still struggling to figure out? Furthermore, every person carries a different form of love. There will undoubtedly be some people who don’t place much importance on that emotion. You might even think that such emotion is absolutely useless in this City. Even if I were to define my love, this wouldn’t come across as a sweet story if you cannot understand it.",
            "However, I can be certain that my sentiment towards Lowell was sincere. The so-called curiosity and sympathy… They bring about attention, admiration, and a little bit of obsession. I learned soon enough that this isn’t much different from what people call “love”. It may not have been something out of a fairy tale or a drama, but we still cherished each other in our little relationship. Perhaps I had been under the impression that love is a concept that is utterly distant from me. The love that I came into was cramped, yet big… and it felt burdensome at times.",
            "You said I am strong, but the truth is that I was weak and fainthearted until the very last time I faced you. I have only grown so ironclad after I lost you. Why did I miss everything while you were still by my side? Why do I spend the whole night longing for you and regretting only after you have parted from me? I do have one regret regarding you: that I could not trust my feelings for you. That I was too afraid to tell you that you’re my everything the night before you left me.",
            "Moments of loneliness will come as I live. It won’t be a thirsty longing for love, however. It is when I look to my side, yet there is no one next to me; when I am worn out from running somewhere; when I feel that my heart grows heavy rather than painful. Trying new things might let me forget it for a moment, but the memories will still follow me for life. When I feel such things, I can go back to familiarity. A familiar place, a familiar mind, a familiar person. And I plan to reunite with you soon. I want to tell you that I no longer have shame for the path I’ve chosen, and that I have finally freed myself from the guilt.",
        ],
    },
    {
        ID: "250037",
        Name: "Miris’ Page",
        Level: "Star of the City",
        Source: "Xiao & Miris",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 7],
        HP: 96,
        StaggerHP: 49,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Miris",
        Passive: [
            "10001",
            "250001",
            "250021",
        ],
        Desc: [
            "Director Xiao liked to emphasize something: “A mercenary’s work is to deceive; to fool the enemy into believing that we are advancing when we defend; to make the enemy believe we will thrust from the front when we strike from above. Feign submission when you raise your claws; we must seem unable when able to attack, that the enemy may grow arrogant. When the enemy is roused, distract them through disturbance; be aware that we ourselves are not subject to such anger. In order to defeat the enemy, we must be roused to anger; to remember that one’s emotions must remain a means to motivate the body and not the ends, and to exploit the enemy’s wrath with this in mind.” Our director may be seized with anger and momentarily stray onto inadvisable paths sometimes, but even the whitest jade has a flaw; I trust her to set herself back on the right track in no time.",
        ],
    },
    {
        ID: "250051",
        Name: "얀샋ㄷ요무’s Page",
        Level: "Star of the City",
        Source: "얀샋ㄷ요무",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [3, 6],
        HP: 103,
        StaggerHP: 55,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Yan_Librarian",
        Passive: [
            "10008",
            "250051",
            "250151",
        ],
        Desc: [
            "Have you ever seen a glimmer of light when you close your eyes? It’s blindingly bright at times, and it shakes in an irregular shape at times. This sensation is often called a phosphene. Whenever I close my eyes, the blurry image of a bloodstained carpet appears to me like that optical phenomenon. The beginning of an unpleasant nightmare. Four mannequins that lost a face and an arm each are lying on the carpet, spilling red beads; another mannequin has its hand on my shoulder. I turn around and look at the loudspeaker in the mannequin’s face. I can feel the vibration coming from it, even though I can’t hear what it says. But I already know what sound this mannequin is making. The vibration precisely matches the words I remember, and my heart starts beating accordingly.",
            "This damned power of recall lost all my good childhood memories to oblivion, yet it brings back such remembrances every time I close my eyes. My response to it is always the same: Take the flower that’s slipped into my hand and nail it into the mannequin’s heart. A beautiful tree in bloom grows from the cracks the flower made. It’s as soft as the hands that caressed me, and it’s as pretty as the sound that consoled me. And it’s as sharp as the noise of that last moment when I was scolded for the first time. Every branch that grows from the tree causes a piercing buzz in my ears, and the petals hurt as they brush past my cheeks as if to make me feel the pain they hold. I stand still like my feet were tied, until my body is covered in scars. One, two… Black marbles fall from the wounds. How long have I been in this cycle of pain?",
            "The nightmares have been with me for a good majority of my life. If I close my eyes, the memory of that time haunts me—and if I open my eyes, a reality I can hardly bear unfolds. I chose to keep my eyes shut because I thought I’d rather deal with the ever-echoing past. At least I won’t be visited by new kinds of pain… Prescripts keep coming without a break. The City folk meet different ends depending on the Prescripts they receive, though their fates all share a commonality of cruelty. Their resentment, screams, tears, rage, and death… It’s too much for my eyes. I sometimes thought how my life would’ve been if I stayed as a commoner taking Prescripts like them. Maybe I was better off back then. Maybe I should’ve just died early so I could breathe again as another being. Why did the Prescripts give me that order that day?",
            "I trace back the nightmares to remember the past; everything was over, and I planned to follow them to death, but I didn’t have the courage to end my own life, so I… I picked up the Prescript that I thought would spell my doom at last and read it slowly. All the fresh-looking Prescript contained was a command to be a Messenger. It was pointing toward a beginning, not an end. I couldn’t see a single word that said anything about salvation or death. After being numb for a while, I finally tumbled down to the floor and broke into laughter louder than any sound I’d made before. I couldn’t help but laugh at my state. I wanted to end my life because of Prescripts, and now the Prescripts won’t even let me do that. Where has my free will run off to?",
            "I was frustrated. Not even my own life was under my control, for everything relies on the Prescripts. Then I’ll gladly play along. Even if I can’t shatter the Prescripts, I’ll at least make a tiny crack. If I can show the masses that it’s possible to oppose the Prescripts, something might change… Something has to… It WILL make a difference. Once I had hope, I could see the way—and once I could see where to go, I had the strength to get up.",
            "However, I realized it only just now. What I felt wasn’t hope, and that ignoring that Prescript and taking my own life as I’d planned might have been a truer expression of my free will.",
            "What is the right way to live a life in this place, I must wonder? I’m not even dreaming of a life that I can be proud of; how does one achieve the feeling that their life is bearable to live, let alone be satisfied with it? I thought I had found an answer to that… But in the end, I couldn’t escape the Prescripts. The Prescripts are the City’s will as it is my will. I’ve realized my limit. I feel as if I’ve hit some kind of wall I can’t overcome. However, I don’t feel all too forlorn and miserable. Maybe there’ll be someone who can ride along with the flow, rather than break it. It just won’t be me; I’m not fit to accomplish such things.",
            "So I want someone to find an answer in my stead. And I hope they can tell me that. Tell me how I can enjoy this nightmare.",
        ],
    },
    {
        ID: "251001",
        Name: "A Rabbit Team Soldier’s Page",
        Level: "Star of the City",
        Source: "R Corp",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [1, 7],
        HP: 87,
        StaggerHP: 46,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "RabbitUnit1",
        Passive: [
            "10001",
            "250123",
            "251001",
            "251101",
            "251201",
        ],
        Desc: [
            "Every team in the Fourth Pack has its own caricature. You’d think that we’ll never get along with each other, having such different personalities and powers and strengths, yeah? Surprisingly enough, we hunt in packs for most operations despite our differences.",
            "The Lapin-o-Rabbit Team is generally seen as a distracted and raving bunch. Maybe it’s because most of us are nimble? But that also means we handle our missions quickly and with certainty. Our method is the cleanest, actually?",
            "Hmm… If I had to admit a teensy little problem with us, it’s that we don’t discriminate enemies from civilians? We do have a tendency to shoot first at any non-Rabbit in the area that comes into our sight. We’ll leave ourselves open for attacks if we take our sweet time to tell ‘em apart, so we’ve got to strike first. But hey, we don’t leave any troubles behind that way, so what’s good is good, yeah?",
        ],
    },
    {
        ID: "251002",
        Name: "A Rhino Team Soldier’s Page",
        Level: "Star of the City",
        Source: "R Corp",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [3, 5],
        HP: 87,
        StaggerHP: 46,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "RhinoUnit1",
        Passive: [
            "10001",
            "250123",
            "251002",
            "251102",
        ],
        Desc: [
            "Every team in the Fourth Pack has its own character! Our personalities, powers, and strengths are all wildly different, but we still do most of our missions in packs.",
            "Us Rhinos specialize in using physical strength. We’re good at pushing ahead, if nothing else! I think we’re the strongest team in the Fourth Pack. Smash ‘em hard, block ‘em hard! We often stand on the front line instead of the frail Rabbits and Reindeer. The Rhino Team’s armor is thick n’ large! And we’ve got tough bodies, too.",
            "Sometimes though, my body starts heating up if I keep moving around, and I can’t control myself for a while. I figure that’s ‘cause of the odd tech R Corp. uses. Something about expanding muscles and pumping more adrenaline into the blood. That’s what they told me. Oh, in case you’re wondering… This ain’t a Singularity or anything. Plenty of others are making use of it, apparently. We never got to hear the deets. We do hear often that we’ve gotta watch out, though. The Rhino Team’s got more destructive power than others, and once one of us starts getting all excited and enters a rampage, it won’t be easy to stop ‘em until they calm down.",
        ],
    },
    {
        ID: "251003",
        Name: "A Reindeer Team Soldier’s Page",
        Level: "Star of the City",
        Source: "R Corp",
        Obtainable: "True",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 87,
        StaggerHP: 46,
        SResist: [0, 0],
        PResist: [0, 1],
        BResist: [0, 0],
        Skin: "DeerUnit1",
        Passive: [
            "10001",
            "250123",
            "251003",
            "251103",
        ],
        Desc: [
            "Every team in the Fourth Pack has its own characteristics. Our personalities, powers, and strengths vary so greatly that it’s hard to imagine us working together… Nonetheless, we move in packs for most missions.",
            "The Reindeer Team utilizes powerful electric waves generated from brainwaves. You see these horns? The electric stimuli generated in the Reindeer’s brain are condensed at the tip of these horns. The concentrated electricity is then collected by our staves for attacks.",
            "There’s one thing we should be careful of when we use this ability: If the battle drags on for too long, or we exert too much power at once… most Reindeer will go insane. The symptoms are expressed in various ways, but in most cases, they hurt their own comrades or damage the psyches of others. We sometimes utilize K Corp’s Singularities to protect our sanity or mitigate the mental damage, although we can’t afford to use it often.",
        ],
    },
    {
        ID: "260001",
        Name: "A Hana Fixer’s Page",
        Level: "Impuritas Civitatis",
        Source: "Hana Association",
        Obtainable: "True",
        Rarity: "Limited",
        Speed: [2, 7],
        HP: 97,
        StaggerHP: 50,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 1],
        Skin: "HanaUnit",
        Passive: [
            "10001",
            "260001",
        ],
        Desc: [
            "Each Association has a creed or maxim that reflects its atmosphere. Some emphasize gallant passion, while others aspire to a quiet and cold attitude. The Hana Association is no exception in that it has a number of outwardly seen principles. Coincidentally, they represent the most basic ideas of the attitude a Fixer must have.",
            "We must exercise concentration and resoluteness in all situations. Be diligent to detect the emergence of a new flow, yet be wary not to be swept by the flow yourself. As our occupation involves placing some on low positions and holding others in high regard, we must secure the values that constitute our frame, while amending outdated parts of our ideologies. Thus, we need to have an open mind that can accept opinions that differ from our own in moderation. Be willing to listen to the criticism of others and acknowledge it, but be cautious not to throw yourself into confusion by accepting any and all opinions, changing yourself without due consideration. Change what needs to be changed, but be stubborn about the rules we’ve maintained. In conclusion, we mustn’t fall for temptation or deception.",
            "Much like how a foundation influences the structures that stand on it, these principles serve as a basis for all Associations to uphold. Being the Association that supervises the system of Fixers in general, the principles of the Hana are also applicable to the mindset any Fixer should have.",
        ],
    },
    {
        ID: "260002",
        Name: "Mirinae’s Page",
        Level: "Impuritas Civitatis",
        Source: "Hana Association",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 102,
        StaggerHP: 52,
        SResist: [1, 0],
        PResist: [0, 1],
        BResist: [0, 0],
        Skin: "Mirinae",
        Passive: [
            "10008",
            "260001",
            "260002",
        ],
        Desc: [
            "There are twelve Fixer Associations across the City, and the Hana Association is the one in charge of general management of the rest. We’re renowned for rating the threat level of hazards that occur in the City, and grading Fixers and Offices. On top of that, we give out Fixer licenses, issue official documents about certain requests, and assign Colors to Fixers who prove themselves to be beyond the grading system. Our Association calls the shots on pretty much everything regarding Fixer activity. Although, there is one thing the Hana Association can’t touch on.",
            "The ratings of hazards in the City are as follows: Urban Myth, Urban Legend, Urban Plague, Urban Nightmare, Star of the City… and Impurity. Most other Associations only deal with Stars of the City or lower. Even though Hana Association has control over grading the hazards… There’s one grade our Association can’t assign: The Impurity. Only the Head has the authority to decide that. I don’t know the exact rationale behind designating Impurities… From what I can see, they seem to declare beings that defile the City as Impurities and banish them to the Outskirts. I suppose the Head manages that part since things like the ethics of the City aren’t subjects we are qualified to discern.",
        ],
    },
    {
        ID: "260003",
        Name: "Harold’s Page",
        Level: "Impuritas Civitatis",
        Source: "Hana Association",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [1, 8],
        HP: 103,
        StaggerHP: 51,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Harold",
        Passive: [
            "10008",
            "260001",
            "260003",
        ],
        Desc: [
            "Some people ask how Stars of the City, the highest level of urban hazards, are any different from Impurities. They wonder… “Aren’t they disrupting the City’s order?”",
            "In the universe that is the City, a center of mass forms for each person who bears a wish for something, and clusters of dreams comparable to interstellar matter gravitate toward those centers. Driven by the force people exert in their efforts to reach those goals, such nebulae repeatedly expand and contract, until they finally fulfill their wishes—creating a Star whose glow we can observe. The people who witness the sparkle of that Star admire how brilliantly it shines in the dark, and entertain the hope that they will shine as brightly one day, making yet more centers in the universe…",
            "Of course, some people will have their eyes fixed to the ground—too busy to gaze at anything other than their path ahead; however, once a person sets their eyes on a Star, they begin to head towards it, using its guidance like a compass. Although they probably aren’t trying to become a Star themselves. They merely want to shine with their dreams for once, not to indulge in the sense of superiority that comes from being high up in the City’s sky.",
        ],
    },
    {
        ID: "260004",
        Name: "Olivier’s Page",
        Level: "Impuritas Civitatis",
        Source: "Hana Association",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 106,
        StaggerHP: 55,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Olivier",
        Passive: [
            "10008",
            "260001",
            "260003",
            "260004",
        ],
        Desc: [
            "Roland and I were long-time partners in Charles’ Office since the year dot. There were twelve members in total—excluding Angelica who joined the Office later on to resolve the case of the Blood-red Night. Consisting of rather few Fixers for a Grade 1 Office, it took on various requests, playing to the strengths of the twelve members who had different quirks and characteristics each. Roland and I got along well together, so I often worked with him. Well, not exactly for that reason. To be precise, someone had to keep his impulse to jump into action before thinking on a dog’s leash.",
            "“Valor without forethought is little more than a bluff, and there is more strength in discretion than recklessness.” I wonder if you remember this piece of advice I gave when you were still prone to take action without thinking. I remember you conceding it and taking a step back. Although I gave you that advice, now I understand that it’s not without fault. Thinking alone doesn’t make progress, and too much caution can be a harm to oneself. I had the prudence, and you had the unhesitating action. We helped each other with our strengths, and we could just live on by dealing with matters at hand back in the day. Maybe those were the days when we could laugh and lament the most, and carry out our lives just like that. But now we’ve come too far to go back—so did you, and so did Charles’ Office.",
        ],
    },
    {
        ID: "260005",
        Name: "Argalia’s Page",
        Level: "Impuritas Civitatis",
        Source: "The Reverberation Ensemble",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [4, 6],
        HP: 106,
        StaggerHP: 56,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Argalia2",
        Passive: [
            "10008",
            "1300001",
            "260005",
            "250113",
        ],
        Desc: [
            "When I heard the news and rushed to the scene, only a hideous musician who had concluded his performance and permanently shut the piano’s lid with his torso awaited me. For the first time, emotions I couldn’t understand welled up inside me. It’s hard to define what they were, even now. It felt as if deep tenebrous stains were seeping out of my heart. Alas, I didn’t shed tears before that piano where your body rested—for I soon realized that you were no longer there.",
            "That’s right; you’re the gentle breeze that brushes past my face, and the clouds that fly in the sky, which give me heed of your presence from overhead or underfoot. I thought you had left me, but you would always come back. That’s why I care no longer about the skin and flesh you wore only momentarily. Angelica. I’ll follow after the name you gave me: Uberto. You used to call me that down in those horrible underground chambers. I’ll create a new world… one where people can live bountiful lives even if they have nothing, free from obsession or greed. When we lose the fixation on our bodies, we won’t be afraid of death anymore. No rest will be eternal.",
        ],
    },
    {
        ID: "260006",
        Name: "Philip’s Page",
        Level: "Impuritas Civitatis",
        Source: "The Reverberation Ensemble",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 102,
        StaggerHP: 52,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Blue_Philip",
        Passive: [
            "10008",
            "1300001",
            "240027",
            "240127",
            "240227",
            "260006",
        ],
        Desc: [
            "How much longer must I walk until I reach an end? How tightly must I shut my eyes, cover my ears, and zip my mouth to keep what’s around me safe before I can feel a semblance of happiness that won’t leave me? I thought I had to overcome this pain and rise above it to become a tougher man. That way, I wouldn’t lose those that are close to me. However, a human is fragile by nature; if one is too weak, they would crumble—and if one is too hardy, they would snap. I realized that there’s little I can do to calm the disorder of this world. How can I live on without falling to despair, then? A mind that is willing to let go of things that were destined to leave at some point. A mind that is content to have nothing. I feel that it’s important to refrain from thinking that anything is in my possession.",
            "I followed your troupe in order to find a way to be happy, but what good did it do for me? Staying with you only exacerbated my suffering, defeating the whole purpose of joining you in the first place. I do want to add that you were not at fault here, though. I was the one who tormented myself. Had I known what I know now back in the past… would that have lessened the pain or changed anything? No, I don’t blame myself for the choice in that moment. Even the failures and misery of the past were all part of the voyage leading up to this moment, so I’m thankful that I managed to achieve something for once. I might have drowned in my own tears and sorrow back then, but ultimately, I’m grateful for the choice I made… and all the things in the world.",
        ],
    },
    {
        ID: "260007",
        Name: "Eileen’s Page",
        Level: "Impuritas Civitatis",
        Source: "The Reverberation Ensemble",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 97,
        StaggerHP: 59,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Eileen",
        Passive: [
            "10008",
            "1300001",
            "260007",
            "240026",
            "250114",
            "250214",
        ],
        Desc: [
            "Where we live, there is nothing that can be achieved with your own will. A flow that we cannot go against dictates us. What we call “gears” are simply there to show the flow. You can’t see it with your eyes. Nobody knows who created this massive current, or why we must follow it. This flow never leads us to bad places, however. Rather, thinking that such a place exists is an act of defiance in itself.",
            "We merely watch events unfold as bystanders. You walk along a path, but was it you who laid the path there? You didn’t teach yourself to lift your legs to propel you forward; they simply moved. Furthermore, the decision to walk wasn’t our own, either. Still too many believe that they moved their legs out of their own volition. It’s a shame to see them struggle to escape the flow, for they’re only straying away from salvation.",
        ],
    },
    {
        ID: "260008",
        Name: "Greta’s Page",
        Level: "Impuritas Civitatis",
        Source: "The Reverberation Ensemble",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 121,
        StaggerHP: 60,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Blue_Greta",
        Passive: [
            "10008",
            "1300001",
            "260008",
        ],
        Desc: [
            "It’s an era where humans are dominated by the act of consumption! When you’re hungry you get annoyed, and when starvation touches your raw nerve, you turn violent. That’s how humans are. And people who eat the same food will naturally grow similar. So the high and mighty beings that wanna rule over you demand ya to eat the “correct” stuff! When something’s “correct”, there’s gotta be something that’s “incorrect”. Incorrect food. It’s gotta mean humans eating humans, don’tcha think?",
            "Why do people think that eating is natural, but then draw the line at eating their fellow man? Who decided it so, and why! Is it because human life is precious? That’s a flawed statement! What makes the lives of animals less precious? We’re not aboutta go down a boring philosophical riddle about the weight of life, now. If humans clearly have more value over animals ‘cause we’re the apex predators, then there shouldn’t be any problem with a pack of humans that rise above the rest and prey on others.",
            "We’ve got two options! First: don’t eat anything. Hey, I’m not suggesting that we all starve to death. Your body is taught to eat! So what if you changed that habit? Maybe instead of food, your empty innards could be filled with possibilities of some other kind? If you ain’t a fan of that, then there’s the second option: eat anything! Just trace the smell of the blood, and stuff what you find in your mouth as your brain tells you to.",
        ],
    },
    {
        ID: "260009",
        Name: "Bremen’s Page",
        Level: "Impuritas Civitatis",
        Source: "The Reverberation Ensemble",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 100,
        StaggerHP: 54,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Blue_Bremen",
        Passive: [
            "10008",
            "1300001",
            "260009",
            "230121",
        ],
        Desc: [
            "Let’s go on an adventure—a world that changes with every step. The me that changes after each step I take. My eyes dazzled by colorful light, I pursue pleasures that I don’t have. Don’t scold us because you can’t understand our pursuit. You just happen to be one of the many who feel joy from common things. We—on the other hand—don’t see any colors in those. You’re the ones drenched in nasty pleasures. We’re simply looking for what we lack. But complete satisfaction will never come; it’ll only sink deeper in the raging thirst. We will spend our days in yet grander debauchery. We’re happy, though. We can wet ourselves in new colors every day, unlike the rest of you.",
        ],
    },
    {
        ID: "260010",
        Name: "Oswald’s Page",
        Level: "Impuritas Civitatis",
        Source: "The Reverberation Ensemble",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [1, 8],
        HP: 102,
        StaggerHP: 53,
        SResist: [0, 1],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Oswald",
        Passive: [
            "10008",
            "1300001",
            "260010",
        ],
        Desc: [
            "People have hopes and dreams!",
            "“I wanna eat three blossoms of flowers!”",
            "“I wanna be a swifty nifty thrifty kitty!”",
            "“I wanna earn a fortune!”",
            "And then they add:",
            "“Maybe I’ll find delicious flowers someday!”",
            "“Maybe I’ll get fat stacks of cash in my paws someday!”",
            "“Maybe I’ll be showered in the loudest applause someday!”",
            "“Someday! Someday! Someday!”",
            "That dastardly “someday” just won’t stop popping up. But to have a hope, you’ve got to prepare incense to offer those wishful prayers upon. A world where one can’t eat flowers! A reminder that you’re a sluggish turtle right now! The beggarly reality! Setting the stage for the performance we call hope!",
            "Thus and therefore, people have the wrong idea about how to have hopes! If they believe that the hopes will come true “someday”, they’ll just keep parroting that contemptible word! The day will never actually come! Having expectations this way will only leave you with bitter anger!",
            "“I’ll change someday?”",
            "“That person will turn over a new leaf someday, if I count on them and wait?”",
            "Nyeh, tch.",
            "People entertain the hopes as they please, and then bite at each other when the change they expected doesn’t happen. Clowns can’t give out smiles in a world full of mean teary friends!",
            "So we should all do the stretches, starting today! Abandon all expectation—just keep a merry positive attitude and laugh no matter what you see! Let’s make a performance about what’s already come true, not of a supposed reality you hope for “someday”! I’m already on the stage, standing under the brightingest spotlight ever.",
        ],
    },
    {
        ID: "260011",
        Name: "Tanya’s Page",
        Level: "Impuritas Civitatis",
        Source: "The Reverberation Ensemble",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 103,
        StaggerHP: 53,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Tanya",
        Passive: [
            "10008",
            "1300001",
            "260011",
        ],
        Desc: [
            "Fighting for survival is a natural thing. Even now, we’re all in battle. There’re more people born than folks dying of natural causes, and the living struggle in their own positions every day. A fight to protect, and to avoid falling behind. Maybe it’s all ‘cause there just ain’t enough seats for the ever-growing population of humans to take? Sure, extra jobs and stuff could be made in the future, but that’s nothing more than a hopeful estimate that might not happen until it’s too late for you. The world we live in right now is what matters. There’s got to be a way to weed out the unfit without straining all of us. And that’s when strength plays its part.",
            "I don’t get why you vilify this. Aren’t we all doing the same thing, directly or not? We elbow our way past others so we can survive, and the losers are knocked outta the race. You say this is fair, but say no to physical conflicts, to “respect life” or whatevs? Then lemme ask: what’s the reason to respect life? Do you think you’re respecting life right now?",
        ],
    },
    {
        ID: "260012",
        Name: "Jae-heon’s Page",
        Level: "Impuritas Civitatis",
        Source: "The Reverberation Ensemble",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 100,
        StaggerHP: 54,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Jaeheon",
        Passive: [
            "10008",
            "1300001",
            "260012",
        ],
        Desc: [
            "Had I been busy with an urgent appointment as any other tragic tale should go, your death wouldn’t have felt so miserable. Yeah. I would’ve cried until my tears had run their course, and I would’ve been ready to send you off. It was an ordinary day. The sort of day when there were no meetings or gatherings to attend to after I came home from work. Your body was crushed beyond recognition—I couldn’t have noticed on my own that it wasn’t a random chunk of flesh. They put your remains in a stasis box and sent it to me; that was their gesture of condolence. I’d have refused to believe it was you, if it weren’t for the clothes. I spent hours sitting there in numbed silence, vacantly staring at a lump I couldn’t even dare to hug.",
            "A stuffed doll you were carrying, now next to the box, caught my eye. Even though it was shredded and soaked in blood, the cotton filling was still clustered together, as if it remembered the volume of the doll. It seems some cotton remained even after the roller crumpled all the outer fabric. Then for reasons unknown, I brought the other dolls out of your room and cut them up with a pair of scissors. I don’t know what possessed me to cut them into pieces of fabric. There wasn’t even enough to fully cover the doll, so I scraped together the pieces of clothing to sew it back up. With the same, gentle hands that made your doll the first time.",
            "The outcome was creepier than what it used to be, but it was the same doll I remembered nonetheless. The appearance didn’t matter. Maybe, just maybe, the same could be said for you? I gazed at the box where you, my son, rested for what would no longer be an eternity. My two hands were once so busy that it was a bother; they had paused for the time, but now they are about to move again—just for you.",
        ],
    },
    {
        ID: "260013",
        Name: "Elena’s Page",
        Level: "Impuritas Civitatis",
        Source: "The Reverberation Ensemble",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 102,
        StaggerHP: 52,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Elena",
        Passive: [
            "10008",
            "1300001",
            "260013",
        ],
        Desc: [
            "Bloodfiends. The beings said to have been punished with neverending thirst for the sin of lusting after human blood. That’s what your kind called us, condemning us out of fear. I was afraid as well when I faced them for the first time in that mansion where everything began. Violent beings who drank the blood of fellow humans. A growing feeling of unease about the possibility of being their next target. The people in the mansion were terrified of those who became monsters. Even though they were humans like us, they were outside of what we thought as the norm. In hindsight, though, it was such a silly thing to do. What is the illusion of normalcy that we feared for and fought for so strongly?",
            "Let’s say that every human on the planet except for one turned into Bloodfiends, and that single person remaining is left “normal”, as they say. In that case, what would normalcy be like there? How must the lone human feel being the monster among the creatures they dreaded? Should they fight to their last breath for the “humanity” they kept for so long? Perhaps that’s become an obsolete ideology, one that’s no longer worth keeping. What if rejecting that old ideal and becoming a Bloodfiend opened up our potential for growth in numerous aspects?",
            "Your kind likes to claim that something is out of the ordinary when it’s only different from what you’ve seen and experienced before. So you fear it, and try to exclude it from your herd. But you see, there’s no real justification for your kind to condemn us.",
        ],
    },
    {
        ID: "260014",
        Name: "Pluto’s Page",
        Level: "Impuritas Civitatis",
        Source: "The Reverberation Ensemble",
        Obtainable: "True",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 103,
        StaggerHP: 51,
        SResist: [0, 0],
        PResist: [0, 1],
        BResist: [1, 0],
        Skin: "Pluto",
        Passive: [
            "10008",
            "1300001",
            "260014",
        ],
        Desc: [
            "The world is one massive aggregation of delusions. A world where individuals can shape their own reality as they see fit. Every person is susceptible to deception, for they have knowledge. For that reason, it is impossible for a pure being untainted by knowledge to see the world as we mistakenly observe it, in the same way they cannot discern the end point of a line or tell between blue and red. A world devoid of wants. It would be unfit to call that place a world. In fact, to even call it a “place” would be yet another misconception amongst us knowing ones. The more one learns, the more delusions they invite.",
            "However, if most people observed the same place and felt the same sentiments, then it might not be your own delusion after all. Wouldn’t you say so? For instance, take a look at the blue sky. The celestial dome is higher and farther than one can fathom, and as blue as it can be. Most will agree that the sky is tall and blue. Alas, those who think as such are ultimately within your view. It’s only natural that they agree with you as they’re figments born out of your delusional mind. Indeed, the sly entity that prevents you from seeing the world in its sincerest form would be none other than yourself. Even the holy entity in which you believe and to which you devote yourself is going to be a projection of your own self, so how can I trust anything that my eyes show me?",
        ],
    },

    // Enemy / Special
    {
        ID: "213213204",
        Name: "-",
        Level: "-",
        Source: "-",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 1],
        HP: 1,
        StaggerHP: 1,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "?",
        Passive: [
        ],
        Desc: [
           "",
        ],
    },
    {
        ID: "100001",
        Name: "Lenny’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 2],
        HP: 10,
        StaggerHP: 5,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "Lenny",
        Passive: [
        ],
        Desc: [
            "Wanna hear a secret? This is kinda embarrassing, but… I used to have a dream once, like Pete does now. Yeah, I know, I’m still younger than him with a long future ahead of me. But what could I do? Life’s too rough for that. Others say that Rats are a pathetic bunch who were too incompetent to join even the smallest Syndicate let alone a Wing. Filthy losers who feed on junk and leftovers, not making any effort to change…",
            "Back when I was a young kid, I didn’t like that. I thought I was better than those Rats. So I decided to get into an examinee town. Little did I know that it’d be the one choice I’d regret the most… I begged and nagged at my parents, wanting to achieve that stupid dream. How’d it go, you ask? Seems you’re just as stupid, aren’t you. I wouldn’t be hanging out with these folks if I made it, now would I?",
            "What I’m saying is, dreaming won’t do jack shit for you. They didn’t end up here because they gave up trying. Hell, they wouldn’t have set foot on this gutter in the first place if they had what it takes to achieve their dreams. You get it now? Pete’s a huge idiot.",
        ],
    },
    {
        ID: "100002",
        Name: "Mang-chi’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 2],
        HP: 10,
        StaggerHP: 5,
        SResist: [-2, -2],
        PResist: [-1, -1],
        BResist: [0, 0],
        Skin: "MangChi",
        Passive: [
        ],
        Desc: [
            "Didja know? There’s grades for each alley in the Backstreets. Funny, ain’t it. Trash in a trash can are grading each other… The parts that’re under the protection of a Syndicate, Office, or Association are pretty safe. Sweepers can’t raid those streets easily. Putting the people who live there in a different grade from those who don’t, though… is pointless, honestly speaking. Sure, it’s a bit safer over there, but we’re talking about the Backstreets, get it?",
            "You know what’s funnier? Even kids would group themselves according to what part of the streets they live in. They’d even shun the others whose clothes or manner didn’t fit their turf’s style. I had no choice but to accept this sad truth.",
            "You wonderin’ how things were in the alleys I lived? Couldn’t afford to pay protection fees to a Syndicate, so the Sweepers came down at night and collected most of my neighbors. I had to witness ‘em take chunks of flesh outta my parents and brothers while they were still breathing. Don’t pity me, though. My story ain’t nothing special around here.",
        ],
    },
    {
        ID: "100003",
        Name: "Pete’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 2],
        HP: 10,
        StaggerHP: 5,
        SResist: [-1, -1],
        PResist: [0, 0],
        BResist: [-2, -2],
        Skin: "Pete",
        Passive: [
        ],
        Desc: [
            "There’s not a lot of peeps who hang around in the Backstreets alone. It’s cuz that’s just madness. Weak and dowdy folks gotta band together to survive. Get into a small Syndicate or anything and make a living somehow. Some ignorant fool makes a scene in the Backstreets on their own, they’re just making themselves a target as soon as others notice they’re alone. That’s why we move in groups. We’re called Rats for a reason. We crawl about the dark in packs, and jump at prey for the chance to bite ‘em apart when we spot one.",
            "So, you wondering if we Rats have any dreams? Hmm… I guess belonging to a proper Syndicate, if any. We’re just too tacky and amateurish to be called one. We hate being bound to rules, so hell’ll freeze over before one of us joins an Office, and no Rat I know would move to an examinee town and study for Wing entrance exams. Those nerds at examinee towns ain’t too different from Rats like us. We’re all dreaming silly dreams that’ll never come true with our petty skills. An Office, a Wing, a Syndicate, or whatever… Think it’s an easy task to belong to a decent group? People just accept what they got and live on. But still, I wanted to have a dream.",
        ],
    },
    {
        ID: "100004",
        Name: "Finn’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 2],
        HP: 18,
        StaggerHP: 4,
        SResist: [0, 0],
        PResist: [-1, -1],
        BResist: [-2, -2],
        Skin: "Finn",
        Passive: [
        ],
        Desc: [
            "It’s been a while, sis. Actually… I talked to you some time ago. By myself, of course. It sounds a bit lonely… But I’m fine! Today’s not gonna be the same as the days before; I have good news. I finally joined an Office run by this guy named ‘Yun’ and officially became a Fixer. You’re proud to see your precious little younger brother grow up and make it, aren’t you? Isn’t it cool? I told you there’s no need to worry about me.",
            "Oh, about Yun’s Office… I think it’s a really nice place. No, I’m not lying. Our operator Yun is a bit cold, but he teaches me a lot of things, and there’s also Eri, who’s my senior. I’ve yet to be friends with her… but she seems like a good person, too. For now, they’re giving me small jobs like searching for lost cats. Maybe they’re worried I’m too inexperienced to handle tougher stuff. It’s not really fancy, but… If I start out with small tasks like this and work up slowly, I’m gonna be a great Fixer one day, yeah? My heart is already pumping with excitement…",
            "When I become a proud and dashing Fixer, I’ll buy a Nest migration ticket and get a nice new home for you. I could buy my gear at a workshop thanks to your help, and all that… Though that’s not all. You always looked after me, sis. …It’s kind of embarrassing to talk about this. Anyway, don’t worry about me, and do the things you want to do. I know you were always too busy caring for me to pursue your own interests. You offered to give me a prosthetic body or even a minor procedure the last time we met, but… I’m doing fine without any of that stuff. And you got money to earn for yourself. Hngh, chaa… I’m tired, so I’ll be going now. I ran around the whole town chasing a cat all day… Night, sis. I hope we see each other again.",
        ],
    },
    {
        ID: "100005",
        Name: "Eri’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 3],
        HP: 22,
        StaggerHP: 8,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "Eri",
        Passive: [
        ],
        Desc: [
            "You have lots of things to prepare before you can jump into the Fixer business. Starting with choosing equipment, you’ll need clothes to protect your bodily accessories, et cetera… But, before any of that, body augmentation comes first. There’s no point having masterful skills or fancy equipment if your body can’t keep up, y’know? And training hard isn’t gonna do it. There’s a limit to training your body, and the fittest body is still no match for mechanical prosthetics or bionic organs. You gotta be able to keep your body intact to do anything, so you’re pretty much forced to spend a fortune on it.",
            "There’s a ton of methods to enhance your body. Exoskeletons, bionic surgeries, nano-tattoos, prosthetic body parts… You name it. Deciding what workshop tech to employ is up to preference and purpose. Some would want insane muscular strength that could let them carry a power pole one-handed, and others would want ludicrous speed, quick enough to skip over multiple blocks in a split second. It’s so diverse, I could go on forever. You need any ability, they’ve got you covered. The only hurdle is money. In the City, money is what gets you power. That’s why the first thing we notice when we assess our foes is how much they’ve spent on their bodies… Oh, of course, some technologies patented by closed groups like certain Syndicates or Wings are hard to get your hands on even if you have all the cash in the world.",
            "Just look at me, though! It took a teensy little procedure for me to lift this humongous weapon with one hand. This is the kind of power you can get, you see? Body augmentation is more of a necessity than an option these days, so you’ll want to study up on that. You don’t wanna stay a weakling when everyone else’s getting their augmentations, now do you?",
        ],
    },
    {
        ID: "100006",
        Name: "Yun’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 3],
        HP: 22,
        StaggerHP: 10,
        SResist: [-1, -1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Yun",
        Passive: [
        ],
        Desc: [
            "Finn was bungling in many ways. He had no talent, he refused to take modification procedures, all he armed himself with was a tiny weapon. I didn’t exactly dislike him, though. They say a delicate person like him is nothing short of pathetic here, but he had passion regardless, and he was going to be our colleague from now on. Besides, it’s not too common to see such a passionate fellow in this grueling mess of a City. He was an interesting one.",
            "Then why did I exploit him? …“Exploit” is a rather harsh word to describe it, if you ask me. A sloppy kid like him would’ve gotten killed anyway, abducted in the Backstreets and fading away while witnessing his innards getting ripped from his body. And that’s one of the tamer examples I could give. In this City, worse things are happening here and there on a daily basis. If he didn’t die there, he could’ve faced a much more terrible fate somewhere else, isn’t that right? …Nevermind, this is all but rationalization. Think what you want.",
        ],
    },
    {
        ID: "100007",
        Name: "Mo’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 3],
        HP: 24,
        StaggerHP: 12,
        SResist: [0, 0],
        PResist: [-1, -1],
        BResist: [0, 0],
        Skin: "Mo",
        Passive: [
        ],
        Desc: [
            "I frankly don’t recommend replacing your entire body with a machine. Especially with a cheap one. Aside from basic issues such as vulnerability to damage and creaky noises, cheap prosthetic bodies compromise too much. You’re basically giving up all the joys of life. Can you imagine? You can’t taste anything when you eat delicious food, and you can’t feel the softness and coziness of a good bed. You can’t feel anything get stuck in your body, be it a piece of paper or a knife. The head remembers those feelings, but you can’t experience them again.",
            "There are ways to overcome it, though. You can buy a desire stimulation chip and plug it in your brain, inject medications, or use other methods. They’re just absurdly expensive. You’re better off saving up for a more expensive prosthetic body if you really want your senses back. High quality, pricey bodies come with sensory organs. As I always say, it’s all about money in this world.",
        ],
    },
    {
        ID: "100008",
        Name: "Consta’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 3],
        HP: 22,
        StaggerHP: 6,
        SResist: [0, -2],
        PResist: [-2, -1],
        BResist: [0, 0],
        Skin: "Consta",
        Passive: [
        ],
        Desc: [
            "What’s your favorite food? That’s the question I used to ask the most when I still had a human body. I love… looooove eating. Talking about food was a huge delight for me. We would share each other’s tastes and preferences, and sometimes head to a restaurant for a meal just like that.",
            "But now… My body’s a machine as you can see. I can’t taste anything anymore. Thanks for pointing that out. Mo told me to stop dreaming about it. I still wanna try more delicious foods, though. Hot and flavorful… Spicy and sweet… Stuff like that. I guess this body is too cheap to restrain delusional thoughts like this. If we get more money and change our bodies to new ones… then maybe I’ll be able to stop these thoughts from getting in the way of my work?",
        ],
    },
    {
        ID: "100009",
        Name: "Arnold’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 3],
        HP: 22,
        StaggerHP: 10,
        SResist: [0, -2],
        PResist: [0, 0],
        BResist: [-2, -1],
        Skin: "Arnold",
        Passive: [
        ],
        Desc: [
            "The City consists of 25 Nests, and 25 Districts of the Backstreets that surround those Nests. And countless Offices and Syndicates reside in the Backstreets. You know what’s a surefire way for a Syndicate to make a name for itself among all the competitors? The simplest method is Office raiding. You literally storm into an Office and wreak havoc on it.",
            "You never know who will be the winner until you fight. It could stop at a good beating and one side surrendering, but some Syndicates raid Offices out of pure boredom and kill everyone. Each Syndicate has its own way of operation. It goes without saying that the Syndicate has more fame to gain out of raiding a high-grade Office filled with seasoned Fixers. So the Offices have to stay sharp at all times. But you’ll also have to watch it. If you misjudge your opponents, you’ll end up dead before you could try anything…",
        ],
    },
    {
        ID: "100010",
        Name: "McCullin’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 3],
        HP: 22,
        StaggerHP: 9,
        SResist: [0, -2],
        PResist: [-1, -1],
        BResist: [0, 0],
        Skin: "McCullin",
        Passive: [
        ],
        Desc: [
            "It’s not entirely impossible for a Syndicate member to engage in Fixer work or vice versa. It’s a pretty common occurrence, actually. If you have the skills to back yourself up, multiple organizations will make sweet offers to recruit you. What matters the most here is the relationships you’ve built. Your fate depends on the things you’ve done, or karma in other words.",
            "We didn’t start out as Fixers at the beginning. No, we were in fact part of a homicidal Syndicate. Just see how intimidating we look. We used to be murder for hire in District 23. It was a small Syndicate ran by Naoki, I, and a few others, but our influence started to expand bit by bit since the young and talented Taein joined us. Our current boss… was originally the representative of an Office we raided. They visited us once they heard that we shredded their Fixers brutally and hung their ragged corpses on the streets like scarecrows. Said they’ll need people like us.",
            "I thought they were just freaky with weird tastes, but looking back, now I get why they chose us. It’s a strategy. Each Office does all kinds of sensational stunts to attract the attention of potential clients in this oversaturated market. They hold radical events such as “Pay for one request, get one for free”, or group weapons into different grades and offer a free exchange for one of their most expensive ones. And the gullible clients fall for it. They don’t know how much more that “one plus one” deal actually costs, or how it has limitations on the grades of requests you can make… They don’t bother looking up to check if the top-grade weapons are in fact used ones. Seems our boss didn’t want to add lies to this industry that’s already full of filthy schemes, but they still had to catch people’s eyes somehow. And this is the result: hire guys like us and proudly advertise it. ‘Fixers from a former killer Syndicate will tear things up for you! You can count on us!’ Hang up a slogan like this, people get hooked up. If that suits their taste, that is.",
        ],
    },
    {
        ID: "100011",
        Name: "Taein’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 3],
        HP: 21,
        StaggerHP: 10,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [-1, -1],
        Skin: "Taein",
        Passive: [
        ],
        Desc: [
            "How’s my new weapon, isn’t it sick? Union Co. is the go-to workshop brand for ready-made bionic weapons and equipment. Their prices are pretty reasonable compared to most procedures and workshop weapons, too. On top of superb performance, you can replace or attach them easily without having to worry about allergies, so it’s pretty damn handy, you see?",
            "Oh, bionic equipment is pretty simple; it’s like a weapon you attach to your body. It’s not at all scary or dangerous, though it could feel a bit awkward when you use it for the first time. In my case, I accidentally ripped Naoki’s clothes while walking by, and cut my own cheek when I flailed it outta frustration… But, now that I’ve gotten used to it, I feel as if I have three hands. If you have trouble finding the perfect procedure or weapon for you, try bionic equipment. I guarantee it’s good.",
        ],
    },
    {
        ID: "100012",
        Name: "Naoki’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 3],
        HP: 21,
        StaggerHP: 10,
        SResist: [0, 0],
        PResist: [0, -1],
        BResist: [-1, -2],
        Skin: "Naoki",
        Passive: [
        ],
        Desc: [
            "There’s a huge variety of workshops. As diverse as Syndicates and Fixers are, weapons need individuality to stand out in this day and age. Old-fashioned swords or guns won’t stand a chance against modern weapons loaded with new technology, I bet. From cheap and common gear to bionic equipment like the one Taein’s using, to equipment with ridiculous abilities that’s almost indistinguishable from magic. Don’t get too hyped, though. More options means you need to be more cautious about choosing the right one for you. If you had the time and money, you could buy ‘em all and test them out at your leisure, but… We have neither, do we?",
            "Don’t just buy the things others recommend without doing your own research, though. That’s one of the stupidest things you could do. Might fit them, but that doesn’t necessarily mean you’ll have a good time with it. Still confident that you can wield ‘em well? Get real, buddy. Workshop equipment is not your average weaponry. So, before you choose your weapon, observe others carefully. See if any workshop products might suit you. Having keen eyes is all part of our skills. Guess why people choose us and our Office out of all the tough Fixers out there.",
        ],
    },
    {
        ID: "101001",
        Name: "A Yun’s Office Fixer, Page 1",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 3],
        HP: 17,
        StaggerHP: 8,
        SResist: [-1, -1],
        PResist: [0, 0],
        BResist: [-2, -2],
        Skin: "YunUnit1",
        Passive: [
        ],
        Desc: [
            "The society of Fixers is built entirely up on meritocracy. The greater you are, the higher you can climb. On the other hand, if you don’t have the capability, you should be thankful for any org that accepts you and stay low. Thing is, ‘capability’ can mean many things. For some, it could be physical strength, and others might have superior intellect. It seems kinda unfair to me that they make arbitrary evaluations of a concept that can be taken in so many different ways. Not that I think I have some hidden talent that deserves a better grade or anything, though. I do feel a bit upset, but I think I’m at the right place. The jobs I usually do are looking for lost cats at night… You can tell how low my spot is, yeah?",
            "I’m not a huge fan of the jobs I’m doing right now, of course. I mean, sure, I wouldn’t say no to some flashier requests. I just accepted to carry on with my life.",
        ],
    },
    {
        ID: "101002",
        Name: "A Yun’s Office Fixer, Page 2",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 3],
        HP: 17,
        StaggerHP: 8,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "YunUnit2",
        Passive: [
        ],
        Desc: [
            "The Backstreets are alleyways densely spread across the city. They’re entangled like spiderwebs, and spread far and wide, so it is virtually impossible for one to know every single thing that occurs in the Backstreets. And they’re populated with all sorts of people.",
            "Examinee towns where people preparing for entrance exams in hopes of getting into a Nest have gathered; Syndicates and Fixers thirstily looking for business; workshops that benefit from their conflicts, crafting various tools and gadgets…  It’s a disorderly lump of all kinds of desires for wealth and dreams.",
            "People think Fixers are “good guys” who fight off bad guys here, but they’re just humans in reality. They’re simply doing their jobs to make a living. Some clients look at us with sparkly eyes like we’re heroes or something. This might seem funny to you, but things get troublesome if we don’t fulfill their requests. They give us a disappointed look, yell profanities at us… Turn into rude customers before leaving.",
        ],
    },
    {
        ID: "101003",
        Name: "A Yun’s Office Fixer, Page 3",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 2],
        HP: 10,
        StaggerHP: 5,
        SResist: [-2, -2],
        PResist: [-1, -1],
        BResist: [0, 0],
        Skin: "YunUnit3",
        Passive: [
        ],
        Desc: [
            "A hotshot Fixer gets all the push they can get from their Office. And an Office housing competent Fixers can get sponsorships from Associations, Wings, or workshops. The same can be said for individual Fixers; the spicy ones are sought after by many firms. But that won’t be you guys. Most of us have to purchase equipment with our own budget. Insane things happen in the City, and even Rats could tear you a new one if you haven’t got any useful gadgets or procedures.",
            "And how do you get the money for that? Duh, you’re supposed to earn it, isn’t that obvious? …Funny, isn’t it. You jump into the Fixer business trying to earn money, but you need to get into debt and spend money to be able to do proper work. How ironic is that? This world’s one giant hamster wheel.",
        ],
    },
    {
        ID: "101004",
        Name: "A Yun’s Office Fixer, Page 3",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 2],
        HP: 10,
        StaggerHP: 5,
        SResist: [-2, -2],
        PResist: [-1, -1],
        BResist: [0, 0],
        Skin: "YunUnit3",
        Passive: [
        ],
        Desc: [
            "A hotshot Fixer gets all the push they can get from their Office. And an Office housing competent Fixers can get sponsorships from Associations, Wings, or workshops. The same can be said for individual Fixers; the spicy ones are sought after by many firms. But that won’t be you guys. Most of us have to purchase equipment with our own budget. Insane things happen in the City, and even Rats could tear you a new one if you haven’t got any useful gadgets or procedures.",
            "And how do you get the money for that? Duh, you’re supposed to earn it, isn’t that obvious? …Funny, isn’t it. You jump into the Fixer business trying to earn money, but you need to get into debt and spend money to be able to do proper work. How ironic is that? This world’s one giant hamster wheel.",
        ],
    },
    {
        ID: "110001",
        Name: "Jack’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 33,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-1, -2],
        BResist: [0, -1],
        Skin: "Jack",
        Passive: [
            "210001",
        ],
        Desc: [
            "Our usual source of cooking ingredients are Syndicates specializing in butchery. The kinds of meat they treat and how they process it differs for each Syndicate, so you should pick your caterer carefully. Our meat pie bistro used to frequently trade with ‘The Musicians of Bremen’ and ‘Little Piggy's’.",
            "‘The Musicians of Bremen’ provided large quantities of meat, though it wasn’t exactly the freshest. Shattered chips of bones were often in the meat, and the mixture of different types would create an odd flavor. Still was a reliable supplier of ingredients, all in all. Outside of special occasions, we’d use them for making experimental dishes or sausages. Oh, speaking of, sausages are made from a mix of several different kinds of meat. You could even find a rat inside at times. Anyway, we rarely sold the dishes made out of their meat other than the sausages. They’d never treat their meat nicely before handing it to us.",
            "The meat from ‘Little Piggy's’ is pricey and comes in small quantities, but its quality is good. We even got the highest grade meat sometimes if we were lucky. Just looking at the meat from ‘Little Piggy's’ fills me with ideas about how to cook it and makes my mouth water. That’s how appealing the meat looks. But the price is rather heavy, so we only used it for important dishes or foods we serve to customers.",
            "But both Syndicates suddenly said they’re no longer selling ingredients for some reason. So now Pierre and I have to pioneer a new supply chain on our own. I don’t think this is all too bad, though. I enjoy working with Pierre a lot.",
        ],
    },
    {
        ID: "110002",
        Name: "Pierre’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 35,
        StaggerHP: 18,
        SResist: [0, 0],
        PResist: [0, -1],
        BResist: [-1, 0],
        Skin: "Pierre",
        Passive: [
            "210002",
        ],
        Desc: [
            "Most cooks who live here have the same dream: becoming one of ‘The Eight Chefs’! They’re the people who pursue the ultimate delicacy. Their way of cooking will… give you a thrill just hearing about it! You don’t feel it? No no, I’m sure you can feel it inside. I sound crazy? Nyeh, listen up, you stubborn square! This is why I can’t talk with people whose brains are too old. They taste bad, too!",
            "There’s a limit to the flavors people can draw forth. The height of taste the human tongue can feel isn’t as impressive as you might think, really. The most delicious food doesn’t come close to sending chills down your spine. At most… it’s just good enough to make your eyes spin! And the food you guys casually eat, going “Mm~ Tasty~”, are way! Way, way way way waaaaaay~ below that! So, many chefs gathered round one time… pondering what to do to pursue a taste beyond this limit… And then inspiration struck all of them at the same time like lightning! What if they sublimated the experience into taste, something beyond what the tongue can feel? You know, they say the presentation of food adds to its taste, right? What if the whole process of cooking could be tasted! They performed several experiments in an attempt to make that dream come true.",
            "“So?” What do you mean, “So?” I wouldn’t be trying so hard if there was an end to delicacy! All the chefs are continuing their research to this day, seeking more stimulating flavors. And I just want to be as good as the stain on their apron at least!",
        ],
    },
    {
        ID: "110003",
        Name: "Mars’ Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 4],
        HP: 25,
        StaggerHP: 10,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Mars",
        Passive: [
            "210003",
        ],
        Desc: [
            "My mother was a Fixer with a high grade that every one of my peers would dream of reaching. She was the envy of all, a radiant individual who received endless supplies of various expensive equipment and garnered constant recruit offers from other Offices. Does that mean I had a safe, comfortable childhood under the care and wealth of such a wonderful person? Had that been the case, I would’ve earned a position in one of the Wings already. Being the son of a high-rank Fixer, I was often targeted by Syndicates opposing her, and my mother’s acquaintances held high expectations for me.",
            "At first, I was okay with their expectations. I was already dreaming to follow the path of my mother. In fact, I was hoping to live up to it and hear compliments such as “I knew you could make it!” from others. “Yes. I’m going to become a great Fixer just like my mother. Then she’ll be proud of me one day, right? She’ll proudly say ‘That's my boy’, in front of others.” I studied hard day after day, taking no breaks in-between… Countless times, I held my sword with a strong resolve, and many days I spent weeping alone. Even if I faced setbacks and failures, I believed I could overcome them and stand strong like the protagonist of a movie. As if I could actually be someone great.",
            "But in the end, I grew into an ordinary aspiring Fixer, and I learned that I was only an average person with no talent to show off. When I entered an ordinary Office with my ordinary capabilities, my mother seemed very glad to hear the news. She said an associate Office of the Zwei is a good start, and that I’ll certainly be able to become successful if I work my way up slowly. However, I was greatly disappointed in myself, and I couldn’t look my mother in the eyes until I said my final goodbyes and left the house.",
        ],
    },
    {
        ID: "110004",
        Name: "Lulu’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 4],
        HP: 22,
        StaggerHP: 10,
        SResist: [-1, -1],
        PResist: [-2, -2],
        BResist: [0, 0],
        Skin: "Ruru",
        Passive: [
            "210006",
        ],
        Desc: [
            "Ugh, crap… Another day without work! Fantastic. There’s got to be some case for us to take care of, like fly tipping or something? I’m gonna forget how to move at this rate… If I told my friends about this, they’re so gonna whine like “Well, isn’t it a good thing that you have a lot of free time~” or “You’re well off, we’re about to starve from the lack of requests~”. Those dummies… Think about it for a moment. You need results to promote to better Fixer grades and see some growth in your Office, right? And that’s gonna lead to higher income for us. For now, I’m working with my boss San and some dork shaped like a ball of rice cake… But things could be better than this in the future, yeah? …It’s not like I have problems with my coworkers!!! I’m talking about stuff like weapons, and Office interior… You know, those kinda things. You get what I mean!",
            "I do bicker with Mars and snap at him often, yes! But that doesn’t mean I hate him. San and Mars are both precious colleagues to me. Though, yeah, I know what you’re about to say. If Fixers develop private feelings for each other, it could be much harder to bear whatever happens down the line. I know what I’m doing is stupid. I have wits, unlike mister rice cake face.",
            "But we’re humans, it’s just… something that can’t be helped. How could we just strictly detach ourselves from one another and focus on work? I tried acting nonchalant, I did, but… I guess I can’t do it. San said he feels the same. I gotta envy Mars for being cool-headed all the time.",
        ],
    },
    {
        ID: "110005",
        Name: "San’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 4],
        HP: 22,
        StaggerHP: 11,
        SResist: [-2, 0],
        PResist: [0, 0],
        BResist: [-1, -1],
        Skin: "San",
        Passive: [
            "220001",
        ],
        Desc: [
            "An associate Office is one that is in a cooperative relationship with one of the Associations. The advantage of this designation is that its Fixers will not have to worry about starving, since they’re paid a stable salary… And that the Office simply has to handle tasks given by the Association with proficiency, rather than having to deal with clients and accept their requests as ordinary Offices do. Spending days without any incident happening in the area designated for peacekeeping can be admittedly boring… Though it’s a blessing to have such a peaceful day in the City. I was grateful to have such serenity each day, reasoning with Lulu’s occasional complaints.",
            "Is boredom the only downside of being an associate Office? That’s not quite true. Because we’re under the direct command of the Association, we’re forced to take on any undesirable tasks they give. Even if it carries the risk of wiping out the Office…",
            "…I can’t blame the Association, so I only have myself to fault for failing to save my guys.",
        ],
    },
    {
        ID: "110006",
        Name: "Lulu’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 30,
        StaggerHP: 12,
        SResist: [-2, -2],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Ruru",
        Passive: [
            "210006",
            "3",
            "1009",
        ],
        Desc: [
            "Ugh, crap… Another day without work! Fantastic. There’s got to be some case for us to take care of, like fly tipping or something? I’m gonna forget how to move at this rate… If I told my friends about this, they’re so gonna whine like “Well, isn’t it a good thing that you have a lot of free time~” or “You’re well off, we’re about to starve from the lack of requests~”. Those dummies… Think about it for a moment. You need results to promote to better Fixer grades and see some growth in your Office, right? And that’s gonna lead to higher income for us. For now, I’m working with my boss San and some dork shaped like a ball of rice cake… But things could be better than this in the future, yeah? …It’s not like I have problems with my coworkers!!! I’m talking about stuff like weapons, and Office interior… You know, those kinda things. You get what I mean!",
            "I do bicker with Mars and snap at him often, yes! But that doesn’t mean I hate him. San and Mars are both precious colleagues to me. Though, yeah, I know what you’re about to say. If Fixers develop private feelings for each other, it could be much harder to bear whatever happens down the line. I know what I’m doing is stupid. I have wits, unlike mister rice cake face.",
            "But we’re humans, it’s just… something that can’t be helped. How could we just strictly detach ourselves from one another and focus on work? I tried acting nonchalant, I did, but… I guess I can’t do it. San said he feels the same. I gotta envy Mars for being cool-headed all the time.",
        ],
    },
    {
        ID: "111001",
        Name: "A Hook Office Fixer, Page 1",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 18,
        StaggerHP: 7,
        SResist: [0, 0],
        PResist: [-2, -1],
        BResist: [-1, -1],
        Skin: "HookUnit1",
        Passive: [
            "200010",
        ],
        Desc: [
            "Back when we were still part of the killer Syndicate, we got a client asking us to hunt some crazed Syndicate. They were shaking like a drenched rat as they came in. I suppose they were scared of places like this. They asked us to catch the wicked criminals kidnapping people in the parts of the streets they live in. We had one question, though; it’s nice that they’re giving us a job, but why ask a Syndicate like ours instead of going to the Zwei or other Offices that are better suited for handling public safety issues?",
            "And they said, they did try to request an Office at first with the money raised by their neighbors. But then the Office asked for a ridiculous sum of money, claiming that there’s much preparation they need to take before they can uproot a whole Syndicate. Poor fellow begged for help, but the Office personnel didn’t even flinch. Well, money is the only thing that gets Fixers moving, so that’s understandable. And I think their friend recommended us to them while they were looking for another way, if I remember it right? Introduced us as a trustworthy Syndicate. So they came all the way to our hideout.",
            "Trustworthy Syndicate… It’s a shame, really. I can still remember the client’s head staring daggers at me, hanging from the top of a power pole. The Syndicate paid us more cash. What could I do about it? We don’t write official contracts or anything, so the highest bidder gets our favor. No use glaring at me like that, pal. We were told by our new client to hang their head and guts out in the streets, to make an example of ‘em. Those sickfucks even used some kinda Singularity to keep ‘em alive. Poor bastard. Shoulda requested an Office in the first place somehow.",
        ],
    },
    {
        ID: "111002",
        Name: "A Hook Office Fixer, Page 2",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 27,
        StaggerHP: 15,
        SResist: [-1, -1],
        PResist: [-2, -2],
        BResist: [0, 0],
        Skin: "HookUnit2",
        Passive: [
            "200010",
        ],
        Desc: [
            "Backstreets are spread all over the City, and the Nests are no exception. But all this means is that “there are Backstreets in the Nests”, since the Nests are completely segregated from the Backstreets in terms of access. Each Wing employs their own methods like electric fences or plasma walls, and some just fence the boundary with a couple of loose chains. Needless to say, the Backstreet residents don’t even think about crossing the border, regardless of how insecure it looks.",
            "If I had to point out one thing the Backstreets and the Nest have in common… It’d be that residents of the Nests can get a good view of the Backstreets, and vice versa. Hey, did you hear that? Watching the Backstreet’s apparently a trend among Nest dwellers these days. After a day’s work, they sit by the windows and look out on the streets, cracking open a can of beer… Chat with their friends about what they witnessed last evening. Hell, there’s even a club dedicated to that, apparently. Isn’t that absurd? People in the Backstreets live from day to day with their lives on the line, and their struggle is nothing more than entertainment to those who live inside the Nest.",
        ],
    },
    {
        ID: "111003",
        Name: "A Backstreets Butcher, Page 1",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 27,
        StaggerHP: 13,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [-1, -1],
        Skin: "BackStreetChef1",
        Passive: [
            "211003",
        ],
        Desc: [
            "District 23 is the street of flavor. Everything is permitted in the pursuit of making delicious dishes. Even dismembering humans. Isn’t that exciting?",
            "‘A guest walked into a restaurant for a meal, but then the chef fell in love with them! They had the perfect amount of tenderness and girth. The chef pulled out a knife, and the guest ended up on a plate. You'll become the food you appreciated one day, and others will appreciate what you've become.’",
            "It’s a common story often told in these streets. Well… If you really become the main character of one of those tales, be honored. That means the chef saw you as excellent meat. Hmm? This is one of the best compliments you can hear in District 23. The more you know~",
        ],
    },
    {
        ID: "111004",
        Name: "A Backstreets Butcher, Page 2",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 27,
        StaggerHP: 13,
        SResist: [0, 0],
        PResist: [-1, -1],
        BResist: [-2, -2],
        Skin: "BackStreetChef2",
        Passive: [
            "211003",
        ],
        Desc: [
            "Butchering a human is a lot simpler than butchering other animals. Most of them are smaller than us. Which means we can subdue them right away even if they try to resist. Oh, I’m not saying you necessarily have to be tall to be a butcher, so don’t be discouraged. Anyway, humans can be a bit noisy, but they’re very handy to deal with overall since there’s little to worry about compared to other meats.",
            "Besides, the uhh… ‘The Eight Chefs’? For them, human meat is the one and only ingredient that matches their pursuit. Some buzz about how the process of cooking should be part of the flavor… You can’t do that with any other meat. So you’d better watch it. If you dare wander this part of the town, your destination might end up being a dining table.",
        ],
    },
    {
        ID: "111005",
        Name: "Lulu’s Friend, Page 1",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 27,
        StaggerHP: 11,
        SResist: [0, 0],
        PResist: [-1, -1],
        BResist: [-2, -2],
        Skin: "LuluFriend1",
        Passive: [
            "211005",
        ],
        Desc: [
            "A peacekeeping Office provides protection for requested territories for a certain period of time. Lulu’s is one of those Offices. What are they protecting against, you ask? The City, obviously. What I’m saying is, their job is to keep the area safe from all sorts of happenings and incidents that occur in the City. Of course, there won’t be much to do if the area is too small or peaceful.",
            "But, man. Compared to us who have to wait indefinitely for someone to make a request… Lulu’s living a good life. At least she does something. And they don’t have to worry about starving to death even if they don’t get requests.",
        ],
    },
    {
        ID: "111006",
        Name: "Lulu’s Friend, Page 2",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 27,
        StaggerHP: 11,
        SResist: [-1, -1],
        PResist: [0, 0],
        BResist: [-2, -2],
        Skin: "LuluFriend2",
        Passive: [
            "211005",
        ],
        Desc: [
            "A peacekeeping Office provides protection for requested territories for a certain period of time. Lulu’s is one of those Offices. What are they protecting against, you ask? The City, obviously. What I’m saying is, their job is to keep the area safe from all sorts of happenings and incidents that occur in the City. Of course, there won’t be much to do if the area is too small or peaceful.",
            "But, man. Compared to us who have to wait indefinitely for someone to make a request… Lulu’s living a good life. At least she does something. And they don’t have to worry about starving to death even if they don’t get requests.",
        ],
    },
    {
        ID: "111007",
        Name: "Lulu’s Friend, Page 3",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 27,
        StaggerHP: 11,
        SResist: [0, 0],
        PResist: [-1, -1],
        BResist: [0, -2],
        Skin: "LuluFriend_Ver2_W1",
        Passive: [
            "211007",
        ],
        Desc: [
            "As her friend, it’s unfortunate that Lulu is struck with grief. I don’t have any tears to shed for her, though. I’ve got my share of rough experiences, I’m just not sharing it with others. Well, I did say I’ll help her out, but the truth is… My Office figured that we could find plenty of valuable loot in the Library. And that’s pretty tempting. The other one is probably thinking the same thing as me. I mean, what dummy would actually head to such a dangerous place motivated purely by a friend’s sob story? That kind of intimate and deep relationship is long gone from this world. Especially in this business.",
            "That’s why I can’t understand Lulu. Sure, let’s say that her colleague died there. Even then, she should be valuing her own life, shouldn’t she? She can be so stupid at times… Welp, I have to go in with her anyway.",
        ],
    },
    {
        ID: "111008",
        Name: "Lulu’s Friend, Page 4",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 27,
        StaggerHP: 11,
        SResist: [-1, -1],
        PResist: [0, 0],
        BResist: [0, -2],
        Skin: "LuluFriend_Ver2_W2",
        Passive: [
            "211007",
        ],
        Desc: [
            "As her friend, it’s unfortunate that Lulu is struck with grief. I don’t have any tears to shed for her, though. I’ve got my share of rough experiences, I’m just not sharing it with others. Well, I did say I’ll help her out, but the truth is… My Office figured that we could find plenty of valuable loot in the Library. And that’s pretty tempting. The other one is probably thinking the same thing as me. I mean, what dummy would actually head to such a dangerous place motivated purely by a friend’s sob story? That kind of intimate and deep relationship is long gone from this world. Especially in this business.",
            "That’s why I can’t understand Lulu. Sure, let’s say that her colleague died there. Even then, she should be valuing her own life, shouldn’t she? She can be so stupid at times… Welp, I have to go in with her anyway.",
        ],
    },
    {
        ID: "120001",
        Name: "San’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 35,
        StaggerHP: 18,
        SResist: [0, 0],
        PResist: [0, 1],
        BResist: [-2, -1],
        Skin: "San",
        Passive: [
            "220001",
        ],
        Desc: [
            "An associate Office is one that is in a cooperative relationship with one of the Associations. The advantage of this designation is that its Fixers will not have to worry about starving, since they’re paid a stable salary… And that the Office simply has to handle tasks given by the Association with proficiency, rather than having to deal with clients and accept their requests as ordinary Offices do. Spending days without any incident happening in the area designated for peacekeeping can be admittedly boring… Though it’s a blessing to have such a peaceful day in the City. I was grateful to have such serenity each day, reasoning with Lulu’s occasional complaints.",
            "Is boredom the only downside of being an associate Office? That’s not quite true. Because we’re under the direct command of the Association, we’re forced to take on any undesirable tasks they give. Even if it carries the risk of wiping out the Office…",
            "…I can’t blame the Association, so I only have myself to fault for failing to save my guys.",
        ],
    },
    {
        ID: "120002",
        Name: "Julia’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 35,
        StaggerHP: 24,
        SResist: [-1, -2],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Julia",
        Passive: [
            "220002",
        ],
        Desc: [
            "I still remember the day when the three of us met for the first time. It was when I joined my previous Office.",
            "I was actually scared back then. It was the first workplace I was assigned to just after I became a Fixer. I was hesitating in front of the glass door, wondering whether I should go in or wait for someone to open it, but then I heard a sound coming from inside. Two people arguing with each other… I decided to get close to the door and eavesdrop on them.",
            "“How tight did the bonds between our fates have to be to lead us here… Sigh…”",
            "“I mean, both you and I are first timers, isn’t it reassuring to be with a familiar face?”",
            "“Not at all! When is this Julia person coming, anyway? Don’t tell me she got disappointed by your pathetic impression and went back already.”",
            "“She’s not coming in because she’s intimidated by your facial expression.”",
            "She gave me a glance, turned back to the tall person with an even fiercer gaze than moments ago, then kicked him in the shin and came striding along towards me. The tall person followed, rubbing his shin. As the person with pigtails got closer and closer, I found myself stepping backward, even though I knew I should be saying hello to her… Soon, the chime on the door rang as it opened up, and we stood still for a few seconds like that, not one of us saying a single word. I don’t know why, but it was so funny to me that she was puckering her lips, just as hesitant to speak as I was, so I burst out laughing.",
        ],
    },
    {
        ID: "120003",
        Name: "Isadora’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 39,
        StaggerHP: 17,
        SResist: [0, 0],
        PResist: [-1, -2],
        BResist: [0, 1],
        Skin: "Isadora",
        Passive: [
            "220003",
        ],
        Desc: [
            "San and Julia are old Fixer friends of mine. And San’s from the streets of District 21, the same place I grew up in. This is a secret I’ve only told Julia, but San actually used to be a huge coward. It’s probably not that surprising to you since he still acts like a coward from time to time. Thinking about the old days makes me laugh, though? He’d always “train” himself so he “doesn’t lag behind” and end up getting scars on his face. And one time, he walked into a dark alleyway, saying exploration shouldn’t be a problem for a brave person even though his face was already full of fear, and then ran back to me in less than a minute.",
            "We almost got into serious danger one time. The two of us were hanging out until after dark, and ran into something nasty in a remote street. It happened when I was a little kid, so my memory of that is blurry… All I can remember is looking at San’s back, standing in front me holding a tree branch he hurriedly picked up. My heart was racing with fright, but looking at his shivering legs made me chuckle a little on the inside. I don’t really remember what happened after that, as I said.",
            "Why am I bringing this up all of a sudden? I don’t know. I was just reminded of the old times seeing San kneel down for the sake of his Office juniors. He never changes, huh?",
        ],
    },
    {
        ID: "120004",
        Name: "Walter’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [3, 5],
        HP: 42,
        StaggerHP: 19,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [-2, -2],
        Skin: "Walter",
        Passive: [
            "10001",
            "220004",
        ],
        Desc: [
            "The Associations handle requests often made for Fixers such as security, combat, assassination, intel, patenting, and trades. When there is money, there are Associations. The Associations follow the demand, not the other way around. Demand equals requests, and requests equals profit.",
            "It may seem too materialistic to you, but seeing how the Associations work, you’ll have to agree that money is their prime objective. For instance, the Associations sort and classify every single notable event in the City. Urban Myths, Urban Legends, Urban Plagues, Urban Nightmares, and Stars of the City… Risk is not what determines their grade. The only question that matters is how much people are willing to pay to have the threat eliminated.",
        ],
    },
    {
        ID: "120005",
        Name: "Mika’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 50,
        StaggerHP: 21,
        SResist: [-2, -1],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Mika",
        Passive: [
            "220005",
        ],
        Desc: [
            "Every useful workshop technology is patented. The City strictly forbade making or selling products using technology patented by another workshop without purchasing the rights to it. If anyone infringes this regulation and still uses technology they shouldn’t have access to… They will receive a cease and desist letter up to three times. When you receive the warning, you must pay all profit you’ve earned through the infringement to A Corp. as a fine. Why A Corp. out of all places? Because that’s the corporate in charge of managing and granting all patents. It’s the Head we’re talking about. In any case, if you can’t pay the penalty by the third warning… The Claw will tear you down.",
            "To tell you the truth… Yes. I’m the daughter of a small workshop owner. My father dreamed to make his little brand famous one day. Its name was… Sorry, I don’t feel like saying it out loud. It’s long gone, so you’ll get nothing even if you look for it. That’s right. As I explained moments ago… If you can’t spit out the money you illegitimately earned from manufacturing or selling products using stolen technology, punishment awaits. W-wait, please listen to my story to the end. My father was a victim of fraud. His friend gave him a technology and asked him to make weapons for his Office out of it, so he made them per his request. He didn’t even realize that the technology was stolen from someone else. He’d already sent the weapons to the Office, and when he was waiting for his friend to test them out and transfer the payment, a cease and desist was sent. …You can guess the rest of this story.",
        ],
    },
    {
        ID: "120006",
        Name: "Olga’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 55,
        StaggerHP: 24,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Olga",
        Passive: [
            "10001",
            "220006",
        ],
        Desc: [
            "Myo and I are old friends. I honestly don’t ‘member how our first meeting went, other than being Backstreets buddies, but eh… That just goes to show how long our friendship’s been, don’t it? We’ve done requests together, been in life or death situations together. We’d been too busy to contact each other often ever since I moved to this Office, but then Myo called me out for a date one day.",
            "Maybe it was because I got to drink with my old friend after a long while, or maybe it was the honor of having a seat with the famous captain of the Rabbit Team, but I was in a mighty good mood. I was taking swig after swig of booze… Rain would’ve scolded me for sure if I went back drunk as a broom, I felt that… But that happens all the time anyway, so I didn’t care much. “How’s it going?” “So-so, how about you?” “Same as you, lass.” After some meaningless chatters, Myo gasped like she remembered something and started skimming through her fanny pack. Then she shot me a stealthy look.",
            "“Psst, Olga. Come closer. We don’t want anyone peeping at us, so stick right next to me. And stay quiet!”",
            "“You’re the noisiest one here and you already stick out like a sore thumb, so just say it already.”",
            "“You’re not a woman of style, are you. It’s more fun to talk like we’re secret agents exchanging confidential info when we’re discussing topics like this! It’s stylish that way. Forget it, R Corp. has been investigating something of late. It’s…”",
            "“Are you giving work to our Office? Or are you just bragging. By the way, I guess it’s pretty serious if R Corp. is paying attention to whatever that is, just how big is it? Oh, I heard people’s been going missing lately… Does it have anything to do with that? Or…”",
            "“Shut up and listen for a sec! You always have too much to say… Here’s the deal, Olga; I’ve got a lush grassland to show you, so graze it to your heart’s content and bring some of its veggies for me. How’s it sound?”",
            "Some words she chose. I clicked me tongue and took a close look at the black card and WARP train tickets Myo pushed to my side, before drinking off my glass and agreeing to give it a go. I wouldn’t have taken it if I’d known it’d bring us to this complete lunacy.",
        ],
    },
    {
        ID: "120007",
        Name: "Rain’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 50,
        StaggerHP: 21,
        SResist: [0, 1],
        PResist: [-1, -2],
        BResist: [0, 0],
        Skin: "Rain",
        Passive: [
            "220007",
        ],
        Desc: [
            "When an Office accepts a request, an official deed of contract must be drawn up before the case can be dealt with. It sounds big, but it’s basically just a mutual promise; I think it’s “consideration” in legal terms. The client will pay a certain amount of money as reward, and the Fixers will do their best to resolve the case… They’re plain and natural clauses for the most part. It seems people in this City are prone to breaking promises as simple as those without a contract to bind them, though. In any case, contracts serve as physical evidence to prove our performance and secure our payment when we submit reports to the Association. Without a contract, there’s no assurance that we’ll score a record for our career or get our due payment. To give you an example, Big Sis resolved a huge case the other day, but we got absolutely nothing out of it because she forgot to sign a contract for it.",
            "Requests made by Wings are quite different from those assigned by the Associations in several aspects. You’ll be made the envy of everyone once you get a request from a Wing. First of all, a Wing commissioning a regular Office indicates that the Office has been recognized to be worthy of its trust, and that alone can be a significant achievement. You’ll have something to brag about to other Fixers… And the payment is big as well. A single request from a Wing resolved can keep us afloat for three months minimum. If I must be honest, however, I am rather… unnerved. As rewarding as work given by Wings can be, there’s significant risk associated with it. Imagine how dangerous and difficult this mission may be if R Corp, a Wing specializing in combat, requested us to resolve it for them. Big Sis happily accepted the job, though I still can’t help but be worried a little. Still… I hope it goes well.",
        ],
    },
    {
        ID: "120008",
        Name: "Gyeong-mi’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [3, 5],
        HP: 55,
        StaggerHP: 26,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [0, 1],
        Skin: "Gyeong-mi",
        Passive: [
            "220008",
            "4",
            "1006",
        ],
        Desc: [
            "Some fools laugh at these accessories I’m wearing. They think I’m a glossy punk trying to look cool, figged out with random ornaments without a second thought. What they don’t know is that these ain’t just for fashion. They’re good for making arrogant idiots let their guard down, but before that, they’re workshop products with real, practical uses.",
            "You heard about how people use belts to choke others, didn’t ya? These accessories are similar to that. They’re useful for beating someone to death, though I gotta take the risk that comes from using ‘em. Expensive gadgets crafted by premium workshops have almost zero side effects. On the other hand, this ring for example lets me deliver a harder blow with my punches, but it chafes the skin of my hand at the same time. This one’s on me for using it for too long, and I hear quality products usually get regular repairs and maintenance to prevent that… The side effects on my gear’s pretty minor and negligible, but in worse cases, you get some poor sod whose neck got snapped by the necklace they were wearing.",
        ],
    },
    {
        ID: "120009",
        Name: "Dino’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 52,
        StaggerHP: 22,
        SResist: [-2, -1],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Dino",
        Passive: [
            "220009",
        ],
        Desc: [
            "Tattoos are the cleanest type of augment procedure you could get. I only got it ‘cause Gyeong-mi pushed me to give it a shot… I’m pretty satisfied with the result. It doesn’t cost an awful lot, and it looks pretty damn nice, too. Weakass wimps run away at the sight of my tattoo. But you see, coolness isn’t the only notable feature of these tattoos.",
            "There’s tons of tattoo types depending on the quality of the ink and the material used, but generally speaking, you can have results like bursts of strength or skin as hard as steel. It used to be a Singularity, but ever since the Wing owning the tech got snapped and its patent expired, everyone and their mother’s been using it. Don’t get tattoos that are too cheap, though. You might wake up to find melted flesh. You get exactly what you pay for in this City. Bastards are only honest when money’s involved.",
        ],
    },
    {
        ID: "120010",
        Name: "Zulu’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 52,
        StaggerHP: 23,
        SResist: [0, 0],
        PResist: [-2, -1],
        BResist: [1, 0],
        Skin: "Zulu",
        Passive: [
            "220010",
        ],
        Desc: [
            "Even if you make your way up to the big leagues and become a decently influential Syndicate, there’s still loads of stronger gangs above ya, and they peck at you all the same. No matter how far a Syndicate climbs and tries, you just can’t surpass the Five Fingers at the top. Syndicates ain’t too different from Fixers in that you have to repeat the same, stupid shit following orders from above. So in my opinion, holding onto your place seems wiser than trying to climb up out of ambition or greed. Unless you’re at rock bottom, of course. Someone’s gotta be below us to serve as a punching bag, ain’t that right?",
        ],
    },
    {
        ID: "121001",
        Name: "A Zwei Fixer’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 39,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-1, -2],
        BResist: [0, 1],
        Skin: "ZweiUnit1",
        Passive: [
            "221001",
        ],
        Desc: [
            "Is there a person or a group dedicated to stopping violence or murder in the Backstreets? Not quite. You’re on your own, unless you have the money to hire Fixers. Protection isn’t some volunteer service you can get for free. Fixers risk their lives for it, it’ll take our lives’ worth of money to get motivated to work. We aren’t robots. If you’re so afraid, why don’t you hire Fixers or move to a Nest. You’re free from all outside threats when you live in a Nest. Unless the Nest falls, of course.",
            "Zwei Association is your shield. We protect you, your family, and your home from Syndicates of the Backstreets or crazed murderers. If you have the wealth to make a direct request to the Association, that is. Without due payment, the Association will not move.",
            "Do you believe our request fee is too expensive, and you would rather request a Syndicate? Hmm… While making a request to a Syndicate is an option… We don’t recommend it. The reason is obvious. No organization in the City that operates without abiding formal procedures can be trusted.",
            "Associate Fixers are classified into multiple levels, too. From Section 1, which is the apex, to Section 6, the bottom… There’s a world of difference in the salaries and treatment they get. I guess that’s because they’re much more experienced than us… If I keep trying hard, then maybe I’ll be able to join Section 5 someday!",
            "It’s not an easy feat to get out of Section 6, of course…. It takes a huge effort, or perhaps something that can’t be accomplished with effort alone. I’m a fresh member here, so there’s still a lot for me to learn… Still, I’m gonna pick up experience as I resolve the missions assigned to me, and I’ll probably figure out what to do in time.",
            "The Zwei tends to be more defensive than other Associations or Offices. Our main purpose is not to fight and win, but rather to ensure the safety of our clients. We don’t perpetrate unnecessary killings in our duty of protecting people.",
            "Thus, if you’re looking to make a request for someone’s death, we recommend seeking other Associations for it.",
        ],
    },
    {
        ID: "121002",
        Name: "A Zwei Fixer’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 39,
        StaggerHP: 15,
        SResist: [-1, -2],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Zwei_Yellow",
        Passive: [
            "221001",
        ],
        Desc: [
            "Is there a person or a group dedicated to stopping violence or murder in the Backstreets? Not quite. You’re on your own, unless you have the money to hire Fixers. Protection isn’t some volunteer service you can get for free. Fixers risk their lives for it, it’ll take our lives’ worth of money to get motivated to work. We aren’t robots. If you’re so afraid, why don’t you hire Fixers or move to a Nest. You’re free from all outside threats when you live in a Nest. Unless the Nest falls, of course.",
            "Zwei Association is your shield. We protect you, your family, and your home from Syndicates of the Backstreets or crazed murderers. If you have the wealth to make a direct request to the Association, that is. Without due payment, the Association will not move.",
            "Do you believe our request fee is too expensive, and you would rather request a Syndicate? Hmm… While making a request to a Syndicate is an option… We don’t recommend it. The reason is obvious. No organization in the City that operates without abiding formal procedures can be trusted.",
            "Associate Fixers are classified into multiple levels, too. From Section 1, which is the apex, to Section 6, the bottom… There’s a world of difference in the salaries and treatment they get. I guess that’s because they’re much more experienced than us… If I keep trying hard, then maybe I’ll be able to join Section 5 someday!",
            "It’s not an easy feat to get out of Section 6, of course…. It takes a huge effort, or perhaps something that can’t be accomplished with effort alone. I’m a fresh member here, so there’s still a lot for me to learn… Still, I’m gonna pick up experience as I resolve the missions assigned to me, and I’ll probably figure out what to do in time.",
            "The Zwei tends to be more defensive than other Associations or Offices. Our main purpose is not to fight and win, but rather to ensure the safety of our clients. We don’t perpetrate unnecessary killings in our duty of protecting people.",
            "Thus, if you’re looking to make a request for someone’s death, we recommend seeking other Associations for it.",
        ],
    },
    {
        ID: "121003",
        Name: "A Zwei Fixer’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 39,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -1],
        BResist: [0, 1],
        Skin: "Zwei_Orange",
        Passive: [
            "221001",
        ],
        Desc: [
            "Is there a person or a group dedicated to stopping violence or murder in the Backstreets? Not quite. You’re on your own, unless you have the money to hire Fixers. Protection isn’t some volunteer service you can get for free. Fixers risk their lives for it, it’ll take our lives’ worth of money to get motivated to work. We aren’t robots. If you’re so afraid, why don’t you hire Fixers or move to a Nest. You’re free from all outside threats when you live in a Nest. Unless the Nest falls, of course.",
            "Zwei Association is your shield. We protect you, your family, and your home from Syndicates of the Backstreets or crazed murderers. If you have the wealth to make a direct request to the Association, that is. Without due payment, the Association will not move.",
            "Do you believe our request fee is too expensive, and you would rather request a Syndicate? Hmm… While making a request to a Syndicate is an option… We don’t recommend it. The reason is obvious. No organization in the City that operates without abiding formal procedures can be trusted.",
            "Associate Fixers are classified into multiple levels, too. From Section 1, which is the apex, to Section 6, the bottom… There’s a world of difference in the salaries and treatment they get. I guess that’s because they’re much more experienced than us… If I keep trying hard, then maybe I’ll be able to join Section 5 someday!",
            "It’s not an easy feat to get out of Section 6, of course…. It takes a huge effort, or perhaps something that can’t be accomplished with effort alone. I’m a fresh member here, so there’s still a lot for me to learn… Still, I’m gonna pick up experience as I resolve the missions assigned to me, and I’ll probably figure out what to do in time.",
            "The Zwei tends to be more defensive than other Associations or Offices. Our main purpose is not to fight and win, but rather to ensure the safety of our clients. We don’t perpetrate unnecessary killings in our duty of protecting people.",
            "Thus, if you’re looking to make a request for someone’s death, we recommend seeking other Associations for it.",
        ],
    },
    {
        ID: "121004",
        Name: "A Zwei Fixer’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 35,
        StaggerHP: 15,
        SResist: [0, 0],
        PResist: [-2, -1],
        BResist: [1, 0],
        Skin: "ZweiUnit1",
        Passive: [
            "221001",
        ],
        Desc: [
            "Is there a person or a group dedicated to stopping violence or murder in the Backstreets? Not quite. You’re on your own, unless you have the money to hire Fixers. Protection isn’t some volunteer service you can get for free. Fixers risk their lives for it, it’ll take our lives’ worth of money to get motivated to work. We aren’t robots. If you’re so afraid, why don’t you hire Fixers or move to a Nest. You’re free from all outside threats when you live in a Nest. Unless the Nest falls, of course.",
            "Zwei Association is your shield. We protect you, your family, and your home from Syndicates of the Backstreets or crazed murderers. If you have the wealth to make a direct request to the Association, that is. Without due payment, the Association will not move.",
            "Do you believe our request fee is too expensive, and you would rather request a Syndicate? Hmm… While making a request to a Syndicate is an option… We don’t recommend it. The reason is obvious. No organization in the City that operates without abiding formal procedures can be trusted.",
            "Associate Fixers are classified into multiple levels, too. From Section 1, which is the apex, to Section 6, the bottom… There’s a world of difference in the salaries and treatment they get. I guess that’s because they’re much more experienced than us… If I keep trying hard, then maybe I’ll be able to join Section 5 someday!",
            "It’s not an easy feat to get out of Section 6, of course…. It takes a huge effort, or perhaps something that can’t be accomplished with effort alone. I’m a fresh member here, so there’s still a lot for me to learn… Still, I’m gonna pick up experience as I resolve the missions assigned to me, and I’ll probably figure out what to do in time.",
            "The Zwei tends to be more defensive than other Associations or Offices. Our main purpose is not to fight and win, but rather to ensure the safety of our clients. We don’t perpetrate unnecessary killings in our duty of protecting people.",
            "Thus, if you’re looking to make a request for someone’s death, we recommend seeking other Associations for it.",
        ],
    },
    {
        ID: "121005",
        Name: "A Stray Dog’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 50,
        StaggerHP: 24,
        SResist: [-1, 0],
        PResist: [0, -1],
        BResist: [0, 0],
        Skin: "StrayDogs_1",
        Passive: [
            "221005",
        ],
        Desc: [
            "It’s true that our Syndicate’s sorta intimidating and got a tight hierarchy goin’ on, but the bond between members is strong. We’re actually leagues nicer than those Office fucks who exploit and abandon each other with every breath. Those crooked bastards’ll do anything for profit. I’m sometimes in awe of the shit they pull.",
            "I actually used to be a Rat. Yeah, those filthy and wretched Rats everyone looks down upon. It’s amazing that I’m now standing shoulder to shoulder with the Dogs, ain’t it? I busted my ass crawling up the ladder. I did everything in my power. Got a small tattoo with the little cash I had, and rummaged through trash to find worn but still usable accessories.",
            "It was a damn tough climb, but now that I’m up here, I’m starting to feel like it might’ve been better off to just live as a Rat. Here, a strict barking order’s set up between members. It’s nothing like the Rats who move in close packs.",
            "Sometimes… I do miss my old family.",
        ],
    },
    {
        ID: "121006",
        Name: "A Stray Dog’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 50,
        StaggerHP: 24,
        SResist: [-1, 0],
        PResist: [0, -1],
        BResist: [0, 0],
        Skin: "StrayDogs_1",
        Passive: [
            "221006",
        ],
        Desc: [
            "It’s true that our Syndicate’s sorta intimidating and got a tight hierarchy goin’ on, but the bond between members is strong. We’re actually leagues nicer than those Office fucks who exploit and abandon each other with every breath. Those crooked bastards’ll do anything for profit. I’m sometimes in awe of the shit they pull.",
            "I actually used to be a Rat. Yeah, those filthy and wretched Rats everyone looks down upon. It’s amazing that I’m now standing shoulder to shoulder with the Dogs, ain’t it? I busted my ass crawling up the ladder. I did everything in my power. Got a small tattoo with the little cash I had, and rummaged through trash to find worn but still usable accessories.",
            "It was a damn tough climb, but now that I’m up here, I’m starting to feel like it might’ve been better off to just live as a Rat. Here, a strict barking order’s set up between members. It’s nothing like the Rats who move in close packs.",
            "Sometimes… I do miss my old family.",
        ],
    },
    {
        ID: "121007",
        Name: "A Grade 8 Fixer, Page 1",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 37,
        StaggerHP: 25,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [-2, -1],
        Skin: "NewStaff_1",
        Passive: [
            "221007",
        ],
        Desc: [
            "All people and firms generating income in this City must pay their taxes. In addition to the fund for work-related expenses such as maintenance of equipment and monthly rent for Office space, which is already a lot, Fixers must accommodate for rather heavy taxes as well. I became a Fixer trying not to starve, but the taxes have put me in an even tougher hardship… Ordinary people have a hard time bearing this pressure, but what can I do… In the City, orders are to be followed.  We all know what happens if we don’t abide by them…",
        ],
    },
    {
        ID: "121008",
        Name: "A Grade 8 Fixer, Page 2",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 37,
        StaggerHP: 25,
        SResist: [-2, -1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "NewStaff_2",
        Passive: [
            "221007",
        ],
        Desc: [
            "All people and firms generating income in this City must pay their taxes. In addition to the fund for work-related expenses such as maintenance of equipment and monthly rent for Office space, which is already a lot, Fixers must accommodate for rather heavy taxes as well. I became a Fixer trying not to starve, but the taxes have put me in an even tougher hardship… Ordinary people have a hard time bearing this pressure, but what can I do… In the City, orders are to be followed.  We all know what happens if we don’t abide by them…",
        ],
    },
    {
        ID: "121009",
        Name: "A Grade 8 Fixer, Page 2",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 37,
        StaggerHP: 25,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [-2, -2],
        Skin: "NewStaff_3",
        Passive: [
            "221009",
        ],
        Desc: [
            "All people and firms generating income in this City must pay their taxes. In addition to the fund for work-related expenses such as maintenance of equipment and monthly rent for Office space, which is already a lot, Fixers must accommodate for rather heavy taxes as well. I became a Fixer trying not to starve, but the taxes have put me in an even tougher hardship… Ordinary people have a hard time bearing this pressure, but what can I do… In the City, orders are to be followed.  We all know what happens if we don’t abide by them…",
        ],
    },
    {
        ID: "121010",
        Name: "A Grade 8 Fixer, Page 3",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 50,
        StaggerHP: 23,
        SResist: [-1, -2],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "3rdFixer_1",
        Passive: [
            "221010",
        ],
        Desc: [
            "For one to start working as a Fixer, they must acquire a license issued by the ‘Hana Association’, the first Association in the order. The set of skills required to get a Fixer’s license is quite different from those needed to pass Wing entrance exams. One is about physical fitness while the other is more about mental prowess, so to speak. There are exceptions, of course, but this is generally the case.",
            "After acquiring the license, the Fixer must join an ‘Office’. After all, it’s nigh impossible for a no-name Fixer to take jobs on their own. Choosing the right Office is also important, but you can worry about that later. Only the skilled ones can afford to make choices, like decline offers from Offices or ask to be transferred to another. Newcomers who’ve only just become Fixers or incompetent planks who can’t handle their work properly should be content with any Office that accepts them.",
        ],
    },
    {
        ID: "121011",
        Name: "A Grade 7 Fixer, Page 1",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 48,
        StaggerHP: 23,
        SResist: [0, 0],
        PResist: [-1, -2],
        BResist: [0, 0],
        Skin: "3rdFixer_2",
        Passive: [
            "221010",
        ],
        Desc: [
            "Really, does being a Fixer sound cool to you? I suppose it seems nicer than the likes of Rats swarming about in the Backstreets. It does have a professional charm to it, too. But this is a tough job, I tell you. It might be better for you to try and enter a small company to do desk work instead. If you really believe that Fixers are cool… then let me tell you something.",
            "Fixers have to risk their lives at every moment. I know, it sounds silly. Everyone already struggles and fights for their life, so what’s so special about us. But, at least, you won’t have to hear of your friend’s death while you’re having lunch. You pack your favorite food, savor its taste, and when you’re about to swallow it… Know how it feels to choke on it? Your friend’s head suddenly rolls over to your feet. Things… just happen like that. Syndicate grunts rush into your Office all of a sudden, heads are blown off, and a gruesome fight breaks out. It’s the so-called ‘Office raid’.",
            "Are you still not convinced? Syndicate or Fixer, once you set foot in this business, all the things will bind you like shackles, slowly dragging you to the bottom. The sheer weight is going to tire you, and you’d no longer be willing to go back up… Go back and think again carefully. It’s not too late for you to make the right choice.",
        ],
    },
    {
        ID: "121012",
        Name: "A Grade 7 Fixer, Page 1",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [3, 5],
        HP: 48,
        StaggerHP: 23,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "3rdFixer_3",
        Passive: [
            "221012",
        ],
        Desc: [
            "Really, does being a Fixer sound cool to you? I suppose it seems nicer than the likes of Rats swarming about in the Backstreets. It does have a professional charm to it, too. But this is a tough job, I tell you. It might be better for you to try and enter a small company to do desk work instead. If you really believe that Fixers are cool… then let me tell you something.",
            "Fixers have to risk their lives at every moment. I know, it sounds silly. Everyone already struggles and fights for their life, so what’s so special about us. But, at least, you won’t have to hear of your friend’s death while you’re having lunch. You pack your favorite food, savor its taste, and when you’re about to swallow it… Know how it feels to choke on it? Your friend’s head suddenly rolls over to your feet. Things… just happen like that. Syndicate grunts rush into your Office all of a sudden, heads are blown off, and a gruesome fight breaks out. It’s the so-called ‘Office raid’.",
            "Are you still not convinced? Syndicate or Fixer, once you set foot in this business, all the things will bind you like shackles, slowly dragging you to the bottom. The sheer weight is going to tire you, and you’d no longer be willing to go back up… Go back and think again carefully. It’s not too late for you to make the right choice.",
        ],
    },
    {
        ID: "121013",
        Name: "An Axe Gang Member, Page 1",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 60,
        StaggerHP: 33,
        SResist: [0, 0],
        PResist: [-1, -2],
        BResist: [0, 0],
        Skin: "AxeGroup1",
        Passive: [
            "221013",
            "4",
            "1006",
        ],
        Desc: [
            "Our Syndicate’s well acquainted with the guys at Hook Office~ We used to chop n’ rip n’ tear together before they moved on to Fixer business… We were the best buddies, the two Syndicates had a wonderful time with each other. We still do help ‘em out sometimes nowadays. Hm? You thought Fixers and Syndicates were enemies for life? Well… You could say it’s a longstanding love-hate relationship. Usually, a Syndicate causes a scene and Fixers come over to take care of it. But think about it for a sec. If Syndicates didn’t exist, more than half of all Offices would be out of jobs, essentially unemployed, ya get it? It’s a symbiotic relationship right there~! So don’t be so cold to us.",
            "And some Fixers often cooperate with Syndicates to handle cases. Y’know, it’s not like dogs and cats constantly fight each other when they’re together, yeah? That sorta logic. We Syndicates do the things Fixers can’t dare take care of. I heard some Offices straight up ban killing people, even. Something about life being precious and whatevs. It’s bullcrap. Anyway, that’s how Syndicates and Fixers complement each other. There’s some crooks you’d want dead for sure before they could complicate things, you see?",
            "Man~ Talking about ‘em makes me miss my ol’ friends. Don’t get to meet those pals often these days… I might as well storm Hook Office this time around, see some familiar faces~",
        ],
    },
    {
        ID: "121014",
        Name: "An Axe Gang Member, Page 2",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [4, 5],
        HP: 65,
        StaggerHP: 33,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [0, 0],
        Skin: "AxeGroup2",
        Passive: [
            "221014",
            "1003",
            "1009",
            "1010",
            "1011",
        ],
        Desc: [
            "If you think Syndicates are nothing more than gangs of ugly and bad guys, then let me tell ya that’s an outdated bias. Course, we’re freer than Fixers who have to follow orders and requests from Associations. A lot of us kill people and do some wicked shit for the sake of cash, I’ll give you that… But others aren’t too different from your average Fixers, I’m tellin’ ya! We get requests and solve problems. Though, our group’s moral compass is tilted a bit to the dark side, so I can’t give you a good example myself…",
            "Right! Some Syndicates actually do heroic stuff. Syndicates hunting Syndicates. I asked ‘em, “Hell man, why aren’t you guys just becoming Fixers instead?”, and they said… They don’t really feel like it, since they don’t really wanna get entangled in formal stuff and there’s just too much to prepare to get a license and everything. Welp, who’s to say Syndicates can’t be the good guys, right? We’re living as we like in the Backstreets.",
        ],
    },
    {
        ID: "130001",
        Name: "The Carnival’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 58,
        StaggerHP: 29,
        SResist: [-2, -2],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Carnival",
        Passive: [
            "230001",
        ],
        Desc: [
            "There are many important things to consider as a Fixer, and attire is one of them. A Fixer’s attire is the most effective way to signify the image of an Office. It’s important for an Office to show that it has formality and class; most Offices have set a dress code for that reason.",
            "As much as it’s necessary to choose the right attire according to the code, the most important factor is the fabric that clothing is made of. Quality fabric can offer better protection, lighten the wearer’s weight for quicker movement, or allow the wearer to carry heavy weapons as large as their body. Those who create and provide such fabric are called ‘Tailors’.",
            "We are Tailors who consume people and make silk out of them. Whether it’s melting people inside our belly and congealing them in a mold, or it’s unraveling humans into the thread they’re really made of, the fundamentals do not matter. This technology doesn’t originally belong to us. We merely took hold of a technology that came off patent when a Wing was broken. The only thing that matters is that silk made from humans has strength that differentiates it from ordinary thread. Only those who crave it visit us.",
            "Cloth weaved from human silk possesses various powers depending on the human’s strengths. Some humans may have a strong body, another may be fragile but wise, and yet another may flaunt incredible speed. Since the silk reflects the characteristics of the human it was made from, there are as many forms and powers of cloth as there are humans in this world. Therefore, there is more to being a Tailor than simply weaving silk carefully. Picking the right people to meet the demands of the client is the most important. Hastily making silk out of a human that looks courageous on the outside might end up yielding useless cloth that does nothing but bolster courage, so one must be careful with picking the right material.",
            "Not every piece of fabric is accessible, however. It takes more than cash to purchase high-class fabric; one must earn the favor of Tailors first and foremost. Many Tailors will only give their best fabric once the trust between them and their client has been established after complex turns of events.",
            "Because of that, Tailors who make high-quality fabric usually belong to an organization and create cloth exclusively for them. But we were different. Until the Index gave us a Prescript, we did our work without taking orders from anyone, unchained to any Syndicate or other organization. We were free, as some may call it.",
            "L8372-#928: ‘Eat 15 Sweepers and extract silk from them to make fabric.’",
        ],
    },
    {
        ID: "130002",
        Name: "The Carnival’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 58,
        StaggerHP: 29,
        SResist: [-2, -2],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Carnival",
        Passive: [
            "230001",
        ],
        Desc: [
            "There are many important things to consider as a Fixer, and attire is one of them. A Fixer’s attire is the most effective way to signify the image of an Office. It’s important for an Office to show that it has formality and class; most Offices have set a dress code for that reason.",
            "As much as it’s necessary to choose the right attire according to the code, the most important factor is the fabric that clothing is made of. Quality fabric can offer better protection, lighten the wearer’s weight for quicker movement, or allow the wearer to carry heavy weapons as large as their body. Those who create and provide such fabric are called ‘Tailors’.",
            "We are Tailors who consume people and make silk out of them. Whether it’s melting people inside our belly and congealing them in a mold, or it’s unraveling humans into the thread they’re really made of, the fundamentals do not matter. This technology doesn’t originally belong to us. We merely took hold of a technology that came off patent when a Wing was broken. The only thing that matters is that silk made from humans has strength that differentiates it from ordinary thread. Only those who crave it visit us.",
            "Cloth weaved from human silk possesses various powers depending on the human’s strengths. Some humans may have a strong body, another may be fragile but wise, and yet another may flaunt incredible speed. Since the silk reflects the characteristics of the human it was made from, there are as many forms and powers of cloth as there are humans in this world. Therefore, there is more to being a Tailor than simply weaving silk carefully. Picking the right people to meet the demands of the client is the most important. Hastily making silk out of a human that looks courageous on the outside might end up yielding useless cloth that does nothing but bolster courage, so one must be careful with picking the right material.",
            "Not every piece of fabric is accessible, however. It takes more than cash to purchase high-class fabric; one must earn the favor of Tailors first and foremost. Many Tailors will only give their best fabric once the trust between them and their client has been established after complex turns of events.",
            "Because of that, Tailors who make high-quality fabric usually belong to an organization and create cloth exclusively for them. But we were different. Until the Index gave us a Prescript, we did our work without taking orders from anyone, unchained to any Syndicate or other organization. We were free, as some may call it.",
            "L8372-#928: ‘Eat 15 Sweepers and extract silk from them to make fabric.’",
        ],
    },
    {
        ID: "130003",
        Name: "The Carnival’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 58,
        StaggerHP: 29,
        SResist: [-2, -2],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Carnival",
        Passive: [
            "230001",
        ],
        Desc: [
            "There are many important things to consider as a Fixer, and attire is one of them. A Fixer’s attire is the most effective way to signify the image of an Office. It’s important for an Office to show that it has formality and class; most Offices have set a dress code for that reason.",
            "As much as it’s necessary to choose the right attire according to the code, the most important factor is the fabric that clothing is made of. Quality fabric can offer better protection, lighten the wearer’s weight for quicker movement, or allow the wearer to carry heavy weapons as large as their body. Those who create and provide such fabric are called ‘Tailors’.",
            "We are Tailors who consume people and make silk out of them. Whether it’s melting people inside our belly and congealing them in a mold, or it’s unraveling humans into the thread they’re really made of, the fundamentals do not matter. This technology doesn’t originally belong to us. We merely took hold of a technology that came off patent when a Wing was broken. The only thing that matters is that silk made from humans has strength that differentiates it from ordinary thread. Only those who crave it visit us.",
            "Cloth weaved from human silk possesses various powers depending on the human’s strengths. Some humans may have a strong body, another may be fragile but wise, and yet another may flaunt incredible speed. Since the silk reflects the characteristics of the human it was made from, there are as many forms and powers of cloth as there are humans in this world. Therefore, there is more to being a Tailor than simply weaving silk carefully. Picking the right people to meet the demands of the client is the most important. Hastily making silk out of a human that looks courageous on the outside might end up yielding useless cloth that does nothing but bolster courage, so one must be careful with picking the right material.",
            "Not every piece of fabric is accessible, however. It takes more than cash to purchase high-class fabric; one must earn the favor of Tailors first and foremost. Many Tailors will only give their best fabric once the trust between them and their client has been established after complex turns of events.",
            "Because of that, Tailors who make high-quality fabric usually belong to an organization and create cloth exclusively for them. But we were different. Until the Index gave us a Prescript, we did our work without taking orders from anyone, unchained to any Syndicate or other organization. We were free, as some may call it.",
            "L8372-#928: ‘Eat 15 Sweepers and extract silk from them to make fabric.’",
        ],
    },
    {
        ID: "130004",
        Name: "Liwei’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [1, 5],
        HP: 58,
        StaggerHP: 34,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [0, 0],
        Skin: "Liwei",
        Passive: [
            "1003",
            "230004",
        ],
        Desc: [
            "A color is the dream and lifetime goal of all Fixers who wish for freedom. Those who have been assigned a color are called the ‘Colors’; a Color is the pride of the Fixer and the Associations. They put forward the Colors as great and successful people that other Fixers will look up to. They dream of earning wealth and fame, and to be free like them one day.",
            "Colors are assigned by the ‘Hana Association’. They’re bundled into such a category because the Hana deemed them to be the most ideal Fixers. Because they’re the most adequate individuals to deal with the ‘Stars of the City’. The title of a Color is forcibly given to Fixers who qualify, essentially. Can a Fixer be truly happy with freedom that was forcefully handed to them?",
            "Why ‘Colors’ of all terms when there are many other stylish words to choose from? I have no comment to make, since I don’t know the reason myself. My assumption is that colors are used because giving people hues representative of them makes it easier to refer to and remember them by. It may not be the answer you were expecting, but it can’t be helped; the Colors have their own ways of working, and they have basically nothing in common. It’s akin to how visible colors have their own vibrant characteristics. In that sense, the term ‘Colors’ isn’t entirely off-putting.",
        ],
    },
    {
        ID: "130005",
        Name: "Stephan’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 5],
        HP: 55,
        StaggerHP: 30,
        SResist: [0, -2],
        PResist: [0, 0],
        BResist: [0, -2],
        Skin: "Stephan",
        Passive: [
            "1002",
            "230005",
        ],
        Desc: [
            "Few Fixers use guns for self-defense. Bullets cost an arm and a leg, and foes who are relatively powerful tend to dodge shots like it’s nothing, and I can barely graze ‘em… There’s not a lot of ways to react to enemies closing in, either. You’d have to be quick on the draw and shoot them in the weak spots; if you aren’t, the other options are running away or grabbing some prop to guard yourself… Like hell that’ll save you. It takes several augmentation procedures to be able to carry something as heavy as a firearm and run fast enough. If you’re a sniper, you’ll be busy packing up your weapon mount n’ everything; have to make unnecessarily big movements. And what if the precious gun gets damaged if you try blocking your foe’s attack with it? Oh, I was talking about the kinds of guns me and Tamaki use, not firearms in general. You see what Liwei’s carrying? I heard there are lighter rifles, and some that come with bayonets for close-quarters combat… But mind you, those guns have their fair share of downsides, so don’t be too quick to buy them. You might as well save the money and get a quality workshop weapon or an augmentation surgery instead. Hell, you could probably buy a fine weapon with the money it takes to buy bullets for target practice. You weren’t planning on using guns in actual fights without even practicing, were you? I mean, go ahead, if you really want dislocated shoulders and severed fingers.",
            "Despite all this, there still are workshops that manufacture guns and people like us who use them. Guns are just that comfortable to use. Those heavy taxes won’t be a problem as long as use your gun for its intended purpose. How many defenseless thugs standing in the middle of the street can notice a bullet flying toward them? Of course, it’d be even better to get specially made workshop devices that use a special technology to muffle the sound of gunfire, but… Don’t expect too much. There’s currently no technology in our world that can completely cancel out noise, and it won’t exist in the foreseeable future. You don’t need that to make guns work, though. All it takes is an advantageous situation.",
        ],
    },
    {
        ID: "130006",
        Name: "Tamaki’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 5],
        HP: 55,
        StaggerHP: 30,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [-2, -2],
        Skin: "Tamaki",
        Passive: [
            "1002",
            "230006",
        ],
        Desc: [
            "There aren’t many workshops that can craft guns. Setting aside the low demand, the difficulty of acquiring a firearms manufacturing license and the Head’s strict guidelines are the biggest limitations. The guidelines include clauses such as: “The maximum length of the gun barrel must be shorter the higher the gun’s caliber is”, “No gun should possess the firepower to penetrate steel or building walls”, “A gunfire sound must be audible”, and I haven’t even started with the “bad” ones yet. The first page of the guideline boldly states: “Do not research or imagine technology that infringes the firearm manufacturing guidelines, as provided by the Head along with the license.” I’m not a gunsmith myself, so I don’t know the details, and I frankly don’t want to know any more than that. There certainly are workshops permitted to make S-class firearms, but I’m guessing only three to five of them exist in the entire City. Who do they take requests from, where they are, and what kind of people run them… They’re all a mystery. The most I could hear was a rumor that an S-class workshop exists somewhere.",
            "People say that the Head put heavy restrictions on firearms because they don’t want its denizens to be harmed too easily. It’s true that a gun can effortlessly kill a person with one well-placed shot. That’s not all; the assailant doesn’t have to show themselves to attack and a flying bullet is simply too fast for the average person to track with their eyes, making it a fine weapon for stealthily killing others. But making it harder to kill people doesn’t seem good enough a reason to impose such restrictions. What about the countless other trifling and useless methods that exist to kill people? I just cannot understand that they would see this as a solely philosophical issue. Are you asking if it’s because the Wings don’t have sufficient technical expertise? I’m not here for senseless chatter. The Wings could easily make superior weapons with their technology, there’s no real reason they couldn’t improve upon the current designs.",
            "There are probably some people who feel the same as me. They don’t question it further or try to dig deeper into the truth, because… Well, they have their hands full with making their ends meet, and they don’t want to risk losing it all meddling in business secrets, I suppose.",
        ],
    },
    {
        ID: "130007",
        Name: "Salvador’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 80,
        StaggerHP: 39,
        SResist: [1, 0],
        PResist: [0, 1],
        BResist: [0, 0],
        Skin: "Salvador",
        Passive: [
            "10001",
            "230007",
            "230107",
            "230207",
        ],
        Desc: [
            "Case Name: ‘Thousand Needles’",
            "Serial Code: DN-00113",
            "Grade: Urban Legend",
            "Date of Occurrence: XXXX/XX/21",
            "Description: This document is a compilation of relevant information on the case of the Thousand Needles, which occurred in the Backstreets of District 22. While a clear conclusion on this case has yet to be made, it is speculated to be a case of the Distortion based on the apparent inability to confirm the cause or analyze the composition.",
            "Case Report: Entity A-01, the first apparent source of the incident, was wandering the Backstreets of District 22 before swelling up and exploding. Numerous needles were dispersed upon the explosion, flying in all directions. The needles which stuck onto building walls caused the site of impact to melt and crack; when a human was struck with one of the needles, they were transformed into A-02, going through the same bizarre process of detonation A-01 did. The orange symbol on the nape of A-01’s neck was also found on the needles discharged from its body. When I arrived at the scene after taking the request, the bits of flesh scattered around the streets began to merge into one giant body using a brainstem focus resonator, becoming a 3-meter-tall (~10ft) mass that I will refer to as A-03. A-03 began throwing large needles, the length of which varied from 1 to 3 meters. Unlike the small needles fired from the explosion of A-01 or A-02 that could only leave small dents on building structures, the giant needles flung by A-03 caused buildings to helplessly melt. In addition, local residents who stared into the entity’s eyes or holes in its body soon produced a boiling sound before turning into A-02, so I had to forbid people from observing it closely.",
            "A-01 visited OO Office to give a request four days prior to the incident. (Refer to &lt;Audio Transcript of Testimony from a Fixer of OO Office&gt;) Judging by what they said, such as “Made a deal with the devil”, and “Terrible things will happen if I break the contract”, it is speculated that ‘Yesterday's Promise’ is behind the incident.",
            "",
            "Audio Transcript of Testimony from a Fixer of OO Office",
            "File Name: #S-0012-XXXX/XX/23",
            "I’m fine. Can I just talk like this? ……Oh, okay. Got it. When was it… A person visited our Office last Wednesday, if my memory serves me right. They introduced themself as an ordinary resident of the Backstreets of District 22, and said they urgently needed help. There were huge bags under their eyes, and their hair was a tangled mess. Their eyes were lifeless and blurry, and there was some sort of symbol on their neck, as if they’d been attacked by a Stigma Workshop product… The desperation was palpable. They couldn’t even walk straight, and they were straining to approach me with their awkward steps. I managed to calm them down, and they said… I’m sorry. I’m not sure how I should explain it… In short, they made a contract with a devilish person of some kind, and they’re scared that they might break the contract, so they were now asking us to take care of the devil so it can’t kill them as punishment. I still don’t get what that was about, even though I’m talking about it. To be frank… I just couldn’t understand what they were saying. Not just because their level of knowledge and manner of speech was lamentably inferior, no. All they uttered was a series of simple words, but the splendid images delivered in those hysteric words they let out like they were possessed by something, I can’t dare try to describe them… They kept saying confusing things like ‘Will skewer people's heads and make a necklace out of them to offer to it.’ ‘They keep getting closer. They're multiplying in numbers. They're approaching from inside me.’ All with a mysteriously bright glint in their eyes. Oh, our Office records counseling with our clients by principle. You’ll see how confusing the whole situation was if you give this file a listen. Don’t worry, we record them with the client’s consent and everything, so there’s nothing illegal about this. (Refer to &lt;Evidence 5-1: OO Office Counseling Audio Recording&gt;.) But what can I do, really. The whole deal with the devil thing just sounds too unrealistic. I honestly thought they were lying, so I made up an excuse to turn them away.",
        ],
    },
    {
        ID: "130008",
        Name: "Yuna’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 60,
        StaggerHP: 32,
        SResist: [-2, 0],
        PResist: [0, 1],
        BResist: [-2, 0],
        Skin: "Yuna",
        Passive: [
            "230008",
            "230207",
        ],
        Desc: [
            "Audio Transcript of Testimony from District 22 Resident 1",
            "File Name: #S-0019-XXXX/XX/25",
            "(Omitted) I think it was last Monday. Dery said something strange to me. They told me they made a contract with someone and they’re scared that they might break it. They said they don’t know what horrifying penalty they’ll have to face upon breaking the contract. I tried to calm them down, saying they should be fine as long as they don’t actually breach the contract, but Dery got ticked off and complained that it’s unfair how they’re supposed to comply with unfavorable terms hidden in the fine print. Then they broke into tears, saying they’re doomed anyway. They apparently agreed to do three tasks in exchange for gaining power. (Omitted)",
            "",
            "Audio Transcript of Testimony from District 22 Resident 2",
            "File Name: #S-0021-XXXX/XX/25",
            "Do I have to recall that messed up memory…? …Alright. If it’s necessary to prevent another incident from happening… I guess there’s no choice. You can record it, sure. I don’t remember everything that happened, actually. That day was just like any other, except Dery showed up in the streets after going missing for a few days, looking awfully gaunt… Other than that, the weather was normal, and the streets were the same as always. I know, that’s when the incident started… Dery was walking the street as they mumbled something, but they didn’t seem to be heading to a specific destination. It’s like they were staring off into space and forcibly dragging their feet along. They said strange things like something… keeps coming, or boiling; they were always a bit of a weirdo, so that didn’t bother me too much. But then… Dery’s body began swelling up. All I could think at that moment was how funny they looked, expanded like a balloon. The scene was that unrealistic. Maybe it was the shock of confronting an unbelievable situation paralyzing the human brain, or the brain beginning to believe that it’s only a dream and marveling at the scene, but I was just standing still and staring at what was going on. “Am I really in reality?” But before I could gather myself up, the incident happened. Dery’s body blew up and weird needles went. Mrs. Madrid, who was standing in front of me, was struck with one of the needles. And her body swelled up and exploded into a shower of needles, just like Dery did. I luckily managed to get away without getting hit by any needles. I ran right to this Office without turning back once… And now… Now… I don’t think I can get back there. I wonder if anyone else lived… If my friend Mijin’s alright… If my house is fine… I’m curious, but I just can’t go back—I can’t do it… What do I do… I don’t wanna go back to… (The interviewee’s breath became coarse and unstable afterwards; the recording was suspended as it was deemed that the interview could no longer proceed.)",
        ],
    },
    {
        ID: "130009",
        Name: "Philip’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 60,
        StaggerHP: 30,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [-2, -2],
        Skin: "Philip",
        Passive: [
            "230009",
            "230207",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "130010",
        Name: "Alloc’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 5],
        HP: 65,
        StaggerHP: 29,
        SResist: [-2, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Alloc",
        Passive: [
            "230010",
        ],
        Desc: [
            "Cane Office is a notary public Office that officially administers various matters when a contract is made between two Offices. A notary public Office preserves evidence involved in contractual processes and certifies legal issues. Sometimes, the Office may play the role of a broker.",
            "When you work with Cane Office, the process you have to follow will usually be simple outside of a few special cases. All you need to do is make a summary of all the details for the deal you’re making and visit the Office. And don’t forget to take all the relevant documents with you: Notarial deed of promissory note, Migration permit for the Nest (or the Backstreets) of District OO, Deed of forward contract, and everything else related to the deal. If you safely finished your business with Cane Office, those documents will become powerful pieces of evidence that’ll protect you in case a dispute breaks out for whatever reason.",
        ],
    },
    {
        ID: "130011",
        Name: "Dalloc’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 60,
        StaggerHP: 27,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [-2, -2],
        Skin: "Dalloc",
        Passive: [
            "230011",
        ],
        Desc: [
            "The Nest is a home where birds brood their eggs. They use their wings to devotedly protect their eggs from outside threat. Such is the role of the Nests and Wings that constitute the City. Do the eggs represent people inhabiting the Nest, then? Not a chance. These “eggs” are the treasures that Wings possess. Singularities, technologies that make money, featured in countless patents. Its residents are nothing more than feathers of the Wings that serve to protect the eggs. A Wing will end up falling when it loses too many of its feathers, but it won’t bother to desperately protect all of its feathers since a feather or two will naturally grow back. They’re basically expendables.",
            "The twenty-six Wings have their own subsets of culture. It might be the personal preference of the Wing’s founder or the influence of the Singularity, but the cultural styles and social atmosphere vary vastly between the Nests. The Wing’s policies also determine the culture of the Backstreets that belong to it. Each Wing has distinct sets of conducts; some Wings take a relatively cooperative approach to their Backstreets, while others thoroughly exploit them. But Wings will be Wings. “Cooperation” is just a fancy expression for “taking advantage of the Backstreets when the Wing needs them”. If you can’t afford to enter a Wing and have to live in the Backstreets, you’re best off settling in the District that suits you well. You’ll still need a home and source of income, of course.",
        ],
    },
    {
        ID: "130012",
        Name: "Bono’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 60,
        StaggerHP: 27,
        SResist: [1, 0],
        PResist: [-2, -2],
        BResist: [0, 0],
        Skin: "Bono",
        Passive: [
            "230012",
        ],
        Desc: [
            "People are hung up on money, but it’s not just because they want to be well off; the formidable tax burden is a big part of why. No matter how humble your job is, you’re still obliged to pay your duties if you earn money. It goes for every type of business transaction. Even Syndicates are no exception; anyone living in the City has to pay taxes. If you don’t meet the deadline, you’ll get a warning. For the first three offenses, you’ll get a notice of warning and no other penalty. But if you don’t pay your taxes for the fourth time? Then you’re dead meat. They’ll come for you. The Eye will seek out tax evaders by any means, and the person it sends will rip those poor cheats to shreds.",
        ],
    },
    {
        ID: "130013",
        Name: "A Love Townsperson’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 3],
        HP: 71,
        StaggerHP: 31,
        SResist: [2, 2],
        PResist: [-2, 0],
        BResist: [-2, 0],
        Skin: "LoveTownPersonH",
        Passive: [
            "230013",
        ],
        Desc: [
        ],
    },
    {
        ID: "130014",
        Name: "A Love Townsperson’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 3],
        HP: 71,
        StaggerHP: 31,
        SResist: [-2, 0],
        PResist: [-2, 0],
        BResist: [2, 2],
        Skin: "LoveTownPersonJ",
        Passive: [
            "230013",
        ],
        Desc: [
        ],
    },
    {
        ID: "130015",
        Name: "A Love Townsperson’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 3],
        HP: 71,
        StaggerHP: 31,
        SResist: [-2, 0],
        PResist: [2, 2],
        BResist: [-2, 0],
        Skin: "LoveTownPersonZ",
        Passive: [
            "230013",
        ],
        Desc: [
        ],
    },
    {
        ID: "130016",
        Name: "Tomerry’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [1, 5],
        HP: 300,
        StaggerHP: 85,
        SResist: [-2, 2],
        PResist: [0, 2],
        BResist: [-2, 2],
        Skin: "TomerryPhase1",
        Passive: [
            "230016",
            "231016",
            "232016",
        ],
        Desc: [
        ],
    },
    {
        ID: "130017",
        Name: "",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [1, 1],
        HP: 150,
        StaggerHP: 60,
        SResist: [0, 2],
        PResist: [0, 2],
        BResist: [0, 2],
        Skin: "TomerryPhase2",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "130018",
        Name: "Sayo’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 79,
        StaggerHP: 38,
        SResist: [1, 0],
        PResist: [0, 1],
        BResist: [-2, 0],
        Skin: "Sayo",
        Passive: [
            "10001",
            "230018",
            "230118",
            "231001",
        ],
        Desc: [
            "The Hand of the Backstreets is possibly the biggest reason no one dares to take care of the lawless land that is the Backstreets; no Associations or Wings can touch it, and not even the Head itself can easily interfere. The five Syndicates at the apex of the Backstreets are called the Thumb, the Index, the Middle, the Ring, and the Pinky, namely. They parcel out districts of the Backstreets and comprehensively manage their territories, and periodically hold meetings to efficiently control the Backstreets. They call this conference the “Finger Bow-Bell”; I’m uncertain as to whether this name is meant to suggest that they actually make pinky swears not to invade each other’s territories, or if they call it as such simply because the Fingers gather in one place… The mind of higher-ups is a mystery, truly. Going back to the topic, when the Finger Bow-Bell nears, all members of the five Fingers will try to avoid conflict and refrain from causing big problems. It’s thanks to the leaders of each Syndicate who caution their subordinates that fights between smaller Syndicates could grow into a massive conflict between the big ones, perhaps… If subsidiary Syndicates ran into trouble, the seniors at the Finger Bow-Bell would be faced with quite the embarrassment, now wouldn’t they?",
        ],
    },
    {
        ID: "130019",
        Name: "Yang’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 78,
        StaggerHP: 37,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [-2, 0],
        Skin: "Yang",
        Passive: [
            "230019",
            "231001",
            "4",
            "1004",
        ],
        Desc: [
            "There are two kinds of folks who hang around in the Backstreets at night: the predator and the prey. Pretty much everything going on in the City can be described as ‘savage’, but the other parts of the City at least put up the effort to package them in gentlemanly guises. Even a cheap hamburger made from whatever unspeakable ingredients is still wrapped in a modern and rich packing, yeah? On the other hand, the Backstreets at night are filled with raw and blatant barbarity; not even a layer of crude cover is there to censor this brutality. No deed is forbidden… No one is held responsible. Imagining the most appalling, vulgar, and filthy deed you can think of. I won’t dare say “beyond your imagination” since I have no idea how insane you might be. But I can guarantee that whatever you’re thinking casually happens somewhere in the dark alleys of the Backstreets at night.",
            "Despite all that, people still inhabit the Backstreets. They doggedly struggle and survive in their own ways here.",
        ],
    },
    {
        ID: "130020",
        Name: "Gin’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 75,
        StaggerHP: 38,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [-2, 0],
        Skin: "Gin",
        Passive: [
            "230020",
            "231001",
            "4",
            "1004",
        ],
        Desc: [
            "A fallen Nest no longer has an owner to protect its inhabitants. What happens to them, then? In the wreckage of the Nest that’s gradually turned into an environment similar to the Backstreets, all they can do is accept horrible deaths as Backstreets residents do or hire a Fixer… Or pay protection fees to one of the powerful Syndicates that enter the Nest and be under their care. Some move to a different Wing, but this is an exceptionally rare case. The Syndicate may charge ridiculously expensive fees, but they will keep you safe for sure once you pay them. (If an even stronger Syndicate comes in, drives off the others, and asks you to pay a protection fee… Then there’s no choice but to give your new protectors what they ask for.) They’ll protect you with their lives as long as you still have money to pay. The assets will become useless when you die anyhow, so you might as well spend it to extend your life for just a little longer. The former feathers don’t have a choice in this matter. If they don’t pay the fee, they’ll die or get kicked out. It would be a miracle to walk out unharmed.",
        ],
    },
    {
        ID: "130021",
        Name: "Meow’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 5],
        HP: 79,
        StaggerHP: 43,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Meow_F",
        Passive: [
            "10001",
            "230021",
            "230121",
        ],
        Desc: [
            "Heehaw, Doodle-doo, Woof… and me. The four of us were moved to the core by the Pianist’s performance. To recreate the performance half as splendid as what we heard that day, we formed the Musicians of Bremen to study the music. We tried flicking strings here and there… Playing music while sitting, on our backs, and even while handstanding! We still couldn’t come close to the Pianist’s level, but we managed to make our own brand of music, something that only the Musicians of Bremen can play. Our performance was actually pretty fantastic, you know?",
            "Sadly, our time didn’t last long. One day, a mysterious person approached us and asked us to join his ensemble and perform with him… Woof, Doodle-doo, and Heehaw took the offer and left with that guy. I had to stay because of new members that had just joined our band, though. Yep, MuMu and Oink. It’s kinda… uncomfortable to just leave them behind, you know? We can’t let them mess around and taint our name, either. I’ve been practicing with them to create a performance that could get a standing ovation once my old bandmates come back. But at their current level of skills, the three would just cluck at these newbies’ performance and go back to whatever they were doing.",
        ],
    },
    {
        ID: "130022",
        Name: "MuMu’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 77,
        StaggerHP: 39,
        SResist: [-2, -2],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Mumu",
        Passive: [
            "230022",
            "230121",
        ],
        Desc: [
            "They say the Backstreets are a nigh-inhabitable hellscape, but the people here live on somehow. There’s lots of people who live in fear every moment, but… The others live a pretty normal life. Some think the Backstreets are totally shady and poorly aged slums… But we do have all the amenities we need here. For one, the supermarkets Oink likes aren’t as good as those in the Nest, but it’s got everything people need. Clothing stores, groceries, dry cleaners, etc… I heard the details are different for each District, so there’s that… I’m just telling you how things are where I live. People here aren’t too unkind to each other. Those Nest dwellers like to gossip about how we’re cruel and dreary and all that, but the truth is, we’re doing just fine.",
            "Oh, and there’s tons of good restaurants here. It’s the street of flavor, after all. Freshly baked meat pies, spaghetti made of special pasta… Your tongue and stomach have a wonderful time if you ever go on a trip to our District. We used to hand over the leftovers from our performance here to local restaurants. That meat would go to waste if we left it on the spot, so we might as well give it to the people who can make good use of it, ain’t that right? When Woof, Doodle-doo, and Heehaw were around, we got enough chow to share with several eateries, but our find was halved since they were gone… And Oink kept making silly mistakes with it and ruined those ingredients too often, so we quit that biz altogether. Which is a tad bit unfortunate~ We sometimes got tasty meals for free when we gave them our meat.",
        ],
    },
    {
        ID: "130023",
        Name: "Oink’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 74,
        StaggerHP: 36,
        SResist: [-2, -2],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Oink",
        Passive: [
            "230023",
            "230121",
        ],
        Desc: [
            "The Seven Association is a Fixer Association specializing in investigation and intelligence, and it’s knowledgeable in pretty much every affair that takes place in the City. Details about a Syndicate gaining infamy in the Backstreets of some place (the Association probably knows what District it is exactly, but I left before I checked the details of it.), all the information revealed about the Distortion Phenomenon which has been going around lately, when and where Fixer Offices start up and close business, and the beat goes on… The Association treats all kinds of information about the City. Oh, they don’t have access to top-secret intels like the secrets of the Singularities each Nest holds, obviously speaking. When they solve cases, they usually cooperate with other Associations like the Shi and the Liu.",
            "If you ask how the Seven Association can secure its confidentiality despite holding lots of juicy info that could attract the many, it’s likely because its staff aren’t bad combatants by any means. They don’t use fancy but crude workshop weapons that are basically large amalgamations of various technologies. Regular informants are armed with nothing more than a simple bladed tool. It sounds very underwhelming judging from the weapon alone, but they use the minimum technique with pinpoint precision to take down their foes.",
        ],
    },
    {
        ID: "130024",
        Name: "Oscar’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 5],
        HP: 81,
        StaggerHP: 45,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Oscar",
        Passive: [
            "10001",
            "230024",
            "230025",
            "230026",
        ],
        Desc: [
            "The 8 o’Clock Circus was a real sod of a case. Its leader wasn’t a particularly powerful enemy, but it took a long time to assess the strengths and behavior of each of his 'crew'. There was no specific pattern to it, and it was difficult to predict what would come next; it was akin to watching an erratic circus of lunacy. Their lair was mysterious and terrifyingly bleak, and the crew took hideous forms as well, looking too grotesque to possibly be considered normal living beings. They were as strong as they looked; when the blob shaped like a lion bit Pameli with its blunt teeth, her body quite literally blew up on the spot.",
            "However, our enemies were slowly brought down from the vantage point, and when they were completely cornered, the leader escaped along with a few of his crew. Even though we couldn’t put an end to the case, we decided to prioritize recovering Pameli’s body as we deemed the Circus would be weakened enough to stay low for a while. As we stored Pameli’s head in a stasis preservation case and headed to the exit of the collapsing circus tent, we ran into a group of Fixers. They seemed rather exhausted after fighting a swarm of the crew outside. I suppose that’s why they couldn’t enter the tent until that moment. It’s not uncommon for two or more Offices of Fixers to be present at the scene of a finished case, so I gently nodded to greet them, identifying ourselves as Fixers of Wedge Office who have come here to solve the case. The shortest person among them… The aged-looking woman who appeared to be the representative of that group looked around the circus tent, let out a deep sigh, and introduced herself as Moses—of Moses’ Office—while smoking from her pipe. Moses then started thinking, presumably ruminating over what words to choose. She must’ve taken a request that’s rather tricky to disclose. The two people behind her nervously exchanging glances with each other appeared to be her bodyguards of some sort. Having such trivial thoughts, I waited for this Moses person to resume speaking. After a brief period of silence, Moses breathed out smoke in the other direction and asked me where the leader of the Circus went. Since I didn’t know much better than them, I told them what I could in brief. They seemed troubled by my unhelpful answer, but they soon accepted it and left the scene.",
            "…That group reportedly appears every time a case of the Distortion is solved. They’re allegedly working as “The Distortion Detective”, but recent witnesses of their appearance were always followed with a Distortion case in the same location. While it’s unclear whether they’re involved in this case… I believe there’s enough reason to be wary of them.",
        ],
    },
    {
        ID: "130025",
        Name: "Pameli’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 72,
        StaggerHP: 34,
        SResist: [-2, 0],
        PResist: [0, 1],
        BResist: [0, 0],
        Skin: "Pameli",
        Passive: [
            "230025",
            "230124",
        ],
        Desc: [
            "Life insurance for Fixers is often a sham. A lot of them take your money never to give it back; even if you terminate your insurance, they won’t. It’s not easy for your damage to be insured, either. You have to be at death’s door to qualify, pretty much? The chances are as low as winning the lottery. And what if you just up and died? What can the dead do with money? You’ll be much better off making a savings account for an augment procedure or quality workshop gear. I was a very lucky case; keep in mind that this isn’t the norm at all. Insurance can sometimes be useful depending on its form and conditions, sure… But if you take the pay into account, it still doesn’t feel too great.        ",
        ],
    },
    {
        ID: "130026",
        Name: "Pamela’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 72,
        StaggerHP: 34,
        SResist: [-2, 0],
        PResist: [0, 1],
        BResist: [0, 0],
        Skin: "Pamela",
        Passive: [
            "230026",
            "230124",
        ],
        Desc: [
            "Basically speaking, people who visit our Office are looking for shrewd and precise situational assessment rather than combat prowess. The ability to make quick calculations for various possible scenarios and neutralize or kill the enemy with the least effort. We are hunters of the City. We Wedge pierce the requests we get with swiftness and precision.",
            "Of course, our Office isn’t perfect in every regard, so we’re in partnership with a number of other Offices. Fixer Offices often request others for help when reinforcements or professional aid in specific areas is needed. In the case of our Office, we were sister Offices with Dawn Office, sharing more information than we did with most other partners. Oscar is good friends with Salvador—the man running that Office—and they’ve known each other for quite some time, but there’s more to this sisterhood than that. Wedge Office excels at analyzing the capabilities of foes, and Dawn Office specializes in combat, so it’s only natural that we go well together.",
        ],
    },
    {
        ID: "130027",
        Name: "Philip’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 70,
        StaggerHP: 30,
        SResist: [-2, -2],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Philip",
        Passive: [
            "230009",
            "230207",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "130028",
        Name: "Philip’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 5],
        HP: 300,
        StaggerHP: 100,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "PhilipEgo",
        Passive: [
            "230028",
            "230128",
            "230228",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "131001",
        Name: "A Kurokumo Henchman’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 75,
        StaggerHP: 35,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [-2, 0],
        Skin: "Kurokumo1",
        Passive: [
            "231001",
            "4",
        ],
        Desc: [
            "“You hear that news? We’re about to collide with Kingfishers again.”",
            "“Kingfishers? Don’t remember that name at all. Were they a real thing?”",
            "“You know, the Syndicate that’s been struggling with finance and feuds between members recently. They seemed to be getting back on their feet after raiding the Constellars, but it looks like that didn’t last long.”",
            "“They were irrelevant chumps, so I completely forgot about ‘em.”",
            "“The Knots seemed to be after them… Maybe they finally hit ‘em.”",
            "“Weaklings will get hounded.”",
            "“And now they’ve been trying to invade our territory, desperate to loot anything.”",
            "“Doesn’t matter. Their names wouldn’t be so unmemorable if they were any strong. Taking ‘em down shouldn’t be a problem.”",
            "“And the Fixers at Clam Office that were cooperating with them from the back are gone, too…”",
            "“Clam? What are they about?”",
        ],
    },
    {
        ID: "132001",
        Name: "Jikan’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 5],
        HP: 80,
        StaggerHP: 34,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Jikan",
        Passive: [
            "10001",
            "211003",
            "232001",
            "232002",
        ],
        Desc: [
            "The Rusted Chains ain’t the biggest Syndicate, but each member’s got strength to boot n’ boast. The only weapon we use is these spiky chains. Tie ‘em, smack ‘em, anythin’ goes. We gotta be careful not to get swung or swayed around, or bind ourselves with our own metal. My body’s full of scars thanks to that, but hey… It’s not too bad, is it?",
        ],
    },
    {
        ID: "132002",
        Name: "A Rusted Chainlink’s page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 70,
        StaggerHP: 34,
        SResist: [0, 0],
        PResist: [-2, 0],
        BResist: [1, 1],
        Skin: "RustyChainGroup",
        Passive: [
            "211003",
            "232002",
        ],
        Desc: [
            "“Bah… Every part of my body’s aching.”",
            "“Cloudy bastards… Why’re they picking at us so much? We’ve taken some serious damage on our side.”",
            "“Heard the Blade Lineage’s also got messed up… Got any news?”",
            "“Heard our boss is gonna go out and talk to ‘em.”",
            "“If boss is going alone… Won’t that be dangerous?” ",
            "“The other side’s also only sending their top dog or whatevs… No need to worry about the boss.”",
            "“Right… They’re weaklings individually, that’s why they like to move in packs.”",
        ],
    },
    {
        ID: "133001",
        Name: "A Workshop-affiliated Fixer’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 75,
        StaggerHP: 34,
        SResist: [-2, 0],
        PResist: [0, 0],
        BResist: [0, -2],
        Skin: "WorkshopFixer",
        Passive: [
            "3008",
            "233001",
        ],
        Desc: [
            "In the City, there are as many workshops as there are unique gadgets. And the Tres Association is the one responsible for managing those workshops in general. It reviews newly designed weapons, files applications to the Head, and charges taxes for them. You can’t use the weapons that haven’t passed their evaluation. Getting a rejection from them basically means they see the weapon as something that shouldn’t be used in this City. They aren’t too cold about it, though. They sometimes send the applicants feedback about how they can improve their designs to a passable level. Not that we need it, since our latest weapon passed on the first try!",
        ],
    },
    {
        ID: "134001",
        Name: "Hanafuda’s Page",
        Level: "Urban Plague",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 5],
        HP: 78,
        StaggerHP: 35,
        SResist: [0, 1],
        PResist: [0, 1],
        BResist: [-2, -2],
        Skin: "J_Named",
        Passive: [
            "10001",
            "234001",
            "234002",
        ],
        Desc: [
            "In the Nest of gambling, hundreds of games take place every day, the humans leaving as winners or losers. Some admit their defeat, while others try to make a scene and escalate it into a violent mess. It’s the job of Offices like ours to monitor the gaming between individuals or organizations, verify the results, and prevent situations from turning violent.",
        ],
    },
    {
        ID: "134002",
        Name: "A Jeong’s Office Fixer’s Page",
        Level: "Urban Plague",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 5],
        HP: 75,
        StaggerHP: 33,
        SResist: [0, 1],
        PResist: [0, -2],
        BResist: [0, 0],
        Skin: "J",
        Passive: [
            "234001",
        ],
        Desc: [
            "Most residents in Nest J are relying on a special entity. I can’t talk much about it, but it’s like the fortune readings others sometimes see. It predicts the events that’ll happen to you during a year like an annual fortune, and gives opinions on immediate matters. It never gives a direct solution to your problems, though. It’s up to you to make your choices… but I can’t deny that it has a strong influence on your decision.",
        ],
    },
    {
        ID: "140001",
        Name: "Yujin’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 348,
        StaggerHP: 62,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 1],
        Skin: "Yujin",
        Passive: [
            "10004",
            "240001",
            "240101",
            "240301",
            "241001",
        ],
        Desc: [
            "Argalia. Alias: The Blue Reverberation. The person who is known to furtively cause incidents. Recently, he is suspected of recruiting individuals wielding powers that are possibly related to the Distortion Phenomenon in an attempt to form an organization. As well as prying into his plots, I intend to hamper his efforts myself before collecting data and presenting evidence of his irregular activity to the Head. As the Blue Reverberation’s plot was already in motion, I needed to act quick and do the least I could to stop him. However, Shi Association was too fatigued from the barrage of requests, so I asked Full-Stop Office to deal with the Church of Gears, whose leader seemed to harness a power that resembles the Distortion. But I haven’t heard from them since. Perhaps they were eliminated in their mission at the hands of the Church… Or, if the Blue Reverberation expected the Fixers’ arrival and toyed with them, then I will definitely have to get to the Library and read their books. There was evident rationale to read the books of the Musicians of Bremen as well, for they could contain even the slightest hint on the Blue Reverberation’s plots he might have told them. Even I do not know the man in detail, admittedly. However, because I am certain that the Blue Reverberation is conspiring something that violates or will violate the rules stipulated by the Head, I must gather crucial evidence and report it.",
            "…I know how corrupt this Association is. I am woefully aware of Thelma’s cunning and unhinged purpose behind saddling Section 2 with one request after another and wearing us down… I am but waiting for the right time. Waiting and enduring until I seize the chance to bring the Shi back to glory… I firmly believe that everything will take a turn for the better once I take care of this work. I pledge to change the system with my hands… No matter what.",
        ],
    },
    {
        ID: "140002",
        Name: "Valentin’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 124,
        StaggerHP: 58,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, -2],
        Skin: "Valentin",
        Passive: [
            "10001",
            "240002",
            "241301",
        ],
        Desc: [
            "Thelma, head of the Southern Branch, has been overworking Section 2 to a nonsensical degree lately. The requests he’s giving us are burdensome to take once per week, and he’s constantly cramming them down our throats, sapping the strength and will out of our section… It’s unclear if we can successfully handle this mission to the Library, but it’s painstakingly obvious that he’ll give us another request to take care of immediately afterwards even if we could; most of our surviving crew are losing what little motivation they had left. As for why he insists on using Section 2 when the other sections are available… He’s probably trying to get rid of Director Yujin because he suspects that our director knows something about the Blue Reverberation. It’s unacceptable that someone could use a branch leader of an Association to make a toy of the entire Association, Color or not. Especially if the goal is to remove our director Yujin… I’m not sure what plan Director Yujin has to overcome this, but I suppose that can wait until we’ve finished our mission.",
        ],
    },
    {
        ID: "140003",
        Name: "Tenma’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [1, 7],
        HP: 120,
        StaggerHP: 59,
        SResist: [0, -2],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Tenma",
        Passive: [
            "10001",
            "240003",
            "241301",
        ],
        Desc: [
            "From the receipt of the request to preparation for execution, every step of an assassination is carried out covertly. Discreet killing is the Shi Association’s specialty. An all-out war in open fields where numerous people clash at once is not our preferred form of battle (though, it’s one of the areas where the Liu Association excels); we truly shine when we operate in small numbers. We pursue extreme efficiency in order to kill our target within the limited window of opportunity. Also required is the ability to make quick assessments of the situation in order to swiftly strike the target’s vital point with minimal movement.",
            "The demand for assassination requests is pretty high these days as the most surefire way to eliminate people armed with high-quality workshop equipment on top of body augments is sneaking up on them for a fatal blow when they least suspect it. Still, the streets aren’t being filled with corpses of assassinated targets because there are Fixers whose job is to kill those who were hired for assassination. Fixers are continuing their fierce strife no matter the place.",
        ],
    },
    {
        ID: "140004",
        Name: "A Puppet, Page 1",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 74,
        StaggerHP: 29,
        SResist: [0, -2],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Puppet2",
        Passive: [
            "240004",
            "240006",
        ],
        Desc: [
            "Life in the Nest isn’t anything special, honestly. It’s the same the whole world over. You get pecked by your boss and go through mountains of workload, you find yourself working overtime pretty much everyday… Payday isn’t all that exciting either, when you realize that you barely get any money for yourself after paying for maintenance, credit cards, insurance, living expenses and all that. Most of your income’s gone in a flash. And then, back to work… I have my ways of enjoying the little things in life, though. When I come back home from work, I crack open a cold one and watch the Backstreets through the window as night falls. When I’m lucky, I can see people chasing each other or getting into a tussle. And I think, ‘Oh, I sure hope that person manages to get away…’ I’m just being a hypocrite, of course. We’re all simply watching it for fun, don’t you agree? It’s like a TV show. Viewers aren’t genuinely concerned for the people on the rectangular screen. All they care about is guessing who will win. So many unrealistic and varied situations take place in the streets, it actually feels as if I’m watching television. Don’t call me out for being inhumane. Who knows, maybe someone is watching me work myself to the bones from a high rise, holding a glass of wine in their hand?",
        ],
    },
    {
        ID: "140005",
        Name: "A Puppet, Page 2",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [3, 5],
        HP: 90,
        StaggerHP: 42,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Puppet1",
        Passive: [
            "10001",
            "240005",
            "240006",
        ],
        Desc: [
            "Money rules this City. Every denizen of the City is obsessed with money to the point of popularizing the belief that money can be thrown almost any problem. While the earnings of an average Nest resident are significantly higher than those of a person inhabiting the Backstreets, there’s also a notable wage gap among the Nest habitants. One thing to keep in mind is that your position in your job doesn’t always guarantee a high income. No matter how high your rank is in a small enterprise, you might not earn much more than a Fixer in the Section 6 of an Association.",
            "Even if your financial gain is on the higher side, you likely won’t earn enough to waste extravagantly. Meaning, you won’t get to take first class seats on WARP trains all the time or load the table with a sumptuous feast. However, it will be enough money to secure a stable life in the Nest. People who earn 4 million Ahn or more per month can be considered the upper middle class. That’s where the quality of life sees a visible increase. You no longer have to worry about being evicted from the Nest for being unable to pay taxes, and you can even hire Fixers to keep you safe. You can save up in case of emergencies, or send your children to better schools. A life lived in safe haven, free of illness and starvation. Well, that’s the life of an upper middle class they all talk about. What is there to be considered special? We just earn a bit more than others, and live in a bit more comfort than others.",
        ],
    },
    {
        ID: "140006",
        Name: "A Puppet’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 61,
        StaggerHP: 27,
        SResist: [0, -2],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "PuppetNormal",
        Passive: [
            "240006",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "140007",
        Name: "A Puppet’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 63,
        StaggerHP: 23,
        SResist: [0, -2],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "PuppetNormal",
        Passive: [
            "240006",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "140008",
        Name: "Emma’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 5],
        HP: 275,
        StaggerHP: 37,
        SResist: [1, 0],
        PResist: [1, 0],
        BResist: [1, 0],
        Skin: "EmaNoah",
        Passive: [
            "240008",
            "240108",
            "240208",
            "240408",
        ],
        Desc: [
            "Each Nest has its Singularity. For example: W Corp. has WARP, a fast and reliable means of transportation that’s guaranteed to deliver you to your destination on time; F Corp. has Fairies, which can unlock anything that’s considered ‘locked’, physically or conceptually; G Corp. has spheres that can control gravity, and so on… J Corp’s Singularity is pretty much the opposite of F Corp’s: it’s a technology that can lock and seal something that’s open or exposed on a conceptual level. Of course, the range or size of things that can be locked will depend on how much you pay. Cheap ones are mostly used for locking small boxes and other personal objects, while expensive ones can seal an area of space so nothing can come inside, or even lock a person’s body to prevent it from being dissected. The technology has a pretty wide range of applications. You can lock basically anything that’s open in one sense or another. Could it be that this Singularity was created because our Nest, where J Corp. is located, is a Nest of gambling that holds a smart few secrets that shouldn’t be leaked… Beats me. Not like anything good will come out of knowing the real reason, anyway…",
        ],
    },
    {
        ID: "140009",
        Name: "Emma’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 5],
        HP: 275,
        StaggerHP: 37,
        SResist: [1, 0],
        PResist: [1, 0],
        BResist: [1, 0],
        Skin: "Ema",
        Passive: [
        ],
        Desc: [
            "Each Nest has its Singularity. For example: W Corp. has WARP, a fast and reliable means of transportation that’s guaranteed to deliver you to your destination on time; F Corp. has Fairies, which can unlock anything that’s considered ‘locked’, physically or conceptually; G Corp. has spheres that can control gravity, and so on… J Corp’s Singularity is pretty much the opposite of F Corp’s: it’s a technology that can lock and seal something that’s open or exposed on a conceptual level. Of course, the range or size of things that can be locked will depend on how much you pay. Cheap ones are mostly used for locking small boxes and other personal objects, while expensive ones can seal an area of space so nothing can come inside, or even lock a person’s body to prevent it from being dissected. The technology has a pretty wide range of applications. You can lock basically anything that’s open in one sense or another. Could it be that this Singularity was created because our Nest, where J Corp. is located, is a Nest of gambling that holds a smart few secrets that shouldn’t be leaked… Beats me. Not like anything good will come out of knowing the real reason, anyway…",
        ],
    },
    {
        ID: "140010",
        Name: "Noah’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 52,
        StaggerHP: 27,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Noah",
        Passive: [
            "240508",
        ],
        Desc: [
            "J Corp. owns the Nest of gambling. Every person here devotes their life to those insane games of chance. Emma and I check the security cameras placed in affiliated facilities and spot anyone who cheats. We get hundreds of calls each day. Please check if the person in a dark red coat at N-9281-R231 used a sleight of hand to switch cards, I think my table was rigged at Q-198-OF1929, I think they’re using marbles that weigh 0.1g more in the roulettes at K-1928-R029, etc… A variety of creative and absurd calls flood the lines all the time.",
            "What’s so difficult about watching the security feed all day, you ask? Sure, you could think that if you’re unfamiliar with how things work here. But imagine having to check the feeds for tens and even hundreds of rooms that have ten cams each. The workload is spread over multiple people, of course, but each of us still has dozens of screens to stare at, it makes my eyes spin like a top. Besides, some people are sneaky enough to pull trickery off camera, and some incidents might occur during maintenance hours. This job is such a busy one, two eyes just aren’t enough. When you’re checking one case, another call comes in, when you’re done checking that, more calls wait for you… The shortage of manpower is driving me crazy, I swear.",
        ],
    },
    {
        ID: "140011",
        Name: "Lion’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 5],
        HP: 77,
        StaggerHP: 32,
        SResist: [1, 0],
        PResist: [-2, 0],
        BResist: [0, 0],
        Skin: "Circus_Lion",
        Passive: [
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "140012",
        Name: "Monkey’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 5],
        HP: 73,
        StaggerHP: 37,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [-2, 0],
        Skin: "Circus_Monkey",
        Passive: [
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "140013",
        Name: "Elephant’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [1, 5],
        HP: 90,
        StaggerHP: 28,
        SResist: [-2, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Circus_Elephant",
        Passive: [
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "140014",
        Name: "Emma’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 300,
        StaggerHP: 63,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "EmaNoah_NoahDown",
        Passive: [
        ],
        Desc: [
            "Each Nest has its Singularity. For example: W Corp. has WARP, a fast and reliable means of transportation that’s guaranteed to deliver you to your destination on time; F Corp. has Fairies, which can unlock anything that’s considered ‘locked’, physically or conceptually; G Corp. has spheres that can control gravity, and so on… J Corp’s Singularity is pretty much the opposite of F Corp’s: it’s a technology that can lock and seal something that’s open or exposed on a conceptual level. Of course, the range or size of things that can be locked will depend on how much you pay. Cheap ones are mostly used for locking small boxes and other personal objects, while expensive ones can seal an area of space so nothing can come inside, or even lock a person’s body to prevent it from being dissected. The technology has a pretty wide range of applications. You can lock basically anything that’s open in one sense or another. Could it be that this Singularity was created because our Nest, where J Corp. is located, is a Nest of gambling that holds a smart few secrets that shouldn’t be leaked… Beats me. Not like anything good will come out of knowing the real reason, anyway…",
        ],
    },
    {
        ID: "140015",
        Name: "Anton’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 78,
        StaggerHP: 42,
        SResist: [1, 0],
        PResist: [0, -2],
        BResist: [0, 0],
        Skin: "Anton",
        Passive: [
            "240015",
            "241002",
            "241202",
        ],
        Desc: [
            "Our body is composed of liquid. Liquid is the substance that fuels our body. While humans maintain their form with the shell they call flesh and skin, we maintain our form with the suit we wear. If this liquid runs out, we will stop dead in place. Therefore, the liquid must always be filled, which is the reason we dine. This liquid is what constitutes and moves our body, but we also use the liquid to sweep the streets and dine. The method is simple. When we embed a hook connected to the fuel tank on our back into a human, they melt like a liquid. Then we consume that liquid to refuel. Without this shell, we would deform and spill on the ground like them. The liquid is patented with the approval of the Head; you must change your body to become like us if you wish to join our family. Do not worry about side effects. Mother will give you all the assistance you need. We all could safely become a family thanks to her.",
        ],
    },
    {
        ID: "140016",
        Name: "Lyla’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [3, 5],
        HP: 84,
        StaggerHP: 39,
        SResist: [0, 0],
        PResist: [1, -2],
        BResist: [0, 0],
        Skin: "Lyla",
        Passive: [
            "240016",
            "241002",
            "241202",
        ],
        Desc: [
            "That is correct. We are conscious of the attention of people during the daytime. We practice caution. It would be a public nuisance to show up in broad daylight and cause a ruckus, and we have a set of rules that we abide to. Of course, if the Head demands our service, we must assemble, day or night. Oh, and I believe there is a small misunderstanding between us. It is not by the will of us Sweepers that the night in the Backstreets has become a time when no deed is forbidden. Does it appear to you that every denizen of the Backstreets disapproves of the rules? ‘Anyone is allowed to commit terrible acts at night, and there is nowhere to complain to if you are victimized.’ While this means terrible things can happen to you at night, it also means that you are free to be the perpetrator of such a deed yourself. In fact, we do not see much benefit from the freedom of the nighttime, other than being allowed to dine all we want.",
        ],
    },
    {
        ID: "140017",
        Name: "Valerie’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 79,
        StaggerHP: 41,
        SResist: [0, 0],
        PResist: [0, -2],
        BResist: [1, 0],
        Skin: "Valerie",
        Passive: [
            "240015",
            "241002",
            "241202",
        ],
        Desc: [
            "The Backstreets are our main stage of activity at night. When night falls, our world unfolds. At regular intervals, we start marching from the perimeter of a Nest and sweep everything as we move forward. Even if someone stands in our way, and attacks us… Even if a powerful Fixer kills a Sweeper next to us who was our family, we pay no heed and continue onward. Like a wave of water, we sweep everything in our way, except for those who are strong enough to resist it. From an edge of a Nest to the opposite end, we march without break for 80 minutes until the ‘Night in the Backstreets’ ends.",
        ],
    },
    {
        ID: "140018",
        Name: "An Index Proselyte’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 96,
        StaggerHP: 54,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "IndexUnit",
        Passive: [
            "240018",
            "240118",
            "2004",
            "2005",
            "2006",
        ],
        Desc: [
            "No two Prescripts are the same in any way; as well as their contents being completely different from each other, you can’t expect when and where you’ll receive one. It could be placed between the patties of the hamburger you’re holding, it could be in your mailbox, it could be handed to you by a passerby. However, if you question who delivers those Prescripts or where they come from and put your curiosity into action, the Proxies will come for you, so beware. Here’s a few examples of the Prescripts:",
            "‘To Rimi, Deliver a bacon pizza to Danny’s doorstep on 8th St. before 10 AM sharp on September 14th.’",
            "‘To Jimin, Do not utter a single word for five days.’",
            "‘To Sehee, If the first person you meet outside today answers your greetings by lifting their right hand, take their heart out; if the person ignores your greetings, remove your own heart from your body.’",
            "…And this is only scratching the surface of the shambolic orders written on the Prescripts. The contents of a Prescript range from ordinary tasks to things that cannot be carried out in relatively normal (in terms of morality) means… The arrant variety and creativity of the Prescripts will make you wonder just what goes on in the head of the person responsible for writing them. Take a moment to think about how you would feel if you received a Prescript that says ‘Chop off your right ankle and eat it medium rare. (P.S. You don't have to eat the bones.)’ You’d think this is an absurd instruction no sane person could follow, but those who belong to the Index will feel glad that it doesn’t require chopping off both feet or eating the bones.",
        ],
    },
    {
        ID: "140019",
        Name: "Rose’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 102,
        StaggerHP: 61,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Rose",
        Passive: [
            "10001",
            "240019",
            "240020",
            "240022",
        ],
        Desc: [
            "Many people are under the impression that W Corp’s Singularity is quick transportation via teleportation. That’s how our technology is advertised to the public, anyway. They aren’t strictly wrong; we’re just hiding the bigger picture from them.",
            "W Corp’s Singularity is the restoration of a previous status. To put it in layman’s terms, even if your body is crushed to a pulp, it can be restored to a recorded state as long as all the pieces remain.",
            "First off, we scan the molecular structures, genomic data, and other information of the passengers required for their restoration when they sit on their seats. The scanned data is stored in the transmission device inside the train, ready to be sent to the restoration machine. With that, any and all kinds of pandemonium into which the carriages may have turned can be reverted with a single button. The machine has difficulty scanning lifeforms that move too much, so we need to take measures to subdue it. As with all Singularities, it has small side effects. Some might leave the train with slightly more weight than before, or gain a bit of height… No one has filed a complaint about it, likely because the change is so minor that they just shrug it off as a matter of feelings, like the body feeling lighter because of their excitement for going on a trip, or it feeling heavier because they ate too much prior to boarding the train.",
            "The passengers don’t remember what happened inside the train, but that’s not because we use amnestics. It’s the restoration procedure reverting the people’s memories to a previous state rather than selectively erasing them. In plain language, everything goes back to how it was when it was scanned. The passengers will continue the conversations they were having when they first boarded the train as if nothing happened. They won’t notice any oddity or displacement in their dialogue; any thoughts they had or words they were about to speak will be restored and resumed seamlessly.",
        ],
    },
    {
        ID: "140020",
        Name: "Sen’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [3, 5],
        HP: 99,
        StaggerHP: 59,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Sen",
        Passive: [
            "240020",
            "240022",
            "2001",
            "2003",
        ],
        Desc: [
            "You thought opening gates to different dimensions was our Singularity? That’s actually a former Singularity a fallen Wing used to own. It wasn’t a very well-known Wing, so you probably won’t recognize it even if I told you its name. Point is, that Wing discovered a way to open gates between dimensions. The ability to create rifts in space. The Wing sadly never knew how to utilize that stunning technology they’d found; the Nest ended up falling before it could find a proper use for the Singularity, and the company now known as W Corp. spent a huge sum of money to purchase it.",
            "At first, people at this corp also struggled to think of a good way to use this tech. Even if it could make a big rip in space, entering it was a whole different matter; you don’t know what’s in there or if you can even come back… They had no idea. But soon enough, W Corp. found a way to put this dimensional gate to use, which involves T Corp’s technology. With the device made by T Corp. that collects time installed in the train, not a single second really 'passes' in the carriages even if the train travels for thousands of years. It’s the, uhh… temporal preservation or whatever. That’s what they apparently use, but it’s too complicated for me. Anyway, whatever happens in the train, we revert it using our Singularity of restoration, and T Corp. takes the time we collect for their own Singularity. We’re good business partners.",
            "This tech isn’t just used for long-distance travel. It’s applied to the weapons we use, too. Equipment used by agents of W Corp. is specialized in tearing and cutting things apart. We can precisely cleave lumps into individual pieces with the help of the space-ripping technology.",
        ],
    },
    {
        ID: "140021",
        Name: "Lesti’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 97,
        StaggerHP: 59,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Lesti",
        Passive: [
            "240021",
            "240022",
            "2001",
            "2003",
        ],
        Desc: [
            "To restore the train, the passengers have to be in their seats. You have to be seated so the scanning program can detect your genomic data and put you back on the right seat~ Oh, and the scanner has trouble reading things that are moving too much, so you should be nice and stay still in your seat! So the WARP cleanup crew (like us!) tidy up the carriages and put the passengers in their seats according to their genomic data. And with the press of a button… Tada! Everything goes back to normal as if nothing happened! I only learned this after I joined the corp… But, isn’t that so cool? That’s what we agents do.",
            "But sometimes, the cleanup crew isn’t enough for the job. What’s so scary about dealing with humans, you ask? I heard this story from my seniors… One time, a Color hid their identity and snuck onto the train. What a shocker that must’ve been… It’s our rule to stop powerful people like Colors or key members of Associations from boarding our WARP trains, or to guide them to take First Class seats if they must board the train, for a safe and smooth restoration process. We want them to sleep without a care instead of joining in the chaos of the other carriages~ That Color Fixer was super tricky to deal with, they told me? Most passengers started training under the Color’s guidance in order to attain some kind of enlightenment. All but a few of our agents were pulverized by those people before they could even see a glimpse of the Color…",
            "But, we aren’t totally powerless against those situations. We would’ve gotten into so many problems otherwise, yeah? In case things get too difficult for our agents to handle, we call R Corp, a Wing we’re partnered with. I saw footage about R Corp. in our training course… They were so cool. That was my first time seeing the mercenaries in action! They’d keep pressing on and wipe their targets, no matter how harsh their resistance was… I was like, whoa, they really are something else. The Fourth Pack… Was it called the Rabbit Team? Yeah, I think it was. I gotta wonder, though; why rabbits of all animals? Isn’t that an herbivore?",
        ],
    },
    {
        ID: "140022",
        Name: "A WARP Cleanup Agent’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [2, 6],
        HP: 94,
        StaggerHP: 52,
        SResist: [0, 1],
        PResist: [-2, 0],
        BResist: [0, 0],
        Skin: "WarpCrewUnit",
        Passive: [
            "240022",
            "2001",
            "2003",
        ],
        Desc: [
            "Sigh… They ain’t going to raise the ticket prices or run fewer trains like the last time, are they?",
            "Whaddaya mean, cap?",
            "Lobotomy Corp—the company that was supplying our energy needs—went down recently.",
            "That’s a good point, it’s harder to operate the trains with less energy… What do you mean by “last time”, though?",
            "Oh, you’re too new to know? Back in the day, L Corp’s Nest was occupied by another energy company.",
            "So, that company puttered out and put our corporation into the same sort of energy shortage we’re dealing with now?",
            "Not quite. It did go bust eventually, but it’s more that the company was stingy about sharing its energy. Awfully strict, too… I heard it had a bad reputation among its partnered companies. Because they were so tight-arsed about energy supply, we had to reduce the number of trains running at the time for a while.",
            "I had no idea…",
            "Don’t count on me, though. I also picked this story up from my superior. That’s enough chittering, let’s get back to work.",
        ],
    },
    {
        ID: "140023",
        Name: "Wang’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [3, 5],
        HP: 98,
        StaggerHP: 54,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Wang",
        Passive: [
            "10001",
            "240023",
            "240026",
        ],
        Desc: [
            "They call the Backstreets unsafe because there’s this one time o’ the day when darkness comes out and your friendly neighborhood watch can’t do jacks about it. The Night in the Backstreets, when the City shuts its eyes. Breakin’ any rules are forgiven during that time. Means to protect yerself from harm like recording videos or hirin’ peacekeepers? All rendered useless. And those rusty ol’ fellas sweep every corner of the streets, so no evidence is left behind. No corpses, no weapons, no nuthin’. Not only do all the security measures stop, peeking at folk as a whole is banned during these hours! Well, stumbling on the scene o’ the crime ain’t banned. What it really means is… you ain’t suppos’d record videos o’ the scene or spy it with security cams… No one should be strolling the streets that late in the first place though, hoh hoh hon!",
            "Cause of that, they don’t ask a darn thing about crimes happening during that time unless an eyewitness shows up. They just can’t, if I’m bein’ blunt. The public institutions… Ye know the deal, those shuckin’ shucks at the Head, Fixer Associations, vigilance peeps n’ the like. If one o’ those officials try to take a dig at somethin’ that happened during the Night in the Backstreets, some scary fellas called the Claws go after ‘em… I hear the Night in the Backstreets is considered a whatsit time for doin’ whatchamacallit permitted by the Head? I’ve got no dang clue why they set a time like this when every soul ‘ere’s already frightened to the bone. No matter what folks say, the Night in the Backstreets starts at 3:13 and ends at 4:34, ne’er too early or late by a single second, every time~",
        ],
    },
    {
        ID: "140024",
        Name: "Jin’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 98,
        StaggerHP: 54,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Jin",
        Passive: [
            "10001",
            "240024",
            "240026",
        ],
        Desc: [
            "The Backstreets aren’t some unlivable mess like some folk’re saying, ye see? Rough things do happen often ‘round here, sure, but there’s some effort at peacekeeping goin’ on to stop a whole lotta people dying all the harking time. Every area of the streets has some kinda neighborhood watch made outta local residents voluntarily doing jobs like Fixers do, trynna make the Backstreets a safer place. Unlike the so-called public safety Association that starts with a Z… whatever that stuffy org is called, the neighborhood watch ain’t chained to any official authority nor do they ask for huge fees. Each area’s got different styles of neighbors, so not everyone in every corner of the town likes ‘em. Most folks do appreciate that they’re kee’ing ‘em safe, though.",
        ],
    },
    {
        ID: "140025",
        Name: "Mi’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 98,
        StaggerHP: 54,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Mi",
        Passive: [
            "10001",
            "240025",
            "240026",
        ],
        Desc: [
            "There’s this one rule that stands squarely in this nigh-lawless land. Doing any kinda harm to the residential area is forbidden… No invading people’s homes, no demolishing ‘em, n’ all that. Not even the big n’ tough crooks of the Fingers can touch this! I’m guessing they decided it’s gotta stay the most whatsit place. If ye didn’t know, the City’s taboos are a ‘uge deal, ‘s much more serious than taboos of the Nest. You break it, and yer life’s over right then n’ there!",
        ],
    },
    {
        ID: "140026",
        Name: "A Smiling Face’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [2, 6],
        HP: 94,
        StaggerHP: 50,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "SmilingFacesUnit",
        Passive: [
            "240026",
            "2007",
            "2009",
        ],
        Desc: [
            "The rules o’ the Backstreets don’t work in the Nest, and the opposite’s also true. You could drag a higher-up working for whatchamacallit from the Nest to the Backstreets and do whatsit to ‘em and get away with it, as long as it was during the Night in the Backstreets and no sneaky rat saw you doin’ it. But if you did the same whatsit in the Nest, you’d be breaking rules. The Night in the Backstreets is only a thing in the Backstreets, like da name suggests.",
        ],
    },
    {
        ID: "141001",
        Name: "A Shi Fixer’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [2, 5],
        HP: 104,
        StaggerHP: 46,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [-2, 0],
        Skin: "ShiFixer",
        Passive: [
            "241301",
        ],
        Desc: [
            "Being an organization that is familiar with dealing death, the Shi’s code of honor is to treat every person equally, as the weight of death is equal for everyone. As long as the request fee is paid, we remove the target with no questions asked, regardless of who the client is, what kind of crime they may have committed, or any other details. The boss of a Syndicate known for murdering people in cold blood, a criminal wanted by a street somewhere, laundering an identity for a person of higher status who often bribes, even requests to kill one’s own friends and family… We handle all requests without leaning to a side. Of course, we have a duty of confidentiality to uphold for our clients. We mustn’t give in and maintain silence even in the face of immediate threats of death. Such are the rules and mindsets that the Shi Association’s members must abide by.",
            "However, the recent behavior of the Southern Branch goes against the core values of the Shi. On top of exerting power for his private interest, his selfish actions are causing severe damage to Section 2… All of us are eagerly waiting for Director Yujin to overthrow this rotten system one day.",
        ],
    },
    {
        ID: "141002",
        Name: "A Sweeper’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 73,
        StaggerHP: 32,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [0, 0],
        Skin: "SweeperUnit",
        Passive: [
            "241002",
            "241202",
        ],
        Desc: [
            "If the ‘Night in the Backstreets’ were to be gone, the Backstreets will fall into even worse chaos than before. In other words, the Night in the Backstreets is the rein that keeps this place in check. Because the Night exists, people here show the least amount of human decency.",
            "Here’s an example. You come home at the end of a hellish day. Dragging your weary body to the sofa, you hope to get a small break lying on the couch and watching cheap entertainment shows. But guess what happens. Some crazy jerk upstairs turns up their speakerphone’s volume to the max and makes obnoxious noises that make your ceiling shake. Too bad, there goes your peaceful respite. You can’t stand the noise that’s getting to your head, so you decide to ask your neighbor to please be considerate and lower the volume. You want to talk this over without a fight, so you battle the furious urge a million times before you go upstairs. But then our unfriendly neighbor gives you a baffling reply when you confront them. I need some free time for myself too, I have gripes with my neighbors that I just live with, so you should do the same. Why make a huge fuss about the noise when it isn’t even too loud, blah blah… Talking out of their ass. What can you do, though? Barely keeping your boiling anger inside, you go back down to your house, covering your ears with a pillow and yelling curse words as you try to sleep. Even if you told your landlord about it, they’d shrug off your complaint and smile like a saint, so there’s no use speaking up about it.",
            "That’s when the Night of the Backstreets comes into play. First off, you block the entrance to that shithead’s house before they return. Anything works; you could weld the door, use wooden planks, padlock the door, or whatever. Ensure that they can’t enter their own house by any means, and go back to your home. Some time later, they’ll come back to find that the door to their house has been sealed shut; they’ll struggle with the door before giving up. And they’ll make a serious face as though they’re trying to think of who could’ve done this ridiculous prank to them. Once they realize that it couldn’t possibly have been anyone else’s doing but yours, it’ll be too late. Because you’ll be behind them, bashing their head in with a brick or some heavy object. Killing them right now would obviously break the rules, so you drag them to your house and enjoy a quiet rest.",
            "When the clock hits 3 AM, you drag the little shit outside and throw it in the middle of a relatively large street. You return to your home before it’s too late and watch the scene from the window. The time is 3:13 AM; Sweepers crawl out of the dark and sweep the streets clean, collecting all the trash including that noise pollutant.",
        ],
    },
    {
        ID: "143001",
        Name: "Dante’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [1, 6],
        HP: 83,
        StaggerHP: 40,
        SResist: [1, 0],
        PResist: [0, -2],
        BResist: [0, 0],
        Skin: "Dante",
        Passive: [
            "10001",
            "243001",
            "243101",
            "243201",
        ],
        Desc: [
            "Seven Association deals with info and investigations; we collect all kinds of information on this City. Though, why aren’t we disclosing the full details about certain cases to the general public through news outlets or anything, you ask? Some things are better left unknown—for the sake of the safety of this world.",
        ],
    },
    {
        ID: "143002",
        Name: "A Seven Association Fixer’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 75,
        StaggerHP: 40,
        SResist: [0, 0],
        PResist: [-2, 0],
        BResist: [0, -2],
        Skin: "SevenUnit",
        Passive: [
            "243001",
        ],
        Desc: [
            "“Section 3 feels empty these days.”",
            "“Oh, didn’t you hear the news? Many of them died in that incident with the Distortion last time. Even the guy we counted on resigned and ran off…”",
            "“Right, that happened. I guess that’s why the empty seats felt even more noticeable… He seemed pretty refreshed and relaxed on his last day.”",
            "“I wonder why he quit, though. Sure, the work here can be tough, but… isn’t it still easy compared to some others?”",
            "“Gotta agree with that. Beats having to worry about getting axed all the time…”",
            "“Rumor says he went on to join the Musicians of Bremen…”",
            "“Why would he join that weird funky band?”",
            "“You tell me. Maybe there was something more important than making a fortune and spending the rest of his life in comfort for him…”",
        ],
    },
    {
        ID: "143003",
        Name: "Bamboo-hatted Kim’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 84,
        StaggerHP: 40,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Kimsatgat",
        Passive: [
            "10001",
            "240002",
            "230024",
            "243003",
            "231001",
            "220003",
        ],
        Desc: [
            "We value the art of violence more than anything here; those with an unscathed body are not permitted to join us. A swordsman who does not have a single blade scar on his skin is doubtlessly too careful when he wields his weapon, and his inane hesitation will be an obstacle. Too irresolute to endure the wounds his own blade would leave, let alone the assault of others… A body free of scars is proof of cowardice. Alas, it would be wise not to expose your wounds outside of those on your face.",
        ],
    },
    {
        ID: "143004",
        Name: "A Blade Lineage Cutthroat’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 77,
        StaggerHP: 40,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [0, 0],
        Skin: "Sword",
        Passive: [
            "231001",
            "220003",
        ],
        Desc: [
            "Blade Lineage isn’t known for coordination. It’s little more than a cohort of people who have nowhere else to go, or those who carry the intent to murder someone. Most who seek to join us sit at lowly social positions. It’s not rare for such people to hold a deadly grudge against someone. You’d best behave before those who are more skilled than you. We may be a band of murderous ruffians, but we understand our place.",
        ],
    },
    {
        ID: "143005",
        Name: "Dong-hwan the Grade 1 Fixer’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 116,
        StaggerHP: 45,
        SResist: [0, 1],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "ClassOneFixer",
        Passive: [
            "10008",
            "250001",
            "243005",
            "243105",
            "243205",
        ],
        Desc: [
            "Hana Association seems to have taken an interest in the Library and the Blue Reverberation—the two entities at the center of all the problems that have been happening in L Corp’s Nest lately—now that they’ve marked their presence in the City’s sky as Stars. I asked a Color who happens to be a friend of mine about it… and he said the Association’s going to recruit him to hunt down the Blue Reverberation and his cohorts soon. They’ve been making quite a scene in L Corp’s Nest… In particular, the lives of many Syndicates, Fixers, and residents close to the Library were lost to their hands, so the Association couldn’t just sit and watch anymore. They’ve apparently set up a camp at the door of the Library, though no one knows what they’re waiting for. A couple other things I heard are that all sorts of sounds and noises are coming from that camp… and that a large number of firearms belonging to the Thumb were abandoned on the ground. Maybe they launched an assault on the Syndicate while it was still struggling to recover from the loss of the Underboss and his Capos. The ensemble’s not like most Syndicates just trying to make money off the turf of the wingless Nest, that’s for sure… But we still don’t know what their goals really are, and I can’t shake this bad feeling.",
            "Anyways, since I was asked to pay a visit to the Library… It’ll be worth investigating the case some more after I get this job done.",
        ],
    },
    {
        ID: "32001",
        Name: "The Crying Children’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 5],
        HP: 312,
        StaggerHP: 115,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "TheCryingChildren",
        Passive: [
            "240028",
            "240128",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "142101",
        Name: "The Crying Children’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 5],
        HP: 312,
        StaggerHP: 115,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "TheCryingChildren_Damaged_1",
        Passive: [
            "240028",
            "240128",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "142201",
        Name: "The Crying Children’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 5],
        HP: 312,
        StaggerHP: 115,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "TheCryingChildren_Damaged_2",
        Passive: [
            "240028",
            "240128",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "142002",
        Name: "The Crying Children’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 125,
        StaggerHP: 41,
        SResist: [1, 0],
        PResist: [1, 0],
        BResist: [1, 0],
        Skin: "ChildCoveringEyes",
        Passive: [
            "240228",
            "240328",
            "240628",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "142003",
        Name: "The Crying Children’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 125,
        StaggerHP: 41,
        SResist: [1, 0],
        PResist: [1, 0],
        BResist: [1, 0],
        Skin: "ChildCoveringEars",
        Passive: [
            "240228",
            "240428",
            "240628",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "142004",
        Name: "The Crying Children’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 125,
        StaggerHP: 41,
        SResist: [1, 0],
        PResist: [1, 0],
        BResist: [1, 0],
        Skin: "ChildCoveringMouth",
        Passive: [
            "240228",
            "240528",
            "240628",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "142005",
        Name: "The Crying Children’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 92,
        StaggerHP: 32,
        SResist: [1, 0],
        PResist: [1, 0],
        BResist: [1, 0],
        Skin: "ChildrenCoveringEyes",
        Passive: [
            "240228",
            "240328",
            "240628",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "142006",
        Name: "The Crying Children’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 92,
        StaggerHP: 32,
        SResist: [1, 0],
        PResist: [1, 0],
        BResist: [1, 0],
        Skin: "ChildrenCoveringEars",
        Passive: [
            "240228",
            "240428",
            "240628",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "142007",
        Name: "The Crying Children’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 92,
        StaggerHP: 32,
        SResist: [1, 0],
        PResist: [1, 0],
        BResist: [1, 0],
        Skin: "ChildrenCoveringMouth",
        Passive: [
            "240228",
            "240528",
            "240628",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "142008",
        Name: "The Crying Children’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [1, 4],
        HP: 92,
        StaggerHP: 32,
        SResist: [1, 0],
        PResist: [1, 0],
        BResist: [1, 0],
        Skin: "ChildCoveringMouth",
        Passive: [
            "240228",
            "240528",
            "240628",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "150001",
        Name: "A Liu Section 2 Fixer’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 98,
        StaggerHP: 46,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "LiuSection2Unit",
        Passive: [
            "10001",
            "250001",
        ],
        Desc: [
            "Liu Association is a battle-oriented Fixer Association specializing in all-out combat; we receive requests from Wings and fight great battles for them. Some may see the Liu’s fighting style as old-fashioned, but we get frequent requests from those who want strong-willed and determined warriors. Most requests that come our way aren’t complicated. Nine out of ten are resolved by simply marching towards enemies and defeating them in battle. It doesn’t require specific strategies or certain personnel. We’re the Liu, the Association that solely exists for war.",
            "That doesn’t mean war is the only type of request we accept. After all, a Fixer is free to take any request. The catch is that all requests must be reported to the Hana Association after you deal with them. The report must include the details of the request, the client’s info, how the case was resolved, and any other relevant information… Once the report has been submitted, Hana Association will assess the performance of the Office and its Fixers, and evaluate them for promotion or demotion. That’s how the grades of Offices and Fixers are updated. Therefore, a Fixer’s grade doesn’t necessarily correlate with strength.",
            "One last thing I’d like to add is that there is a line Fixers shouldn’t cross; a Fixer may advertise themself or their Office to get more requests, but they should not threaten people to give requests to them. This is an area handled by the Hana Association and Öufi Association, a specialist in dealings and transactions. Of course, Associations shouldn’t have to worry about running out of requests in the first place.",
        ],
    },
    {
        ID: "150002",
        Name: "Lowell’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 127,
        StaggerHP: 68,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Lowell",
        Passive: [
            "10008",
            "250002",
            "250003",
            "250004",
            "250001",
        ],
        Desc: [
            "Xiao was a cold person who wouldn’t easily show her feelings. Even though the Liu consists of those who only face forward and never express any emotion in battle, Xiao was especially hard-edged above the rest. I came to wonder if she was capable of possessing emotions at all. Her tone was dry in the most upsetting situations, and she seemed apathetic to the loss of several colleagues. Never showing her emotions in response anything, but thoroughly looking after herself. That was my impression of Xiao. I thought the path Xiao was walking was completely different from mine. We disagreed on every aspect, from strategies to personalities; I thought my relationship with her would stay a formal relation between two coworking directors of an association.",
            "I don’t remember when and how we got so close to each other. I couldn’t be bothered to push away the person who naturally came to my side. We started spending more time together outside of work; people intersect one another somehow. Though, I have no clue how our paths managed to converge, or what about the paths led them to cross… One thing I can say for certain is that… our relationship isn’t a superficial bond between two directors. We need each other because we cherish each other, not the other way around; can you really call it love if you only cherish your significant other because you need something out of them? At the very least, I don’t think of Xiao as an object of exploitation nor gratification.",
            "However, I know that preaching love is utterly meaningless in this City. A Fixer should never be carried away by emotion. I know well that a person at a position as high as mine should be extra careful. I’ve seen countless Fixers who brought private matters to the official grounds, only to meet undesirable results. The moment you get swayed by something you cherish, you lose yourself; you neglect your own safety. When a human, a creature that always puts itself above all else, loses their edge because of what they hold dear and places higher priority on it over their own life… The consequences will be grim in any case. Knowing this, I decided to remind ourselves of one thing when we plighted our troth: Whatever happens to each other, we won’t put ourselves at risk. As I thought, Xiao agreed plainly and rightly. I could trust in Xiao, and I was glad to have this person as my lifelong partner. It was reassuring to know that Xiao wouldn’t throw away her own life if I ever died. Focus on my own survival, even in a mortal peril. Perhaps my heart has grown stronger since I met her. Having her next to me was already a great help to me at that point.",
        ],
    },
    {
        ID: "150003",
        Name: "Cecil’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 111,
        StaggerHP: 57,
        SResist: [0, 1],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Cecil",
        Passive: [
            "10001",
            "250003",
            "250001",
        ],
        Desc: [
            "The Liu is an Association that specializes in warfare. We work for the single goal of victory. However, victory isn’t necessarily won in battle. The ideal course of action begins by identifying the reason the enemy intends to fight in the first place. Next, we break the enemy’s will. Only then will we launch an attack on enemy forces. Even when war is inevitable, we mustn’t hope for victory after starting the war. ‘Secure a path to victory before engaging in warfare.’ The Liu engages in battles that are already won. With a strategy that is fated to lead us to triumph, we face enemies that are fated to lose.",
            "In other words, we don’t participate in a war that cannot be won. Blindly charging into the fray isn’t always the path to victory. And while strategizing allows you to look ahead and see where victory lies, it doesn’t ensure that you will reach it. Therefore, it’s crucial to assess the strength of the ally and the condition of the enemy before you determine if you should advance or retreat. It’s up to the director of each section—our leaders, basically—to decide what to prioritize and what to discard. For instance, Director Lowell is extremely cautious; he’s not hesitant to retreat and reorganize his forces if there’s a slight disadvantage. On the other hand, Director Xiao tends to push forward as long as there is an opportunity to count on, but she isn’t reckless about it; she designs elaborate strategies that will overcome the odds. Director Lowell’s choices aren’t always wise, and Director Xiao’s choices don’t always result in a smooth victory, but the two work their hardest within their abilities.",
        ],
    },
    {
        ID: "150004",
        Name: "Mei’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 111,
        StaggerHP: 57,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 1],
        Skin: "Mei",
        Passive: [
            "10001",
            "250004",
            "250001",
        ],
        Desc: [
            "Outside of weapons and martial arts, the most important thing that provides us with protection is our clothing. It might look like a fancy suit with golden decorations at first glance, but you know how a Fixer’s attire is no ordinary clothing! It’s mandatory for people working in relatively higher Sections to wear clothing adorned with the moonlight stone, M Corp’s Singularity. Of course, the Liu doesn’t have the exclusive right to use it, so you can see it on the clothes of other Fixers and Syndicate members, too. The moonlight stone emits a golden glint, and you can either gild your clothes with it or make ornaments out of it.",
            "The moonlight stone mitigates or shuts off psychological affliction induced from all kinds of mental attacks, pressure, interference, and all that… Whether it’s caused by seeing, hearing, or feeling something, or a direct assault to the mind. Although, I don’t really know how the stone works… They said it amplifies a single purpose or thought, making people forget the mental pain coming from outside, or fortifying the mind as if it’s surrounded with a giant barrier. It’s all thanks to this clothing that we didn’t panic when we saw the Crying Children, a Distortion!",
        ],
    },
    {
        ID: "150005",
        Name: "A Thumb Soldato’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 98,
        StaggerHP: 46,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "ThumbUnit",
        Passive: [
            "10001",
            "250005",
            "230004",
        ],
        Desc: [
            "The Thumb is the most cultivated and humane of the Five Fingers. Just be polite, and know to respect others. But then, why did the Thumb top the list of Syndicates one would never want to get involved with in the survey for Fixers conducted by the Hana Association, in spite of such good manners? The reason is simple: Hierarchy is absolute for the Thumb. To us, it’s as natural as the fact of nature that spilt blood only flows downwards, not up. One is expected to give unconditional obedience to a higher authority. That’s where the relative courteousness of the Thumb comes from.",
        ],
    },
    {
        ID: "150006",
        Name: "Kalo’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 127,
        StaggerHP: 68,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Kalo",
        Passive: [
            "10008",
            "250005",
            "250006",
            "250106",
            "230024",
            "230005",
            "3008",
        ],
        Desc: [
            "Capo dei capi (Godfather), Sottocapo (Underboss), Capo (Captain), and Soldato (Soldier/Goodfella)… The Thumb is divided into these four echelons. This hierarchical structure is still effective outside of the Syndicate. For example, a common Fixer is comparable to a Soldato, an Associate Fixer to a Capo, a board member of a Wing to a Sottocapo… This is how the hierarchy is to be interpreted. No outsider is exempt from this rule. No matter how you usually behave, you must remember your place and respect our rules when you’re dealing with the Thumb. If a young, oblivious Fixer walks up to a Capo and speaks to them, that poor picciotto will be rolling in the street the next day with his jaw and teeth missing. On the other hand, someone with the right level of authority or person of a higher class would be a different story. If a person on the same echelon as ours were to approach us, we’d gladly greet them and hear what they have to say with an open mind. Conversations with them are to be conducted with courtesy and decorum. Furthermore, if the person you’re dealing with stands on a higher echelon than yours… They must be treated with utmost devotion and delicacy. Such is the rule of ours, and the respect to their position. Don’t be too bitter over it. Indeed, class is earned, not given for free; it’s only right to give it the respect it deserves.",
        ],
    },
    {
        ID: "150007",
        Name: "Boris’ Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 127,
        StaggerHP: 68,
        SResist: [0, 0],
        PResist: [0, 1],
        BResist: [1, 0],
        Skin: "Boris",
        Passive: [
            "10001",
            "250007",
            "240003",
            "3009",
            "240005",
        ],
        Desc: [
            "The Thumb uses various types of bullets. We pick the right ammo for the right situation. But, as you can guess, the price of those bullets is a serious drawback. Not even the Thumb, one of the Five Fingers sitting at the apex of the Backstreets, can just waste bullets willy-nilly… That’s how costly it gets. You can’t get trigger happy. Because of that, the Thumb fight with the bayonet and buttstock of their guns most of the time, and only fire bullets when it’s absolutely necessary. The buttstock is built to be solid enough to crush most things to a pulp, and the bayonet is pretty handy as a sword. Some just stick to raw strength, though.",
        ],
    },
    {
        ID: "150008",
        Name: "Katriel’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 109,
        StaggerHP: 55,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Katriel",
        Passive: [
            "10001",
            "250005",
            "250008",
            "230004",
            "3008",
        ],
        Desc: [
            "The Thumb’s chain of command is simple: Obey the orders issued by your superior unconditionally, and do not question the intentions of your superior. Kill if you’re told to kill, and die if you’re told to die. You cannot defy the orders no matter how baffling it may seem. Those who violate them are punished on the spot. Even if the order is made by someone whose rank is only one step higher than yours, you’re still obligated to follow it. There’s nothing you can do about it, unless another person whose position in the pecking order is even higher than your commander’s decides to step in and take your side.",
            "There is one exception, however; it’s when a high-ranking individual temporarily devolves their power to a subordinate of theirs. Usually, this occurs if they have urgent business that prevents them from joining a meeting, or when they need their peer to know something that the subordinate can explain more professionally… It’s still a rare occurrence even then. No one transfers their authority for the fun of simulated uprising or other trivial reasons. That’s how significant the hierarchy is to us.",
        ],
    },
    {
        ID: "150009",
        Name: "Denis’ Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 111,
        StaggerHP: 54,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Dennis",
        Passive: [
            "10001",
            "250005",
            "250009",
            "230004",
            "3008",
        ],
        Desc: [
            "Even in a powerful Syndicate, weaklings exist… Cowardice can surface among the strong, and chaos can ensue from the most faultless rules. Not everyone in the Thumb can abide the rules without a slip-up.",
            "What happens when one violates the rules… If someone is trying to disrupt the hierarchy, they will be purged in a few days. It doesn’t matter if it’s a member of the Syndicate or an outsider… Every person must abide by the rules… The degree of violation is irrelevant; that doesn’t decide the weight of the purge. The one thing that matters the most is the fact that they showed insolence. The lesson is marked with blood so that no one… no one dares to break this rule again. That’s the most important one. It might seem like nitpicking, but there’s one basic principle to remember: Don’t get on the nerves of your superior. It’s such an elementary part of the basic decencies for human relationships, yet so many people seem to be oblivious of this…",
        ],
    },
    {
        ID: "150105",
        Name: "A Thumb Soldato’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 96,
        StaggerHP: 43,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "ThumbUnit",
        Passive: [
            "10001",
            "250005",
            "230004",
        ],
        Desc: [
            "The Thumb is the most cultivated and humane of the Five Fingers. Just be polite, and know to respect others. But then, why did the Thumb top the list of Syndicates one would never want to get involved with in the survey for Fixers conducted by the Hana Association, in spite of such good manners? The reason is simple: Hierarchy is absolute for the Thumb. To us, it’s as natural as the fact of nature that spilt blood only flows downwards, not up. One is expected to give unconditional obedience to a higher authority. That’s where the relative courteousness of the Thumb comes from.",
        ],
    },
    {
        ID: "150010",
        Name: "Nemo’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [4, 6],
        HP: 129,
        StaggerHP: 61,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Nemo",
        Passive: [
            "10001",
            "250010",
            "250110",
            "250210",
            "240101",
            "230012",
            "240002",
        ],
        Desc: [
            "We live in turbulent times when Wings are destined to fall behind in the market if they don’t respond to patent disputes effectively, big or small! It’s one of the reasons patent wars are that much important. Those megacorporations sue one another for patent infringement, or accuse one another for stealing their patent… Us small fries can watch the giants clash without worrying about getting caught in the crossfire; in fact, we benefit from such conflict! There are unspoken rules that you need to remember to keep your stake in a patent war: One must patent their technology separately for areas outside of the Nest or other domain under their jurisdiction, one must avoid admitting to infringement before carefully reviewing the lawsuit, the rights to a technology cannot be protected if its details were publicized through advertisements or such before the patent was registered, et cetera… Patent wars break out for so many reasons, it’ll take a day and a half to list them out!",
        ],
    },
    {
        ID: "150011",
        Name: "Martina’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 115,
        StaggerHP: 59,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Martina",
        Passive: [
            "10001",
            "250012",
            "250110",
            "250210",
            "230008",
            "210003",
            "3008",
        ],
        Desc: [
            "Notarization is the process of drafting a document to officially certify a deal between two Offices in case things happen… A notarial act is fairly powerful. Through these documents, you can verify various facts and secure executory force. Meaning, if one side doesn’t carry out their part of the contract… The contract can be enforced on them. There’s no need to argue about who is to blame. Notary acts exist to stop unnecessary disputes from occurring, and it’s the job of notary public Offices like Cane Office to help with that…",
            "Oh, and the City is divided into domains… It’s similar to how the Zwei Association sets territories for policing; it’s fair to expect at least one notary public Office in every domain. This isn’t to say that you can only use the notary public in your domain; if you can’t find a notary public, or if the Office isn’t functional for whatever reason, you can always go to other domains… Though it costs a bit more… A lot of people still choose the latter since they need to get business done in a hurry. Not every notary public Office has the same level of professionalism, after all…",
        ],
    },
    {
        ID: "150012",
        Name: "Bada’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 115,
        StaggerHP: 51,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Bada",
        Passive: [
            "10001",
            "250011",
            "250110",
            "250210",
            "220006",
            "230012",
            "221005",
        ],
        Desc: [
            "Contracts should be signed on equal terms with the consent of all parties involved. And the Offices must fulfill the terms of the contract following the mutual agreement. It’s a societal boundary that keeps us humans from betraying each other’s trust as we must coexist. Although these principles are rather abstract, they exist to prevent anyone from devising lowly schemes and ensure that each party gets just benefits. The Head’s rules don’t cover every small detail, so you can say this is a necessary addition to fill those gaps.",
        ],
    },
    {
        ID: "150013",
        Name: "Argalia’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 500,
        StaggerHP: 350,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "Argalia",
        Passive: [
            "250013",
            "250113",
        ],
        Desc: [
            "When I heard the news and rushed to the scene, only a hideous musician who had concluded his performance and permanently shut the piano’s lid with his torso awaited me. For the first time, emotions I couldn’t understand welled up inside me. It’s hard to define what they were, even now. It felt as if deep tenebrous stains were seeping out of my heart. Alas, I didn’t shed tears before that piano where your body rested—for I soon realized that you were no longer there.",
            "That’s right; you’re the gentle breeze that brushes past my face, and the clouds that fly in the sky, which give me heed of your presence from overhead or underfoot. I thought you had left me, but you would always come back. That’s why I care no longer about the skin and flesh you wore only momentarily. Angelica. I’ll follow after the name you gave me: Uberto. You used to call me that down in those horrible underground chambers. I’ll create a new world… one where people can live bountiful lives even if they have nothing, free from obsession or greed. When we lose the fixation on our bodies, we won’t be afraid of death anymore. No rest will be eternal.",
        ],
    },
    {
        ID: "150014",
        Name: "A Church of Gears Worshipper’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Paperback",
        Speed: [2, 6],
        HP: 97,
        StaggerHP: 57,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "GearsUnit",
        Passive: [
            "240026",
            "250014",
            "250114",
            "250214",
            "240025",
        ],
        Desc: [
            "As the gears turn, our bodies are put in motion… Thought Gears are indispensable for Meat Gears… The introduction seems terrifying, but Thought Gears are said to feel much more satisfaction than Meat Gears do as time passes… Actually, I’m not sure if… a Thought Gear can still think like a human… They say Thought Gears are honored to be serving their role… But perhaps it’s only a made up story told by the worshippers who hadn’t completely gone awry… wishing to free themselves of what little guilt they had… The words I sometimes hear aren’t heard through my ears… The gear guides my body as it rotates, as if it’s entering commands into my brain… Though that matters not… We are able to live thanks to the help of the Thought Gears… We’re no longer lost, unable to find a way ahead… Even if there is no path to take… It tells me where to place my next step…",
        ],
    },
    {
        ID: "152001",
        Name: "Allen’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [3, 6],
        HP: 110,
        StaggerHP: 57,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "AwlOfNight_Named",
        Passive: [
            "10008",
            "252001",
            "252002",
            "252003",
        ],
        Desc: [
            "The message we got wasn’t unexpected. The boss of our organization had always been a rash one, and he’d no patience with injustice or for his own curiosity. It was a miracle that he managed to stay under the Thumb for so long. I told him to be more careful since his words and actions as the boss will affect his underlings as well, yet here we are… I thought I’d flip my lid at hearing the news, but I didn’t feel as much anger as I expected to. The only thought that came to my mind was that he’d finally done it. With my head cool, I calmly considered my next move. At least some of us’ll make it outta here thanks to the early warning.",
        ],
    },
    {
        ID: "152002",
        Name: "A Night Awl’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 100,
        StaggerHP: 45,
        SResist: [0, 0],
        PResist: [0, 1],
        BResist: [0, 0],
        Skin: "AwlOfNight",
        Passive: [
            "10001",
            "252001",
            "252002",
        ],
        Desc: [
            "S’usually a good idea to zip your mouth shut at a gathering of Thumb subsidiaries. If you don’t have any good suggestions to make, shutting up is the next best contribution you can make. Can never be sure if what you’re about to say is a good opinion either, so just sock it in general. In other places, mistakes would just cost ya own life, but losing your credit in meetings like that means the members of your Syndicate are also biting the dust. What did we do wrong to deserve the punishment for our boss being a moron?",
        ],
    },
    {
        ID: "153001",
        Name: "An Udjat’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 100,
        StaggerHP: 49,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Usett",
        Passive: [
            "10001",
            "253001",
            "253002",
            "253003",
        ],
        Desc: [
            "We are Udjat. While it’s a Grade 1 Office on the surface, we only receive requests from one person. It exists for Lady Dias and Lady Dias alone. We are ready to perform any feat that she demands. Her pure ambition will bring her to a position of great power one day. We simply serve as stepping stones for her ascent to the top.",
        ],
    },
    {
        ID: "154001",
        Name: "Irina’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 126,
        StaggerHP: 63,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "MiraeNamed",
        Passive: [
            "10008",
            "254001",
            "254002",
            "254003",
        ],
        Desc: [
            "Did you know? Many people whom insurance companies employ are those who have experience with detective work involving investigations and deduction. Since we deal with huge sums of money, there are more than a few cases where our clients deliberately harm themselves or lie to us in an attempt to commit insurance fraud. A considerable number of calls we get actually aren’t mere incidents. How do we tell apart a real accident from the fake ones, then? Haha, that’s a business secret. Well, maybe a little hint… Oftentimes, something will be off about the way they act or talk. I told you that folks who used to do detective work frequently jump over to our industry, right? Those armchair fellows certainly have their wits… Their keen eyes will catch the signs hidden in even the most elaborate of disguises.",
        ],
    },
    {
        ID: "154002",
        Name: "A Mirae Insurer’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 99,
        StaggerHP: 49,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Mirae",
        Passive: [
            "10001",
            "254001",
        ],
        Desc: [
            "In this City, money has more value than anything. You need money to be able to start anything. Money is also required in case of unexpected events. An accident that will cost you a great deal of money could happen at any time; insurance is useful for such cases. As long as the conditions are met, the payout will fill in for financial damage. Of course… not all accidents will fit the insurance’s bill perfectly.",
        ],
    },
    {
        ID: "155001",
        Name: "Yae’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 126,
        StaggerHP: 62,
        SResist: [0, 1],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "CorNamed",
        Passive: [
            "10008",
            "240026",
            "255001",
            "255002",
            "255003",
            "255004",
        ],
        Desc: [
            "A friend of mine who was trained in the same workshop as me told me about this place. Said some new tech was discovered recently. Something about tinkering with the mind to use it for your advantage… It’s apparently more powerful than I can ever imagine? I’m honestly not very good at forming an impression of something when I just hear or read about it… So I told them I don’t get it, and then they said maybe going to the Library would help. They’ve been researching this new and exciting technology lately, but they say they’re too scared to head into that place even if there’s vital information to be found. They weren’t the kind of person to get physical… so I understand. Thus, I told my buddy that I’d visit that place for them once I’m finished developing this one thing. There’s a new gadget to test anyway, and to witness a technology that’s still obscure and hot off the presses… That just makes your heart throb, doesn’t it?",
        ],
    },
    {
        ID: "155002",
        Name: "A Leaflet Workshop Fixer’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 100,
        StaggerHP: 49,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 0],
        Skin: "Cor",
        Passive: [
            "10001",
            "240026",
            "255001",
            "255002",
        ],
        Desc: [
            "Leaflet Workshop… It’s a good place! Offers serviceable weapons to Fixers at a reasonable price, and sells quality weapons to underground Syndicates at higher prices… There’s been cases of the opposite happening sometimes, but that’s not what matters. Just wanted to emphasize that people from all walks of life visit our workshop. Oh, and I heard some workshops have membership clubs! The select few chosen by the workshop’s owner are sent an invitation, or so I heard. Business would be much handier if we adopted the same system… as with everything else… Greeting guests is the one thing that’s more dangerous than developing new weapons when you run a workshop.",
        ],
    },
    {
        ID: "156001",
        Name: "Bayard’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 126,
        StaggerHP: 63,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "BayyardNamed",
        Passive: [
            "10008",
            "256001",
            "256002",
            "256003",
            "256004",
        ],
        Desc: [
            "This wasn’t always the prim and proper Office of amenable Fixers that it is now. It was the complete opposite, actually, full of uncontrollable punks. I tried to gather the rascals in one place and lead them, but it never worked out smoothly. It was a ragtag band of people without a place to call home, like Rats. So I got my frustration off my chest when I met my old friend Maugie… Oh, maybe you’re more familiar with the name Maugris? Anyway, after hearing my ramblings, they said that there’s someone in their Office who would be perfect for the job, and I took the offer since I didn’t have any better ideas. That someone was Renaud.",
        ],
    },
    {
        ID: "156002",
        Name: "A Bayard’s Office Fixer’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 99,
        StaggerHP: 49,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Bayyard",
        Passive: [
            "10001",
            "256001",
            "256002",
        ],
        Desc: [
            "Charles’ Office, the place Renaud worked, was popular among Fixers. It was the subject of a lot of gossip. For good reason, as it was a Grade 1 Office consisting of just a few elites, handling any request with ease… People would often wonder exactly what kind of Fixers were in that Office. All we know about the Office is that its Fixers wore luxurious clothes, and the Office interior was fancy as well—in a style unique to the northern side… And that there were twelve Fixers led by someone called the “captain”… and they’ve all parted ways now, living their own lives. That’s about it.",
        ],
    },
    {
        ID: "150015",
        Name: "Esther’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 200,
        StaggerHP: 145,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Esther",
        Passive: [
            "150015",
            "250115",
            "250015",
            "240018",
        ],
        Desc: [
            "Is forging Prescripts a violation of rules? The answer is “Not exactly.” It can be written on any kind of paper, and as long as it is stamped with the seal of the Index, it’ll pass as a real Prescript. You will then wonder: Wouldn’t there be many people who exploit the system with malicious intent? Copying the seal is a complicated process, and not many know how; even if they overcame those hurdles, they still cannot outsmart the Prescripts. The Prescripts know all. They can tell whether or not a Prescript has been carried out, how it was done, and if someone is delivering fabricated Prescripts. An individual sending counterfeit Prescripts out of their own volition can ultimately be traced back to the will of the Prescripts, and the City itself. I suppose the Prescripts have some generosity for those forgers, as they may remain unpunished unless a Prescript ordering it has been issued. The Prescripts were already aware that Messenger Yan was giving out false ones, hence the Prescript to follow those faked orders. …No, that the Prescripts “know” might not be the most appropriate expression.",
        ],
    },
    {
        ID: "150016",
        Name: "Hubert’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [4, 6],
        HP: 195,
        StaggerHP: 135,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Hubert",
        Passive: [
            "150016",
            "250115",
            "250016",
            "240018",
        ],
        Desc: [
            "There are a number of ranks within the Index. Proselytes, Messengers, and Proxies are as much as I know.",
            "Those who have been chosen by the Prescripts will decide whether to become a Proselyte. If they accept it, they will cover their eyes with a blindfold as they serve the role. The blindfold has little symbolic significance; it’s to teach the Proselyte to follow the Prescripts regardless of what is happening before their eyes. Usually, a group of five to six Proselytes accompany a Proxy, learning the rules of the Index and the role of each rank. If a Proselyte shows a certain level of competence, the Prescripts will assign the role of a Messenger or a Proxy to them. After being promoted, they are given a blade of their own, and they may take off the blindfold.",
            "The Prescripts are a predetermined path; there is no point for Proselytes to refuse any. It’s still within their choice to decline the Prescript’s offer. Even though they’re free to quit anytime, no one knows if the Prescripts will allow it. The Prescripts might order Proxies to kill the runaway who abandoned their position, or let it slide, or even give the order to resign first. The Prescripts are truly unpredictable.",
        ],
    },
    {
        ID: "150017",
        Name: "Gloria’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 210,
        StaggerHP: 125,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Gloria",
        Passive: [
            "150017",
            "250115",
            "250016",
            "240018",
        ],
        Desc: [
            "The Index has an arsenal of swords and blades. Most of the Prescripts we receive can be solved with a sword, too. Mmm~ Never really thought about why we use swords, nope! Maybe it’s because they have this oppressive aura and make us look serious or something?!",
            "Each of us uses different types of blades. Starting with the ranks of Messengers and Proxies, the Prescripts give personalized swords. From a light one-edged sword fit for slicing things quickly; to heavy, double-edged greatswords~ They come in all kinds of shapes and sizes. Helps us stand out from each other. As for me, I’ve got five whole blades~ Maybe being speedy helped? It looks like we get swords that fit our traits~ Have you seen the sword Hubert’s carrying? It looks so heavy, and he swings it like it’s nothing.",
        ],
    },
    {
        ID: "151001",
        Name: "An Index Proselyte’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 5],
        HP: 99,
        StaggerHP: 62,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "IndexUnit",
        Passive: [
            "240018",
            "240118",
            "240003",
        ],
        Desc: [
            "No two Prescripts are the same in any way; as well as their contents being completely different from each other, you can’t expect when and where you’ll receive one. It could be placed between the patties of the hamburger you’re holding, it could be in your mailbox, it could be handed to you by a passerby. However, if you question who delivers those Prescripts or where they come from and put your curiosity into action, the Proxies will come for you, so beware. Here’s a few examples of the Prescripts:",
            "‘To Rimi, Deliver a bacon pizza to Danny’s doorstep on 8th St. before 10 AM sharp on September 14th.’",
            "‘To Jimin, Do not utter a single word for five days.’",
            "‘To Sehee, If the first person you meet outside today answers your greetings by lifting their right hand, take their heart out; if the person ignores your greetings, remove your own heart from your body.’",
            "…And this is only scratching the surface of the shambolic orders written on the Prescripts. The contents of a Prescript range from ordinary tasks to things that cannot be carried out in relatively normal (in terms of morality) means… The arrant variety and creativity of the Prescripts will make you wonder just what goes on in the head of the person responsible for writing them. Take a moment to think about how you would feel if you received a Prescript that says ‘Chop off your right ankle and eat it medium rare. (P.S. You don't have to eat the bones.)’ You’d think this is an absurd instruction no sane person could follow, but those who belong to the Index will feel glad that it doesn’t require chopping off both feet or eating the bones.",
        ],
    },
    {
        ID: "151002",
        Name: "An Index Proselyte’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 99,
        StaggerHP: 62,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "IndexUnit",
        Passive: [
            "240018",
            "240118",
            "10001",
            "240003",
        ],
        Desc: [
            "No two Prescripts are the same in any way; as well as their contents being completely different from each other, you can’t expect when and where you’ll receive one. It could be placed between the patties of the hamburger you’re holding, it could be in your mailbox, it could be handed to you by a passerby. However, if you question who delivers those Prescripts or where they come from and put your curiosity into action, the Proxies will come for you, so beware. Here’s a few examples of the Prescripts:",
            "‘To Rimi, Deliver a bacon pizza to Danny’s doorstep on 8th St. before 10 AM sharp on September 14th.’",
            "‘To Jimin, Do not utter a single word for five days.’",
            "‘To Sehee, If the first person you meet outside today answers your greetings by lifting their right hand, take their heart out; if the person ignores your greetings, remove your own heart from your body.’",
            "…And this is only scratching the surface of the shambolic orders written on the Prescripts. The contents of a Prescript range from ordinary tasks to things that cannot be carried out in relatively normal (in terms of morality) means… The arrant variety and creativity of the Prescripts will make you wonder just what goes on in the head of the person responsible for writing them. Take a moment to think about how you would feel if you received a Prescript that says ‘Chop off your right ankle and eat it medium rare. (P.S. You don't have to eat the bones.)’ You’d think this is an absurd instruction no sane person could follow, but those who belong to the Index will feel glad that it doesn’t require chopping off both feet or eating the bones.",
        ],
    },
    {
        ID: "150018",
        Name: "Chun’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 126,
        StaggerHP: 62,
        SResist: [0, 0],
        PResist: [0, 1],
        BResist: [1, 0],
        Skin: "Chun",
        Passive: [
            "10001",
            "250001",
            "250018",
            "3009",
        ],
        Desc: [
            "Right now, Nest L is practically a warzone with all the Associations, Syndicates, and Fixers at each other’s throats. On top of that, the Distortions are making things worse for Associations and the residents of the Nest… According to the report from the powers up above, there are three major factions of note currently remaining in the Nest: The Index, R Corp, and the Blue Reverberation and his group. R Corp. seemed to be eliminating threats as per request from another Wing, similar to what the Liu is doing. The Index appears to have been guided here by the Prescripts. After all, they gladly obeyed the piece of paper telling them to kill every member of the Thumb in the Nest. As a result, pretty much every Thumb crook and the Syndicate’s subsidiaries that were in this place are goners… Even the Underboss who was supposed to lead them kicked the bucket, so you can guess how it went.",
        ],
    },
    {
        ID: "150019",
        Name: "A Liu Section 1 Fixer’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 99,
        StaggerHP: 49,
        SResist: [0, 0],
        PResist: [0, 1],
        BResist: [0, 0],
        Skin: "Liu1Unit",
        Passive: [
            "10001",
            "250001",
            "240002",
        ],
        Desc: [
            "To a leader of the Liu, the most crucial element that can make or break a battle is vigor; not the competence or strength of individuals. With vigor, even the weakest creek can carry heavy rocks like a gale blowing up leaves. Therefore, an excellent leader chooses good Fixers and then puts vigor into them. Strength or skill alone won’t make a good Fixer. While those traits do play a role in higher Sections, the most important quality is how well the Fixer meshes with their leader’s combat style. Section 2, the team with Mei and Cecil, consists of careful and level-headed Fixers. They go quite well with Director Lowell because of that. Section 1 would clearly be superior in terms of sheer power, but we follow different strategies with pros and cons for each, so a direct comparison won’t really tell much about our actual performance in the field.",
        ],
    },
    {
        ID: "150020",
        Name: "Xiao’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 400,
        StaggerHP: 125,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 1],
        Skin: "Shyao",
        Passive: [
            "10004",
            "250001",
            "250020",
            "250018",
            "250021",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "150021",
        Name: "Miris’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 126,
        StaggerHP: 63,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 1],
        Skin: "Miris",
        Passive: [
            "10001",
            "250001",
            "250021",
            "240002",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "150022",
        Name: "The Red Mist’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 7],
        HP: 700,
        StaggerHP: 270,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Kali",
        Passive: [
            "250022",
            "250222",
            "250322",
        ],
        Desc: [
            "E.G.O. The weapon that corresponds to the mind of its wielder. The sword Carmen gave me was extracted from someone by chance. Giant eyeballs were attached to the sword adorned with crimson chunks of flesh; they watched my every move, almost to the point of making me feel a bit uncomfortable. Wondering if this was a product of some new Singularity, I asked Carmen what the thing was; she only said that I’ll have to get used to it, since there’s little she can do about how it looks. Although it looked a bit creepy, it wasn’t anything unbearable, and Carmen didn’t seem to mind it as long as there were experiments to be performed with it. She added that I have to be careful with it as it was thanks to sheer luck that the “E.G.O” could be extracted at all in its unstable state. I had a plethora of experience handling various workshop products, so I decided to take the sword without much hesitation.",
            "When I first had the sword in my grip, I didn’t feel anything in particular. All I could tell is that it’s just a big, heavy greatsword; nothing out of the ordinary other than its appearance. But when I held the sword a few days later to protect a coworker of mine, I heard a voice. It was the voice of someone desperately yearning for something. Unfortunately, the meaning of that voice was lost on me. Rather… it wasn’t even human speech. An awkward sound mimicking somebody. Noises of teeth grinding, bones crackling, mingling with flesh. Some things collide, fall apart, and mix in irregular patterns as if to mimic the way humans speak. However, that sound was too violent and sharp. The strong obsession of an empty one. Attachment. Void. I’m not sure what word I should use to define this.",
            "One thing I understood was that only I could hear that voice, and that it rang in my head rather than my ears. The stronger and clearer my aim to protect someone became, the louder the noise in my head got. Anxious that my mind might be consumed by the voice if I let it weaken my will, I tried my best to pretend that I didn’t hear it. The eyes on the blade carefully observed me as I fought the voice in my head. The piercing gaze persisted as if to replace me if I faltered even for a second; it made me feel hazy sometimes. The “voice” was only a bunch of grinding noises at the beginning, but it slowly learned to speak over time. Soon enough, it started speaking in a language that I could understand, though it stammered a bit. It takes human hide to protect human flesh. A shell… It kept asking for a shell. I couldn’t stop the voice, so the most I could do was ignore it.",
            "Even though there was danger in using it, its power was formidable; with it, I protected many a person, and cut down many a threat. The voice became stronger and deeper with the more blood the blade drank. One day, it asked a sharp question: “Don’t you desire a human shell as well?” When I think back on it, the question might not have been aimed at me specifically. It would only say whatever it wanted to say. It wouldn’t try to convince or allure me. All it uttered was monologue. Yet, I was frozen stiff when I heard that. It kept saying something. Are our lives really worth the blood I spilt for them? It wasn’t actually capable of forming such detailed sentences, but my head took it that way for some reason… Maybe I was thinking to myself.",
            "I denied its claim at the start. I’d never provoked anyone first. I’d only acted to protect others from an approaching danger. But, I felt a small part of myself waver from what the voice said. What will remain when I keep washing away blood with blood? A bloodstained shell would be all that is left.",
            "I collapsed for a moment; but I didn’t stop thinking. If I broke down, I might be in danger as Carmen warned. Carmen… Right, Carmen would’ve been different. Nothing could possibly beat the glitter in her eyes that shines as she pioneers a new path. Those honest, virtuous eyes… Even when someone jeered at her speech, even when everyone despaired in the face of an obstacle that brought progress to a halt, Carmen never stopped looking after others. She would always take the initiative to lead all of them. If I can protect a person like that, maybe this place will change? Yes. As long as I can protect that one person.",
            "As my thoughts became clearer, I couldn’t just sit down. My body acted before my head could decide what to do. I don’t exactly remember what happened then. When I finally took a grip on my rationality in a vast mindscape and came back to my senses, my body was burning hot. Is this rage? Have I been taken over to the point where I can’t even see ahead? But I felt so calm, refreshed even. My head was kept cool, while my heart leading the body was aflame. It wasn’t long until I felt that something was different. On solid armor, there was a layer of something tough and dense, but it wasn’t fabric… A veil of mist was covering me. Astonished, I moved around and shook my limbs several times, and the veil dissipated soon after.",
            "When Carmen learned of this, she didn’t say much. She didn’t make a big fuss about it or suggest trying something with it right away. She only said that wielding this power is more important than simply manifesting it, so I shouldn’t be lazy… She went back to work after leaving that peculiar piece of advice. Maybe she didn’t want me to feel too much pressure.",
            "As more time passed, I could use the armor for longer, and eventually got to draw out its full power. I had a weapon and armor that resonate with my emotions. Using them, I could protect more people, and I was able to draw forth more durability and strength. The researchers seemed to be struggling to make progress with their work, but it was alright. I believed in them to make it through, and I just had to be quicker to do my job in the meantime. However, not long after, the incident happened all too suddenly. No, maybe it wasn’t so sudden. The sign was there.",
            "Just around this corner, I can hear a child crying; she’s sitting in front of a door. One of the two children Carmen took in died in a failed experiment. Unlike Lisa who was wary and reluctant to open up to us, Enoch showed interest in our research, and volunteered to be a test subject the other day. Enoch’s speech was so concise and on point, everyone was shocked. He wasn’t afraid, and he wasn’t shaking… His voice was unswerving and gentle. Enoch’s eyes weren’t those of a naive little kid. His words and thoughts were surprisingly deep and mature; even I was astonished. I sometimes wondered what made this kid have such thoughts. His eyes seemed to have already seen so much of this world’s despair and misfortune. However, it was still no reason to allow a kid to participate in the experiments. Carmen spent several nights agonizing over the matter.",
            "The experiment was authorized at last, though I didn’t want to know what they thought of it anymore. What were they going to do, holding the hand of that little kid? I had to wonder if we were that desperate. But I shrugged it off. I wasn’t one to stop him from doing what he chose to do.",
            "“You should’ve been the one to die…” The other kid, who was now all alone, mumbled crying. Her words had no weight to it. She probably spouted what she didn’t sincerely mean, because the situation was too much for her.",
            "“Yeah… I— I should have died.” Carmen’s answer, on the other hand, was likely sincere. Everyone stood still. A crack appeared in our minds which we never thought would crumble. Maybe we all expected it to happen deep down.",
            "Carmen’s state worsened with each passing day, like a rusting nail. The sunny eyes of the woman who had brought us together were now cloudy, and she spoke less and less. Her voice was lifeless, and she had gotten so cold; it wouldn’t have come to anyone’s surprise if she died at any moment. She didn’t bother trying to look okay. I think it was better that way. Everyone in the laboratory felt constraint in her presence. They viewed Carmen in different ways. Reproachful looks of those resenting her for bringing them so far, only to let go of her responsibility. Concerned looks of those worried that something might happen to her. And I guess there were some who had no thoughts. The research went on quietly, but not for long.",
            "A few days later, Carmen spilled out all of the guilt within her and plunged into it, never to come back up.",
        ],
    },
    {
        ID: "150035",
        Name: "The Purple Tear’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 700,
        StaggerHP: 290,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "ThePurpleTear_F",
        Passive: [
            "250227",
            "250027",
            "250327",
            "250427",
        ],
        Desc: [
            "If you’re reading this book, it must mean there’s something you want to know about me. I’m sure you have lots of questions, but I sadly can’t give out detailed answers. It’s hard to come up with a definition and explanation for a power that naturally emerged, you see? How should I put it, in that case…",
            "I can travel through time and space and see a myriad of possibilities, too many for you to possibly fathom. It’s probably a little bit different from time travel as you commonly imagine it. The future self who experienced a certain past returns to it in order to change the future… Whatever is going on in the past, some kind of paradox is bound to happen to causality. Big or small. Little things can set off massive twists, like the flap of a butterfly’s wings causing a tornado… And even I’m afraid of bearing that risk. It could turn into a cycle of meaningless struggles.",
            "Yeah. I guess it’s fairer to say that I travel to a completely different space. Ever thought about the possibility that an infinity of different versions of the world you live in might exist? Let’s say that you sidetracked on your way home and were killed by some Syndicate members that ambushed you. But in another world, you might have decided you wanna go straight home, and the assault would’ve never happened. Or, you might have noticed the Syndicate members as soon as you stepped into the wrong alley and quickly got back on track. Those small choices can add up, and result in countless worlds where countless outcomes unfold. …I know what you’re thinking; this isn’t logic that can realistically be proven. I know all of this sounds unbelievable. People can’t understand me because of that, and even I have difficulty explaining myself.",
            "I made it sound grandiose, but this power isn’t almighty by any means, so I try not to use it carelessly. Not that I expect you to care for such details. It’s already complicated enough as it is, isn’t it? Just know that this power isn’t omnipotent. No power is conveniently given to you in this world, after all; there’s always a price you need to pay, and there is a world I yearn to reach, no matter that price. I’m doing this so I can find the world where I can see that possibility.",
            "And in the many worlds I’ve been to while doing this job… I saw many people who were lost after losing their precious stuff, just like me. I couldn’t just pass them by. They looked so miserable and pitiful. Well… It wasn’t entirely out of goodwill. The fact that they were worth helping played a big part. Once again, nothing in this world is free. I didn’t quite pity them as much as I weighed up the favors they could give me in return. Thanks to that, I’ve become acquainted with quite a few Fixers… And as corny as it is to say this myself, some even started calling me their mentor, and became my devoted admirers.",
            "Lots of people ask me what I’m going to such great lengths to see. A leading figure that commands powerful Fixers who are on the level of a Color? I dunno. All I want is to meet my son, whom I had to part with in the most unfortunate way. Meaning I don’t care about the ancillary stuff. I can see it so faintly… It almost seems to be within my reach, but it always ends up being a mirage.",
        ],
    },
    {
        ID: "150036",
        Name: "Xiao’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 400,
        StaggerHP: 270,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 1],
        Skin: "XiaoDistort",
        Passive: [
            "150036",
            "250001",
            "250020",
            "250021",
        ],
        Desc: [
            "I was in no way a soft person, though I don’t view myself as particularly tough or rugged, either. A straight and honest person. Accusations would be brought against me for being unmoved by the death of any person however close they may have been in life, a point not everyone would see as criticism. How could a person be so cold and heartless, even if the basic bearing of a Fixer is to look after oneself first and foremost? At first, I spent much time thinking over it, and asked myself many questions. Xiao as a person valued the lives of her colleagues, although her position forced her to keep her farewell to deceased teammates short, since carrying out her duty and emerging victorious came first. Shedding fewer drops of tears than the number of fallen was all the tribute I could pay. Bawling my eyes out would have stirred uneasiness in my colleagues. In the early days, the responsibility sometimes felt too heavy and burdensome.",
            "I had never once thought that my method was incorrect; I believed it to be the best method for myself, and I deemed that problems couldn’t be solved any other way. Most Fixers will probably think in the same way. Therefore, I could not understand the manners of Lowell, the newly appointed Section 2 Director at the time. A person who tries to look after everyone, and doesn’t hide his grief-stricken face when a coworker passes away. It seemed clear as crystal that his tenderness would one day lead his team to death, yet he was faring better than I thought. A polar opposite to me. The ways I wanted to pursue but gave up because I was faced with my limitations. It might have upset me for a moment. A principle I could not follow, for I was not allowed to openly express sadness over the death of the few in order to protect the many; and my obligation to seize any chance of victory compelled me to march forward if there was something to count on. My capability wasn’t vast enough to embrace every member of the team. Was my choice wrong? What did he have that I did not? Looking back, I don’t think what I felt was envy or jealousy. The indignation certainly was not a toxic emotion. I’m sure each of us had different specialties.",
            "It is said that people intersect with one another in some manner. I don’t think the process to be natural at all; I was not a believer of fateful meetings. After all, two parallel roads could never cross. A relationship begins with a desire to know. Simple curiosity. To know more about a person, or to go further and see what they are seeing together. People open up new roads to merge into the roads of others for various reasons.",
            "I thought I would never care about him since he was so different from me, but my expectations weren’t quite right. I wanted to learn more about him, and I wanted to know what this emotion I felt was. And I thought I could perhaps become a better person if I saw what he was seeing together. If there’s one thing I realized, it’s that relationships between people always start from such small curiosity.",
            "Taking in what I have said so far, you would think that this is such a peculiar and untruthful love. You might think it’s fussy. I cannot give out a clear answer, for I can’t dare define what love is. What could I say or add about an emotion I felt for the first time, one that I am still struggling to figure out? Furthermore, every person carries a different form of love. There will undoubtedly be some people who don’t place much importance on that emotion. You might even think that such emotion is absolutely useless in this City. Even if I were to define my love, this wouldn’t come across as a sweet story if you cannot understand it.",
            "However, I can be certain that my sentiment towards Lowell was sincere. The so-called curiosity and sympathy… They bring about attention, admiration, and a little bit of obsession. I learned soon enough that this isn’t much different from what people call “love”. It may not have been something out of a fairy tale or a drama, but we still cherished each other in our little relationship. Perhaps I had been under the impression that love is a concept that is utterly distant from me. The love that I came into was cramped, yet big… and it felt burdensome at times.",
            "You said I am strong, but the truth is that I was weak and fainthearted until the very last time I faced you. I have only grown so ironclad after I lost you. Why did I miss everything while you were still by my side? Why do I spend the whole night longing for you and regretting only after you have parted from me? I do have one regret regarding you: that I could not trust my feelings for you. That I was too afraid to tell you that you’re my everything the night before you left me.",
            "Moments of loneliness will come as I live. It won’t be a thirsty longing for love, however. It is when I look to my side, yet there is no one next to me; when I am worn out from running somewhere; when I feel that my heart grows heavy rather than painful. Trying new things might let me forget it for a moment, but the memories will still follow me for life. When I feel such things, I can go back to familiarity. A familiar place, a familiar mind, a familiar person. And I plan to reunite with you soon. I want to tell you that I no longer have shame for the path I’ve chosen, and that I have finally freed myself from the guilt.",
        ],
    },
    {
        ID: "150037",
        Name: "Miris’ Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 6],
        HP: 196,
        StaggerHP: 143,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 1],
        Skin: "Miris",
        Passive: [
            "150037",
            "250001",
            "250021",
            "240002",
        ],
        Desc: [
            "Director Xiao liked to emphasize something: “A mercenary’s work is to deceive; to fool the enemy into believing that we are advancing when we defend; to make the enemy believe we will thrust from the front when we strike from above. Feign submission when you raise your claws; we must seem unable when able to attack, that the enemy may grow arrogant. When the enemy is roused, distract them through disturbance; be aware that we ourselves are not subject to such anger. In order to defeat the enemy, we must be roused to anger; to remember that one’s emotions must remain a means to motivate the body and not the ends, and to exploit the enemy’s wrath with this in mind.” Our director may be seized with anger and momentarily stray onto inadvisable paths sometimes, but even the whitest jade has a flaw; I trust her to set herself back on the right track in no time.",
        ],
    },
    {
        ID: "150038",
        Name: "Xiao’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 700,
        StaggerHP: 550,
        SResist: [1, 0],
        PResist: [1, 1],
        BResist: [0, 1],
        Skin: "XiaoDistort",
        Passive: [
            "150038",
            "150138",
            "150238",
            "150338",
            "250336",
            "250001",
            "250020",
            "250021",
        ],
        Desc: [
            "I was in no way a soft person, though I don’t view myself as particularly tough or rugged, either. A straight and honest person. Accusations would be brought against me for being unmoved by the death of any person however close they may have been in life, a point not everyone would see as criticism. How could a person be so cold and heartless, even if the basic bearing of a Fixer is to look after oneself first and foremost? At first, I spent much time thinking over it, and asked myself many questions. Xiao as a person valued the lives of her colleagues, although her position forced her to keep her farewell to deceased teammates short, since carrying out her duty and emerging victorious came first. Shedding fewer drops of tears than the number of fallen was all the tribute I could pay. Bawling my eyes out would have stirred uneasiness in my colleagues. In the early days, the responsibility sometimes felt too heavy and burdensome.",
            "I had never once thought that my method was incorrect; I believed it to be the best method for myself, and I deemed that problems couldn’t be solved any other way. Most Fixers will probably think in the same way. Therefore, I could not understand the manners of Lowell, the newly appointed Section 2 Director at the time. A person who tries to look after everyone, and doesn’t hide his grief-stricken face when a coworker passes away. It seemed clear as crystal that his tenderness would one day lead his team to death, yet he was faring better than I thought. A polar opposite to me. The ways I wanted to pursue but gave up because I was faced with my limitations. It might have upset me for a moment. A principle I could not follow, for I was not allowed to openly express sadness over the death of the few in order to protect the many; and my obligation to seize any chance of victory compelled me to march forward if there was something to count on. My capability wasn’t vast enough to embrace every member of the team. Was my choice wrong? What did he have that I did not? Looking back, I don’t think what I felt was envy or jealousy. The indignation certainly was not a toxic emotion. I’m sure each of us had different specialties.",
            "It is said that people intersect with one another in some manner. I don’t think the process to be natural at all; I was not a believer of fateful meetings. After all, two parallel roads could never cross. A relationship begins with a desire to know. Simple curiosity. To know more about a person, or to go further and see what they are seeing together. People open up new roads to merge into the roads of others for various reasons.",
            "I thought I would never care about him since he was so different from me, but my expectations weren’t quite right. I wanted to learn more about him, and I wanted to know what this emotion I felt was. And I thought I could perhaps become a better person if I saw what he was seeing together. If there’s one thing I realized, it’s that relationships between people always start from such small curiosity.",
            "Taking in what I have said so far, you would think that this is such a peculiar and untruthful love. You might think it’s fussy. I cannot give out a clear answer, for I can’t dare define what love is. What could I say or add about an emotion I felt for the first time, one that I am still struggling to figure out? Furthermore, every person carries a different form of love. There will undoubtedly be some people who don’t place much importance on that emotion. You might even think that such emotion is absolutely useless in this City. Even if I were to define my love, this wouldn’t come across as a sweet story if you cannot understand it.",
            "However, I can be certain that my sentiment towards Lowell was sincere. The so-called curiosity and sympathy… They bring about attention, admiration, and a little bit of obsession. I learned soon enough that this isn’t much different from what people call “love”. It may not have been something out of a fairy tale or a drama, but we still cherished each other in our little relationship. Perhaps I had been under the impression that love is a concept that is utterly distant from me. The love that I came into was cramped, yet big… and it felt burdensome at times.",
            "You said I am strong, but the truth is that I was weak and fainthearted until the very last time I faced you. I have only grown so ironclad after I lost you. Why did I miss everything while you were still by my side? Why do I spend the whole night longing for you and regretting only after you have parted from me? I do have one regret regarding you: that I could not trust my feelings for you. That I was too afraid to tell you that you’re my everything the night before you left me.",
            "Moments of loneliness will come as I live. It won’t be a thirsty longing for love, however. It is when I look to my side, yet there is no one next to me; when I am worn out from running somewhere; when I feel that my heart grows heavy rather than painful. Trying new things might let me forget it for a moment, but the memories will still follow me for life. When I feel such things, I can go back to familiarity. A familiar place, a familiar mind, a familiar person. And I plan to reunite with you soon. I want to tell you that I no longer have shame for the path I’ve chosen, and that I have finally freed myself from the guilt.",
        ],
    },
    {
        ID: "150039",
        Name: "",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 7],
        HP: 200,
        StaggerHP: 0,
        SResist: [0, 2],
        PResist: [1, 2],
        BResist: [0, 2],
        Skin: "Yan_Hand",
        Passive: [
            "150039",
            "150139",
        ],
        Desc: [
        ],
    },
    {
        ID: "150040",
        Name: "",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 7],
        HP: 200,
        StaggerHP: 0,
        SResist: [1, 2],
        PResist: [0, 2],
        BResist: [0, 2],
        Skin: "Yan_Hand",
        Passive: [
            "150039",
            "150139",
        ],
        Desc: [
        ],
    },
    {
        ID: "150051",
        Name: "얀샋ㄷ요무’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 5],
        HP: 500,
        StaggerHP: 280,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Yan_Distort",
        Passive: [
            "150051",
            "150151",
            "150251",
            "151139",
            "151239",
        ],
        Desc: [
            "Have you ever seen a glimmer of light when you close your eyes? It’s blindingly bright at times, and it shakes in an irregular shape at times. This sensation is often called a phosphene. Whenever I close my eyes, the blurry image of a bloodstained carpet appears to me like that optical phenomenon. The beginning of an unpleasant nightmare. Four mannequins that lost a face and an arm each are lying on the carpet, spilling red beads; another mannequin has its hand on my shoulder. I turn around and look at the loudspeaker in the mannequin’s face. I can feel the vibration coming from it, even though I can’t hear what it says. But I already know what sound this mannequin is making. The vibration precisely matches the words I remember, and my heart starts beating accordingly.",
            "This damned power of recall lost all my good childhood memories to oblivion, yet it brings back such remembrances every time I close my eyes. My response to it is always the same: Take the flower that’s slipped into my hand and nail it into the mannequin’s heart. A beautiful tree in bloom grows from the cracks the flower made. It’s as soft as the hands that caressed me, and it’s as pretty as the sound that consoled me. And it’s as sharp as the noise of that last moment when I was scolded for the first time. Every branch that grows from the tree causes a piercing buzz in my ears, and the petals hurt as they brush past my cheeks as if to make me feel the pain they hold. I stand still like my feet were tied, until my body is covered in scars. One, two… Black marbles fall from the wounds. How long have I been in this cycle of pain?",
            "The nightmares have been with me for a good majority of my life. If I close my eyes, the memory of that time haunts me—and if I open my eyes, a reality I can hardly bear unfolds. I chose to keep my eyes shut because I thought I’d rather deal with the ever-echoing past. At least I won’t be visited by new kinds of pain… Prescripts keep coming without a break. The City folk meet different ends depending on the Prescripts they receive, though their fates all share a commonality of cruelty. Their resentment, screams, tears, rage, and death… It’s too much for my eyes. I sometimes thought how my life would’ve been if I stayed as a commoner taking Prescripts like them. Maybe I was better off back then. Maybe I should’ve just died early so I could breathe again as another being. Why did the Prescripts give me that order that day?",
            "I trace back the nightmares to remember the past; everything was over, and I planned to follow them to death, but I didn’t have the courage to end my own life, so I… I picked up the Prescript that I thought would spell my doom at last and read it slowly. All the fresh-looking Prescript contained was a command to be a Messenger. It was pointing toward a beginning, not an end. I couldn’t see a single word that said anything about salvation or death. After being numb for a while, I finally tumbled down to the floor and broke into laughter louder than any sound I’d made before. I couldn’t help but laugh at my state. I wanted to end my life because of Prescripts, and now the Prescripts won’t even let me do that. Where has my free will run off to?",
            "I was frustrated. Not even my own life was under my control, for everything relies on the Prescripts. Then I’ll gladly play along. Even if I can’t shatter the Prescripts, I’ll at least make a tiny crack. If I can show the masses that it’s possible to oppose the Prescripts, something might change… Something has to… It WILL make a difference. Once I had hope, I could see the way—and once I could see where to go, I had the strength to get up.",
            "However, I realized it only just now. What I felt wasn’t hope, and that ignoring that Prescript and taking my own life as I’d planned might have been a truer expression of my free will.",
            "What is the right way to live a life in this place, I must wonder? I’m not even dreaming of a life that I can be proud of; how does one achieve the feeling that their life is bearable to live, let alone be satisfied with it? I thought I had found an answer to that… But in the end, I couldn’t escape the Prescripts. The Prescripts are the City’s will as it is my will. I’ve realized my limit. I feel as if I’ve hit some kind of wall I can’t overcome. However, I don’t feel all too forlorn and miserable. Maybe there’ll be someone who can ride along with the flow, rather than break it. It just won’t be me; I’m not fit to accomplish such things.",
            "So I want someone to find an answer in my stead. And I hope they can tell me that. Tell me how I can enjoy this nightmare.",
        ],
    },
    {
        ID: "150023",
        Name: "Nikolai’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 166,
        StaggerHP: 90,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Nicolai",
        Passive: [
            "10008",
            "250123",
            "250023",
            "250223",
        ],
        Desc: [
            "After a moment of silence, she slowly opened her mouth. A large-scale war was about to occur. If we made big enough contributions in that war, we might be able to avoid being destroyed. That wasn’t a suggestion or a plea for help. It was a semi-mandatory request. The reward: We get to avoid termination. Her attitude was something else; the way she confidently delivered her speech in front of me gave off a certain sense of conviction. It was as if she were saying she’s going to make the war happen. Baffled, I let out a bout of laughter. I knew we weren’t in the position to refuse it.",
            "And she was right; a huge war broke out soon after. Thick smoke covered that Nest.",
        ],
    },
    {
        ID: "150024",
        Name: "Myo’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 156,
        StaggerHP: 82,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Myo1",
        Passive: [
            "10001",
            "250123",
            "251001",
            "251101",
            "251024",
        ],
        Desc: [
            "Ever since that day, I trained myself, aspiring to become like the hero that saved me that day; and landed a job at R Corp. I wanted to become a hero myself and save the lives of others… What I wanted more than anything, though, was to meet that person once more. R Corp. participated in most large battles in the City, so I expected to see her someday. I thought she’d have been alive all along since she was tough. I was going to thank her and show her how much stronger I had gotten since then if I did get to see her again.",
            "But, I… well, yeah, I couldn’t tell her. Not just because I never saw the Red Mist again… or Gebura, as she is called now. We did meet each other after a long time, but that’s another story. I wouldn’t have been able to say it even if I met the Red Mist when she was alive and well. I got embarrassed of myself again. I thought I’d saved everyone, but after all, what I’ve been doing was far from being a hero.",
            "Hey, what do you think a hero is?",
        ],
    },
    {
        ID: "150025",
        Name: "Maxim’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 152,
        StaggerHP: 82,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Maxim",
        Passive: [
            "10001",
            "250123",
            "251002",
            "251102",
            "250025",
        ],
        Desc: [
            "One day, some rich person visited us and said that a war will break out soon. Said we’ll get some benefits if we helped her.",
            "That gave us a bigger thing to worry about than an upcoming destruction. A war is about to happen? Nikolai collected her thoughts and calmly asked why a war was going to occur.",
            "That person paused for a bit, then spoke in a languid tone. I was creeped out by how she said it like it was no big deal.",
            "“When one person’s pure ambition and another’s tragic obsession join together, a dream is destined to be born.”",
        ],
    },
    {
        ID: "150026",
        Name: "Rudolph’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 152,
        StaggerHP: 95,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Rudolph",
        Passive: [
            "10001",
            "250123",
            "251003",
            "251103",
            "250026",
        ],
        Desc: [
            "R Corp. is particularly famous as a private military company. No matter how many combatants die in battle, we fill the vacancy with new soldiers in no time. It was natural for the Wings giving us requests to wonder what kind of Singularity we have to pump out so many mercenaries in such a short time frame. Besides, our soldiers weren’t lacking in combat prowess by any means, so there had to be more to us than just hiring many people. The mercenaries of R Corp. don’t fear death in the first place; they don’t hesitate to carry out any tasks. We’re big in numbers, casualties are replaced quickly, and we fearlessly proceed and get the job done. R Corp’s mercs were ideal for Outskirts explorations and other dangerous operations.",
            "How could such a feat be possible, then? People started making guesses.",
            "At the end of the day people just laughed it off, talking about how nonsensical their hypotheses were and how secretive Singularities are. Maybe they had the right answer, though they missed the mark a bit.",
        ],
    },
    {
        ID: "150028",
        Name: "Myo’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 186,
        StaggerHP: 92,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Myo1",
        Passive: [
            "10001",
            "250123",
            "251001",
            "250024",
        ],
        Desc: [
            "Ever since that day, I trained myself, aspiring to become like the hero that saved me that day; and landed a job at R Corp. I wanted to become a hero myself and save the lives of others… What I wanted more than anything, though, was to meet that person once more. R Corp. participated in most large battles in the City, so I expected to see her someday. I thought she’d have been alive all along since she was tough. I was going to thank her and show her how much stronger I had gotten since then if I did get to see her again.",
            "But, I… well, yeah, I couldn’t tell her. Not just because I never saw the Red Mist again… or Gebura, as she is called now. We did meet each other after a long time, but that’s another story. I wouldn’t have been able to say it even if I met the Red Mist when she was alive and well. I got embarrassed of myself again. I thought I’d saved everyone, but after all, what I’ve been doing was far from being a hero.",
            "Hey, what do you think a hero is?",
        ],
    },
    {
        ID: "150029",
        Name: "Maxim’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 192,
        StaggerHP: 92,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Maxim",
        Passive: [
            "10001",
            "250123",
            "251002",
            "250025",
        ],
        Desc: [
            "One day, some rich person visited us and said that a war will break out soon. Said we’ll get some benefits if we helped her.",
            "That gave us a bigger thing to worry about than an upcoming destruction. A war is about to happen? Nikolai collected her thoughts and calmly asked why a war was going to occur.",
            "That person paused for a bit, then spoke in a languid tone. I was creeped out by how she said it like it was no big deal.",
            "“When one person’s pure ambition and another’s tragic obsession join together, a dream is destined to be born.”",
        ],
    },
    {
        ID: "150030",
        Name: "Rudolph’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 182,
        StaggerHP: 95,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Rudolph",
        Passive: [
            "10001",
            "250123",
            "251003",
            "250026",
        ],
        Desc: [
            "R Corp. is particularly famous as a private military company. No matter how many combatants die in battle, we fill the vacancy with new soldiers in no time. It was natural for the Wings giving us requests to wonder what kind of Singularity we have to pump out so many mercenaries in such a short time frame. Besides, our soldiers weren’t lacking in combat prowess by any means, so there had to be more to us than just hiring many people. The mercenaries of R Corp. don’t fear death in the first place; they don’t hesitate to carry out any tasks. We’re big in numbers, casualties are replaced quickly, and we fearlessly proceed and get the job done. R Corp’s mercs were ideal for Outskirts explorations and other dangerous operations.",
            "How could such a feat be possible, then? People started making guesses.",
            "At the end of the day people just laughed it off, talking about how nonsensical their hypotheses were and how secretive Singularities are. Maybe they had the right answer, though they missed the mark a bit.",
        ],
    },
    {
        ID: "150031",
        Name: "Nikolai’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 200,
        StaggerHP: 120,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Nicolai",
        Passive: [
            "10008",
            "250123",
            "250023",
            "250223",
        ],
        Desc: [
            "After a moment of silence, she slowly opened her mouth. A large-scale war was about to occur. If we made big enough contributions in that war, we might be able to avoid being destroyed. That wasn’t a suggestion or a plea for help. It was a semi-mandatory request. The reward: We get to avoid termination. Her attitude was something else; the way she confidently delivered her speech in front of me gave off a certain sense of conviction. It was as if she were saying she’s going to make the war happen. Baffled, I let out a bout of laughter. I knew we weren’t in the position to refuse it.",
            "And she was right; a huge war broke out soon after. Thick smoke covered that Nest.",
        ],
    },
    {
        ID: "150032",
        Name: "Myo’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 186,
        StaggerHP: 92,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Myo2",
        Passive: [
            "10001",
            "250123",
            "251001",
            "250024",
            "3007",
            "3008",
        ],
        Desc: [
            "Ever since that day, I trained myself, aspiring to become like the hero that saved me that day; and landed a job at R Corp. I wanted to become a hero myself and save the lives of others… What I wanted more than anything, though, was to meet that person once more. R Corp. participated in most large battles in the City, so I expected to see her someday. I thought she’d have been alive all along since she was tough. I was going to thank her and show her how much stronger I had gotten since then if I did get to see her again.",
            "But, I… well, yeah, I couldn’t tell her. Not just because I never saw the Red Mist again… or Gebura, as she is called now. We did meet each other after a long time, but that’s another story. I wouldn’t have been able to say it even if I met the Red Mist when she was alive and well. I got embarrassed of myself again. I thought I’d saved everyone, but after all, what I’ve been doing was far from being a hero.",
            "Hey, what do you think a hero is?",
        ],
    },
    {
        ID: "150033",
        Name: "Maxim’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 192,
        StaggerHP: 92,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Maxim",
        Passive: [
            "10001",
            "250123",
            "251002",
            "250025",
        ],
        Desc: [
            "One day, some rich person visited us and said that a war will break out soon. Said we’ll get some benefits if we helped her.",
            "That gave us a bigger thing to worry about than an upcoming destruction. A war is about to happen? Nikolai collected her thoughts and calmly asked why a war was going to occur.",
            "That person paused for a bit, then spoke in a languid tone. I was creeped out by how she said it like it was no big deal.",
            "“When one person’s pure ambition and another’s tragic obsession join together, a dream is destined to be born.”",
        ],
    },
    {
        ID: "150034",
        Name: "Rudolph’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 182,
        StaggerHP: 95,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Rudolph",
        Passive: [
            "10001",
            "250123",
            "251003",
            "250026",
        ],
        Desc: [
            "R Corp. is particularly famous as a private military company. No matter how many combatants die in battle, we fill the vacancy with new soldiers in no time. It was natural for the Wings giving us requests to wonder what kind of Singularity we have to pump out so many mercenaries in such a short time frame. Besides, our soldiers weren’t lacking in combat prowess by any means, so there had to be more to us than just hiring many people. The mercenaries of R Corp. don’t fear death in the first place; they don’t hesitate to carry out any tasks. We’re big in numbers, casualties are replaced quickly, and we fearlessly proceed and get the job done. R Corp’s mercs were ideal for Outskirts explorations and other dangerous operations.",
            "How could such a feat be possible, then? People started making guesses.",
            "At the end of the day people just laughed it off, talking about how nonsensical their hypotheses were and how secretive Singularities are. Maybe they had the right answer, though they missed the mark a bit.",
        ],
    },
    {
        ID: "150101",
        Name: "A Rabbit Team Soldier’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 99,
        StaggerHP: 49,
        SResist: [1, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "RabbitUnit3",
        Passive: [
            "10001",
            "250123",
            "251001",
        ],
        Desc: [
            "Every team in the Fourth Pack has its own caricature. You’d think that we’ll never get along with each other, having such different personalities and powers and strengths, yeah? Surprisingly enough, we hunt in packs for most operations despite our differences.",
            "The Lapin-o-Rabbit Team is generally seen as a distracted and raving bunch. Maybe it’s because most of us are nimble? But that also means we handle our missions quickly and with certainty. Our method is the cleanest, actually?",
            "Hmm… If I had to admit a teensy little problem with us, it’s that we don’t discriminate enemies from civilians? We do have a tendency to shoot first at any non-Rabbit in the area that comes into our sight. We’ll leave ourselves open for attacks if we take our sweet time to tell ‘em apart, so we’ve got to strike first. But hey, we don’t leave any troubles behind that way, so what’s good is good, yeah?",
        ],
    },
    {
        ID: "150102",
        Name: "A Rhino Team Soldier’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 102,
        StaggerHP: 45,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "RhinoUnit3",
        Passive: [
            "10001",
            "250123",
            "251002",
        ],
        Desc: [
            "Every team in the Fourth Pack has its own character! Our personalities, powers, and strengths are all wildly different, but we still do most of our missions in packs.",
            "Us Rhinos specialize in using physical strength. We’re good at pushing ahead, if nothing else! I think we’re the strongest team in the Fourth Pack. Smash ‘em hard, block ‘em hard! We often stand on the front line instead of the frail Rabbits and Reindeer. The Rhino Team’s armor is thick n’ large! And we’ve got tough bodies, too.",
            "Sometimes though, my body starts heating up if I keep moving around, and I can’t control myself for a while. I figure that’s ‘cause of the odd tech R Corp. uses. Something about expanding muscles and pumping more adrenaline into the blood. That’s what they told me. Oh, in case you’re wondering… This ain’t a Singularity or anything. Plenty of others are making use of it, apparently. We never got to hear the deets. We do hear often that we’ve gotta watch out, though. The Rhino Team’s got more destructive power than others, and once one of us starts getting all excited and enters a rampage, it won’t be easy to stop ‘em until they calm down.",
        ],
    },
    {
        ID: "150103",
        Name: "A Reindeer Team Soldier’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 98,
        StaggerHP: 50,
        SResist: [0, 0],
        PResist: [0, 1],
        BResist: [0, 0],
        Skin: "DeerUnit3",
        Passive: [
            "10001",
            "250123",
            "251003",
        ],
        Desc: [
            "Every team in the Fourth Pack has its own characteristics. Our personalities, powers, and strengths vary so greatly that it’s hard to imagine us working together… Nonetheless, we move in packs for most missions.",
            "The Reindeer Team utilizes powerful electric waves generated from brainwaves. You see these horns? The electric stimuli generated in the Reindeer’s brain are condensed at the tip of these horns. The concentrated electricity is then collected by our staves for attacks.",
            "There’s one thing we should be careful of when we use this ability: If the battle drags on for too long, or we exert too much power at once… most Reindeer will go insane. The symptoms are expressed in various ways, but in most cases, they hurt their own comrades or damage the psyches of others. We sometimes utilize K Corp’s Singularities to protect our sanity or mitigate the mental damage, although we can’t afford to use it often.",
        ],
    },
    {
        ID: "160001",
        Name: "A Hana Fixer’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 7],
        HP: 105,
        StaggerHP: 60,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 1],
        Skin: "HanaUnit",
        Passive: [
            "10001",
            "260001",
        ],
        Desc: [
            "Each Association has a creed or maxim that reflects its atmosphere. Some emphasize gallant passion, while others aspire to a quiet and cold attitude. The Hana Association is no exception in that it has a number of outwardly seen principles. Coincidentally, they represent the most basic ideas of the attitude a Fixer must have.",
            "We must exercise concentration and resoluteness in all situations. Be diligent to detect the emergence of a new flow, yet be wary not to be swept by the flow yourself. As our occupation involves placing some on low positions and holding others in high regard, we must secure the values that constitute our frame, while amending outdated parts of our ideologies. Thus, we need to have an open mind that can accept opinions that differ from our own in moderation. Be willing to listen to the criticism of others and acknowledge it, but be cautious not to throw yourself into confusion by accepting any and all opinions, changing yourself without due consideration. Change what needs to be changed, but be stubborn about the rules we’ve maintained. In conclusion, we mustn’t fall for temptation or deception.",
            "Much like how a foundation influences the structures that stand on it, these principles serve as a basis for all Associations to uphold. Being the Association that supervises the system of Fixers in general, the principles of the Hana are also applicable to the mindset any Fixer should have.",
        ],
    },
    {
        ID: "160101",
        Name: "A Hana Fixer’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 7],
        HP: 105,
        StaggerHP: 60,
        SResist: [0, 0],
        PResist: [1, 0],
        BResist: [0, 1],
        Skin: "HanaUnit",
        Passive: [
            "10001",
            "260001",
        ],
        Desc: [
            "Each Association has a creed or maxim that reflects its atmosphere. Some emphasize gallant passion, while others aspire to a quiet and cold attitude. The Hana Association is no exception in that it has a number of outwardly seen principles. Coincidentally, they represent the most basic ideas of the attitude a Fixer must have.",
            "We must exercise concentration and resoluteness in all situations. Be diligent to detect the emergence of a new flow, yet be wary not to be swept by the flow yourself. As our occupation involves placing some on low positions and holding others in high regard, we must secure the values that constitute our frame, while amending outdated parts of our ideologies. Thus, we need to have an open mind that can accept opinions that differ from our own in moderation. Be willing to listen to the criticism of others and acknowledge it, but be cautious not to throw yourself into confusion by accepting any and all opinions, changing yourself without due consideration. Change what needs to be changed, but be stubborn about the rules we’ve maintained. In conclusion, we mustn’t fall for temptation or deception.",
            "Much like how a foundation influences the structures that stand on it, these principles serve as a basis for all Associations to uphold. Being the Association that supervises the system of Fixers in general, the principles of the Hana are also applicable to the mindset any Fixer should have.",
        ],
    },
    {
        ID: "160002",
        Name: "Mirinae’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 235,
        StaggerHP: 135,
        SResist: [1, 0],
        PResist: [0, 1],
        BResist: [0, 0],
        Skin: "Mirinae",
        Passive: [
            "10008",
            "260001",
            "260002",
        ],
        Desc: [
            "There are twelve Fixer Associations across the City, and the Hana Association is the one in charge of general management of the rest. We’re renowned for rating the threat level of hazards that occur in the City, and grading Fixers and Offices. On top of that, we give out Fixer licenses, issue official documents about certain requests, and assign Colors to Fixers who prove themselves to be beyond the grading system. Our Association calls the shots on pretty much everything regarding Fixer activity. Although, there is one thing the Hana Association can’t touch on.",
            "The ratings of hazards in the City are as follows: Urban Myth, Urban Legend, Urban Plague, Urban Nightmare, Star of the City… and Impurity. Most other Associations only deal with Stars of the City or lower. Even though Hana Association has control over grading the hazards… There’s one grade our Association can’t assign: The Impurity. Only the Head has the authority to decide that. I don’t know the exact rationale behind designating Impurities… From what I can see, they seem to declare beings that defile the City as Impurities and banish them to the Outskirts. I suppose the Head manages that part since things like the ethics of the City aren’t subjects we are qualified to discern.",
        ],
    },
    {
        ID: "160003",
        Name: "Harold’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 8],
        HP: 230,
        StaggerHP: 140,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Harold",
        Passive: [
            "10008",
            "260001",
            "260003",
        ],
        Desc: [
            "Some people ask how Stars of the City, the highest level of urban hazards, are any different from Impurities. They wonder… “Aren’t they disrupting the City’s order?”",
            "In the universe that is the City, a center of mass forms for each person who bears a wish for something, and clusters of dreams comparable to interstellar matter gravitate toward those centers. Driven by the force people exert in their efforts to reach those goals, such nebulae repeatedly expand and contract, until they finally fulfill their wishes—creating a Star whose glow we can observe. The people who witness the sparkle of that Star admire how brilliantly it shines in the dark, and entertain the hope that they will shine as brightly one day, making yet more centers in the universe…",
            "Of course, some people will have their eyes fixed to the ground—too busy to gaze at anything other than their path ahead; however, once a person sets their eyes on a Star, they begin to head towards it, using its guidance like a compass. Although they probably aren’t trying to become a Star themselves. They merely want to shine with their dreams for once, not to indulge in the sense of superiority that comes from being high up in the City’s sky.",
        ],
    },
    {
        ID: "160004",
        Name: "Olivier’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 210,
        StaggerHP: 125,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Olivier",
        Passive: [
            "10008",
            "260001",
            "260004",
            "260003",
            "160004",
        ],
        Desc: [
            "Roland and I were long-time partners in Charles’ Office since the year dot. There were twelve members in total—excluding Angelica who joined the Office later on to resolve the case of the Blood-red Night. Consisting of rather few Fixers for a Grade 1 Office, it took on various requests, playing to the strengths of the twelve members who had different quirks and characteristics each. Roland and I got along well together, so I often worked with him. Well, not exactly for that reason. To be precise, someone had to keep his impulse to jump into action before thinking on a dog’s leash.",
            "“Valor without forethought is little more than a bluff, and there is more strength in discretion than recklessness.” I wonder if you remember this piece of advice I gave when you were still prone to take action without thinking. I remember you conceding it and taking a step back. Although I gave you that advice, now I understand that it’s not without fault. Thinking alone doesn’t make progress, and too much caution can be a harm to oneself. I had the prudence, and you had the unhesitating action. We helped each other with our strengths, and we could just live on by dealing with matters at hand back in the day. Maybe those were the days when we could laugh and lament the most, and carry out our lives just like that. But now we’ve come too far to go back—so did you, and so did Charles’ Office.",
        ],
    },
    {
        ID: "170001",
        Name: "The Black Silence’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 400,
        StaggerHP: 350,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "BlackSilenceMask",
        Passive: [
            "170001",
            "170006",
            "170002",
            "170003",
            "170004",
            "170005",
            "250002",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "170101",
        Name: "Roland’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 1000,
        StaggerHP: 150,
        SResist: [1, -2],
        PResist: [0, -2],
        BResist: [0, -1],
        Skin: "Roland2Phase",
        Passive: [
            "10004",
            "170101",
            "170102",
            "170103",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "170102",
        Name: "A Smoldering Byproduct’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 60,
        StaggerHP: 30,
        SResist: [0, -2],
        PResist: [0, -2],
        BResist: [-1, -1],
        Skin: "Roland2PhaseEnemy",
        Passive: [
            "170102",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "170201",
        Name: "Roland’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 3],
        HP: 400,
        StaggerHP: 180,
        SResist: [1, 1],
        PResist: [-2, -2],
        BResist: [0, 0],
        Skin: "BlackSilence3",
        Passive: [
            "170201",
            "170202",
            "170203",
            "170204",
            "170205",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "170202",
        Name: "Angelica’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 4],
        HP: 350,
        StaggerHP: 150,
        SResist: [1, 1],
        PResist: [1, 1],
        BResist: [1, 1],
        Skin: "AngelicaPhantom",
        Passive: [
            "170211",
            "170202",
            "170212",
            "170213",
            "170214",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "170301",
        Name: "The Black Silence’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 999,
        StaggerHP: 500,
        SResist: [1, 1],
        PResist: [1, 1],
        BResist: [1, 1],
        Skin: "BlackSilence4",
        Passive: [
            "170301",
            "170302",
            "170303",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "170311",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 1],
        HP: 50,
        StaggerHP: 30,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "BlackSilence4_Weapon1",
        Passive: [
            "170320",
        ],
        Desc: [
        ],
    },
    {
        ID: "170312",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 1],
        HP: 50,
        StaggerHP: 30,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "BlackSilence4_Weapon2",
        Passive: [
            "170320",
        ],
        Desc: [
        ],
    },
    {
        ID: "170313",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 1],
        HP: 50,
        StaggerHP: 30,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "BlackSilence4_Weapon3",
        Passive: [
            "170320",
        ],
        Desc: [
        ],
    },
    {
        ID: "170314",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 1],
        HP: 50,
        StaggerHP: 30,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "BlackSilence4_Weapon6",
        Passive: [
            "170320",
        ],
        Desc: [
        ],
    },
    {
        ID: "170315",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 1],
        HP: 50,
        StaggerHP: 30,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "BlackSilence4_Weapon4",
        Passive: [
            "170320",
        ],
        Desc: [
        ],
    },
    {
        ID: "170316",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 1],
        HP: 50,
        StaggerHP: 30,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "BlackSilence4_Weapon5",
        Passive: [
            "170320",
        ],
        Desc: [
        ],
    },
    {
        ID: "170317",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 1],
        HP: 50,
        StaggerHP: 30,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "BlackSilence4_Weapon7",
        Passive: [
            "170320",
        ],
        Desc: [
        ],
    },
    {
        ID: "170318",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 1],
        HP: 50,
        StaggerHP: 30,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "BlackSilence4_Weapon8",
        Passive: [
            "170320",
        ],
        Desc: [
        ],
    },
    {
        ID: "170319",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 1],
        HP: 50,
        StaggerHP: 30,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "BlackSilence4_Weapon9",
        Passive: [
            "170320",
        ],
        Desc: [
        ],
    },
    {
        ID: "170321",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 100,
        StaggerHP: 80,
        SResist: [0, 1],
        PResist: [1, 2],
        BResist: [0, -2],
        Skin: "BlackSilence4",
        Passive: [
            "170335",
            "170330",
            "170331",
        ],
        Desc: [
        ],
    },
    {
        ID: "170322",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 120,
        StaggerHP: 80,
        SResist: [0, 1],
        PResist: [0, -2],
        BResist: [1, 2],
        Skin: "BlackSilence4",
        Passive: [
            "170335",
            "170330",
            "170332",
        ],
        Desc: [
        ],
    },
    {
        ID: "170323",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 180,
        StaggerHP: 80,
        SResist: [0, 1],
        PResist: [0, 1],
        BResist: [0, 1],
        Skin: "BlackSilence4",
        Passive: [
            "170335",
            "170330",
            "170333",
        ],
        Desc: [
        ],
    },
    {
        ID: "170324",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 120,
        StaggerHP: 80,
        SResist: [1, 2],
        PResist: [0, 1],
        BResist: [0, 1],
        Skin: "BlackSilence4",
        Passive: [
            "170335",
            "170330",
            "170334",
        ],
        Desc: [
        ],
    },
    {
        ID: "180001",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [4, 6],
        HP: "∞ ?",
        StaggerHP: "∞ ?",
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "TheHead",
        Passive: [
            "180001",
        ],
        Desc: [
        ],
    },
    {
        ID: "180002",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [4, 6],
        HP: "∞ ?",
        StaggerHP: "∞ ?",
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "TheClaw",
        Passive: [
            "180002",
        ],
        Desc: [
        ],
    },
    {
        ID: "180003",
        Name: "The Black Silence’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 106,
        StaggerHP: 56,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "BlackSilence",
        Passive: [
            "10008",
            "10012",
            "10013",
            "10112 ",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "180004",
        Name: "The Red Mist’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 8],
        HP: 120,
        StaggerHP: 67,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "Kali",
        Passive: [
            "10008",
            "250122",
            "250222",
            "250322",
            "180104",
        ],
        Desc: [
            "E.G.O. The weapon that corresponds to the mind of its wielder. The sword Carmen gave me was extracted from someone by chance. Giant eyeballs were attached to the sword adorned with crimson chunks of flesh; they watched my every move, almost to the point of making me feel a bit uncomfortable. Wondering if this was a product of some new Singularity, I asked Carmen what the thing was; she only said that I’ll have to get used to it, since there’s little she can do about how it looks. Although it looked a bit creepy, it wasn’t anything unbearable, and Carmen didn’t seem to mind it as long as there were experiments to be performed with it. She added that I have to be careful with it as it was thanks to sheer luck that the “E.G.O” could be extracted at all in its unstable state. I had a plethora of experience handling various workshop products, so I decided to take the sword without much hesitation.",
            "When I first had the sword in my grip, I didn’t feel anything in particular. All I could tell is that it’s just a big, heavy greatsword; nothing out of the ordinary other than its appearance. But when I held the sword a few days later to protect a coworker of mine, I heard a voice. It was the voice of someone desperately yearning for something. Unfortunately, the meaning of that voice was lost on me. Rather… it wasn’t even human speech. An awkward sound mimicking somebody. Noises of teeth grinding, bones crackling, mingling with flesh. Some things collide, fall apart, and mix in irregular patterns as if to mimic the way humans speak. However, that sound was too violent and sharp. The strong obsession of an empty one. Attachment. Void. I’m not sure what word I should use to define this.",
            "One thing I understood was that only I could hear that voice, and that it rang in my head rather than my ears. The stronger and clearer my aim to protect someone became, the louder the noise in my head got. Anxious that my mind might be consumed by the voice if I let it weaken my will, I tried my best to pretend that I didn’t hear it. The eyes on the blade carefully observed me as I fought the voice in my head. The piercing gaze persisted as if to replace me if I faltered even for a second; it made me feel hazy sometimes. The “voice” was only a bunch of grinding noises at the beginning, but it slowly learned to speak over time. Soon enough, it started speaking in a language that I could understand, though it stammered a bit. It takes human hide to protect human flesh. A shell… It kept asking for a shell. I couldn’t stop the voice, so the most I could do was ignore it.",
            "Even though there was danger in using it, its power was formidable; with it, I protected many a person, and cut down many a threat. The voice became stronger and deeper with the more blood the blade drank. One day, it asked a sharp question: “Don’t you desire a human shell as well?” When I think back on it, the question might not have been aimed at me specifically. It would only say whatever it wanted to say. It wouldn’t try to convince or allure me. All it uttered was monologue. Yet, I was frozen stiff when I heard that. It kept saying something. Are our lives really worth the blood I spilt for them? It wasn’t actually capable of forming such detailed sentences, but my head took it that way for some reason… Maybe I was thinking to myself.",
            "I denied its claim at the start. I’d never provoked anyone first. I’d only acted to protect others from an approaching danger. But, I felt a small part of myself waver from what the voice said. What will remain when I keep washing away blood with blood? A bloodstained shell would be all that is left.",
            "I collapsed for a moment; but I didn’t stop thinking. If I broke down, I might be in danger as Carmen warned. Carmen… Right, Carmen would’ve been different. Nothing could possibly beat the glitter in her eyes that shines as she pioneers a new path. Those honest, virtuous eyes… Even when someone jeered at her speech, even when everyone despaired in the face of an obstacle that brought progress to a halt, Carmen never stopped looking after others. She would always take the initiative to lead all of them. If I can protect a person like that, maybe this place will change? Yes. As long as I can protect that one person.",
            "As my thoughts became clearer, I couldn’t just sit down. My body acted before my head could decide what to do. I don’t exactly remember what happened then. When I finally took a grip on my rationality in a vast mindscape and came back to my senses, my body was burning hot. Is this rage? Have I been taken over to the point where I can’t even see ahead? But I felt so calm, refreshed even. My head was kept cool, while my heart leading the body was aflame. It wasn’t long until I felt that something was different. On solid armor, there was a layer of something tough and dense, but it wasn’t fabric… A veil of mist was covering me. Astonished, I moved around and shook my limbs several times, and the veil dissipated soon after.",
            "When Carmen learned of this, she didn’t say much. She didn’t make a big fuss about it or suggest trying something with it right away. She only said that wielding this power is more important than simply manifesting it, so I shouldn’t be lazy… She went back to work after leaving that peculiar piece of advice. Maybe she didn’t want me to feel too much pressure.",
            "As more time passed, I could use the armor for longer, and eventually got to draw out its full power. I had a weapon and armor that resonate with my emotions. Using them, I could protect more people, and I was able to draw forth more durability and strength. The researchers seemed to be struggling to make progress with their work, but it was alright. I believed in them to make it through, and I just had to be quicker to do my job in the meantime. However, not long after, the incident happened all too suddenly. No, maybe it wasn’t so sudden. The sign was there.",
            "Just around this corner, I can hear a child crying; she’s sitting in front of a door. One of the two children Carmen took in died in a failed experiment. Unlike Lisa who was wary and reluctant to open up to us, Enoch showed interest in our research, and volunteered to be a test subject the other day. Enoch’s speech was so concise and on point, everyone was shocked. He wasn’t afraid, and he wasn’t shaking… His voice was unswerving and gentle. Enoch’s eyes weren’t those of a naive little kid. His words and thoughts were surprisingly deep and mature; even I was astonished. I sometimes wondered what made this kid have such thoughts. His eyes seemed to have already seen so much of this world’s despair and misfortune. However, it was still no reason to allow a kid to participate in the experiments. Carmen spent several nights agonizing over the matter.",
            "The experiment was authorized at last, though I didn’t want to know what they thought of it anymore. What were they going to do, holding the hand of that little kid? I had to wonder if we were that desperate. But I shrugged it off. I wasn’t one to stop him from doing what he chose to do.",
            "“You should’ve been the one to die…” The other kid, who was now all alone, mumbled crying. Her words had no weight to it. She probably spouted what she didn’t sincerely mean, because the situation was too much for her.",
            "“Yeah… I— I should have died.” Carmen’s answer, on the other hand, was likely sincere. Everyone stood still. A crack appeared in our minds which we never thought would crumble. Maybe we all expected it to happen deep down.",
            "Carmen’s state worsened with each passing day, like a rusting nail. The sunny eyes of the woman who had brought us together were now cloudy, and she spoke less and less. Her voice was lifeless, and she had gotten so cold; it wouldn’t have come to anyone’s surprise if she died at any moment. She didn’t bother trying to look okay. I think it was better that way. Everyone in the laboratory felt constraint in her presence. They viewed Carmen in different ways. Reproachful looks of those resenting her for bringing them so far, only to let go of her responsibility. Concerned looks of those worried that something might happen to her. And I guess there were some who had no thoughts. The research went on quietly, but not for long.",
            "A few days later, Carmen spilled out all of the guilt within her and plunged into it, never to come back up.",
        ],
    },
    {
        ID: "180005",
        Name: "Patron Librarian of Philosophy’s Page",
        Level: "Library",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 115,
        StaggerHP: 70,
        SResist: [1, 2],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Binah",
        Passive: [
            "10008",
            "10010",
            "180005",
        ],
        Desc: [
        ],
    },
    {
        ID: "1408011",
        Name: "Elena’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 400,
        StaggerHP: 310,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "TwistedElena",
        Passive: [
            "1408011",
            "1408012",
            "260013",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1410011",
        Name: "Argalia’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [4, 6],
        HP: 575,
        StaggerHP: 410,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "TwistedArgalia",
        Passive: [
            "1410011",
            "260005",
            "1410012",
            "1410013",
            "1410014",
            "1408012",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1410012",
        Name: "",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [4, 6],
        HP: 700,
        StaggerHP: 550,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "BlackSilence",
        Passive: [
        ],
        Desc: [
        ],
    },
    {
        ID: "1409011",
        Name: "Pluto’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 380,
        StaggerHP: 275,
        SResist: [0, 0],
        PResist: [0, 1],
        BResist: [1, 0],
        Skin: "TwistedPluto",
        Passive: [
            "1409011",
            "1409012",
            "1409013",
            "1408012",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1409021",
        Name: "Shade’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 155,
        StaggerHP: 95,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "JaeheonPuppetN",
        Passive: [
            "1409021",
            "1409022",
            "1408012",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1405011",
        Name: "Oswald’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 4],
        HP: 250,
        StaggerHP: 250,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "TwistedOswald",
        Passive: [
            "1405000",
            "1405011",
            "1405012",
            "1405013",
            "1405014",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1405021",
        Name: "Mr. Knife’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 4],
        HP: 60,
        StaggerHP: 40,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [-2, -2],
        Skin: "OswaldBlade_Added",
        Passive: [
            "1405000",
            "1405021",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1405031",
        Name: "Ms. Mermaid’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 3],
        HP: 70,
        StaggerHP: 50,
        SResist: [-2, -2],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "OswaldMermaid_Added",
        Passive: [
            "1405000",
            "1405031",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1405041",
        Name: "Mx. Bunny’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 4],
        HP: 140,
        StaggerHP: 70,
        SResist: [0, 0],
        PResist: [-2, -2],
        BResist: [1, 1],
        Skin: "OswaldRabbit",
        Passive: [
            "1405000",
            "1405041",
            "1405042",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1407011",
        Name: "Jae-heon’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 4],
        HP: 300,
        StaggerHP: 300,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "TwistedJaeheon",
        Passive: [
            "1405000",
            "1407011",
            "1407012",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1406011",
        Name: "Tanya’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 8],
        HP: 340,
        StaggerHP: 300,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "TwistedTanya",
        Passive: [
            "1405000",
            "1406011",
            "1406012",
            "1406013",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1304011",
        Name: "Bremen’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 900,
        StaggerHP: 60,
        SResist: [2, 1],
        PResist: [2, 0],
        BResist: [2, 1],
        Skin: "Blue_Bremen",
        Passive: [
            "1300001",
            "1304011",
            "1304014",
            "1304012",
            "1304015",
            "1304016",
        ],
        Desc: [
            "Let’s go on an adventure—a world that changes with every step. The me that changes after each step I take. My eyes dazzled by colorful light, I pursue pleasures that I don’t have. Don’t scold us because you can’t understand our pursuit. You just happen to be one of the many who feel joy from common things. We—on the other hand—don’t see any colors in those. You’re the ones drenched in nasty pleasures. We’re simply looking for what we lack. But complete satisfaction will never come; it’ll only sink deeper in the raging thirst. We will spend our days in yet grander debauchery. We’re happy, though. We can wet ourselves in new colors every day, unlike the rest of you.",
        ],
    },
    {
        ID: "1304021",
        Name: "A Puppet’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 4],
        HP: 70,
        StaggerHP: 40,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "JaeheonPuppetN",
        Passive: [
            "240006",
            "230121",
            "1307021",
            "1307001",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1304031",
        Name: "Ms. Mermaid’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 4],
        HP: 240,
        StaggerHP: 100,
        SResist: [0, 0],
        PResist: [0, -2],
        BResist: [1, 1],
        Skin: "OswaldMermaid",
        Passive: [
            "10001",
            "1305021",
            "1305031",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1404011",
        Name: "Bremen’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 5],
        HP: 200,
        StaggerHP: 60,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [1, 1],
        Skin: "Twistbremen",
        Passive: [
            "1400001",
            "1404011",
            "1404012",
            "1404013",
            "1401015",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1302011",
        Name: "Eileen’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 500,
        StaggerHP: 500,
        SResist: [1, 2],
        PResist: [1, 2],
        BResist: [1, 2],
        Skin: "Eileen",
        Passive: [
            "1302011",
            "1302012",
            "1302013",
            "1302014",
            "1302016",
            "1302015",
            "1302017",
            "1300001",
        ],
        Desc: [
            "Where we live, there is nothing that can be achieved with your own will. A flow that we cannot go against dictates us. What we call “gears” are simply there to show the flow. You can’t see it with your eyes. Nobody knows who created this massive current, or why we must follow it. This flow never leads us to bad places, however. Rather, thinking that such a place exists is an act of defiance in itself.",
            "We merely watch events unfold as bystanders. You walk along a path, but was it you who laid the path there? You didn’t teach yourself to lift your legs to propel you forward; they simply moved. Furthermore, the decision to walk wasn’t our own, either. Still too many believe that they moved their legs out of their own volition. It’s a shame to see them struggle to escape the flow, for they’re only straying away from salvation.",
        ],
    },
    {
        ID: "1302021",
        Name: "A Gear Worshipper’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 105,
        StaggerHP: 60,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 1],
        Skin: "GearsUnit",
        Passive: [
            "1302021",
            "240026",
            "250014",
            "250114",
            "250214",
            "240025",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1402011",
        Name: "Eileen’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 7],
        HP: 180,
        StaggerHP: 85,
        SResist: [1, 0],
        PResist: [1, 1],
        BResist: [0, 1],
        Skin: "TwistEileen",
        Passive: [
            "240026",
            "1400001",
            "1402011",
            "1402012",
            "1402013",
            "1402014",
            "1401015",
            "1404014",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1308011",
        Name: "Elena’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 400,
        StaggerHP: 310,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Elena",
        Passive: [
            "1308011",
            "1300001",
        ],
        Desc: [
            "Bloodfiends. The beings said to have been punished with neverending thirst for the sin of lusting after human blood. That’s what your kind called us, condemning us out of fear. I was afraid as well when I faced them for the first time in that mansion where everything began. Violent beings who drank the blood of fellow humans. A growing feeling of unease about the possibility of being their next target. The people in the mansion were terrified of those who became monsters. Even though they were humans like us, they were outside of what we thought as the norm. In hindsight, though, it was such a silly thing to do. What is the illusion of normalcy that we feared for and fought for so strongly?",
            "Let’s say that every human on the planet except for one turned into Bloodfiends, and that single person remaining is left “normal”, as they say. In that case, what would normalcy be like there? How must the lone human feel being the monster among the creatures they dreaded? Should they fight to their last breath for the “humanity” they kept for so long? Perhaps that’s become an obsolete ideology, one that’s no longer worth keeping. What if rejecting that old ideal and becoming a Bloodfiend opened up our potential for growth in numerous aspects?",
            "Your kind likes to claim that something is out of the ordinary when it’s only different from what you’ve seen and experienced before. So you fear it, and try to exclude it from your herd. But you see, there’s no real justification for your kind to condemn us.",
        ],
    },
    {
        ID: "1308021",
        Name: "The Vermilion Cross’ Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 550,
        StaggerHP: 350,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "OrangeCross",
        Passive: [
            "1308021",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1306011",
        Name: "Tanya’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [3, 9],
        HP: 500,
        StaggerHP: 350,
        SResist: [0, 0],
        PResist: [1, 1],
        BResist: [0, 0],
        Skin: "Tanya",
        Passive: [
            "1306011",
            "1300001",
            "1306012",
            "1306013",
        ],
        Desc: [
            "Fighting for survival is a natural thing. Even now, we’re all in battle. There’re more people born than folks dying of natural causes, and the living struggle in their own positions every day. A fight to protect, and to avoid falling behind. Maybe it’s all ‘cause there just ain’t enough seats for the ever-growing population of humans to take? Sure, extra jobs and stuff could be made in the future, but that’s nothing more than a hopeful estimate that might not happen until it’s too late for you. The world we live in right now is what matters. There’s got to be a way to weed out the unfit without straining all of us. And that’s when strength plays its part.",
            "I don’t get why you vilify this. Aren’t we all doing the same thing, directly or not? We elbow our way past others so we can survive, and the losers are knocked outta the race. You say this is fair, but say no to physical conflicts, to “respect life” or whatevs? Then lemme ask: what’s the reason to respect life? Do you think you’re respecting life right now?",
        ],
    },
    {
        ID: "1310011",
        Name: "Argalia’s Page",
        Level: "Star of the City",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [3, 6],
        HP: 550,
        StaggerHP: 410,
        SResist: [0, 1],
        PResist: [0, 0],
        BResist: [1, 0],
        Skin: "Argalia2",
        Passive: [
            "1310011",
            "1300001",
            "250113",
            "1310012",
            "1310013",
            "1310014",
            "1310015",
        ],
        Desc: [
            "When I heard the news and rushed to the scene, only a hideous musician who had concluded his performance and permanently shut the piano’s lid with his torso awaited me. For the first time, emotions I couldn’t understand welled up inside me. It’s hard to define what they were, even now. It felt as if deep tenebrous stains were seeping out of my heart. Alas, I didn’t shed tears before that piano where your body rested—for I soon realized that you were no longer there.",
            "That’s right; you’re the gentle breeze that brushes past my face, and the clouds that fly in the sky, which give me heed of your presence from overhead or underfoot. I thought you had left me, but you would always come back. That’s why I care no longer about the skin and flesh you wore only momentarily. Angelica. I’ll follow after the name you gave me: Uberto. You used to call me that down in those horrible underground chambers. I’ll create a new world… one where people can live bountiful lives even if they have nothing, free from obsession or greed. When we lose the fixation on our bodies, we won’t be afraid of death anymore. No rest will be eternal.",
        ],
    },
    {
        ID: "1303011",
        Name: "Greta’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 5],
        HP: 1000,
        StaggerHP: 500,
        SResist: [1, 1],
        PResist: [1, 1],
        BResist: [1, 1],
        Skin: "Blue_Greta",
        Passive: [
            "1300001",
            "1303011",
            "1303014",
            "1303015",
            "1303016",
            "1303012",
        ],
        Desc: [
            "It’s an era where humans are dominated by the act of consumption! When you’re hungry you get annoyed, and when starvation touches your raw nerve, you turn violent. That’s how humans are. And people who eat the same food will naturally grow similar. So the high and mighty beings that wanna rule over you demand ya to eat the “correct” stuff! When something’s “correct”, there’s gotta be something that’s “incorrect”. Incorrect food. It’s gotta mean humans eating humans, don’tcha think?",
            "Why do people think that eating is natural, but then draw the line at eating their fellow man? Who decided it so, and why! Is it because human life is precious? That’s a flawed statement! What makes the lives of animals less precious? We’re not aboutta go down a boring philosophical riddle about the weight of life, now. If humans clearly have more value over animals ‘cause we’re the apex predators, then there shouldn’t be any problem with a pack of humans that rise above the rest and prey on others.",
            "We’ve got two options! First: don’t eat anything. Hey, I’m not suggesting that we all starve to death. Your body is taught to eat! So what if you changed that habit? Maybe instead of food, your empty innards could be filled with possibilities of some other kind? If you ain’t a fan of that, then there’s the second option: eat anything! Just trace the smell of the blood, and stuff what you find in your mouth as your brain tells you to.",
        ],
    },
    {
        ID: "1303021",
        Name: "Some Fresh Meat’s… Page?",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 1],
        HP: 80,
        StaggerHP: 40,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "Blue_Greta_Meat",
        Passive: [
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1403011",
        Name: "Greta’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [3, 6],
        HP: 250,
        StaggerHP: 110,
        SResist: [1, 1],
        PResist: [0, 0],
        BResist: [1, 1],
        Skin: "TwistGreta",
        Passive: [
            "10008",
            "1400001",
            "1303015",
            "1403011",
            "1403012",
            "1403013",
            "1403014",
            "1401015",
            "1404014",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1307011",
        Name: "Jae-heon’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 4],
        HP: 300,
        StaggerHP: 200,
        SResist: [1, 1],
        PResist: [1, 1],
        BResist: [1, 1],
        Skin: "Jaeheon",
        Passive: [
            "1307011",
            "1307012",
            "1307013",
            "1307014",
            "1300001",
        ],
        Desc: [
            "Had I been busy with an urgent appointment as any other tragic tale should go, your death wouldn’t have felt so miserable. Yeah. I would’ve cried until my tears had run their course, and I would’ve been ready to send you off. It was an ordinary day. The sort of day when there were no meetings or gatherings to attend to after I came home from work. Your body was crushed beyond recognition—I couldn’t have noticed on my own that it wasn’t a random chunk of flesh. They put your remains in a stasis box and sent it to me; that was their gesture of condolence. I’d have refused to believe it was you, if it weren’t for the clothes. I spent hours sitting there in numbed silence, vacantly staring at a lump I couldn’t even dare to hug.",
            "A stuffed doll you were carrying, now next to the box, caught my eye. Even though it was shredded and soaked in blood, the cotton filling was still clustered together, as if it remembered the volume of the doll. It seems some cotton remained even after the roller crumpled all the outer fabric. Then for reasons unknown, I brought the other dolls out of your room and cut them up with a pair of scissors. I don’t know what possessed me to cut them into pieces of fabric. There wasn’t even enough to fully cover the doll, so I scraped together the pieces of clothing to sew it back up. With the same, gentle hands that made your doll the first time.",
            "The outcome was creepier than what it used to be, but it was the same doll I remembered nonetheless. The appearance didn’t matter. Maybe, just maybe, the same could be said for you? I gazed at the box where you, my son, rested for what would no longer be an eternity. My two hands were once so busy that it was a bother; they had paused for the time, but now they are about to move again—just for you.",
        ],
    },
    {
        ID: "1307021",
        Name: "A Puppet’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 4],
        HP: 70,
        StaggerHP: 50,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "JaeheonPuppetN",
        Passive: [
            "240006",
            "1307021",
            "1307001",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1307031",
        Name: "A Nimble Puppet’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 7],
        HP: 80,
        StaggerHP: 70,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "JaeheonPuppetQ",
        Passive: [
            "240004",
            "240006",
            "1307031",
            "1307001",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1307041",
        Name: "A Weighty Puppet’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Limited",
        Speed: [2, 3],
        HP: 100,
        StaggerHP: 90,
        SResist: [0, 0],
        PResist: [0, 0],
        BResist: [0, 0],
        Skin: "JaeheonPuppetH",
        Passive: [
            "240005",
            "240006",
            "1307041",
            "1307001",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1307051",
        Name: "Puppet Angelica’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Hardcover",
        Speed: [2, 6],
        HP: 120,
        StaggerHP: 80,
        SResist: [1, 1],
        PResist: [1, 1],
        BResist: [1, 1],
        Skin: "AngelicaPuppet",
        Passive: [
            "10001",
            "240004",
            "240005",
            "240006",
            "1307001",
            "1307051",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1305011",
        Name: "Oswald’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 4],
        HP: 300,
        StaggerHP: 200,
        SResist: [1,2],
        PResist: [1,2],
        BResist: [1,2],
        Skin: "Oswald",
        Passive: [
            "10004",
            "1305011",
            "1305012",
            "1305013",
            "1305014",
            "1300001",
        ],
        Desc: [
            "People have hopes and dreams!",
            "Thus and therefore, people have the wrong idea about how to have hopes! If they believe that the hopes will come true “someday”, they’ll just keep parroting that contemptible word! The day will never actually come! Having expectations this way will only leave you with bitter anger!",
            "So we should all do the stretches, starting today! Abandon all expectation—just keep a merry positive attitude and laugh no matter what you see! Let’s make a performance about what’s already come true, not of a supposed reality you hope for “someday”! I’m already on the stage, standing under the brightingest spotlight ever.",
        ],
    },
    {
        ID: "1305021",
        Name: "Mr. Knife’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [3, 5],
        HP: 180,
        StaggerHP: 85,
        SResist: [1, 1],
        PResist: [0, -2],
        BResist: [0, 0],
        Skin: "OswaldBlade",
        Passive: [
            "10001",
            "1305021",
            "1305022",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1305031",
        Name: "Ms. Mermaid’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [1, 4],
        HP: 240,
        StaggerHP: 100,
        SResist: [0, 0],
        PResist: [0, -2],
        BResist: [1, 1],
        Skin: "OswaldMermaid",
        Passive: [
            "10001",
            "1305021",
            "1305031",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1301011",
        Name: "Philip’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 5],
        HP: 550,
        StaggerHP: 160,
        SResist: [2,2],
        PResist: [2,2],
        BResist: [2,2],
        Skin: "Blue_Philip",
        Passive: [
            "1300001",
            "1301011",
            "1301015",
            "1301016",
            "1301017",
            "1301018",
            "1301012",
            "1301019",
        ],
        Desc: [
            "How much longer must I walk until I reach an end? How tightly must I shut my eyes, cover my ears, and zip my mouth to keep what’s around me safe before I can feel a semblance of happiness that won’t leave me? I thought I had to overcome this pain and rise above it to become a tougher man. That way, I wouldn’t lose those that are close to me. However, a human is fragile by nature; if one is too weak, they would crumble—and if one is too hardy, they would snap. I realized that there’s little I can do to calm the disorder of this world. How can I live on without falling to despair, then? A mind that is willing to let go of things that were destined to leave at some point. A mind that is content to have nothing. I feel that it’s important to refrain from thinking that anything is in my possession.",
            "I followed your troupe in order to find a way to be happy, but what good did it do for me? Staying with you only exacerbated my suffering, defeating the whole purpose of joining you in the first place. I do want to add that you were not at fault here, though. I was the one who tormented myself. Had I known what I know now back in the past… would that have lessened the pain or changed anything? No, I don’t blame myself for the choice in that moment. Even the failures and misery of the past were all part of the voyage leading up to this moment, so I’m thankful that I managed to achieve something for once. I might have drowned in my own tears and sorrow back then, but ultimately, I’m grateful for the choice I made… and all the things in the world.",
        ],
    },
    {
        ID: "1301021",
        Name: "The Crying Children’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 4],
        HP: 60,
        StaggerHP: 40,
        SResist: [1, 1],
        PResist: [1, 1],
        BResist: [1, 1],
        Skin: "ChildCoveringMouth",
        Passive: [
            "10001",
            "1301021",
            "1301022",
            "1301023",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1401011",
        Name: "Philip’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 7],
        HP: 190,
        StaggerHP: 110,
        SResist: [1, 1],
        PResist: [1, 0],
        BResist: [0, 1],
        Skin: "TwistPhilip",
        Passive: [
            "10008",
            "1400001",
            "1301017",
            "1301015",
            "1401011",
            "1401012",
            "1401014",
            "1401016",
            "1401017",
            "1404014",
        ],
        Desc: [
            "",
        ],
    },
    {
        ID: "1309011",
        Name: "Pluto’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 200,
        StaggerHP: 450,
        SResist: [2, 2],
        PResist: [2, 2],
        BResist: [2, 2],
        Skin: "Pluto",
        Passive: [
            "1309011",
            "1309012",
            "1309013",
            "1309014",
            "1300001",
        ],
        Desc: [
            "The world is one massive aggregation of delusions. A world where individuals can shape their own reality as they see fit. Every person is susceptible to deception, for they have knowledge. For that reason, it is impossible for a pure being untainted by knowledge to see the world as we mistakenly observe it, in the same way they cannot discern the end point of a line or tell between blue and red. A world devoid of wants. It would be unfit to call that place a world. In fact, to even call it a “place” would be yet another misconception amongst us knowing ones. The more one learns, the more delusions they invite.",
            "However, if most people observed the same place and felt the same sentiments, then it might not be your own delusion after all. Wouldn’t you say so? For instance, take a look at the blue sky. The celestial dome is higher and farther than one can fathom, and as blue as it can be. Most will agree that the sky is tall and blue. Alas, those who think as such are ultimately within your view. It’s only natural that they agree with you as they’re figments born out of your delusional mind. Indeed, the sly entity that prevents you from seeing the world in its sincerest form would be none other than yourself. Even the holy entity in which you believe and to which you devote yourself is going to be a projection of your own self, so how can I trust anything that my eyes show me?",
        ],
    },
    {
        ID: "1309021",
        Name: "A Shade’s Page",
        Level: "Impuritas Civitatis",
        Source: "abcdef",
        Obtainable: "False",
        Rarity: "Objet D'art",
        Speed: [2, 6],
        HP: 100,
        StaggerHP: 100,
        SResist: [1, 1],
        PResist: [1, 1],
        BResist: [1, 1],
        Skin: "JaeheonPuppetN",
        Passive: [
        ],
        Desc: [
            "",
        ],
    },

]